/* Reconstructed from tenant.zip:public/build/assets/dist-B86vIM39.js
 * Original SHA-256: 0fdad3edb918be4c2236498dd2d755b60a6a41d3de17403948ba676052d1cb07
 * Surviving compiled logic, formatted and relinked. Original templates/comments/names are not recovered.
 */
var e = [],
  t = [];
(() => {
  let n =
    `lc,34,7n,7,7b,19,,,,2,,2,,,20,b,1c,l,g,,2t,7,2,6,2,2,,4,z,,u,r,2j,b,1m,9,9,,o,4,,9,,3,,5,17,3,3b,f,,w,1j,,,,4,8,4,,3,7,a,2,t,,1m,,,,2,4,8,,9,,a,2,q,,2,2,1l,,4,2,4,2,2,3,3,,u,2,3,,b,2,1l,,4,5,,2,4,,k,2,m,6,,,1m,,,2,,4,8,,7,3,a,2,u,,1n,,,,c,,9,,14,,3,,1l,3,5,3,,4,7,2,b,2,t,,1m,,2,,2,,3,,5,2,7,2,b,2,s,2,1l,2,,,2,4,8,,9,,a,2,t,,20,,4,,2,3,,,8,,29,,2,7,c,8,2q,,2,9,b,6,22,2,r,,,,,,1j,e,,5,,2,5,b,,10,9,,2u,4,,6,,2,2,2,p,2,4,3,g,4,d,,2,2,6,,f,,jj,3,qa,3,t,3,t,2,u,2,1s,2,,7,8,,2,b,9,,19,3,3b,2,y,,3a,3,4,2,9,,6,3,63,2,2,,1m,,,7,,,,,2,8,6,a,2,,1c,h,1r,4,1c,7,,,5,,14,9,c,2,w,4,2,2,,3,1k,,,2,3,,,3,1m,8,2,2,48,3,,d,,7,4,,6,,3,2,5i,1m,,5,ek,,5f,x,2da,3,3x,,2o,w,fe,6,2x,2,n9w,4,,a,w,2,28,2,7k,,3,,4,,p,2,5,,47,2,q,i,d,,12,8,p,b,1a,3,1c,,2,4,2,2,13,,1v,6,2,2,2,2,c,,8,,1b,,1f,,,3,2,2,5,2,,,16,2,8,,6m,,2,,4,,fn4,,kh,g,g,g,a6,2,gt,,6a,,45,5,1ae,3,,2,5,4,14,3,4,,4l,2,fx,4,ar,2,49,b,4w,,1i,f,1k,3,1d,4,2,2,1x,3,10,5,,8,1q,,c,2,1g,9,a,4,2,,2n,3,2,,,2,6,,4g,,3,8,l,2,1l,2,,,,,m,,e,7,3,5,5f,8,2,3,,,n,,29,,2,6,,,2,,,2,,2,6j,,2,4,6,2,,2,r,2,2d,8,2,,,2,2y,,,,2,6,,,2t,3,2,4,,5,77,9,,2,6t,,a,2,,,4,,40,4,2,2,4,,w,a,14,6,2,4,8,,9,6,2,3,1a,d,,2,ba,7,,6,,,2a,m,2,7,,2,,2,3e,6,3,,,2,,7,,,20,2,3,,,,9n,2,f0b,5,1n,7,t4,,1r,4,29,,f5k,2,43q,,,3,4,5,8,8,2,7,u,4,44,3,1iz,1j,4,1e,8,,e,,m,5,,f,11s,7,,h,2,7,,2,,5,79,7,c5,4,15s,7,31,7,240,5,gx7k,2o,3k,6o`
      .split(`,`)
      .map((e) => (e ? parseInt(e, 36) : 1));
  for (let r = 0, i = 0; r < n.length; r++) (r % 2 ? t : e).push((i += n[r]));
})();
function n(n) {
  if (n < 768) return !1;
  for (let r = 0, i = e.length; ;) {
    let a = (r + i) >> 1;
    if (n < e[a]) i = a;
    else if (n >= t[a]) r = a + 1;
    else return !0;
    if (r == i) return !1;
  }
}
function r(e) {
  return e >= 127462 && e <= 127487;
}
var i = 8205;
function a(e, t, n = !0, r = !0) {
  return (n ? o : s)(e, t, r);
}
function o(e, t, a) {
  if (t == e.length) return t;
  t && l(e.charCodeAt(t)) && u(e.charCodeAt(t - 1)) && t--;
  let o = c(e, t);
  for (t += d(o); t < e.length;) {
    let s = c(e, t);
    if (o == i || s == i || (a && n(s))) ((t += d(s)), (o = s));
    else if (r(s)) {
      let n = 0,
        i = t - 2;
      for (; i >= 0 && r(c(e, i));) (n++, (i -= 2));
      if (n % 2 == 0) break;
      t += 2;
    } else break;
  }
  return t;
}
function s(e, t, n) {
  for (; t > 0;) {
    let r = o(e, t - 2, n);
    if (r < t) return r;
    t--;
  }
  return 0;
}
function c(e, t) {
  let n = e.charCodeAt(t);
  if (!u(n) || t + 1 == e.length) return n;
  let r = e.charCodeAt(t + 1);
  return l(r) ? ((n - 55296) << 10) + (r - 56320) + 65536 : n;
}
function l(e) {
  return e >= 56320 && e < 57344;
}
function u(e) {
  return e >= 55296 && e < 56320;
}
function d(e) {
  return e < 65536 ? 1 : 2;
}
var f = class e {
    lineAt(e) {
      if (e < 0 || e > this.length)
        throw RangeError(`Invalid position ${e} in document of length ${this.length}`);
      return this.lineInner(e, !1, 1, 0);
    }
    line(e) {
      if (e < 1 || e > this.lines)
        throw RangeError(`Invalid line number ${e} in ${this.lines}-line document`);
      return this.lineInner(e, !0, 1, 0);
    }
    replace(e, t, n) {
      [e, t] = x(this, e, t);
      let r = [];
      return (
        this.decompose(0, e, r, 2),
        n.length && n.decompose(0, n.length, r, 3),
        this.decompose(t, this.length, r, 1),
        m.from(r, this.length - (t - e) + n.length)
      );
    }
    append(e) {
      return this.replace(this.length, this.length, e);
    }
    slice(e, t = this.length) {
      [e, t] = x(this, e, t);
      let n = [];
      return (this.decompose(e, t, n, 0), m.from(n, t - e));
    }
    eq(e) {
      if (e == this) return !0;
      if (e.length != this.length || e.lines != this.lines) return !1;
      let t = this.scanIdentical(e, 1),
        n = this.length - this.scanIdentical(e, -1),
        r = new v(this),
        i = new v(e);
      for (let e = t, a = t; ;) {
        if (
          (r.next(e),
          i.next(e),
          (e = 0),
          r.lineBreak != i.lineBreak || r.done != i.done || r.value != i.value)
        )
          return !1;
        if (((a += r.value.length), r.done || a >= n)) return !0;
      }
    }
    iter(e = 1) {
      return new v(this, e);
    }
    iterRange(e, t = this.length) {
      return new y(this, e, t);
    }
    iterLines(e, t) {
      let n;
      if (e == null) n = this.iter();
      else {
        t ??= this.lines + 1;
        let r = this.line(e).from;
        n = this.iterRange(
          r,
          Math.max(r, t == this.lines + 1 ? this.length : t <= 1 ? 0 : this.line(t - 1).to),
        );
      }
      return new ee(n);
    }
    toString() {
      return this.sliceString(0);
    }
    toJSON() {
      let e = [];
      return (this.flatten(e), e);
    }
    constructor() {}
    static of(t) {
      if (t.length == 0) throw RangeError(`A document must have at least one line`);
      return t.length == 1 && !t[0] ? e.empty : t.length <= 32 ? new p(t) : m.from(p.split(t, []));
    }
  },
  p = class e extends f {
    constructor(e, t = h(e)) {
      (super(), (this.text = e), (this.length = t));
    }
    get lines() {
      return this.text.length;
    }
    get children() {
      return null;
    }
    lineInner(e, t, n, r) {
      for (let i = 0; ; i++) {
        let a = this.text[i],
          o = r + a.length;
        if ((t ? n : o) >= e) return new b(r, o, n, a);
        ((r = o + 1), n++);
      }
    }
    decompose(t, n, r, i) {
      let a =
        t <= 0 && n >= this.length
          ? this
          : new e(_(this.text, t, n), Math.min(n, this.length) - Math.max(0, t));
      if (i & 1) {
        let t = r.pop(),
          n = g(a.text, t.text.slice(), 0, a.length);
        if (n.length <= 32) r.push(new e(n, t.length + a.length));
        else {
          let t = n.length >> 1;
          r.push(new e(n.slice(0, t)), new e(n.slice(t)));
        }
      } else r.push(a);
    }
    replace(t, n, r) {
      if (!(r instanceof e)) return super.replace(t, n, r);
      [t, n] = x(this, t, n);
      let i = g(this.text, g(r.text, _(this.text, 0, t)), n),
        a = this.length + r.length - (n - t);
      return i.length <= 32 ? new e(i, a) : m.from(e.split(i, []), a);
    }
    sliceString(
      e,
      t = this.length,
      n = `
`,
    ) {
      [e, t] = x(this, e, t);
      let r = ``;
      for (let i = 0, a = 0; i <= t && a < this.text.length; a++) {
        let o = this.text[a],
          s = i + o.length;
        (i > e && a && (r += n),
          e < s && t > i && (r += o.slice(Math.max(0, e - i), t - i)),
          (i = s + 1));
      }
      return r;
    }
    flatten(e) {
      for (let t of this.text) e.push(t);
    }
    scanIdentical() {
      return 0;
    }
    static split(t, n) {
      let r = [],
        i = -1;
      for (let a of t)
        (r.push(a),
          (i += a.length + 1),
          r.length == 32 && (n.push(new e(r, i)), (r = []), (i = -1)));
      return (i > -1 && n.push(new e(r, i)), n);
    }
  },
  m = class e extends f {
    constructor(e, t) {
      (super(), (this.children = e), (this.length = t), (this.lines = 0));
      for (let t of e) this.lines += t.lines;
    }
    lineInner(e, t, n, r) {
      for (let i = 0; ; i++) {
        let a = this.children[i],
          o = r + a.length,
          s = n + a.lines - 1;
        if ((t ? s : o) >= e) return a.lineInner(e, t, n, r);
        ((r = o + 1), (n = s + 1));
      }
    }
    decompose(e, t, n, r) {
      for (let i = 0, a = 0; a <= t && i < this.children.length; i++) {
        let o = this.children[i],
          s = a + o.length;
        if (e <= s && t >= a) {
          let i = r & ((a <= e) | (s >= t ? 2 : 0));
          a >= e && s <= t && !i ? n.push(o) : o.decompose(e - a, t - a, n, i);
        }
        a = s + 1;
      }
    }
    replace(t, n, r) {
      if ((([t, n] = x(this, t, n)), r.lines < this.lines))
        for (let i = 0, a = 0; i < this.children.length; i++) {
          let o = this.children[i],
            s = a + o.length;
          if (t >= a && n <= s) {
            let c = o.replace(t - a, n - a, r),
              l = this.lines - o.lines + c.lines;
            if (c.lines < l >> 4 && c.lines > l >> 6) {
              let a = this.children.slice();
              return ((a[i] = c), new e(a, this.length - (n - t) + r.length));
            }
            return super.replace(a, s, c);
          }
          a = s + 1;
        }
      return super.replace(t, n, r);
    }
    sliceString(
      e,
      t = this.length,
      n = `
`,
    ) {
      [e, t] = x(this, e, t);
      let r = ``;
      for (let i = 0, a = 0; i < this.children.length && a <= t; i++) {
        let o = this.children[i],
          s = a + o.length;
        (a > e && i && (r += n),
          e < s && t > a && (r += o.sliceString(e - a, t - a, n)),
          (a = s + 1));
      }
      return r;
    }
    flatten(e) {
      for (let t of this.children) t.flatten(e);
    }
    scanIdentical(t, n) {
      if (!(t instanceof e)) return 0;
      let r = 0,
        [i, a, o, s] =
          n > 0
            ? [0, 0, this.children.length, t.children.length]
            : [this.children.length - 1, t.children.length - 1, -1, -1];
      for (; ; i += n, a += n) {
        if (i == o || a == s) return r;
        let e = this.children[i],
          c = t.children[a];
        if (e != c) return r + e.scanIdentical(c, n);
        r += e.length + 1;
      }
    }
    static from(t, n = t.reduce((e, t) => e + t.length + 1, -1)) {
      let r = 0;
      for (let e of t) r += e.lines;
      if (r < 32) {
        let e = [];
        for (let n of t) n.flatten(e);
        return new p(e, n);
      }
      let i = Math.max(32, r >> 5),
        a = i << 1,
        o = i >> 1,
        s = [],
        c = 0,
        l = -1,
        u = [];
      function d(t) {
        let n;
        if (t.lines > a && t instanceof e) for (let e of t.children) d(e);
        else
          t.lines > o && (c > o || !c)
            ? (f(), s.push(t))
            : t instanceof p && c && (n = u[u.length - 1]) instanceof p && t.lines + n.lines <= 32
              ? ((c += t.lines),
                (l += t.length + 1),
                (u[u.length - 1] = new p(n.text.concat(t.text), n.length + 1 + t.length)))
              : (c + t.lines > i && f(), (c += t.lines), (l += t.length + 1), u.push(t));
      }
      function f() {
        c != 0 && (s.push(u.length == 1 ? u[0] : e.from(u, l)), (l = -1), (c = u.length = 0));
      }
      for (let e of t) d(e);
      return (f(), s.length == 1 ? s[0] : new e(s, n));
    }
  };
f.empty = new p([``], 0);
function h(e) {
  let t = -1;
  for (let n of e) t += n.length + 1;
  return t;
}
function g(e, t, n = 0, r = 1e9) {
  for (let i = 0, a = 0, o = !0; a < e.length && i <= r; a++) {
    let s = e[a],
      c = i + s.length;
    (c >= n &&
      (c > r && (s = s.slice(0, r - i)),
      i < n && (s = s.slice(n - i)),
      o ? ((t[t.length - 1] += s), (o = !1)) : t.push(s)),
      (i = c + 1));
  }
  return t;
}
function _(e, t, n) {
  return g(e, [``], t, n);
}
var v = class {
    constructor(e, t = 1) {
      ((this.dir = t),
        (this.done = !1),
        (this.lineBreak = !1),
        (this.value = ``),
        (this.nodes = [e]),
        (this.offsets = [t > 0 ? 1 : (e instanceof p ? e.text.length : e.children.length) << 1]));
    }
    nextInner(e, t) {
      for (this.done = this.lineBreak = !1; ;) {
        let n = this.nodes.length - 1,
          r = this.nodes[n],
          i = this.offsets[n],
          a = i >> 1,
          o = r instanceof p ? r.text.length : r.children.length;
        if (a == (t > 0 ? o : 0)) {
          if (n == 0) return ((this.done = !0), (this.value = ``), this);
          (t > 0 && this.offsets[n - 1]++, this.nodes.pop(), this.offsets.pop());
        } else if ((i & 1) == (t > 0 ? 0 : 1)) {
          if (((this.offsets[n] += t), e == 0))
            return (
              (this.lineBreak = !0),
              (this.value = `
`),
              this
            );
          e--;
        } else if (r instanceof p) {
          let i = r.text[a + (t < 0 ? -1 : 0)];
          if (((this.offsets[n] += t), i.length > Math.max(0, e)))
            return (
              (this.value = e == 0 ? i : t > 0 ? i.slice(e) : i.slice(0, i.length - e)),
              this
            );
          e -= i.length;
        } else {
          let i = r.children[a + (t < 0 ? -1 : 0)];
          e > i.length
            ? ((e -= i.length), (this.offsets[n] += t))
            : (t < 0 && this.offsets[n]--,
              this.nodes.push(i),
              this.offsets.push(
                t > 0 ? 1 : (i instanceof p ? i.text.length : i.children.length) << 1,
              ));
        }
      }
    }
    next(e = 0) {
      return (
        e < 0 && (this.nextInner(-e, -this.dir), (e = this.value.length)),
        this.nextInner(e, this.dir)
      );
    }
  },
  y = class {
    constructor(e, t, n) {
      ((this.value = ``),
        (this.done = !1),
        (this.cursor = new v(e, t > n ? -1 : 1)),
        (this.pos = t > n ? e.length : 0),
        (this.from = Math.min(t, n)),
        (this.to = Math.max(t, n)));
    }
    nextInner(e, t) {
      if (t < 0 ? this.pos <= this.from : this.pos >= this.to)
        return ((this.value = ``), (this.done = !0), this);
      e += Math.max(0, t < 0 ? this.pos - this.to : this.from - this.pos);
      let n = t < 0 ? this.pos - this.from : this.to - this.pos;
      (e > n && (e = n), (n -= e));
      let { value: r } = this.cursor.next(e);
      return (
        (this.pos += (r.length + e) * t),
        (this.value = r.length <= n ? r : t < 0 ? r.slice(r.length - n) : r.slice(0, n)),
        (this.done = !this.value),
        this
      );
    }
    next(e = 0) {
      return (
        e < 0
          ? (e = Math.max(e, this.from - this.pos))
          : e > 0 && (e = Math.min(e, this.to - this.pos)),
        this.nextInner(e, this.cursor.dir)
      );
    }
    get lineBreak() {
      return this.cursor.lineBreak && this.value != ``;
    }
  },
  ee = class {
    constructor(e) {
      ((this.inner = e), (this.afterBreak = !0), (this.value = ``), (this.done = !1));
    }
    next(e = 0) {
      let { done: t, lineBreak: n, value: r } = this.inner.next(e);
      return (
        t && this.afterBreak
          ? ((this.value = ``), (this.afterBreak = !1))
          : t
            ? ((this.done = !0), (this.value = ``))
            : n
              ? this.afterBreak
                ? (this.value = ``)
                : ((this.afterBreak = !0), this.next())
              : ((this.value = r), (this.afterBreak = !1)),
        this
      );
    }
    get lineBreak() {
      return !1;
    }
  };
typeof Symbol < `u` &&
  ((f.prototype[Symbol.iterator] = function () {
    return this.iter();
  }),
  (v.prototype[Symbol.iterator] =
    y.prototype[Symbol.iterator] =
    ee.prototype[Symbol.iterator] =
      function () {
        return this;
      }));
var b = class {
  constructor(e, t, n, r) {
    ((this.from = e), (this.to = t), (this.number = n), (this.text = r));
  }
  get length() {
    return this.to - this.from;
  }
};
function x(e, t, n) {
  return ((t = Math.max(0, Math.min(e.length, t))), [t, Math.max(t, Math.min(e.length, n))]);
}
function S(e, t, n = !0, r = !0) {
  return a(e, t, n, r);
}
function te(e) {
  return e >= 56320 && e < 57344;
}
function ne(e) {
  return e >= 55296 && e < 56320;
}
function re(e, t) {
  let n = e.charCodeAt(t);
  if (!ne(n) || t + 1 == e.length) return n;
  let r = e.charCodeAt(t + 1);
  return te(r) ? ((n - 55296) << 10) + (r - 56320) + 65536 : n;
}
function ie(e) {
  return e <= 65535
    ? String.fromCharCode(e)
    : ((e -= 65536), String.fromCharCode((e >> 10) + 55296, (e & 1023) + 56320));
}
function ae(e) {
  return e < 65536 ? 1 : 2;
}
var oe = /\r\n?|\n/,
  C = (function (e) {
    return (
      (e[(e.Simple = 0)] = `Simple`),
      (e[(e.TrackDel = 1)] = `TrackDel`),
      (e[(e.TrackBefore = 2)] = `TrackBefore`),
      (e[(e.TrackAfter = 3)] = `TrackAfter`),
      e
    );
  })((C ||= {})),
  se = class e {
    constructor(e) {
      this.sections = e;
    }
    get length() {
      let e = 0;
      for (let t = 0; t < this.sections.length; t += 2) e += this.sections[t];
      return e;
    }
    get newLength() {
      let e = 0;
      for (let t = 0; t < this.sections.length; t += 2) {
        let n = this.sections[t + 1];
        e += n < 0 ? this.sections[t] : n;
      }
      return e;
    }
    get empty() {
      return this.sections.length == 0 || (this.sections.length == 2 && this.sections[1] < 0);
    }
    iterGaps(e) {
      for (let t = 0, n = 0, r = 0; t < this.sections.length;) {
        let i = this.sections[t++],
          a = this.sections[t++];
        (a < 0 ? (e(n, r, i), (r += i)) : (r += a), (n += i));
      }
    }
    iterChangedRanges(e, t = !1) {
      ue(this, e, t);
    }
    get invertedDesc() {
      let t = [];
      for (let e = 0; e < this.sections.length;) {
        let n = this.sections[e++],
          r = this.sections[e++];
        r < 0 ? t.push(n, r) : t.push(r, n);
      }
      return new e(t);
    }
    composeDesc(e) {
      return this.empty ? e : e.empty ? this : fe(this, e);
    }
    mapDesc(e, t = !1) {
      return e.empty ? this : de(this, e, t);
    }
    mapPos(e, t = -1, n = C.Simple) {
      let r = 0,
        i = 0;
      for (let a = 0; a < this.sections.length;) {
        let o = this.sections[a++],
          s = this.sections[a++],
          c = r + o;
        if (s < 0) {
          if (c > e) return i + (e - r);
          i += o;
        } else {
          if (
            n != C.Simple &&
            c >= e &&
            ((n == C.TrackDel && r < e && c > e) ||
              (n == C.TrackBefore && r < e) ||
              (n == C.TrackAfter && c > e))
          )
            return null;
          if (c > e || (c == e && t < 0 && !o)) return e == r || t < 0 ? i : i + s;
          i += s;
        }
        r = c;
      }
      if (e > r) throw RangeError(`Position ${e} is out of range for changeset of length ${r}`);
      return i;
    }
    touchesRange(e, t = e) {
      for (let n = 0, r = 0; n < this.sections.length && r <= t;) {
        let i = this.sections[n++],
          a = this.sections[n++],
          o = r + i;
        if (a >= 0 && r <= t && o >= e) return r < e && o > t ? `cover` : !0;
        r = o;
      }
      return !1;
    }
    toString() {
      let e = ``;
      for (let t = 0; t < this.sections.length;) {
        let n = this.sections[t++],
          r = this.sections[t++];
        e += (e ? ` ` : ``) + n + (r >= 0 ? `:` + r : ``);
      }
      return e;
    }
    toJSON() {
      return this.sections;
    }
    static fromJSON(t) {
      if (!Array.isArray(t) || t.length % 2 || t.some((e) => typeof e != `number`))
        throw RangeError(`Invalid JSON representation of ChangeDesc`);
      return new e(t);
    }
    static create(t) {
      return new e(t);
    }
  },
  ce = class e extends se {
    constructor(e, t) {
      (super(e), (this.inserted = t));
    }
    apply(e) {
      if (this.length != e.length)
        throw RangeError(`Applying change set to a document with the wrong length`);
      return (ue(this, (t, n, r, i, a) => (e = e.replace(r, r + (n - t), a)), !1), e);
    }
    mapDesc(e, t = !1) {
      return de(this, e, t, !0);
    }
    invert(t) {
      let n = this.sections.slice(),
        r = [];
      for (let e = 0, i = 0; e < n.length; e += 2) {
        let a = n[e],
          o = n[e + 1];
        if (o >= 0) {
          ((n[e] = o), (n[e + 1] = a));
          let s = e >> 1;
          for (; r.length < s;) r.push(f.empty);
          r.push(a ? t.slice(i, i + a) : f.empty);
        }
        i += a;
      }
      return new e(n, r);
    }
    compose(e) {
      return this.empty ? e : e.empty ? this : fe(this, e, !0);
    }
    map(e, t = !1) {
      return e.empty ? this : de(this, e, t, !0);
    }
    iterChanges(e, t = !1) {
      ue(this, e, t);
    }
    get desc() {
      return se.create(this.sections);
    }
    filter(t) {
      let n = [],
        r = [],
        i = [],
        a = new pe(this);
      done: for (let e = 0, o = 0; ;) {
        let s = e == t.length ? 1e9 : t[e++];
        for (; o < s || (o == s && a.len == 0);) {
          if (a.done) break done;
          let e = Math.min(a.len, s - o);
          w(i, e, -1);
          let t = a.ins == -1 ? -1 : a.off == 0 ? a.ins : 0;
          (w(n, e, t), t > 0 && le(r, n, a.text), a.forward(e), (o += e));
        }
        let c = t[e++];
        for (; o < c;) {
          if (a.done) break done;
          let e = Math.min(a.len, c - o);
          (w(n, e, -1), w(i, e, a.ins == -1 ? -1 : a.off == 0 ? a.ins : 0), a.forward(e), (o += e));
        }
      }
      return {
        changes: new e(n, r),
        filtered: se.create(i),
      };
    }
    toJSON() {
      let e = [];
      for (let t = 0; t < this.sections.length; t += 2) {
        let n = this.sections[t],
          r = this.sections[t + 1];
        r < 0
          ? e.push(n)
          : r == 0
            ? e.push([n])
            : e.push([n].concat(this.inserted[t >> 1].toJSON()));
      }
      return e;
    }
    static of(t, n, r) {
      let i = [],
        a = [],
        o = 0,
        s = null;
      function c(t = !1) {
        if (!t && !i.length) return;
        o < n && w(i, n - o, -1);
        let r = new e(i, a);
        ((s = s ? s.compose(r.map(s)) : r), (i = []), (a = []), (o = 0));
      }
      function l(t) {
        if (Array.isArray(t)) for (let e of t) l(e);
        else if (t instanceof e) {
          if (t.length != n)
            throw RangeError(`Mismatched change set length (got ${t.length}, expected ${n})`);
          (c(), (s = s ? s.compose(t.map(s)) : t));
        } else {
          let { from: e, to: s = e, insert: l } = t;
          if (e > s || e < 0 || s > n)
            throw RangeError(`Invalid change range ${e} to ${s} (in doc of length ${n})`);
          let u = l ? (typeof l == `string` ? f.of(l.split(r || oe)) : l) : f.empty,
            d = u.length;
          if (e == s && d == 0) return;
          (e < o && c(), e > o && w(i, e - o, -1), w(i, s - e, d), le(a, i, u), (o = s));
        }
      }
      return (l(t), c(!s), s);
    }
    static empty(t) {
      return new e(t ? [t, -1] : [], []);
    }
    static fromJSON(t) {
      if (!Array.isArray(t)) throw RangeError(`Invalid JSON representation of ChangeSet`);
      let n = [],
        r = [];
      for (let e = 0; e < t.length; e++) {
        let i = t[e];
        if (typeof i == `number`) n.push(i, -1);
        else if (
          !Array.isArray(i) ||
          typeof i[0] != `number` ||
          i.some((e, t) => t && typeof e != `string`)
        )
          throw RangeError(`Invalid JSON representation of ChangeSet`);
        else if (i.length == 1) n.push(i[0], 0);
        else {
          for (; r.length < e;) r.push(f.empty);
          ((r[e] = f.of(i.slice(1))), n.push(i[0], r[e].length));
        }
      }
      return new e(n, r);
    }
    static createSet(t, n) {
      return new e(t, n);
    }
  };
function w(e, t, n, r = !1) {
  if (t == 0 && n <= 0) return;
  let i = e.length - 2;
  i >= 0 && n <= 0 && n == e[i + 1]
    ? (e[i] += t)
    : i >= 0 && t == 0 && e[i] == 0
      ? (e[i + 1] += n)
      : r
        ? ((e[i] += t), (e[i + 1] += n))
        : e.push(t, n);
}
function le(e, t, n) {
  if (n.length == 0) return;
  let r = (t.length - 2) >> 1;
  if (r < e.length) e[e.length - 1] = e[e.length - 1].append(n);
  else {
    for (; e.length < r;) e.push(f.empty);
    e.push(n);
  }
}
function ue(e, t, n) {
  let r = e.inserted;
  for (let i = 0, a = 0, o = 0; o < e.sections.length;) {
    let s = e.sections[o++],
      c = e.sections[o++];
    if (c < 0) ((i += s), (a += s));
    else {
      let l = i,
        u = a,
        d = f.empty;
      for (
        ;
        (l += s),
          (u += c),
          c && r && (d = d.append(r[(o - 2) >> 1])),
          !(n || o == e.sections.length || e.sections[o + 1] < 0);
      )
        ((s = e.sections[o++]), (c = e.sections[o++]));
      (t(i, l, a, u, d), (i = l), (a = u));
    }
  }
}
function de(e, t, n, r = !1) {
  let i = [],
    a = r ? [] : null,
    o = new pe(e),
    s = new pe(t);
  for (let e = -1; ;)
    if ((o.done && s.len) || (s.done && o.len)) throw Error(`Mismatched change set lengths`);
    else if (o.ins == -1 && s.ins == -1) {
      let e = Math.min(o.len, s.len);
      (w(i, e, -1), o.forward(e), s.forward(e));
    } else if (
      s.ins >= 0 &&
      (o.ins < 0 || e == o.i || (o.off == 0 && (s.len < o.len || (s.len == o.len && !n))))
    ) {
      let t = s.len;
      for (w(i, s.ins, -1); t;) {
        let n = Math.min(o.len, t);
        (o.ins >= 0 && e < o.i && o.len <= n && (w(i, 0, o.ins), a && le(a, i, o.text), (e = o.i)),
          o.forward(n),
          (t -= n));
      }
      s.next();
    } else if (o.ins >= 0) {
      let t = 0,
        n = o.len;
      for (; n;)
        if (s.ins == -1) {
          let e = Math.min(n, s.len);
          ((t += e), (n -= e), s.forward(e));
        } else if (s.ins == 0 && s.len < n) ((n -= s.len), s.next());
        else break;
      (w(i, t, e < o.i ? o.ins : 0),
        a && e < o.i && le(a, i, o.text),
        (e = o.i),
        o.forward(o.len - n));
    } else if (o.done && s.done) return a ? ce.createSet(i, a) : se.create(i);
    else throw Error(`Mismatched change set lengths`);
}
function fe(e, t, n = !1) {
  let r = [],
    i = n ? [] : null,
    a = new pe(e),
    o = new pe(t);
  for (let e = !1; ;)
    if (a.done && o.done) return i ? ce.createSet(r, i) : se.create(r);
    else if (a.ins == 0) (w(r, a.len, 0, e), a.next());
    else if (o.len == 0 && !o.done) (w(r, 0, o.ins, e), i && le(i, r, o.text), o.next());
    else if (a.done || o.done) throw Error(`Mismatched change set lengths`);
    else {
      let t = Math.min(a.len2, o.len),
        n = r.length;
      if (a.ins == -1) {
        let n = o.ins == -1 ? -1 : o.off ? 0 : o.ins;
        (w(r, t, n, e), i && n && le(i, r, o.text));
      } else
        o.ins == -1
          ? (w(r, a.off ? 0 : a.len, t, e), i && le(i, r, a.textBit(t)))
          : (w(r, a.off ? 0 : a.len, o.off ? 0 : o.ins, e), i && !o.off && le(i, r, o.text));
      ((e = (a.ins > t || (o.ins >= 0 && o.len > t)) && (e || r.length > n)),
        a.forward2(t),
        o.forward(t));
    }
}
var pe = class {
    constructor(e) {
      ((this.set = e), (this.i = 0), this.next());
    }
    next() {
      let { sections: e } = this.set;
      (this.i < e.length
        ? ((this.len = e[this.i++]), (this.ins = e[this.i++]))
        : ((this.len = 0), (this.ins = -2)),
        (this.off = 0));
    }
    get done() {
      return this.ins == -2;
    }
    get len2() {
      return this.ins < 0 ? this.len : this.ins;
    }
    get text() {
      let { inserted: e } = this.set,
        t = (this.i - 2) >> 1;
      return t >= e.length ? f.empty : e[t];
    }
    textBit(e) {
      let { inserted: t } = this.set,
        n = (this.i - 2) >> 1;
      return n >= t.length && !e
        ? f.empty
        : t[n].slice(this.off, e == null ? void 0 : this.off + e);
    }
    forward(e) {
      e == this.len ? this.next() : ((this.len -= e), (this.off += e));
    }
    forward2(e) {
      this.ins == -1
        ? this.forward(e)
        : e == this.ins
          ? this.next()
          : ((this.ins -= e), (this.off += e));
    }
  },
  me = class e {
    constructor(e, t, n) {
      ((this.from = e), (this.to = t), (this.flags = n));
    }
    get anchor() {
      return this.flags & 32 ? this.to : this.from;
    }
    get head() {
      return this.flags & 32 ? this.from : this.to;
    }
    get empty() {
      return this.from == this.to;
    }
    get assoc() {
      return this.flags & 8 ? -1 : this.flags & 16 ? 1 : 0;
    }
    get bidiLevel() {
      let e = this.flags & 7;
      return e == 7 ? null : e;
    }
    get goalColumn() {
      let e = this.flags >> 6;
      return e == 16777215 ? void 0 : e;
    }
    map(t, n = -1) {
      let r, i;
      return (
        this.empty
          ? (r = i = t.mapPos(this.from, n))
          : ((r = t.mapPos(this.from, 1)), (i = t.mapPos(this.to, -1))),
        r == this.from && i == this.to ? this : new e(r, i, this.flags)
      );
    }
    extend(e, t = e, n = 0) {
      if (e <= this.anchor && t >= this.anchor) return T.range(e, t, void 0, void 0, n);
      let r = Math.abs(e - this.anchor) > Math.abs(t - this.anchor) ? e : t;
      return T.range(this.anchor, r, void 0, void 0, n);
    }
    eq(e, t = !1) {
      return (
        this.anchor == e.anchor &&
        this.head == e.head &&
        this.goalColumn == e.goalColumn &&
        (!t || !this.empty || this.assoc == e.assoc)
      );
    }
    toJSON() {
      return {
        anchor: this.anchor,
        head: this.head,
      };
    }
    static fromJSON(e) {
      if (!e || typeof e.anchor != `number` || typeof e.head != `number`)
        throw RangeError(`Invalid JSON representation for SelectionRange`);
      return T.range(e.anchor, e.head);
    }
    static create(t, n, r) {
      return new e(t, n, r);
    }
  },
  T = class e {
    constructor(e, t) {
      ((this.ranges = e), (this.mainIndex = t));
    }
    map(t, n = -1) {
      return t.empty
        ? this
        : e.create(
            this.ranges.map((e) => e.map(t, n)),
            this.mainIndex,
          );
    }
    eq(e, t = !1) {
      if (this.ranges.length != e.ranges.length || this.mainIndex != e.mainIndex) return !1;
      for (let n = 0; n < this.ranges.length; n++)
        if (!this.ranges[n].eq(e.ranges[n], t)) return !1;
      return !0;
    }
    get main() {
      return this.ranges[this.mainIndex];
    }
    asSingle() {
      return this.ranges.length == 1 ? this : new e([this.main], 0);
    }
    addRange(t, n = !0) {
      return e.create([t].concat(this.ranges), n ? 0 : this.mainIndex + 1);
    }
    replaceRange(t, n = this.mainIndex) {
      let r = this.ranges.slice();
      return ((r[n] = t), e.create(r, this.mainIndex));
    }
    toJSON() {
      return {
        ranges: this.ranges.map((e) => e.toJSON()),
        main: this.mainIndex,
      };
    }
    static fromJSON(t) {
      if (!t || !Array.isArray(t.ranges) || typeof t.main != `number` || t.main >= t.ranges.length)
        throw RangeError(`Invalid JSON representation for EditorSelection`);
      return new e(
        t.ranges.map((e) => me.fromJSON(e)),
        t.main,
      );
    }
    static single(t, n = t) {
      return new e([e.range(t, n)], 0);
    }
    static create(t, n = 0) {
      if (t.length == 0) throw RangeError(`A selection needs at least one range`);
      for (let r = 0, i = 0; i < t.length; i++) {
        let a = t[i];
        if (a.empty ? a.from <= r : a.from < r) return e.normalized(t.slice(), n);
        r = a.to;
      }
      return new e(t, n);
    }
    static cursor(e, t = 0, n, r) {
      return me.create(
        e,
        e,
        (t == 0 ? 0 : t < 0 ? 8 : 16) | (n == null ? 7 : Math.min(6, n)) | ((r ?? 16777215) << 6),
      );
    }
    static range(e, t, n, r, i) {
      let a = ((n ?? 16777215) << 6) | (r == null ? 7 : Math.min(6, r));
      return (
        !i && e != t && (i = t < e ? 1 : -1),
        t < e ? me.create(t, e, 48 | a) : me.create(e, t, (i ? (i < 0 ? 8 : 16) : 0) | a)
      );
    }
    static normalized(t, n = 0) {
      let r = t[n];
      (t.sort((e, t) => e.from - t.from), (n = t.indexOf(r)));
      for (let r = 1; r < t.length; r++) {
        let i = t[r],
          a = t[r - 1];
        if (i.empty ? i.from <= a.to : i.from < a.to) {
          let o = a.from,
            s = Math.max(i.to, a.to);
          (r <= n && n--, t.splice(--r, 2, i.anchor > i.head ? e.range(s, o) : e.range(o, s)));
        }
      }
      return new e(t, n);
    }
  };
function he(e, t) {
  for (let n of e.ranges) if (n.to > t) throw RangeError(`Selection points outside of document`);
}
var ge = 0,
  E = class e {
    constructor(e, t, n, r, i) {
      ((this.combine = e),
        (this.compareInput = t),
        (this.compare = n),
        (this.isStatic = r),
        (this.id = ge++),
        (this.default = e([])),
        (this.extensions = typeof i == `function` ? i(this) : i));
    }
    get reader() {
      return this;
    }
    static define(t = {}) {
      return new e(
        t.combine || ((e) => e),
        t.compareInput || ((e, t) => e === t),
        t.compare || (t.combine ? (e, t) => e === t : _e),
        !!t.static,
        t.enables,
      );
    }
    of(e) {
      return new ve([], this, 0, e);
    }
    compute(e, t) {
      if (this.isStatic) throw Error(`Can't compute a static facet`);
      return new ve(e, this, 1, t);
    }
    computeN(e, t) {
      if (this.isStatic) throw Error(`Can't compute a static facet`);
      return new ve(e, this, 2, t);
    }
    from(e, t) {
      return ((t ||= (e) => e), this.compute([e], (n) => t(n.field(e))));
    }
  };
function _e(e, t) {
  return e == t || (e.length == t.length && e.every((e, n) => e === t[n]));
}
var ve = class {
  constructor(e, t, n, r) {
    ((this.dependencies = e),
      (this.facet = t),
      (this.type = n),
      (this.value = r),
      (this.id = ge++));
  }
  dynamicSlot(e) {
    let t = this.value,
      n = this.facet.compareInput,
      r = this.id,
      i = e[r] >> 1,
      a = this.type == 2,
      o = !1,
      s = !1,
      c = [];
    for (let t of this.dependencies)
      t == `doc` ? (o = !0) : t == `selection` ? (s = !0) : (e[t.id] ?? 1) & 1 || c.push(e[t.id]);
    return {
      create(e) {
        return ((e.values[i] = t(e)), 1);
      },
      update(e, r) {
        if ((o && r.docChanged) || (s && (r.docChanged || r.selection)) || be(e, c)) {
          let r = t(e);
          if (a ? !ye(r, e.values[i], n) : !n(r, e.values[i])) return ((e.values[i] = r), 1);
        }
        return 0;
      },
      reconfigure: (e, o) => {
        let s,
          c = o.config.address[r];
        if (c != null) {
          let r = Ne(o, c);
          if (
            this.dependencies.every((t) =>
              t instanceof E
                ? o.facet(t) === e.facet(t)
                : t instanceof Ce
                  ? o.field(t, !1) == e.field(t, !1)
                  : !0,
            ) ||
            (a ? ye((s = t(e)), r, n) : n((s = t(e)), r))
          )
            return ((e.values[i] = r), 0);
        } else s = t(e);
        return ((e.values[i] = s), 1);
      },
    };
  }
};
function ye(e, t, n) {
  if (e.length != t.length) return !1;
  for (let r = 0; r < e.length; r++) if (!n(e[r], t[r])) return !1;
  return !0;
}
function be(e, t) {
  let n = !1;
  for (let r of t) Me(e, r) & 1 && (n = !0);
  return n;
}
function xe(e, t, n) {
  let r = n.map((t) => e[t.id]),
    i = n.map((e) => e.type),
    a = r.filter((e) => !(e & 1)),
    o = e[t.id] >> 1;
  function s(e) {
    let n = [];
    for (let t = 0; t < r.length; t++) {
      let a = Ne(e, r[t]);
      if (i[t] == 2) for (let e of a) n.push(e);
      else n.push(a);
    }
    return t.combine(n);
  }
  return {
    create(e) {
      for (let t of r) Me(e, t);
      return ((e.values[o] = s(e)), 1);
    },
    update(e, n) {
      if (!be(e, a)) return 0;
      let r = s(e);
      return t.compare(r, e.values[o]) ? 0 : ((e.values[o] = r), 1);
    },
    reconfigure(e, i) {
      let a = be(e, r),
        c = i.config.facets[t.id],
        l = i.facet(t);
      if (c && !a && _e(n, c)) return ((e.values[o] = l), 0);
      let u = s(e);
      return t.compare(u, l) ? ((e.values[o] = l), 0) : ((e.values[o] = u), 1);
    },
  };
}
var Se = E.define({
    static: !0,
  }),
  Ce = class e {
    constructor(e, t, n, r, i) {
      ((this.id = e),
        (this.createF = t),
        (this.updateF = n),
        (this.compareF = r),
        (this.spec = i),
        (this.provides = void 0));
    }
    static define(t) {
      let n = new e(ge++, t.create, t.update, t.compare || ((e, t) => e === t), t);
      return (t.provide && (n.provides = t.provide(n)), n);
    }
    create(e) {
      return (e.facet(Se).find((e) => e.field == this)?.create || this.createF)(e);
    }
    slot(e) {
      let t = e[this.id] >> 1;
      return {
        create: (e) => ((e.values[t] = this.create(e)), 1),
        update: (e, n) => {
          let r = e.values[t],
            i = this.updateF(r, n);
          return this.compareF(r, i) ? 0 : ((e.values[t] = i), 1);
        },
        reconfigure: (e, n) => {
          let r = e.facet(Se),
            i = n.facet(Se),
            a;
          return (a = r.find((e) => e.field == this)) && a != i.find((e) => e.field == this)
            ? ((e.values[t] = a.create(e)), 1)
            : n.config.address[this.id] == null
              ? ((e.values[t] = this.create(e)), 1)
              : ((e.values[t] = n.field(this)), 0);
        },
      };
    }
    init(e) {
      return [
        this,
        Se.of({
          field: this,
          create: e,
        }),
      ];
    }
    get extension() {
      return this;
    }
  },
  we = {
    lowest: 4,
    low: 3,
    default: 2,
    high: 1,
    highest: 0,
  };
function Te(e) {
  return (t) => new De(t, e);
}
var Ee = {
    highest: Te(we.highest),
    high: Te(we.high),
    default: Te(we.default),
    low: Te(we.low),
    lowest: Te(we.lowest),
  },
  De = class {
    constructor(e, t) {
      ((this.inner = e), (this.prec = t));
    }
  },
  Oe = class e {
    of(e) {
      return new ke(this, e);
    }
    reconfigure(t) {
      return e.reconfigure.of({
        compartment: this,
        extension: t,
      });
    }
    get(e) {
      return e.config.compartments.get(this);
    }
  },
  ke = class {
    constructor(e, t) {
      ((this.compartment = e), (this.inner = t));
    }
  },
  Ae = class e {
    constructor(e, t, n, r, i, a) {
      for (
        this.base = e,
          this.compartments = t,
          this.dynamicSlots = n,
          this.address = r,
          this.staticValues = i,
          this.facets = a,
          this.statusTemplate = [];
        this.statusTemplate.length < n.length;
      )
        this.statusTemplate.push(0);
    }
    staticFacet(e) {
      let t = this.address[e.id];
      return t == null ? e.default : this.staticValues[t >> 1];
    }
    static resolve(t, n, r) {
      let i = [],
        a = Object.create(null),
        o = new Map();
      for (let e of je(t, n, o))
        e instanceof Ce ? i.push(e) : (a[e.facet.id] || (a[e.facet.id] = [])).push(e);
      let s = Object.create(null),
        c = [],
        l = [];
      for (let e of i) ((s[e.id] = l.length << 1), l.push((t) => e.slot(t)));
      let u = r?.config.facets;
      for (let e in a) {
        let t = a[e],
          n = t[0].facet,
          i = (u && u[e]) || [];
        if (t.every((e) => e.type == 0)) {
          if (((s[n.id] = (c.length << 1) | 1), _e(i, t))) c.push(r.facet(n));
          else {
            let e = n.combine(t.map((e) => e.value));
            c.push(r && n.compare(e, r.facet(n)) ? r.facet(n) : e);
          }
        } else {
          for (let e of t)
            e.type == 0
              ? ((s[e.id] = (c.length << 1) | 1), c.push(e.value))
              : ((s[e.id] = l.length << 1), l.push((t) => e.dynamicSlot(t)));
          ((s[n.id] = l.length << 1), l.push((e) => xe(e, n, t)));
        }
      }
      return new e(
        t,
        o,
        l.map((e) => e(s)),
        s,
        c,
        a,
      );
    }
  };
function je(e, t, n) {
  let r = [[], [], [], [], []],
    i = new Map();
  function a(e, o) {
    let s = i.get(e);
    if (s != null) {
      if (s <= o) return;
      let t = r[s].indexOf(e);
      (t > -1 && r[s].splice(t, 1), e instanceof ke && n.delete(e.compartment));
    }
    if ((i.set(e, o), Array.isArray(e))) for (let t of e) a(t, o);
    else if (e instanceof ke) {
      if (n.has(e.compartment)) throw RangeError(`Duplicate use of compartment in extensions`);
      let r = t.get(e.compartment) || e.inner;
      (n.set(e.compartment, r), a(r, o));
    } else if (e instanceof De) a(e.inner, e.prec);
    else if (e instanceof Ce) (r[o].push(e), e.provides && a(e.provides, o));
    else if (e instanceof ve)
      (r[o].push(e), e.facet.extensions && a(e.facet.extensions, we.default));
    else {
      let t = e.extension;
      if (!t)
        throw Error(
          `Unrecognized extension value in extension set (${e}). This sometimes happens because multiple instances of @codemirror/state are loaded, breaking instanceof checks.`,
        );
      a(t, o);
    }
  }
  return (a(e, we.default), r.reduce((e, t) => e.concat(t)));
}
function Me(e, t) {
  if (t & 1) return 2;
  let n = t >> 1,
    r = e.status[n];
  if (r == 4) throw Error(`Cyclic dependency between fields and/or facets`);
  if (r & 2) return r;
  e.status[n] = 4;
  let i = e.computeSlot(e, e.config.dynamicSlots[n]);
  return (e.status[n] = 2 | i);
}
function Ne(e, t) {
  return t & 1 ? e.config.staticValues[t >> 1] : e.values[t >> 1];
}
var Pe = E.define(),
  Fe = E.define({
    combine: (e) => e.some((e) => e),
    static: !0,
  }),
  Ie = E.define({
    combine: (e) => (e.length ? e[0] : void 0),
    static: !0,
  }),
  Le = E.define(),
  Re = E.define(),
  ze = E.define(),
  Be = E.define({
    combine: (e) => (e.length ? e[0] : !1),
  }),
  Ve = class {
    constructor(e, t) {
      ((this.type = e), (this.value = t));
    }
    static define() {
      return new He();
    }
  },
  He = class {
    of(e) {
      return new Ve(this, e);
    }
  },
  Ue = class {
    constructor(e) {
      this.map = e;
    }
    of(e) {
      return new D(this, e);
    }
  },
  D = class e {
    constructor(e, t) {
      ((this.type = e), (this.value = t));
    }
    map(t) {
      let n = this.type.map(this.value, t);
      return n === void 0 ? void 0 : n == this.value ? this : new e(this.type, n);
    }
    is(e) {
      return this.type == e;
    }
    static define(e = {}) {
      return new Ue(e.map || ((e) => e));
    }
    static mapEffects(e, t) {
      if (!e.length) return e;
      let n = [];
      for (let r of e) {
        let e = r.map(t);
        e && n.push(e);
      }
      return n;
    }
  };
((D.reconfigure = D.define()), (D.appendConfig = D.define()));
var O = class e {
  constructor(t, n, r, i, a, o) {
    ((this.startState = t),
      (this.changes = n),
      (this.selection = r),
      (this.effects = i),
      (this.annotations = a),
      (this.scrollIntoView = o),
      (this._doc = null),
      (this._state = null),
      r && he(r, n.newLength),
      a.some((t) => t.type == e.time) || (this.annotations = a.concat(e.time.of(Date.now()))));
  }
  static create(t, n, r, i, a, o) {
    return new e(t, n, r, i, a, o);
  }
  get newDoc() {
    return (this._doc ||= this.changes.apply(this.startState.doc));
  }
  get newSelection() {
    return this.selection || this.startState.selection.map(this.changes);
  }
  get state() {
    return (this._state || this.startState.applyTransaction(this), this._state);
  }
  annotation(e) {
    for (let t of this.annotations) if (t.type == e) return t.value;
  }
  get docChanged() {
    return !this.changes.empty;
  }
  get reconfigured() {
    return this.startState.config != this.state.config;
  }
  isUserEvent(t) {
    let n = this.annotation(e.userEvent);
    return !!(
      n &&
      (n == t || (n.length > t.length && n.slice(0, t.length) == t && n[t.length] == `.`))
    );
  }
};
((O.time = Ve.define()),
  (O.userEvent = Ve.define()),
  (O.addToHistory = Ve.define()),
  (O.remote = Ve.define()));
function We(e, t) {
  let n = [];
  for (let r = 0, i = 0; ;) {
    let a, o;
    if (r < e.length && (i == t.length || t[i] >= e[r])) ((a = e[r++]), (o = e[r++]));
    else if (i < t.length) ((a = t[i++]), (o = t[i++]));
    else return n;
    !n.length || n[n.length - 1] < a ? n.push(a, o) : n[n.length - 1] < o && (n[n.length - 1] = o);
  }
}
function Ge(e, t, n) {
  let r, i, a;
  return (
    n
      ? ((r = t.changes), (i = ce.empty(t.changes.length)), (a = e.changes.compose(t.changes)))
      : ((r = t.changes.map(e.changes)),
        (i = e.changes.mapDesc(t.changes, !0)),
        (a = e.changes.compose(r))),
    {
      changes: a,
      selection: t.selection ? t.selection.map(i) : e.selection?.map(r),
      effects: D.mapEffects(e.effects, r).concat(D.mapEffects(t.effects, i)),
      annotations: e.annotations.length ? e.annotations.concat(t.annotations) : t.annotations,
      scrollIntoView: e.scrollIntoView || t.scrollIntoView,
    }
  );
}
function Ke(e, t, n) {
  let r = t.selection,
    i = Ze(t.annotations);
  return (
    t.userEvent && (i = i.concat(O.userEvent.of(t.userEvent))),
    {
      changes: t.changes instanceof ce ? t.changes : ce.of(t.changes || [], n, e.facet(Ie)),
      selection: r && (r instanceof T ? r : T.single(r.anchor, r.head)),
      effects: Ze(t.effects),
      annotations: i,
      scrollIntoView: !!t.scrollIntoView,
    }
  );
}
function qe(e, t, n) {
  let r = Ke(e, t.length ? t[0] : {}, e.doc.length);
  t.length && t[0].filter === !1 && (n = !1);
  for (let i = 1; i < t.length; i++) {
    t[i].filter === !1 && (n = !1);
    let a = !!t[i].sequential;
    r = Ge(r, Ke(e, t[i], a ? r.changes.newLength : e.doc.length), a);
  }
  let i = O.create(e, r.changes, r.selection, r.effects, r.annotations, r.scrollIntoView);
  return Ye(n ? Je(i) : i);
}
function Je(e) {
  let t = e.startState,
    n = !0;
  for (let r of t.facet(Le)) {
    let t = r(e);
    if (t === !1) {
      n = !1;
      break;
    }
    Array.isArray(t) && (n = n === !0 ? t : We(n, t));
  }
  if (n !== !0) {
    let r, i;
    if (n === !1) ((i = e.changes.invertedDesc), (r = ce.empty(t.doc.length)));
    else {
      let t = e.changes.filter(n);
      ((r = t.changes), (i = t.filtered.mapDesc(t.changes).invertedDesc));
    }
    e = O.create(
      t,
      r,
      e.selection && e.selection.map(i),
      D.mapEffects(e.effects, i),
      e.annotations,
      e.scrollIntoView,
    );
  }
  let r = t.facet(Re);
  for (let n = r.length - 1; n >= 0; n--) {
    let i = r[n](e);
    e =
      i instanceof O
        ? i
        : Array.isArray(i) && i.length == 1 && i[0] instanceof O
          ? i[0]
          : qe(t, Ze(i), !1);
  }
  return e;
}
function Ye(e) {
  let t = e.startState,
    n = t.facet(ze),
    r = e;
  for (let i = n.length - 1; i >= 0; i--) {
    let a = n[i](e);
    a && Object.keys(a).length && (r = Ge(r, Ke(t, a, e.changes.newLength), !0));
  }
  return r == e
    ? e
    : O.create(t, e.changes, e.selection, r.effects, r.annotations, r.scrollIntoView);
}
var Xe = [];
function Ze(e) {
  return e == null ? Xe : Array.isArray(e) ? e : [e];
}
var Qe = (function (e) {
    return (
      (e[(e.Word = 0)] = `Word`),
      (e[(e.Space = 1)] = `Space`),
      (e[(e.Other = 2)] = `Other`),
      e
    );
  })((Qe ||= {})),
  $e =
    /[\u00df\u0587\u0590-\u05f4\u0600-\u06ff\u3040-\u309f\u30a0-\u30ff\u3400-\u4db5\u4e00-\u9fcc\uac00-\ud7af]/,
  et;
try {
  et = RegExp(`[\\p{Alphabetic}\\p{Number}_]`, `u`);
} catch {}
function tt(e) {
  if (et) return et.test(e);
  for (let t = 0; t < e.length; t++) {
    let n = e[t];
    if (/\w/.test(n) || (n > `` && (n.toUpperCase() != n.toLowerCase() || $e.test(n)))) return !0;
  }
  return !1;
}
function nt(e) {
  return (t) => {
    if (!/\S/.test(t)) return Qe.Space;
    if (tt(t)) return Qe.Word;
    for (let n = 0; n < e.length; n++) if (t.indexOf(e[n]) > -1) return Qe.Word;
    return Qe.Other;
  };
}
var k = class e {
  constructor(e, t, n, r, i, a) {
    ((this.config = e),
      (this.doc = t),
      (this.selection = n),
      (this.values = r),
      (this.status = e.statusTemplate.slice()),
      (this.computeSlot = i),
      a && (a._state = this));
    for (let e = 0; e < this.config.dynamicSlots.length; e++) Me(this, e << 1);
    this.computeSlot = null;
  }
  field(e, t = !0) {
    let n = this.config.address[e.id];
    if (n == null) {
      if (t) throw RangeError(`Field is not present in this state`);
      return;
    }
    return (Me(this, n), Ne(this, n));
  }
  update(...e) {
    return qe(this, e, !0);
  }
  applyTransaction(t) {
    let n = this.config,
      { base: r, compartments: i } = n;
    for (let e of t.effects)
      e.is(Oe.reconfigure)
        ? ((n &&= ((i = new Map()), n.compartments.forEach((e, t) => i.set(t, e)), null)),
          i.set(e.value.compartment, e.value.extension))
        : e.is(D.reconfigure)
          ? ((n = null), (r = e.value))
          : e.is(D.appendConfig) && ((n = null), (r = Ze(r).concat(e.value)));
    let a;
    n
      ? (a = t.startState.values.slice())
      : ((n = Ae.resolve(r, i, this)),
        (a = new e(
          n,
          this.doc,
          this.selection,
          n.dynamicSlots.map(() => null),
          (e, t) => t.reconfigure(e, this),
          null,
        ).values));
    let o = t.startState.facet(Fe) ? t.newSelection : t.newSelection.asSingle();
    new e(n, t.newDoc, o, a, (e, n) => n.update(e, t), t);
  }
  replaceSelection(e) {
    return (
      typeof e == `string` && (e = this.toText(e)),
      this.changeByRange((t) => ({
        changes: {
          from: t.from,
          to: t.to,
          insert: e,
        },
        range: T.cursor(t.from + e.length),
      }))
    );
  }
  changeByRange(e) {
    let t = this.selection,
      n = e(t.ranges[0]),
      r = this.changes(n.changes),
      i = [n.range],
      a = Ze(n.effects);
    for (let n = 1; n < t.ranges.length; n++) {
      let o = e(t.ranges[n]),
        s = this.changes(o.changes),
        c = s.map(r);
      for (let e = 0; e < n; e++) i[e] = i[e].map(c);
      let l = r.mapDesc(s, !0);
      (i.push(o.range.map(l)),
        (r = r.compose(c)),
        (a = D.mapEffects(a, c).concat(D.mapEffects(Ze(o.effects), l))));
    }
    return {
      changes: r,
      selection: T.create(i, t.mainIndex),
      effects: a,
    };
  }
  changes(t = []) {
    return t instanceof ce ? t : ce.of(t, this.doc.length, this.facet(e.lineSeparator));
  }
  toText(t) {
    return f.of(t.split(this.facet(e.lineSeparator) || oe));
  }
  sliceDoc(e = 0, t = this.doc.length) {
    return this.doc.sliceString(e, t, this.lineBreak);
  }
  facet(e) {
    let t = this.config.address[e.id];
    return t == null ? e.default : (Me(this, t), Ne(this, t));
  }
  toJSON(e) {
    let t = {
      doc: this.sliceDoc(),
      selection: this.selection.toJSON(),
    };
    if (e)
      for (let n in e) {
        let r = e[n];
        r instanceof Ce &&
          this.config.address[r.id] != null &&
          (t[n] = r.spec.toJSON(this.field(e[n]), this));
      }
    return t;
  }
  static fromJSON(t, n = {}, r) {
    if (!t || typeof t.doc != `string`)
      throw RangeError(`Invalid JSON representation for EditorState`);
    let i = [];
    if (r) {
      for (let e in r)
        if (Object.prototype.hasOwnProperty.call(t, e)) {
          let n = r[e],
            a = t[e];
          i.push(n.init((e) => n.spec.fromJSON(a, e)));
        }
    }
    return e.create({
      doc: t.doc,
      selection: T.fromJSON(t.selection),
      extensions: n.extensions ? i.concat([n.extensions]) : i,
    });
  }
  static create(t = {}) {
    let n = Ae.resolve(t.extensions || [], new Map()),
      r =
        t.doc instanceof f
          ? t.doc
          : f.of((t.doc || ``).split(n.staticFacet(e.lineSeparator) || oe)),
      i = t.selection
        ? t.selection instanceof T
          ? t.selection
          : T.single(t.selection.anchor, t.selection.head)
        : T.single(0);
    return (
      he(i, r.length),
      n.staticFacet(Fe) || (i = i.asSingle()),
      new e(
        n,
        r,
        i,
        n.dynamicSlots.map(() => null),
        (e, t) => t.create(e),
        null,
      )
    );
  }
  get tabSize() {
    return this.facet(e.tabSize);
  }
  get lineBreak() {
    return (
      this.facet(e.lineSeparator) ||
      `
`
    );
  }
  get readOnly() {
    return this.facet(Be);
  }
  phrase(t, ...n) {
    for (let n of this.facet(e.phrases))
      if (Object.prototype.hasOwnProperty.call(n, t)) {
        t = n[t];
        break;
      }
    return (
      n.length &&
        (t = t.replace(/\$(\$|\d*)/g, (e, t) => {
          if (t == `$`) return `$`;
          let r = +(t || 1);
          return !r || r > n.length ? e : n[r - 1];
        })),
      t
    );
  }
  languageDataAt(e, t, n = -1) {
    let r = [];
    for (let i of this.facet(Pe))
      for (let a of i(this, t, n)) Object.prototype.hasOwnProperty.call(a, e) && r.push(a[e]);
    return r;
  }
  charCategorizer(e) {
    let t = this.languageDataAt(`wordChars`, e);
    return nt(t.length ? t[0] : ``);
  }
  wordAt(e) {
    let { text: t, from: n, length: r } = this.doc.lineAt(e),
      i = this.charCategorizer(e),
      a = e - n,
      o = e - n;
    for (; a > 0;) {
      let e = S(t, a, !1);
      if (i(t.slice(e, a)) != Qe.Word) break;
      a = e;
    }
    for (; o < r;) {
      let e = S(t, o);
      if (i(t.slice(o, e)) != Qe.Word) break;
      o = e;
    }
    return a == o ? null : T.range(a + n, o + n);
  }
};
((k.allowMultipleSelections = Fe),
  (k.tabSize = E.define({
    combine: (e) => (e.length ? e[0] : 4),
  })),
  (k.lineSeparator = Ie),
  (k.readOnly = Be),
  (k.phrases = E.define({
    compare(e, t) {
      let n = Object.keys(e),
        r = Object.keys(t);
      return n.length == r.length && n.every((n) => e[n] == t[n]);
    },
  })),
  (k.languageData = Pe),
  (k.changeFilter = Le),
  (k.transactionFilter = Re),
  (k.transactionExtender = ze),
  (Oe.reconfigure = D.define()));
function rt(e, t, n = {}) {
  let r = {};
  for (let t of e)
    for (let e of Object.keys(t)) {
      let i = t[e],
        a = r[e];
      if (a === void 0) r[e] = i;
      else if (!(a === i || i === void 0))
        if (Object.hasOwnProperty.call(n, e)) r[e] = n[e](a, i);
        else throw Error(`Config merge conflict for field ` + e);
    }
  for (let e in t) r[e] === void 0 && (r[e] = t[e]);
  return r;
}
var it = class {
  eq(e) {
    return this == e;
  }
  range(e, t = e) {
    return ot.create(e, t, this);
  }
};
((it.prototype.startSide = it.prototype.endSide = 0),
  (it.prototype.point = !1),
  (it.prototype.mapMode = C.TrackDel));
function at(e, t) {
  return e == t || (e.constructor == t.constructor && e.eq(t));
}
var ot = class e {
  constructor(e, t, n) {
    ((this.from = e), (this.to = t), (this.value = n));
  }
  static create(t, n, r) {
    return new e(t, n, r);
  }
};
function st(e, t) {
  return e.from - t.from || e.value.startSide - t.value.startSide;
}
var ct = class e {
    constructor(e, t, n, r) {
      ((this.from = e), (this.to = t), (this.value = n), (this.maxPoint = r));
    }
    get length() {
      return this.to[this.to.length - 1];
    }
    findIndex(e, t, n, r = 0) {
      let i = n ? this.to : this.from;
      for (let a = r, o = i.length; ;) {
        if (a == o) return a;
        let r = (a + o) >> 1,
          s = i[r] - e || (n ? this.value[r].endSide : this.value[r].startSide) - t;
        if (r == a) return s >= 0 ? a : o;
        s >= 0 ? (o = r) : (a = r + 1);
      }
    }
    between(e, t, n, r) {
      for (let i = this.findIndex(t, -1e9, !0), a = this.findIndex(n, 1e9, !1, i); i < a; i++)
        if (r(this.from[i] + e, this.to[i] + e, this.value[i]) === !1) return !1;
    }
    map(t, n) {
      let r = [],
        i = [],
        a = [],
        o = -1,
        s = -1;
      for (let e = 0; e < this.value.length; e++) {
        let c = this.value[e],
          l = this.from[e] + t,
          u = this.to[e] + t,
          d,
          f;
        if (l == u) {
          let e = n.mapPos(l, c.startSide, c.mapMode);
          if (
            e == null ||
            ((d = f = e), c.startSide != c.endSide && ((f = n.mapPos(l, c.endSide)), f < d))
          )
            continue;
        } else if (
          ((d = n.mapPos(l, c.startSide)),
          (f = n.mapPos(u, c.endSide)),
          d > f || (d == f && c.startSide > 0 && c.endSide <= 0))
        )
          continue;
        (f - d || c.endSide - c.startSide) < 0 ||
          (o < 0 && (o = d),
          c.point && (s = Math.max(s, f - d)),
          r.push(c),
          i.push(d - o),
          a.push(f - o));
      }
      return {
        mapped: r.length ? new e(i, a, r, s) : null,
        pos: o,
      };
    }
  },
  A = class e {
    constructor(e, t, n, r) {
      ((this.chunkPos = e), (this.chunk = t), (this.nextLayer = n), (this.maxPoint = r));
    }
    static create(t, n, r, i) {
      return new e(t, n, r, i);
    }
    get length() {
      let e = this.chunk.length - 1;
      return e < 0 ? 0 : Math.max(this.chunkEnd(e), this.nextLayer.length);
    }
    get size() {
      if (this.isEmpty) return 0;
      let e = this.nextLayer.size;
      for (let t of this.chunk) e += t.value.length;
      return e;
    }
    chunkEnd(e) {
      return this.chunkPos[e] + this.chunk[e].length;
    }
    update(t) {
      let { add: n = [], sort: r = !1, filterFrom: i = 0, filterTo: a = this.length } = t,
        o = t.filter;
      if (n.length == 0 && !o) return this;
      if ((r && (n = n.slice().sort(st)), this.isEmpty)) return n.length ? e.of(n) : this;
      let s = new ft(this, null, -1).goto(0),
        c = 0,
        l = [],
        u = new ut();
      for (; s.value || c < n.length;)
        if (c < n.length && (s.from - n[c].from || s.startSide - n[c].value.startSide) >= 0) {
          let e = n[c++];
          u.addInner(e.from, e.to, e.value) || l.push(e);
        } else
          s.rangeIndex == 1 &&
          s.chunkIndex < this.chunk.length &&
          (c == n.length || this.chunkEnd(s.chunkIndex) < n[c].from) &&
          (!o || i > this.chunkEnd(s.chunkIndex) || a < this.chunkPos[s.chunkIndex]) &&
          u.addChunk(this.chunkPos[s.chunkIndex], this.chunk[s.chunkIndex])
            ? s.nextChunk()
            : ((!o || i > s.to || a < s.from || o(s.from, s.to, s.value)) &&
                (u.addInner(s.from, s.to, s.value) || l.push(ot.create(s.from, s.to, s.value))),
              s.next());
      return u.finishInner(
        this.nextLayer.isEmpty && !l.length
          ? e.empty
          : this.nextLayer.update({
              add: l,
              filter: o,
              filterFrom: i,
              filterTo: a,
            }),
      );
    }
    map(t) {
      if (t.empty || this.isEmpty) return this;
      let n = [],
        r = [],
        i = -1;
      for (let e = 0; e < this.chunk.length; e++) {
        let a = this.chunkPos[e],
          o = this.chunk[e],
          s = t.touchesRange(a, a + o.length);
        if (s === !1) ((i = Math.max(i, o.maxPoint)), n.push(o), r.push(t.mapPos(a)));
        else if (s === !0) {
          let { mapped: e, pos: s } = o.map(a, t);
          e && ((i = Math.max(i, e.maxPoint)), n.push(e), r.push(s));
        }
      }
      let a = this.nextLayer.map(t);
      return n.length == 0 ? a : new e(r, n, a || e.empty, i);
    }
    between(e, t, n) {
      if (!this.isEmpty) {
        for (let r = 0; r < this.chunk.length; r++) {
          let i = this.chunkPos[r],
            a = this.chunk[r];
          if (t >= i && e <= i + a.length && a.between(i, e - i, t - i, n) === !1) return;
        }
        this.nextLayer.between(e, t, n);
      }
    }
    iter(e = 0) {
      return pt.from([this]).goto(e);
    }
    get isEmpty() {
      return this.nextLayer == this;
    }
    static iter(e, t = 0) {
      return pt.from(e).goto(t);
    }
    static compare(e, t, n, r, i = -1) {
      let a = e.filter((e) => e.maxPoint > 0 || (!e.isEmpty && e.maxPoint >= i)),
        o = t.filter((e) => e.maxPoint > 0 || (!e.isEmpty && e.maxPoint >= i)),
        s = dt(a, o, n),
        c = new ht(a, s, i),
        l = new ht(o, s, i);
      (n.iterGaps((e, t, n) => gt(c, e, l, t, n, r)),
        n.empty && n.length == 0 && gt(c, 0, l, 0, 0, r));
    }
    static eq(e, t, n = 0, r) {
      r ??= 999999999;
      let i = e.filter((e) => !e.isEmpty && t.indexOf(e) < 0),
        a = t.filter((t) => !t.isEmpty && e.indexOf(t) < 0);
      if (i.length != a.length) return !1;
      if (!i.length) return !0;
      let o = dt(i, a),
        s = new ht(i, o, 0).goto(n),
        c = new ht(a, o, 0).goto(n);
      for (;;) {
        if (
          s.to != c.to ||
          !_t(s.active, c.active) ||
          (s.point && (!c.point || !at(s.point, c.point)))
        )
          return !1;
        if (s.to > r) return !0;
        (s.next(), c.next());
      }
    }
    static spans(e, t, n, r, i = -1) {
      let a = new ht(e, null, i).goto(t),
        o = t,
        s = a.openStart;
      for (;;) {
        let e = Math.min(a.to, n);
        if (a.point) {
          let n = a.activeForPoint(a.to),
            i =
              a.pointFrom < t
                ? n.length + 1
                : a.point.startSide < 0
                  ? n.length
                  : Math.min(n.length, s);
          (r.point(o, e, a.point, n, i, a.pointRank), (s = Math.min(a.openEnd(e), n.length)));
        } else e > o && (r.span(o, e, a.active, s), (s = a.openEnd(e)));
        if (a.to > n) return s + (a.point && a.to > n ? 1 : 0);
        ((o = a.to), a.next());
      }
    }
    static of(e, t = !1) {
      let n = new ut();
      for (let r of e instanceof ot ? [e] : t ? lt(e) : e) n.add(r.from, r.to, r.value);
      return n.finish();
    }
    static join(t) {
      if (!t.length) return e.empty;
      let n = t[t.length - 1];
      for (let r = t.length - 2; r >= 0; r--)
        for (let i = t[r]; i != e.empty; i = i.nextLayer)
          n = new e(i.chunkPos, i.chunk, n, Math.max(i.maxPoint, n.maxPoint));
      return n;
    }
  };
A.empty = new A([], [], null, -1);
function lt(e) {
  if (e.length > 1)
    for (let t = e[0], n = 1; n < e.length; n++) {
      let r = e[n];
      if (st(t, r) > 0) return e.slice().sort(st);
      t = r;
    }
  return e;
}
A.empty.nextLayer = A.empty;
var ut = class e {
  finishChunk(e) {
    (this.chunks.push(new ct(this.from, this.to, this.value, this.maxPoint)),
      this.chunkPos.push(this.chunkStart),
      (this.chunkStart = -1),
      (this.setMaxPoint = Math.max(this.setMaxPoint, this.maxPoint)),
      (this.maxPoint = -1),
      e && ((this.from = []), (this.to = []), (this.value = [])));
  }
  constructor() {
    ((this.chunks = []),
      (this.chunkPos = []),
      (this.chunkStart = -1),
      (this.last = null),
      (this.lastFrom = -1e9),
      (this.lastTo = -1e9),
      (this.from = []),
      (this.to = []),
      (this.value = []),
      (this.maxPoint = -1),
      (this.setMaxPoint = -1),
      (this.nextLayer = null));
  }
  add(t, n, r) {
    this.addInner(t, n, r) || (this.nextLayer ||= new e()).add(t, n, r);
  }
  addInner(e, t, n) {
    let r = e - this.lastTo || n.startSide - this.last.endSide;
    if (r <= 0 && (e - this.lastFrom || n.startSide - this.last.startSide) < 0)
      throw Error("Ranges must be added sorted by `from` position and `startSide`");
    return r < 0
      ? !1
      : (this.from.length == 250 && this.finishChunk(!0),
        this.chunkStart < 0 && (this.chunkStart = e),
        this.from.push(e - this.chunkStart),
        this.to.push(t - this.chunkStart),
        (this.last = n),
        (this.lastFrom = e),
        (this.lastTo = t),
        this.value.push(n),
        n.point && (this.maxPoint = Math.max(this.maxPoint, t - e)),
        !0);
  }
  addChunk(e, t) {
    if ((e - this.lastTo || t.value[0].startSide - this.last.endSide) < 0) return !1;
    (this.from.length && this.finishChunk(!0),
      (this.setMaxPoint = Math.max(this.setMaxPoint, t.maxPoint)),
      this.chunks.push(t),
      this.chunkPos.push(e));
    let n = t.value.length - 1;
    return (
      (this.last = t.value[n]),
      (this.lastFrom = t.from[n] + e),
      (this.lastTo = t.to[n] + e),
      !0
    );
  }
  finish() {
    return this.finishInner(A.empty);
  }
  finishInner(e) {
    if ((this.from.length && this.finishChunk(!1), this.chunks.length == 0)) return e;
    let t = A.create(
      this.chunkPos,
      this.chunks,
      this.nextLayer ? this.nextLayer.finishInner(e) : e,
      this.setMaxPoint,
    );
    return ((this.from = null), t);
  }
};
function dt(e, t, n) {
  let r = new Map();
  for (let t of e)
    for (let e = 0; e < t.chunk.length; e++)
      t.chunk[e].maxPoint <= 0 && r.set(t.chunk[e], t.chunkPos[e]);
  let i = new Set();
  for (let e of t)
    for (let t = 0; t < e.chunk.length; t++) {
      let a = r.get(e.chunk[t]);
      a != null &&
        (n ? n.mapPos(a) : a) == e.chunkPos[t] &&
        !n?.touchesRange(a, a + e.chunk[t].length) &&
        i.add(e.chunk[t]);
    }
  return i;
}
var ft = class {
    constructor(e, t, n, r = 0) {
      ((this.layer = e), (this.skip = t), (this.minPoint = n), (this.rank = r));
    }
    get startSide() {
      return this.value ? this.value.startSide : 0;
    }
    get endSide() {
      return this.value ? this.value.endSide : 0;
    }
    goto(e, t = -1e9) {
      return ((this.chunkIndex = this.rangeIndex = 0), this.gotoInner(e, t, !1), this);
    }
    gotoInner(e, t, n) {
      for (; this.chunkIndex < this.layer.chunk.length;) {
        let t = this.layer.chunk[this.chunkIndex];
        if (!(
          (this.skip && this.skip.has(t)) ||
          this.layer.chunkEnd(this.chunkIndex) < e ||
          t.maxPoint < this.minPoint
        ))
          break;
        (this.chunkIndex++, (n = !1));
      }
      if (this.chunkIndex < this.layer.chunk.length) {
        let r = this.layer.chunk[this.chunkIndex].findIndex(
          e - this.layer.chunkPos[this.chunkIndex],
          t,
          !0,
        );
        (!n || this.rangeIndex < r) && this.setRangeIndex(r);
      }
      this.next();
    }
    forward(e, t) {
      (this.to - e || this.endSide - t) < 0 && this.gotoInner(e, t, !0);
    }
    next() {
      for (;;)
        if (this.chunkIndex == this.layer.chunk.length) {
          ((this.from = this.to = 1e9), (this.value = null));
          break;
        } else {
          let e = this.layer.chunkPos[this.chunkIndex],
            t = this.layer.chunk[this.chunkIndex],
            n = e + t.from[this.rangeIndex];
          if (
            ((this.from = n),
            (this.to = e + t.to[this.rangeIndex]),
            (this.value = t.value[this.rangeIndex]),
            this.setRangeIndex(this.rangeIndex + 1),
            this.minPoint < 0 || (this.value.point && this.to - this.from >= this.minPoint))
          )
            break;
        }
    }
    setRangeIndex(e) {
      if (e == this.layer.chunk[this.chunkIndex].value.length) {
        if ((this.chunkIndex++, this.skip))
          for (
            ;
            this.chunkIndex < this.layer.chunk.length &&
            this.skip.has(this.layer.chunk[this.chunkIndex]);
          )
            this.chunkIndex++;
        this.rangeIndex = 0;
      } else this.rangeIndex = e;
    }
    nextChunk() {
      (this.chunkIndex++, (this.rangeIndex = 0), this.next());
    }
    compare(e) {
      return (
        this.from - e.from ||
        this.startSide - e.startSide ||
        this.rank - e.rank ||
        this.to - e.to ||
        this.endSide - e.endSide
      );
    }
  },
  pt = class e {
    constructor(e) {
      this.heap = e;
    }
    static from(t, n = null, r = -1) {
      let i = [];
      for (let e = 0; e < t.length; e++)
        for (let a = t[e]; !a.isEmpty; a = a.nextLayer)
          a.maxPoint >= r && i.push(new ft(a, n, r, e));
      return i.length == 1 ? i[0] : new e(i);
    }
    get startSide() {
      return this.value ? this.value.startSide : 0;
    }
    goto(e, t = -1e9) {
      for (let n of this.heap) n.goto(e, t);
      for (let e = this.heap.length >> 1; e >= 0; e--) mt(this.heap, e);
      return (this.next(), this);
    }
    forward(e, t) {
      for (let n of this.heap) n.forward(e, t);
      for (let e = this.heap.length >> 1; e >= 0; e--) mt(this.heap, e);
      (this.to - e || this.value.endSide - t) < 0 && this.next();
    }
    next() {
      if (this.heap.length == 0)
        ((this.from = this.to = 1e9), (this.value = null), (this.rank = -1));
      else {
        let e = this.heap[0];
        ((this.from = e.from),
          (this.to = e.to),
          (this.value = e.value),
          (this.rank = e.rank),
          e.value && e.next(),
          mt(this.heap, 0));
      }
    }
  };
function mt(e, t) {
  for (let n = e[t]; ;) {
    let r = (t << 1) + 1;
    if (r >= e.length) break;
    let i = e[r];
    if ((r + 1 < e.length && i.compare(e[r + 1]) >= 0 && ((i = e[r + 1]), r++), n.compare(i) < 0))
      break;
    ((e[r] = n), (e[t] = i), (t = r));
  }
}
var ht = class {
  constructor(e, t, n) {
    ((this.minPoint = n),
      (this.active = []),
      (this.activeTo = []),
      (this.activeRank = []),
      (this.minActive = -1),
      (this.point = null),
      (this.pointFrom = 0),
      (this.pointRank = 0),
      (this.to = -1e9),
      (this.endSide = 0),
      (this.openStart = -1),
      (this.cursor = pt.from(e, t, n)));
  }
  goto(e, t = -1e9) {
    return (
      this.cursor.goto(e, t),
      (this.active.length = this.activeTo.length = this.activeRank.length = 0),
      (this.minActive = -1),
      (this.to = e),
      (this.endSide = t),
      (this.openStart = -1),
      this.next(),
      this
    );
  }
  forward(e, t) {
    for (
      ;
      this.minActive > -1 &&
      (this.activeTo[this.minActive] - e || this.active[this.minActive].endSide - t) < 0;
    )
      this.removeActive(this.minActive);
    this.cursor.forward(e, t);
  }
  removeActive(e) {
    (vt(this.active, e),
      vt(this.activeTo, e),
      vt(this.activeRank, e),
      (this.minActive = bt(this.active, this.activeTo)));
  }
  addActive(e) {
    let t = 0,
      { value: n, to: r, rank: i } = this.cursor;
    for (; t < this.activeRank.length && (i - this.activeRank[t] || r - this.activeTo[t]) > 0;) t++;
    (yt(this.active, t, n),
      yt(this.activeTo, t, r),
      yt(this.activeRank, t, i),
      e && yt(e, t, this.cursor.from),
      (this.minActive = bt(this.active, this.activeTo)));
  }
  next() {
    let e = this.to,
      t = this.point;
    this.point = null;
    let n = this.openStart < 0 ? [] : null;
    for (;;) {
      let r = this.minActive;
      if (
        r > -1 &&
        (this.activeTo[r] - this.cursor.from || this.active[r].endSide - this.cursor.startSide) < 0
      ) {
        if (this.activeTo[r] > e) {
          ((this.to = this.activeTo[r]), (this.endSide = this.active[r].endSide));
          break;
        }
        (this.removeActive(r), n && vt(n, r));
      } else if (!this.cursor.value) {
        this.to = this.endSide = 1e9;
        break;
      } else if (this.cursor.from > e) {
        ((this.to = this.cursor.from), (this.endSide = this.cursor.startSide));
        break;
      } else {
        let e = this.cursor.value;
        if (!e.point) (this.addActive(n), this.cursor.next());
        else if (t && this.cursor.to == this.to && this.cursor.from < this.cursor.to)
          this.cursor.next();
        else {
          ((this.point = e),
            (this.pointFrom = this.cursor.from),
            (this.pointRank = this.cursor.rank),
            (this.to = this.cursor.to),
            (this.endSide = e.endSide),
            this.cursor.next(),
            this.forward(this.to, this.endSide));
          break;
        }
      }
    }
    if (n) {
      this.openStart = 0;
      for (let t = n.length - 1; t >= 0 && n[t] < e; t--) this.openStart++;
    }
  }
  activeForPoint(e) {
    if (!this.active.length) return this.active;
    let t = [];
    for (let n = this.active.length - 1; n >= 0 && !(this.activeRank[n] < this.pointRank); n--)
      (this.activeTo[n] > e ||
        (this.activeTo[n] == e && this.active[n].endSide >= this.point.endSide)) &&
        t.push(this.active[n]);
    return t.reverse();
  }
  openEnd(e) {
    let t = 0;
    for (let n = this.activeTo.length - 1; n >= 0 && this.activeTo[n] > e; n--) t++;
    return t;
  }
};
function gt(e, t, n, r, i, a) {
  (e.goto(t), n.goto(r));
  let o = r + i,
    s = r,
    c = r - t,
    l = !!a.boundChange;
  for (let t = !1; ;) {
    let r = e.to + c - n.to,
      i = r || e.endSide - n.endSide,
      u = i < 0 ? e.to + c : n.to,
      d = Math.min(u, o);
    if (
      (e.point || n.point
        ? ((e.point &&
            n.point &&
            at(e.point, n.point) &&
            _t(e.activeForPoint(e.to), n.activeForPoint(n.to))) ||
            a.comparePoint(s, d, e.point, n.point),
          (t = !1))
        : (t && a.boundChange(s),
          d > s && !_t(e.active, n.active) && a.compareRange(s, d, e.active, n.active),
          l && d < o && (r || e.openEnd(u) != n.openEnd(u)) && (t = !0)),
      u > o)
    )
      break;
    ((s = u), i <= 0 && e.next(), i >= 0 && n.next());
  }
}
function _t(e, t) {
  if (e.length != t.length) return !1;
  for (let n = 0; n < e.length; n++) if (e[n] != t[n] && !at(e[n], t[n])) return !1;
  return !0;
}
function vt(e, t) {
  for (let n = t, r = e.length - 1; n < r; n++) e[n] = e[n + 1];
  e.pop();
}
function yt(e, t, n) {
  for (let n = e.length - 1; n >= t; n--) e[n + 1] = e[n];
  e[t] = n;
}
function bt(e, t) {
  let n = -1,
    r = 1e9;
  for (let i = 0; i < t.length; i++)
    (t[i] - r || e[i].endSide - e[n].endSide) < 0 && ((n = i), (r = t[i]));
  return n;
}
function xt(e, t, n = e.length) {
  let r = 0;
  for (let i = 0; i < n && i < e.length;)
    e.charCodeAt(i) == 9 ? ((r += t - (r % t)), i++) : (r++, (i = S(e, i)));
  return r;
}
function St(e, t, n, r) {
  for (let r = 0, i = 0; ;) {
    if (i >= t) return r;
    if (r == e.length) break;
    ((i += e.charCodeAt(r) == 9 ? n - (i % n) : 1), (r = S(e, r)));
  }
  return r === !0 ? -1 : e.length;
}
for (
  var Ct = `ͼ`,
    wt = typeof Symbol > `u` ? `__ͼ` : Symbol.for(Ct),
    Tt = typeof Symbol > `u` ? `__styleSet` + Math.floor(Math.random() * 1e8) : Symbol(`styleSet`),
    Et = typeof globalThis < `u` ? globalThis : typeof window < `u` ? window : {},
    Dt = class {
      constructor(e, t) {
        this.rules = [];
        let { finish: n } = t || {};
        function r(e) {
          return /^@/.test(e) ? [e] : e.split(/,\s*/);
        }
        function i(e, t, a, o) {
          let s = [],
            c = /^@(\w+)\b/.exec(e[0]),
            l = c && c[1] == `keyframes`;
          if (c && t == null) return a.push(e[0] + `;`);
          for (let n in t) {
            let o = t[n];
            if (/&/.test(n))
              i(
                n
                  .split(/,\s*/)
                  .map((t) => e.map((e) => t.replace(/&/, e)))
                  .reduce((e, t) => e.concat(t)),
                o,
                a,
              );
            else if (o && typeof o == `object`) {
              if (!c)
                throw RangeError(
                  `The value of a property (` + n + `) should be a primitive value.`,
                );
              i(r(n), o, s, l);
            } else
              o != null &&
                s.push(
                  n.replace(/_.*/, ``).replace(/[A-Z]/g, (e) => `-` + e.toLowerCase()) +
                    `: ` +
                    o +
                    `;`,
                );
          }
          (s.length || l) &&
            a.push((n && !c && !o ? e.map(n) : e).join(`, `) + ` {` + s.join(` `) + `}`);
        }
        for (let t in e) i(r(t), e[t], this.rules);
      }
      getRules() {
        return this.rules.join(`
`);
      }
      static newName() {
        let e = Et[wt] || 1;
        return ((Et[wt] = e + 1), Ct + e.toString(36));
      }
      static mount(e, t, n) {
        let r = e[Tt],
          i = n && n.nonce;
        (r ? i && r.setNonce(i) : (r = new kt(e, i)), r.mount(Array.isArray(t) ? t : [t], e));
      }
    },
    Ot = new Map(),
    kt = class {
      constructor(e, t) {
        let n = e.ownerDocument || e,
          r = n.defaultView;
        if (!e.head && e.adoptedStyleSheets && r.CSSStyleSheet) {
          let t = Ot.get(n);
          if (t) return (e[Tt] = t);
          ((this.sheet = new r.CSSStyleSheet()), Ot.set(n, this));
        } else
          ((this.styleTag = n.createElement(`style`)), t && this.styleTag.setAttribute(`nonce`, t));
        ((this.modules = []), (e[Tt] = this));
      }
      mount(e, t) {
        let n = this.sheet,
          r = 0,
          i = 0;
        for (let t = 0; t < e.length; t++) {
          let a = e[t],
            o = this.modules.indexOf(a);
          if ((o < i && o > -1 && (this.modules.splice(o, 1), i--, (o = -1)), o == -1)) {
            if ((this.modules.splice(i++, 0, a), n))
              for (let e = 0; e < a.rules.length; e++) n.insertRule(a.rules[e], r++);
          } else {
            for (; i < o;) r += this.modules[i++].rules.length;
            ((r += a.rules.length), i++);
          }
        }
        if (n)
          t.adoptedStyleSheets.indexOf(this.sheet) < 0 &&
            (t.adoptedStyleSheets = [this.sheet, ...t.adoptedStyleSheets]);
        else {
          let e = ``;
          for (let t = 0; t < this.modules.length; t++)
            e +=
              this.modules[t].getRules() +
              `
`;
          this.styleTag.textContent = e;
          let n = t.head || t;
          this.styleTag.parentNode != n && n.insertBefore(this.styleTag, n.firstChild);
        }
      }
      setNonce(e) {
        this.styleTag &&
          this.styleTag.getAttribute(`nonce`) != e &&
          this.styleTag.setAttribute(`nonce`, e);
      }
    },
    At = {
      8: `Backspace`,
      9: `Tab`,
      10: `Enter`,
      12: `NumLock`,
      13: `Enter`,
      16: `Shift`,
      17: `Control`,
      18: `Alt`,
      20: `CapsLock`,
      27: `Escape`,
      32: ` `,
      33: `PageUp`,
      34: `PageDown`,
      35: `End`,
      36: `Home`,
      37: `ArrowLeft`,
      38: `ArrowUp`,
      39: `ArrowRight`,
      40: `ArrowDown`,
      44: `PrintScreen`,
      45: `Insert`,
      46: `Delete`,
      59: `;`,
      61: `=`,
      91: `Meta`,
      92: `Meta`,
      106: `*`,
      107: `+`,
      108: `,`,
      109: `-`,
      110: `.`,
      111: `/`,
      144: `NumLock`,
      145: `ScrollLock`,
      160: `Shift`,
      161: `Shift`,
      162: `Control`,
      163: `Control`,
      164: `Alt`,
      165: `Alt`,
      173: `-`,
      186: `;`,
      187: `=`,
      188: `,`,
      189: `-`,
      190: `.`,
      191: `/`,
      192: "`",
      219: `[`,
      220: `\\`,
      221: `]`,
      222: `'`,
    },
    jt = {
      48: `)`,
      49: `!`,
      50: `@`,
      51: `#`,
      52: `$`,
      53: `%`,
      54: `^`,
      55: `&`,
      56: `*`,
      57: `(`,
      59: `:`,
      61: `+`,
      173: `_`,
      186: `:`,
      187: `+`,
      188: `<`,
      189: `_`,
      190: `>`,
      191: `?`,
      192: `~`,
      219: `{`,
      220: `|`,
      221: `}`,
      222: `"`,
    },
    Mt = typeof navigator < `u` && /Mac/.test(navigator.platform),
    Nt =
      typeof navigator < `u` &&
      /MSIE \d|Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent),
    j = 0;
  j < 10;
  j++
)
  At[48 + j] = At[96 + j] = String(j);
for (var j = 1; j <= 24; j++) At[j + 111] = `F` + j;
for (var j = 65; j <= 90; j++)
  ((At[j] = String.fromCharCode(j + 32)), (jt[j] = String.fromCharCode(j)));
for (var Pt in At) jt.hasOwnProperty(Pt) || (jt[Pt] = At[Pt]);
function Ft(e) {
  var t =
    (!(
      (Mt && e.metaKey && e.shiftKey && !e.ctrlKey && !e.altKey) ||
      (Nt && e.shiftKey && e.key && e.key.length == 1) ||
      e.key == `Unidentified`
    ) &&
      e.key) ||
    (e.shiftKey ? jt : At)[e.keyCode] ||
    e.key ||
    `Unidentified`;
  return (
    t == `Esc` && (t = `Escape`),
    t == `Del` && (t = `Delete`),
    t == `Left` && (t = `ArrowLeft`),
    t == `Up` && (t = `ArrowUp`),
    t == `Right` && (t = `ArrowRight`),
    t == `Down` && (t = `ArrowDown`),
    t
  );
}
function It() {
  var e = arguments[0];
  typeof e == `string` && (e = document.createElement(e));
  var t = 1,
    n = arguments[1];
  if (n && typeof n == `object` && n.nodeType == null && !Array.isArray(n)) {
    for (var r in n)
      if (Object.prototype.hasOwnProperty.call(n, r)) {
        var i = n[r];
        typeof i == `string` ? e.setAttribute(r, i) : i != null && (e[r] = i);
      }
    t++;
  }
  for (; t < arguments.length; t++) Lt(e, arguments[t]);
  return e;
}
function Lt(e, t) {
  if (typeof t == `string`) e.appendChild(document.createTextNode(t));
  else if (t != null)
    if (t.nodeType != null) e.appendChild(t);
    else if (Array.isArray(t)) for (var n = 0; n < t.length; n++) Lt(e, t[n]);
    else throw RangeError(`Unsupported child node: ` + t);
}
var M =
    typeof navigator < `u`
      ? navigator
      : {
          userAgent: ``,
          vendor: ``,
          platform: ``,
        },
  Rt =
    typeof document < `u`
      ? document
      : {
          documentElement: {
            style: {},
          },
        },
  zt = /Edge\/(\d+)/.exec(M.userAgent),
  Bt = /MSIE \d/.test(M.userAgent),
  Vt = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(M.userAgent),
  Ht = !!(Bt || Vt || zt),
  Ut = !Ht && /gecko\/(\d+)/i.test(M.userAgent),
  Wt = !Ht && /Chrome\/(\d+)/.exec(M.userAgent),
  Gt = `webkitFontSmoothing` in Rt.documentElement.style,
  Kt = !Ht && /Apple Computer/.test(M.vendor),
  qt = Kt && (/Mobile\/\w+/.test(M.userAgent) || M.maxTouchPoints > 2),
  N = {
    mac: qt || /Mac/.test(M.platform),
    windows: /Win/.test(M.platform),
    linux: /Linux|X11/.test(M.platform),
    ie: Ht,
    ie_version: Bt ? Rt.documentMode || 6 : Vt ? +Vt[1] : zt ? +zt[1] : 0,
    gecko: Ut,
    gecko_version: Ut ? +(/Firefox\/(\d+)/.exec(M.userAgent) || [0, 0])[1] : 0,
    chrome: !!Wt,
    chrome_version: Wt ? +Wt[1] : 0,
    ios: qt,
    android: /Android\b/.test(M.userAgent),
    webkit: Gt,
    webkit_version: Gt ? +(/\bAppleWebKit\/(\d+)/.exec(M.userAgent) || [0, 0])[1] : 0,
    safari: Kt,
    safari_version: Kt ? +(/\bVersion\/(\d+(\.\d+)?)/.exec(M.userAgent) || [0, 0])[1] : 0,
    tabSize: Rt.documentElement.style.tabSize == null ? `-moz-tab-size` : `tab-size`,
  };
function Jt(e, t) {
  for (let n in e)
    n == `class` && t.class
      ? (t.class += ` ` + e.class)
      : n == `style` && t.style
        ? (t.style += `;` + e.style)
        : (t[n] = e[n]);
  return t;
}
var Yt = Object.create(null);
function Xt(e, t, n) {
  if (e == t) return !0;
  ((e ||= Yt), (t ||= Yt));
  let r = Object.keys(e),
    i = Object.keys(t);
  if (r.length - (n && r.indexOf(n) > -1 ? 1 : 0) != i.length - (n && i.indexOf(n) > -1 ? 1 : 0))
    return !1;
  for (let a of r) if (a != n && (i.indexOf(a) == -1 || e[a] !== t[a])) return !1;
  return !0;
}
function Zt(e, t) {
  for (let n = e.attributes.length - 1; n >= 0; n--) {
    let r = e.attributes[n].name;
    t[r] ?? e.removeAttribute(r);
  }
  for (let n in t) {
    let r = t[n];
    n == `style` ? (e.style.cssText = r) : e.getAttribute(n) != r && e.setAttribute(n, r);
  }
}
function Qt(e, t, n) {
  let r = !1;
  if (t)
    for (let i in t)
      (n && i in n) || ((r = !0), i == `style` ? (e.style.cssText = ``) : e.removeAttribute(i));
  if (n)
    for (let i in n)
      (t && t[i] == n[i]) ||
        ((r = !0), i == `style` ? (e.style.cssText = n[i]) : e.setAttribute(i, n[i]));
  return r;
}
function $t(e) {
  let t = Object.create(null);
  for (let n = 0; n < e.attributes.length; n++) {
    let r = e.attributes[n];
    t[r.name] = r.value;
  }
  return t;
}
var en = class {
    eq(e) {
      return !1;
    }
    updateDOM(e, t, n) {
      return !1;
    }
    compare(e) {
      return this == e || (this.constructor == e.constructor && this.eq(e));
    }
    get estimatedHeight() {
      return -1;
    }
    get lineBreaks() {
      return 0;
    }
    ignoreEvent(e) {
      return !0;
    }
    coordsAt(e, t, n) {
      return null;
    }
    get isHidden() {
      return !1;
    }
    get editable() {
      return !1;
    }
    destroy(e) {}
  },
  P = (function (e) {
    return (
      (e[(e.Text = 0)] = `Text`),
      (e[(e.WidgetBefore = 1)] = `WidgetBefore`),
      (e[(e.WidgetAfter = 2)] = `WidgetAfter`),
      (e[(e.WidgetRange = 3)] = `WidgetRange`),
      e
    );
  })((P ||= {})),
  F = class extends it {
    constructor(e, t, n, r) {
      (super(), (this.startSide = e), (this.endSide = t), (this.widget = n), (this.spec = r));
    }
    get heightRelevant() {
      return !1;
    }
    static mark(e) {
      return new tn(e);
    }
    static widget(e) {
      let t = Math.max(-1e4, Math.min(1e4, e.side || 0)),
        n = !!e.block;
      return (
        (t += n && !e.inlineOrder ? (t > 0 ? 3e8 : -4e8) : t > 0 ? 1e8 : -1e8),
        new rn(e, t, t, n, e.widget || null, !1)
      );
    }
    static replace(e) {
      let t = !!e.block,
        n,
        r;
      if (e.isBlockGap) ((n = -5e8), (r = 4e8));
      else {
        let { start: i, end: a } = an(e, t);
        ((n = (i ? (t ? -3e8 : -1) : 5e8) - 1), (r = (a ? (t ? 2e8 : 1) : -6e8) + 1));
      }
      return new rn(e, n, r, t, e.widget || null, !0);
    }
    static line(e) {
      return new nn(e);
    }
    static set(e, t = !1) {
      return A.of(e, t);
    }
    hasHeight() {
      return this.widget ? this.widget.estimatedHeight > -1 : !1;
    }
  };
F.none = A.empty;
var tn = class e extends F {
  constructor(e) {
    let { start: t, end: n } = an(e);
    (super(t ? -1 : 5e8, n ? 1 : -6e8, null, e),
      (this.tagName = e.tagName || `span`),
      (this.attrs =
        e.class && e.attributes
          ? Jt(e.attributes, {
              class: e.class,
            })
          : e.class
            ? {
                class: e.class,
              }
            : e.attributes || Yt));
  }
  eq(t) {
    return this == t || (t instanceof e && this.tagName == t.tagName && Xt(this.attrs, t.attrs));
  }
  range(e, t = e) {
    if (e >= t) throw RangeError(`Mark decorations may not be empty`);
    return super.range(e, t);
  }
};
tn.prototype.point = !1;
var nn = class e extends F {
  constructor(e) {
    super(-2e8, -2e8, null, e);
  }
  eq(t) {
    return (
      t instanceof e &&
      this.spec.class == t.spec.class &&
      Xt(this.spec.attributes, t.spec.attributes)
    );
  }
  range(e, t = e) {
    if (t != e) throw RangeError(`Line decoration ranges must be zero-length`);
    return super.range(e, t);
  }
};
((nn.prototype.mapMode = C.TrackBefore), (nn.prototype.point = !0));
var rn = class e extends F {
  constructor(e, t, n, r, i, a) {
    (super(t, n, i, e),
      (this.block = r),
      (this.isReplace = a),
      (this.mapMode = r ? (t <= 0 ? C.TrackBefore : C.TrackAfter) : C.TrackDel));
  }
  get type() {
    return this.startSide == this.endSide
      ? this.startSide <= 0
        ? P.WidgetBefore
        : P.WidgetAfter
      : P.WidgetRange;
  }
  get heightRelevant() {
    return (
      this.block ||
      (!!this.widget && (this.widget.estimatedHeight >= 5 || this.widget.lineBreaks > 0))
    );
  }
  eq(t) {
    return (
      t instanceof e &&
      on(this.widget, t.widget) &&
      this.block == t.block &&
      this.startSide == t.startSide &&
      this.endSide == t.endSide
    );
  }
  range(e, t = e) {
    if (this.isReplace && (e > t || (e == t && this.startSide > 0 && this.endSide <= 0)))
      throw RangeError(`Invalid range for replacement decoration`);
    if (!this.isReplace && t != e)
      throw RangeError(`Widget decorations can only have zero-length ranges`);
    return super.range(e, t);
  }
};
rn.prototype.point = !0;
function an(e, t = !1) {
  let { inclusiveStart: n, inclusiveEnd: r } = e;
  return (
    (n ??= e.inclusive),
    (r ??= e.inclusive),
    {
      start: n ?? t,
      end: r ?? t,
    }
  );
}
function on(e, t) {
  return e == t || !!(e && t && e.compare(t));
}
function sn(e, t, n, r = 0) {
  let i = n.length - 1;
  i >= 0 && n[i] + r >= e ? (n[i] = Math.max(n[i], t)) : n.push(e, t);
}
var cn = class e extends it {
  constructor(e, t, n) {
    (super(), (this.tagName = e), (this.attributes = t), (this.rank = n));
  }
  eq(t) {
    return (
      t == this ||
      (t instanceof e && this.tagName == t.tagName && Xt(this.attributes, t.attributes))
    );
  }
  static create(t) {
    return new e(
      t.tagName,
      t.attributes || Yt,
      t.rank == null ? 50 : Math.max(0, Math.min(t.rank, 100)),
    );
  }
  static set(e, t = !1) {
    return A.of(e, t);
  }
};
cn.prototype.startSide = cn.prototype.endSide = -1;
function ln(e) {
  let t;
  return ((t = e.nodeType == 11 ? (e.getSelection ? e : e.ownerDocument) : e), t.getSelection());
}
function un(e, t) {
  return t ? e == t || e.contains(t.nodeType == 1 ? t : t.parentNode) : !1;
}
function dn(e, t) {
  if (!t.anchorNode) return !1;
  try {
    return un(e, t.anchorNode);
  } catch {
    return !1;
  }
}
function fn(e) {
  return e.nodeType == 3
    ? Dn(e, 0, e.nodeValue.length).getClientRects()
    : e.nodeType == 1
      ? e.getClientRects()
      : [];
}
function pn(e, t, n, r) {
  return n ? gn(e, t, n, r, -1) || gn(e, t, n, r, 1) : !1;
}
function mn(e) {
  for (var t = 0; ; t++) if (((e = e.previousSibling), !e)) return t;
}
function hn(e) {
  return e.nodeType == 1 && /^(DIV|P|LI|UL|OL|BLOCKQUOTE|DD|DT|H\d|SECTION|PRE)$/.test(e.nodeName);
}
function gn(e, t, n, r, i) {
  for (;;) {
    if (e == n && t == r) return !0;
    if (t == (i < 0 ? 0 : _n(e))) {
      if (e.nodeName == `DIV`) return !1;
      let n = e.parentNode;
      if (!n || n.nodeType != 1) return !1;
      ((t = mn(e) + (i < 0 ? 0 : 1)), (e = n));
    } else if (e.nodeType == 1) {
      if (
        ((e = e.childNodes[t + (i < 0 ? -1 : 0)]), e.nodeType == 1 && e.contentEditable == `false`)
      )
        return !1;
      t = i < 0 ? _n(e) : 0;
    } else return !1;
  }
}
function _n(e) {
  return e.nodeType == 3 ? e.nodeValue.length : e.childNodes.length;
}
function vn(e, t) {
  let n = t ? e.left : e.right;
  return {
    left: n,
    right: n,
    top: e.top,
    bottom: e.bottom,
  };
}
function yn(e) {
  let t = e.visualViewport;
  return t
    ? {
        left: 0,
        right: t.width,
        top: 0,
        bottom: t.height,
      }
    : {
        left: 0,
        right: e.innerWidth,
        top: 0,
        bottom: e.innerHeight,
      };
}
function bn(e, t) {
  let n = t.width / e.offsetWidth,
    r = t.height / e.offsetHeight;
  return (
    ((n > 0.995 && n < 1.005) || !isFinite(n) || Math.abs(t.width - e.offsetWidth) < 1) && (n = 1),
    ((r > 0.995 && r < 1.005) || !isFinite(r) || Math.abs(t.height - e.offsetHeight) < 1) &&
      (r = 1),
    {
      scaleX: n,
      scaleY: r,
    }
  );
}
function xn(e, t, n, r, i, a, o, s) {
  let c = e.ownerDocument,
    l = c.defaultView || window;
  for (let u = e, d = !1; u && !d;)
    if (u.nodeType == 1) {
      let e,
        f = u == c.body,
        p = 1,
        m = 1;
      if (f) e = yn(l);
      else {
        if (
          (/^(fixed|sticky)$/.test(getComputedStyle(u).position) && (d = !0),
          u.scrollHeight <= u.clientHeight && u.scrollWidth <= u.clientWidth)
        ) {
          u = u.assignedSlot || u.parentNode;
          continue;
        }
        let t = u.getBoundingClientRect();
        (({ scaleX: p, scaleY: m } = bn(u, t)),
          (e = {
            left: t.left,
            right: t.left + u.clientWidth * p,
            top: t.top,
            bottom: t.top + u.clientHeight * m,
          }));
      }
      let h = 0,
        g = 0;
      if (i == `nearest`)
        t.top < e.top + o
          ? ((g = t.top - (e.top + o)),
            n > 0 && t.bottom > e.bottom + g && (g = t.bottom - e.bottom + o))
          : t.bottom > e.bottom - o &&
            ((g = t.bottom - e.bottom + o),
            n < 0 && t.top - g < e.top && (g = t.top - (e.top + o)));
      else {
        let r = t.bottom - t.top,
          a = e.bottom - e.top;
        g =
          (i == `center` && r <= a
            ? t.top + r / 2 - a / 2
            : i == `start` || (i == `center` && n < 0)
              ? t.top - o
              : t.bottom - a + o) - e.top;
      }
      if (
        (r == `nearest`
          ? t.left < e.left + a
            ? ((h = t.left - (e.left + a)),
              n > 0 && t.right > e.right + h && (h = t.right - e.right + a))
            : t.right > e.right - a &&
              ((h = t.right - e.right + a),
              n < 0 && t.left < e.left + h && (h = t.left - (e.left + a)))
          : (h =
              (r == `center`
                ? t.left + (t.right - t.left) / 2 - (e.right - e.left) / 2
                : (r == `start`) == s
                  ? t.left - a
                  : t.right - (e.right - e.left) + a) - e.left),
        h || g)
      )
        if (f) l.scrollBy(h, g);
        else {
          let e = 0,
            n = 0;
          if (g) {
            let e = u.scrollTop;
            ((u.scrollTop += g / m), (n = (u.scrollTop - e) * m));
          }
          if (h) {
            let t = u.scrollLeft;
            ((u.scrollLeft += h / p), (e = (u.scrollLeft - t) * p));
          }
          ((t = {
            left: t.left - e,
            top: t.top - n,
            right: t.right - e,
            bottom: t.bottom - n,
          }),
            e && Math.abs(e - h) < 1 && (r = `nearest`),
            n && Math.abs(n - g) < 1 && (i = `nearest`));
        }
      if (f) break;
      ((t.top < e.top || t.bottom > e.bottom || t.left < e.left || t.right > e.right) &&
        (t = {
          left: Math.max(t.left, e.left),
          right: Math.min(t.right, e.right),
          top: Math.max(t.top, e.top),
          bottom: Math.min(t.bottom, e.bottom),
        }),
        (u = u.assignedSlot || u.parentNode));
    } else if (u.nodeType == 11) u = u.host;
    else break;
}
function Sn(e, t = !0) {
  let n = e.ownerDocument,
    r = null,
    i = null;
  for (let a = e.parentNode; a && !(a == n.body || ((!t || r) && i));)
    if (a.nodeType == 1)
      (!i && a.scrollHeight > a.clientHeight && (i = a),
        t && !r && a.scrollWidth > a.clientWidth && (r = a),
        (a = a.assignedSlot || a.parentNode));
    else if (a.nodeType == 11) a = a.host;
    else break;
  return {
    x: r,
    y: i,
  };
}
var Cn = class {
    constructor() {
      ((this.anchorNode = null),
        (this.anchorOffset = 0),
        (this.focusNode = null),
        (this.focusOffset = 0));
    }
    eq(e) {
      return (
        this.anchorNode == e.anchorNode &&
        this.anchorOffset == e.anchorOffset &&
        this.focusNode == e.focusNode &&
        this.focusOffset == e.focusOffset
      );
    }
    setRange(e) {
      let { anchorNode: t, focusNode: n } = e;
      this.set(
        t,
        Math.min(e.anchorOffset, t ? _n(t) : 0),
        n,
        Math.min(e.focusOffset, n ? _n(n) : 0),
      );
    }
    set(e, t, n, r) {
      ((this.anchorNode = e),
        (this.anchorOffset = t),
        (this.focusNode = n),
        (this.focusOffset = r));
    }
  },
  wn = null;
N.safari && N.safari_version >= 26 && (wn = !1);
function Tn(e) {
  if (e.setActive) return e.setActive();
  if (wn) return e.focus(wn);
  let t = [];
  for (
    let n = e;
    n && (t.push(n, n.scrollTop, n.scrollLeft), n != n.ownerDocument);
    n = n.parentNode
  );
  if (
    (e.focus(
      wn == null
        ? {
            get preventScroll() {
              return (
                (wn = {
                  preventScroll: !0,
                }),
                !0
              );
            },
          }
        : void 0,
    ),
    !wn)
  ) {
    wn = !1;
    for (let e = 0; e < t.length;) {
      let n = t[e++],
        r = t[e++],
        i = t[e++];
      (n.scrollTop != r && (n.scrollTop = r), n.scrollLeft != i && (n.scrollLeft = i));
    }
  }
}
var En;
function Dn(e, t, n = t) {
  let r = (En ||= document.createRange());
  return (r.setEnd(e, n), r.setStart(e, t), r);
}
function On(e, t, n, r) {
  let i = {
    key: t,
    code: t,
    keyCode: n,
    which: n,
    cancelable: !0,
  };
  r && ({ altKey: i.altKey, ctrlKey: i.ctrlKey, shiftKey: i.shiftKey, metaKey: i.metaKey } = r);
  let a = new KeyboardEvent(`keydown`, i);
  ((a.synthetic = !0), e.dispatchEvent(a));
  let o = new KeyboardEvent(`keyup`, i);
  return ((o.synthetic = !0), e.dispatchEvent(o), a.defaultPrevented || o.defaultPrevented);
}
function kn(e) {
  for (; e;) {
    if (e && (e.nodeType == 9 || (e.nodeType == 11 && e.host))) return e;
    e = e.assignedSlot || e.parentNode;
  }
  return null;
}
function An(e, t) {
  let n = t.focusNode,
    r = t.focusOffset;
  if (!n || t.anchorNode != n || t.anchorOffset != r) return !1;
  for (r = Math.min(r, _n(n)); ;)
    if (r) {
      if (n.nodeType != 1) return !1;
      let e = n.childNodes[r - 1];
      e.contentEditable == `false` ? r-- : ((n = e), (r = _n(n)));
    } else if (n == e) return !0;
    else ((r = mn(n)), (n = n.parentNode));
}
function jn(e) {
  return e instanceof Window
    ? e.pageYOffset > Math.max(0, e.document.documentElement.scrollHeight - e.innerHeight - 4)
    : e.scrollTop > Math.max(1, e.scrollHeight - e.clientHeight - 4);
}
function Mn(e, t) {
  for (let n = e, r = t; ;)
    if (n.nodeType == 3 && r > 0)
      return {
        node: n,
        offset: r,
      };
    else if (n.nodeType == 1 && r > 0) {
      if (n.contentEditable == `false`) return null;
      ((n = n.childNodes[r - 1]), (r = _n(n)));
    } else if (n.parentNode && !hn(n)) ((r = mn(n)), (n = n.parentNode));
    else return null;
}
function Nn(e, t) {
  for (let n = e, r = t; ;)
    if (n.nodeType == 3 && r < n.nodeValue.length)
      return {
        node: n,
        offset: r,
      };
    else if (n.nodeType == 1 && r < n.childNodes.length) {
      if (n.contentEditable == `false`) return null;
      ((n = n.childNodes[r]), (r = 0));
    } else if (n.parentNode && !hn(n)) ((r = mn(n) + 1), (n = n.parentNode));
    else return null;
}
var Pn = class e {
    constructor(e, t, n = !0) {
      ((this.node = e), (this.offset = t), (this.precise = n));
    }
    static before(t, n) {
      return new e(t.parentNode, mn(t), n);
    }
    static after(t, n) {
      return new e(t.parentNode, mn(t) + 1, n);
    }
  },
  I = (function (e) {
    return ((e[(e.LTR = 0)] = `LTR`), (e[(e.RTL = 1)] = `RTL`), e);
  })((I ||= {})),
  Fn = I.LTR,
  In = I.RTL;
function Ln(e) {
  let t = [];
  for (let n = 0; n < e.length; n++) t.push(1 << e[n]);
  return t;
}
var Rn = Ln(
    `88888888888888888888888888888888888666888888787833333333337888888000000000000000000000000008888880000000000000000000000000088888888888888888888888888888888888887866668888088888663380888308888800000000000000000000000800000000000000000000000000000008`,
  ),
  zn = Ln(
    `4444448826627288999999999992222222222222222222222222222222222222222222222229999999999999999999994444444444644222822222222222222222222222222222222222222222222222222222222222222222222222222222222222222222222222222222999999949999999229989999223333333333`,
  ),
  Bn = Object.create(null),
  Vn = [];
for (let e of [`()`, `[]`, `{}`]) {
  let t = e.charCodeAt(0),
    n = e.charCodeAt(1);
  ((Bn[t] = n), (Bn[n] = -t));
}
function Hn(e) {
  return e <= 247
    ? Rn[e]
    : 1424 <= e && e <= 1524
      ? 2
      : 1536 <= e && e <= 1785
        ? zn[e - 1536]
        : 1774 <= e && e <= 2220
          ? 4
          : 8192 <= e && e <= 8204
            ? 256
            : 64336 <= e && e <= 65023
              ? 4
              : 1;
}
var Un = /[\u0590-\u05f4\u0600-\u06ff\u0700-\u08ac\ufb50-\ufdff]/,
  Wn = class {
    get dir() {
      return this.level % 2 ? In : Fn;
    }
    constructor(e, t, n) {
      ((this.from = e), (this.to = t), (this.level = n));
    }
    side(e, t) {
      return (this.dir == t) == e ? this.to : this.from;
    }
    forward(e, t) {
      return e == (this.dir == t);
    }
    static find(e, t, n, r) {
      let i = -1;
      for (let a = 0; a < e.length; a++) {
        let o = e[a];
        if (o.from <= t && o.to >= t) {
          if (o.level == n) return a;
          (i < 0 || (r == 0 ? e[i].level > o.level : r < 0 ? o.from < t : o.to > t)) && (i = a);
        }
      }
      if (i < 0) throw RangeError(`Index out of range`);
      return i;
    }
  };
function Gn(e, t) {
  if (e.length != t.length) return !1;
  for (let n = 0; n < e.length; n++) {
    let r = e[n],
      i = t[n];
    if (r.from != i.from || r.to != i.to || r.direction != i.direction || !Gn(r.inner, i.inner))
      return !1;
  }
  return !0;
}
var L = [];
function Kn(e, t, n, r, i) {
  for (let a = 0; a <= r.length; a++) {
    let o = a ? r[a - 1].to : t,
      s = a < r.length ? r[a].from : n,
      c = a ? 256 : i;
    for (let t = o, n = c, r = c; t < s; t++) {
      let i = Hn(e.charCodeAt(t));
      (i == 512 ? (i = n) : i == 8 && r == 4 && (i = 16),
        (L[t] = i == 4 ? 2 : i),
        i & 7 && (r = i),
        (n = i));
    }
    for (let e = o, t = c, r = c; e < s; e++) {
      let i = L[e];
      if (i == 128) e < s - 1 && t == L[e + 1] && t & 24 ? (i = L[e] = t) : (L[e] = 256);
      else if (i == 64) {
        let i = e + 1;
        for (; i < s && L[i] == 64;) i++;
        let a = (e && t == 8) || (i < n && L[i] == 8) ? (r == 1 ? 1 : 8) : 256;
        for (let t = e; t < i; t++) L[t] = a;
        e = i - 1;
      } else i == 8 && r == 1 && (L[e] = 1);
      ((t = i), i & 7 && (r = i));
    }
  }
}
function qn(e, t, n, r, i) {
  let a = i == 1 ? 2 : 1;
  for (let o = 0, s = 0, c = 0; o <= r.length; o++) {
    let l = o ? r[o - 1].to : t,
      u = o < r.length ? r[o].from : n;
    for (let t = l, n, r, o; t < u; t++)
      if ((r = Bn[(n = e.charCodeAt(t))])) {
        if (r < 0) {
          for (let e = s - 3; e >= 0; e -= 3)
            if (Vn[e + 1] == -r) {
              let n = Vn[e + 2],
                r = n & 2 ? i : n & 4 ? (n & 1 ? a : i) : 0;
              (r && (L[t] = L[Vn[e]] = r), (s = e));
              break;
            }
        } else if (Vn.length == 189) break;
        else ((Vn[s++] = t), (Vn[s++] = n), (Vn[s++] = c));
      } else if ((o = L[t]) == 2 || o == 1) {
        let e = o == i;
        c = +!e;
        for (let t = s - 3; t >= 0; t -= 3) {
          let n = Vn[t + 2];
          if (n & 2) break;
          if (e) Vn[t + 2] |= 2;
          else {
            if (n & 4) break;
            Vn[t + 2] |= 4;
          }
        }
      }
  }
}
function Jn(e, t, n, r) {
  for (let i = 0, a = r; i <= n.length; i++) {
    let o = i ? n[i - 1].to : e,
      s = i < n.length ? n[i].from : t;
    for (let c = o; c < s;) {
      let o = L[c];
      if (o == 256) {
        let o = c + 1;
        for (;;)
          if (o == s) {
            if (i == n.length) break;
            ((o = n[i++].to), (s = i < n.length ? n[i].from : t));
          } else if (L[o] == 256) o++;
          else break;
        let l = a == 1,
          u = l == ((o < t ? L[o] : r) == 1) ? (l ? 1 : 2) : r;
        for (let t = o, r = i, a = r ? n[r - 1].to : e; t > c;)
          (t == a && ((t = n[--r].from), (a = r ? n[r - 1].to : e)), (L[--t] = u));
        c = o;
      } else ((a = o), c++);
    }
  }
}
function Yn(e, t, n, r, i, a, o) {
  let s = r % 2 ? 2 : 1;
  if (r % 2 == i % 2)
    for (let c = t, l = 0; c < n;) {
      let t = !0,
        u = !1;
      if (l == a.length || c < a[l].from) {
        let e = L[c];
        e != s && ((t = !1), (u = e == 16));
      }
      let d = !t && s == 1 ? [] : null,
        f = t ? r : r + 1,
        p = c;
      run: for (;;)
        if (l < a.length && p == a[l].from) {
          if (u) break run;
          let m = a[l];
          if (!t)
            for (let e = m.to, t = l + 1; ;) {
              if (e == n) break run;
              if (t < a.length && a[t].from == e) e = a[t++].to;
              else if (L[e] == s) break run;
              else break;
            }
          (l++,
            d
              ? d.push(m)
              : (m.from > c && o.push(new Wn(c, m.from, f)),
                Xn(e, (m.direction == Fn) == !(f % 2) ? r : r + 1, i, m.inner, m.from, m.to, o),
                (c = m.to)),
            (p = m.to));
        } else if (p == n || (t ? L[p] != s : L[p] == s)) break;
        else p++;
      (d ? Yn(e, c, p, r + 1, i, d, o) : c < p && o.push(new Wn(c, p, f)), (c = p));
    }
  else
    for (let c = n, l = a.length; c > t;) {
      let n = !0,
        u = !1;
      if (!l || c > a[l - 1].to) {
        let e = L[c - 1];
        e != s && ((n = !1), (u = e == 16));
      }
      let d = !n && s == 1 ? [] : null,
        f = n ? r : r + 1,
        p = c;
      run: for (;;)
        if (l && p == a[l - 1].to) {
          if (u) break run;
          let m = a[--l];
          if (!n)
            for (let e = m.from, n = l; ;) {
              if (e == t) break run;
              if (n && a[n - 1].to == e) e = a[--n].from;
              else if (L[e - 1] == s) break run;
              else break;
            }
          (d
            ? d.push(m)
            : (m.to < c && o.push(new Wn(m.to, c, f)),
              Xn(e, (m.direction == Fn) == !(f % 2) ? r : r + 1, i, m.inner, m.from, m.to, o),
              (c = m.from)),
            (p = m.from));
        } else if (p == t || (n ? L[p - 1] != s : L[p - 1] == s)) break;
        else p--;
      (d ? Yn(e, p, c, r + 1, i, d, o) : p < c && o.push(new Wn(p, c, f)), (c = p));
    }
}
function Xn(e, t, n, r, i, a, o) {
  let s = t % 2 ? 2 : 1;
  (Kn(e, i, a, r, s), qn(e, i, a, r, s), Jn(i, a, r, s), Yn(e, i, a, t, n, r, o));
}
function Zn(e, t, n) {
  if (!e) return [new Wn(0, 0, +(t == In))];
  if (t == Fn && !n.length && !Un.test(e)) return Qn(e.length);
  if (n.length) for (; e.length > L.length;) L[L.length] = 256;
  let r = [],
    i = t == Fn ? 0 : 1;
  return (Xn(e, i, i, n, 0, e.length, r), r);
}
function Qn(e) {
  return [new Wn(0, e, 0)];
}
var $n = ``;
function er(e, t, n, r, i) {
  let a = r.head - e.from,
    o = Wn.find(t, a, r.bidiLevel ?? -1, r.assoc),
    s = t[o],
    c = s.side(i, n);
  if (a == c) {
    let e = (o += i ? 1 : -1);
    if (e < 0 || e >= t.length) return null;
    ((s = t[(o = e)]), (a = s.side(!i, n)), (c = s.side(i, n)));
  }
  let l = S(e.text, a, s.forward(i, n));
  ((l < s.from || l > s.to) && (l = c), ($n = e.text.slice(Math.min(a, l), Math.max(a, l))));
  let u = o == (i ? t.length - 1 : 0) ? null : t[o + (i ? 1 : -1)];
  return u && l == c && u.level + +!i < s.level
    ? T.cursor(u.side(!i, n) + e.from, u.forward(i, n) ? 1 : -1, u.level)
    : T.cursor(l + e.from, s.forward(i, n) ? -1 : 1, s.level);
}
function tr(e, t, n) {
  for (let r = t; r < n; r++) {
    let t = Hn(e.charCodeAt(r));
    if (t == 1) return Fn;
    if (t == 2 || t == 4) return In;
  }
  return Fn;
}
var nr = E.define(),
  rr = E.define(),
  ir = E.define(),
  ar = E.define(),
  or = E.define(),
  sr = E.define(),
  cr = E.define(),
  lr = E.define(),
  ur = E.define(),
  dr = E.define({
    combine: (e) => e.some((e) => e),
  }),
  fr = E.define({
    combine: (e) => e.some((e) => e),
  }),
  pr = E.define(),
  mr = class e {
    constructor(e, t, n, r, i, a = !1) {
      ((this.range = e),
        (this.y = t),
        (this.x = n),
        (this.yMargin = r),
        (this.xMargin = i),
        (this.isSnapshot = a));
    }
    map(t) {
      return t.empty
        ? this
        : new e(this.range.map(t), this.y, this.x, this.yMargin, this.xMargin, this.isSnapshot);
    }
    clip(t) {
      return this.range.to <= t.doc.length
        ? this
        : new e(
            T.cursor(t.doc.length),
            this.y,
            this.x,
            this.yMargin,
            this.xMargin,
            this.isSnapshot,
          );
    }
  },
  hr = D.define({
    map: (e, t) => e.map(t),
  }),
  gr = D.define();
function _r(e, t, n) {
  let r = e.facet(ar);
  r.length
    ? r[0](t)
    : (window.onerror && window.onerror(String(t), n, void 0, void 0, t)) ||
      (n ? console.error(n + `:`, t) : console.error(t));
}
var vr = E.define({
    combine: (e) => (e.length ? e[0] : !0),
  }),
  yr = 0,
  br = E.define({
    combine(e) {
      return e.filter((t, n) => {
        for (let r = 0; r < n; r++) if (e[r].plugin == t.plugin) return !1;
        return !0;
      });
    },
  }),
  xr = class e {
    constructor(e, t, n, r, i) {
      ((this.id = e),
        (this.create = t),
        (this.domEventHandlers = n),
        (this.domEventObservers = r),
        (this.baseExtensions = i(this)),
        (this.extension = this.baseExtensions.concat(
          br.of({
            plugin: this,
            arg: void 0,
          }),
        )));
    }
    of(e) {
      return this.baseExtensions.concat(
        br.of({
          plugin: this,
          arg: e,
        }),
      );
    }
    static define(t, n) {
      let { eventHandlers: r, eventObservers: i, provide: a, decorations: o } = n || {};
      return new e(yr++, t, r, i, (e) => {
        let t = [];
        return (
          o &&
            t.push(
              Tr.of((t) => {
                let n = t.plugin(e);
                return n ? o(n) : F.none;
              }),
            ),
          a && t.push(a(e)),
          t
        );
      });
    }
    static fromClass(t, n) {
      return e.define((e, n) => new t(e, n), n);
    }
  },
  Sr = class {
    constructor(e) {
      ((this.spec = e), (this.mustUpdate = null), (this.value = null));
    }
    get plugin() {
      return this.spec && this.spec.plugin;
    }
    update(e) {
      if (!this.value) {
        if (this.spec)
          try {
            this.value = this.spec.plugin.create(e, this.spec.arg);
          } catch (t) {
            (_r(e.state, t, `CodeMirror plugin crashed`), this.deactivate());
          }
      } else if (this.mustUpdate) {
        let e = this.mustUpdate;
        if (((this.mustUpdate = null), this.value.update))
          try {
            this.value.update(e);
          } catch (t) {
            if ((_r(e.state, t, `CodeMirror plugin crashed`), this.value.destroy))
              try {
                this.value.destroy();
              } catch {}
            this.deactivate();
          }
      }
      return this;
    }
    destroy(e) {
      if (this.value?.destroy)
        try {
          this.value.destroy();
        } catch (t) {
          _r(e.state, t, `CodeMirror plugin crashed`);
        }
    }
    deactivate() {
      this.spec = this.value = null;
    }
  },
  Cr = E.define(),
  wr = E.define(),
  Tr = E.define(),
  Er = E.define(),
  Dr = E.define(),
  Or = E.define(),
  kr = E.define();
function Ar(e, t) {
  let n = e.state.facet(kr);
  if (!n.length) return n;
  let r = n.map((t) => (t instanceof Function ? t(e) : t)),
    i = [];
  return (
    A.spans(r, t.from, t.to, {
      point() {},
      span(e, n, r, a) {
        let o = e - t.from,
          s = n - t.from,
          c = i;
        for (let e = r.length - 1; e >= 0; e--, a--) {
          let n = r[e].spec.bidiIsolate,
            i;
          if (
            ((n ??= tr(t.text, o, s)),
            a > 0 && c.length && (i = c[c.length - 1]).to == o && i.direction == n)
          )
            ((i.to = s), (c = i.inner));
          else {
            let e = {
              from: o,
              to: s,
              direction: n,
              inner: [],
            };
            (c.push(e), (c = e.inner));
          }
        }
      },
    }),
    i
  );
}
var jr = E.define();
function Mr(e) {
  let t = 0,
    n = 0,
    r = 0,
    i = 0;
  for (let a of e.state.facet(jr)) {
    let o = a(e);
    o &&
      (o.left != null && (t = Math.max(t, o.left)),
      o.right != null && (n = Math.max(n, o.right)),
      o.top != null && (r = Math.max(r, o.top)),
      o.bottom != null && (i = Math.max(i, o.bottom)));
  }
  return {
    left: t,
    right: n,
    top: r,
    bottom: i,
  };
}
var Nr = E.define(),
  Pr = class e {
    constructor(e, t, n, r) {
      ((this.fromA = e), (this.toA = t), (this.fromB = n), (this.toB = r));
    }
    join(t) {
      return new e(
        Math.min(this.fromA, t.fromA),
        Math.max(this.toA, t.toA),
        Math.min(this.fromB, t.fromB),
        Math.max(this.toB, t.toB),
      );
    }
    addToSet(e) {
      let t = e.length,
        n = this;
      for (; t > 0; t--) {
        let r = e[t - 1];
        if (!(r.fromA > n.toA)) {
          if (r.toA < n.fromA) break;
          ((n = n.join(r)), e.splice(t - 1, 1));
        }
      }
      return (e.splice(t, 0, n), e);
    }
    static extendWithRanges(t, n) {
      if (n.length == 0) return t;
      let r = [];
      for (let i = 0, a = 0, o = 0; ;) {
        let s = i < t.length ? t[i].fromB : 1e9,
          c = a < n.length ? n[a] : 1e9,
          l = Math.min(s, c);
        if (l == 1e9) break;
        let u = l + o,
          d = l,
          f = u;
        for (;;)
          if (a < n.length && n[a] <= d) {
            let e = n[a + 1];
            ((a += 2), (d = Math.max(d, e)));
            for (let e = i; e < t.length && t[e].fromB <= d; e++) o = t[e].toA - t[e].toB;
            f = Math.max(f, e + o);
          } else if (i < t.length && t[i].fromB <= d) {
            let e = t[i++];
            ((d = Math.max(d, e.toB)), (f = Math.max(f, e.toA)), (o = e.toA - e.toB));
          } else break;
        r.push(new e(u, f, l, d));
      }
      return r;
    }
  },
  Fr = class e {
    constructor(e, t, n) {
      ((this.view = e),
        (this.state = t),
        (this.transactions = n),
        (this.flags = 0),
        (this.startState = e.state),
        (this.changes = ce.empty(this.startState.doc.length)));
      for (let e of n) this.changes = this.changes.compose(e.changes);
      let r = [];
      (this.changes.iterChangedRanges((e, t, n, i) => r.push(new Pr(e, t, n, i))),
        (this.changedRanges = r));
    }
    static create(t, n, r) {
      return new e(t, n, r);
    }
    get viewportChanged() {
      return (this.flags & 4) > 0;
    }
    get viewportMoved() {
      return (this.flags & 8) > 0;
    }
    get heightChanged() {
      return (this.flags & 2) > 0;
    }
    get geometryChanged() {
      return this.docChanged || (this.flags & 18) > 0;
    }
    get focusChanged() {
      return (this.flags & 1) > 0;
    }
    get docChanged() {
      return !this.changes.empty;
    }
    get selectionSet() {
      return this.transactions.some((e) => e.selection);
    }
    get empty() {
      return this.flags == 0 && this.transactions.length == 0;
    }
  },
  Ir = [],
  R = class {
    constructor(e, t, n = 0) {
      ((this.dom = e),
        (this.length = t),
        (this.flags = n),
        (this.parent = null),
        (e.cmTile = this));
    }
    get breakAfter() {
      return this.flags & 1;
    }
    get children() {
      return Ir;
    }
    isWidget() {
      return !1;
    }
    get isHidden() {
      return !1;
    }
    isComposite() {
      return !1;
    }
    isLine() {
      return !1;
    }
    isText() {
      return !1;
    }
    isBlock() {
      return !1;
    }
    get domAttrs() {
      return null;
    }
    sync(e) {
      if (((this.flags |= 2), this.flags & 4)) {
        this.flags &= -5;
        let e = this.domAttrs;
        e && Zt(this.dom, e);
      }
    }
    toString() {
      return (
        this.constructor.name +
        (this.children.length ? `(${this.children})` : ``) +
        (this.breakAfter ? `#` : ``)
      );
    }
    destroy() {
      this.parent = null;
    }
    setDOM(e) {
      ((this.dom = e), (e.cmTile = this));
    }
    get posAtStart() {
      return this.parent ? this.parent.posBefore(this) : 0;
    }
    get posAtEnd() {
      return this.posAtStart + this.length;
    }
    posBefore(e, t = this.posAtStart) {
      let n = t;
      for (let t of this.children) {
        if (t == e) return n;
        n += t.length + t.breakAfter;
      }
      throw RangeError(`Invalid child in posBefore`);
    }
    posAfter(e) {
      return this.posBefore(e) + e.length;
    }
    covers(e) {
      return !0;
    }
    coordsIn(e, t) {
      return null;
    }
    domPosFor(e, t) {
      let n = mn(this.dom),
        r = this.length ? e > 0 : t > 0;
      return new Pn(this.parent.dom, n + +!!r, e == 0 || e == this.length);
    }
    markDirty(e) {
      ((this.flags &= -3),
        e && (this.flags |= 4),
        this.parent && this.parent.flags & 2 && this.parent.markDirty(!1));
    }
    get overrideDOMText() {
      return null;
    }
    get root() {
      for (let e = this; e; e = e.parent) if (e instanceof zr) return e;
      return null;
    }
    static get(e) {
      return e.cmTile;
    }
  },
  Lr = class extends R {
    constructor(e) {
      (super(e, 0), (this._children = []));
    }
    isComposite() {
      return !0;
    }
    get children() {
      return this._children;
    }
    get lastChild() {
      return this.children.length ? this.children[this.children.length - 1] : null;
    }
    append(e) {
      (this.children.push(e), (e.parent = this));
    }
    sync(e) {
      if (this.flags & 2) return;
      super.sync(e);
      let t = this.dom,
        n = null,
        r,
        i = e?.node == t ? e : null,
        a = 0;
      for (let o of this.children) {
        if (
          (o.sync(e),
          (a += o.length + o.breakAfter),
          (r = n ? n.nextSibling : t.firstChild),
          i && r != o.dom && (i.written = !0),
          o.dom.parentNode == t)
        )
          for (; r && r != o.dom;) r = Rr(r);
        else t.insertBefore(o.dom, r);
        n = o.dom;
      }
      for (r = n ? n.nextSibling : t.firstChild, i && r && (i.written = !0); r;) r = Rr(r);
      this.length = a;
    }
  };
function Rr(e) {
  let t = e.nextSibling;
  return (e.parentNode.removeChild(e), t);
}
var zr = class extends Lr {
    constructor(e, t) {
      (super(t), (this.view = e));
    }
    owns(e) {
      for (; e; e = e.parent) if (e == this) return !0;
      return !1;
    }
    isBlock() {
      return !0;
    }
    nearest(e) {
      for (;;) {
        if (!e) return null;
        let t = R.get(e);
        if (t && this.owns(t)) return t;
        e = e.parentNode;
      }
    }
    blockTiles(e) {
      for (let t = [], n = this, r = 0, i = 0; ;)
        if (r == n.children.length) {
          if (!t.length) return;
          ((n = n.parent), n.breakAfter && i++, (r = t.pop()));
        } else {
          let a = n.children[r++];
          if (a instanceof Br) (t.push(r), (n = a), (r = 0));
          else {
            let t = i + a.length,
              n = e(a, i);
            if (n !== void 0) return n;
            i = t + a.breakAfter;
          }
        }
    }
    resolveBlock(e, t) {
      let n,
        r = -1,
        i,
        a = -1;
      if (
        (this.blockTiles((o, s) => {
          let c = s + o.length;
          if (e >= s && e <= c) {
            if (o.isWidget() && t >= -1 && t <= 1) {
              if (o.flags & 32) return !0;
              o.flags & 16 && (n = void 0);
            }
            ((s < e || (e == c && (t < -1 ? o.length : o.covers(1)))) &&
              (!n || (!o.isWidget() && n.isWidget())) &&
              ((n = o), (r = e - s)),
              (c > e || (e == s && (t > 1 ? o.length : o.covers(-1)))) &&
                (!i || (!o.isWidget() && i.isWidget())) &&
                ((i = o), (a = e - s)));
          }
        }),
        !n && !i)
      )
        throw Error(`No tile at position ` + e);
      return (n && t < 0) || !i
        ? {
            tile: n,
            offset: r,
          }
        : {
            tile: i,
            offset: a,
          };
    }
  },
  Br = class e extends Lr {
    constructor(e, t) {
      (super(e), (this.wrapper = t));
    }
    isBlock() {
      return !0;
    }
    covers(e) {
      return this.children.length
        ? e < 0
          ? this.children[0].covers(-1)
          : this.lastChild.covers(1)
        : !1;
    }
    get domAttrs() {
      return this.wrapper.attributes;
    }
    static of(t, n) {
      let r = new e(n || document.createElement(t.tagName), t);
      return (n || (r.flags |= 4), r);
    }
  },
  Vr = class e extends Lr {
    constructor(e, t) {
      (super(e), (this.attrs = t));
    }
    isLine() {
      return !0;
    }
    static start(t, n, r) {
      let i = new e(n || document.createElement(`div`), t);
      return ((!n || !r) && (i.flags |= 4), i);
    }
    get domAttrs() {
      return this.attrs;
    }
    resolveInline(e, t, n) {
      let r = null,
        i = -1,
        a = null,
        o = -1;
      function s(e, c) {
        for (let l = 0, u = 0; l < e.children.length && u <= c; l++) {
          let d = e.children[l],
            f = u + d.length;
          (f >= c &&
            (d.isComposite()
              ? s(d, c - u)
              : (!a || (a.isHidden && (t > 0 || (n && Ur(a, d))))) && (f > c || d.flags & 32)
                ? ((a = d), (o = c - u))
                : (u < c || (d.flags & 16 && !d.isHidden)) && ((r = d), (i = c - u))),
            (u = f));
        }
      }
      s(this, e);
      let c = (t < 0 ? r : a) || r || a;
      return c
        ? {
            tile: c,
            offset: c == r ? i : o,
          }
        : null;
    }
    coordsIn(e, t) {
      let n = this.resolveInline(e, t, !0);
      return n ? n.tile.coordsIn(Math.max(0, n.offset), t) : Hr(this);
    }
    domIn(e, t) {
      let n = this.resolveInline(e, t);
      if (n) {
        let { tile: e, offset: r } = n;
        if (this.dom.contains(e.dom))
          return e.isText()
            ? new Pn(e.dom, Math.min(e.dom.nodeValue.length, r))
            : e.domPosFor(r, e.flags & 16 ? 1 : e.flags & 32 ? -1 : t);
        let i = n.tile.parent,
          a = !1;
        for (let e of i.children) {
          if (a) return new Pn(e.dom, 0);
          e == n.tile && (a = !0);
        }
      }
      return new Pn(this.dom, 0);
    }
  };
function Hr(e) {
  let t = e.dom.lastChild;
  if (!t) return e.dom.getBoundingClientRect();
  let n = fn(t);
  return n[n.length - 1] || null;
}
function Ur(e, t) {
  let n = e.coordsIn(0, 1),
    r = t.coordsIn(0, 1);
  return n && r && r.top < n.bottom;
}
var z = class e extends Lr {
    constructor(e, t) {
      (super(e), (this.mark = t));
    }
    get domAttrs() {
      return this.mark.attrs;
    }
    static of(t, n) {
      let r = new e(n || document.createElement(t.tagName), t);
      return (n || (r.flags |= 4), r);
    }
  },
  Wr = class e extends R {
    constructor(e, t) {
      (super(e, t.length), (this.text = t));
    }
    sync(e) {
      this.flags & 2 ||
        (super.sync(e),
        this.dom.nodeValue != this.text &&
          (e && e.node == this.dom && (e.written = !0), (this.dom.nodeValue = this.text)));
    }
    isText() {
      return !0;
    }
    toString() {
      return JSON.stringify(this.text);
    }
    coordsIn(e, t) {
      let n = this.dom.nodeValue.length;
      e > n && (e = n);
      let r = e,
        i = e,
        a = 0;
      (e == 0 && t < 0) || (e == n && t >= 0)
        ? N.chrome || N.gecko || (e ? (r--, (a = 1)) : i < n && (i++, (a = -1)))
        : t < 0
          ? r--
          : i < n && i++;
      let o = Dn(this.dom, r, i).getClientRects();
      if (!o.length) return null;
      let s = o[(a ? a < 0 : t >= 0) ? 0 : o.length - 1];
      return (
        N.safari && !a && s.width == 0 && (s = Array.prototype.find.call(o, (e) => e.width) || s),
        a ? vn(s, a < 0) : s || null
      );
    }
    static of(t, n) {
      let r = new e(n || document.createTextNode(t), t);
      return (n || (r.flags |= 2), r);
    }
  },
  Gr = class e extends R {
    constructor(e, t, n, r) {
      (super(e, t, r), (this.widget = n));
    }
    isWidget() {
      return !0;
    }
    get isHidden() {
      return this.widget.isHidden;
    }
    covers(e) {
      return this.flags & 48 ? !1 : (this.flags & (e < 0 ? 64 : 128)) > 0;
    }
    coordsIn(e, t) {
      return this.coordsInWidget(e, t, !1);
    }
    coordsInWidget(e, t, n) {
      let r = this.widget.coordsAt(this.dom, e, t);
      if (r) return r;
      if (n) return vn(this.dom.getBoundingClientRect(), this.length ? e == 0 : t <= 0);
      {
        let t = this.dom.getClientRects(),
          n = null;
        if (!t.length) return null;
        let r = this.flags & 16 ? !0 : this.flags & 32 ? !1 : e > 0;
        for (
          let i = r ? t.length - 1 : 0;
          (n = t[i]), !(e > 0 ? i == 0 : i == t.length - 1 || n.top < n.bottom);
          i += r ? -1 : 1
        );
        return vn(n, !r);
      }
    }
    get overrideDOMText() {
      if (!this.length) return f.empty;
      let { root: e } = this;
      if (!e) return f.empty;
      let t = this.posAtStart;
      return e.view.state.doc.slice(t, t + this.length);
    }
    destroy() {
      (super.destroy(), this.widget.destroy(this.dom));
    }
    static of(t, n, r, i, a) {
      return (
        a || ((a = t.toDOM(n)), t.editable || (a.contentEditable = `false`)),
        new e(a, r, t, i)
      );
    }
  },
  Kr = class extends R {
    constructor(e) {
      let t = document.createElement(`img`);
      ((t.className = `cm-widgetBuffer`), t.setAttribute(`aria-hidden`, `true`), super(t, 0, e));
    }
    get isHidden() {
      return !0;
    }
    get overrideDOMText() {
      return f.empty;
    }
    coordsIn(e) {
      return this.dom.getBoundingClientRect();
    }
  },
  qr = class {
    constructor(e) {
      ((this.index = 0), (this.beforeBreak = !1), (this.parents = []), (this.tile = e));
    }
    advance(e, t, n) {
      let { tile: r, index: i, beforeBreak: a, parents: o } = this;
      for (; e || t > 0;)
        if (!r.isComposite()) {
          if (i == r.length) ((a = !!r.breakAfter), ({ tile: r, index: i } = o.pop()), i++);
          else if (e) {
            let t = Math.min(e, r.length - i);
            (n && n.skip(r, i, i + t), (e -= t), (i += t));
          } else break;
        } else if (a) {
          if (!e) break;
          (n && n.break(), e--, (a = !1));
        } else if (i == r.children.length) {
          if (!e && !o.length) break;
          (n && n.leave(r), (a = !!r.breakAfter), ({ tile: r, index: i } = o.pop()), i++);
        } else {
          let s = r.children[i],
            c = s.breakAfter;
          (t > 0 ? s.length <= e : s.length < e) &&
          (!n || n.skip(s, 0, s.length) !== !1 || !s.isComposite)
            ? ((a = !!c), i++, (e -= s.length))
            : (o.push({
                tile: r,
                index: i,
              }),
              (r = s),
              (i = 0),
              n && s.isComposite() && n.enter(s));
        }
      return ((this.tile = r), (this.index = i), (this.beforeBreak = a), this);
    }
    get root() {
      return this.parents.length ? this.parents[0].tile : this.tile;
    }
  },
  Jr = class {
    constructor(e, t, n, r) {
      ((this.from = e), (this.to = t), (this.wrapper = n), (this.rank = r));
    }
  },
  Yr = class {
    constructor(e, t, n) {
      ((this.cache = e),
        (this.root = t),
        (this.blockWrappers = n),
        (this.curLine = null),
        (this.lastBlock = null),
        (this.afterWidget = null),
        (this.pos = 0),
        (this.wrappers = []),
        (this.wrapperPos = 0));
    }
    addText(e, t, n, r) {
      this.flushBuffer();
      let i = this.ensureMarks(t, n),
        a = i.lastChild;
      if (a && a.isText() && !(a.flags & 8) && a.length + e.length < 512) {
        this.cache.reused.set(a, 2);
        let t = (i.children[i.children.length - 1] = new Wr(a.dom, a.text + e));
        t.parent = i;
      } else i.append(r || Wr.of(e, this.cache.find(Wr)?.dom));
      ((this.pos += e.length), (this.afterWidget = null));
    }
    addComposition(e, t) {
      let n = this.curLine;
      n.dom != t.line.dom &&
        (n.setDOM(this.cache.reused.has(t.line) ? ai(t.line.dom) : t.line.dom),
        this.cache.reused.set(t.line, 2));
      let r = n;
      for (let e = t.marks.length - 1; e >= 0; e--) {
        let n = t.marks[e],
          i = r.lastChild;
        if (i instanceof z && i.mark.eq(n.mark)) (i.dom != n.dom && i.setDOM(ai(n.dom)), (r = i));
        else {
          if (this.cache.reused.get(n)) {
            let e = R.get(n.dom);
            e && e.setDOM(ai(n.dom));
          }
          let e = z.of(n.mark, n.dom);
          (r.append(e), (r = e));
        }
        this.cache.reused.set(n, 2);
      }
      let i = R.get(e.text);
      i && this.cache.reused.set(i, 2);
      let a = new Wr(e.text, e.text.nodeValue);
      ((a.flags |= 8), (this.pos = e.range.toB), r.append(a));
    }
    addInlineWidget(e, t, n) {
      let r = this.afterWidget && e.flags & 48 && (this.afterWidget.flags & 48) == (e.flags & 48);
      r || this.flushBuffer();
      let i = this.ensureMarks(t, n);
      (!r && !(e.flags & 16) && i.append(this.getBuffer(1)),
        i.append(e),
        (this.pos += e.length),
        (this.afterWidget = e));
    }
    addMark(e, t, n) {
      (this.flushBuffer(),
        this.ensureMarks(t, n).append(e),
        (this.pos += e.length),
        (this.afterWidget = null));
    }
    addBlockWidget(e) {
      (this.getBlockPos().append(e), (this.pos += e.length), (this.lastBlock = e), this.endLine());
    }
    continueWidget(e) {
      let t = this.afterWidget || this.lastBlock;
      ((t.length += e), (this.pos += e));
    }
    addLineStart(e, t) {
      e ||= ni;
      let n = Vr.start(e, t || this.cache.find(Vr)?.dom, !!t);
      this.getBlockPos().append((this.lastBlock = this.curLine = n));
    }
    addLine(e) {
      (this.getBlockPos().append(e), (this.pos += e.length), (this.lastBlock = e), this.endLine());
    }
    addBreak() {
      ((this.lastBlock.flags |= 1), this.endLine(), this.pos++);
    }
    addLineStartIfNotCovered(e) {
      this.blockPosCovered() || this.addLineStart(e);
    }
    ensureLine(e) {
      this.curLine || this.addLineStart(e);
    }
    ensureMarks(e, t) {
      let n = this.curLine;
      for (let r = e.length - 1; r >= 0; r--) {
        let i = e[r],
          a;
        if (t > 0 && (a = n.lastChild) && a instanceof z && a.mark.eq(i)) ((n = a), t--);
        else {
          let e = z.of(i, this.cache.find(z, (e) => e.mark.eq(i))?.dom);
          (n.append(e), (n = e), (t = 0));
        }
      }
      return n;
    }
    endLine() {
      if (this.curLine) {
        this.flushBuffer();
        let e = this.curLine.lastChild;
        ((!e ||
          !ei(this.curLine, !1) ||
          (e.dom.nodeName != `BR` && e.isWidget() && !(N.ios && ei(this.curLine, !0)))) &&
          this.curLine.append(this.cache.findWidget(si, 0, 32) || new Gr(si.toDOM(), 0, si, 32)),
          (this.curLine = this.afterWidget = null));
      }
    }
    updateBlockWrappers() {
      this.wrapperPos > this.pos + 1e4 &&
        (this.blockWrappers.goto(this.pos), (this.wrappers.length = 0));
      for (let e = this.wrappers.length - 1; e >= 0; e--)
        this.wrappers[e].to < this.pos && this.wrappers.splice(e, 1);
      for (let e = this.blockWrappers; e.value && e.from <= this.pos; e.next())
        if (e.to >= this.pos) {
          let t = e.rank * 102 + e.value.rank,
            n = new Jr(e.from, e.to, e.value, t),
            r = this.wrappers.length;
          for (
            ;
            r > 0 && (this.wrappers[r - 1].rank - n.rank || this.wrappers[r - 1].to - n.to) < 0;
          )
            r--;
          this.wrappers.splice(r, 0, n);
        }
      this.wrapperPos = this.pos;
    }
    getBlockPos() {
      this.updateBlockWrappers();
      let e = this.root;
      for (let t of this.wrappers) {
        let n = e.lastChild;
        if (t.from < this.pos && n instanceof Br && n.wrapper.eq(t.wrapper)) e = n;
        else {
          let n = Br.of(t.wrapper, this.cache.find(Br, (e) => e.wrapper.eq(t.wrapper))?.dom);
          (e.append(n), (e = n));
        }
      }
      return e;
    }
    blockPosCovered() {
      let e = this.lastBlock;
      return e != null && !e.breakAfter && (!e.isWidget() || (e.flags & 160) > 0);
    }
    getBuffer(e) {
      let t = 2 | (e < 0 ? 16 : 32),
        n = this.cache.find(Kr, void 0, 1);
      return (n && (n.flags = t), n || new Kr(t));
    }
    flushBuffer() {
      this.afterWidget &&
        !(this.afterWidget.flags & 32) &&
        (this.afterWidget.parent.append(this.getBuffer(-1)), (this.afterWidget = null));
    }
  },
  Xr = class {
    constructor(e) {
      ((this.skipCount = 0), (this.text = ``), (this.textOff = 0), (this.cursor = e.iter()));
    }
    skip(e) {
      this.textOff + e <= this.text.length
        ? (this.textOff += e)
        : ((this.skipCount += e - (this.text.length - this.textOff)),
          (this.text = ``),
          (this.textOff = 0));
    }
    next(e) {
      if (this.textOff == this.text.length) {
        let { value: t, lineBreak: n, done: r } = this.cursor.next(this.skipCount);
        if (((this.skipCount = 0), r))
          throw Error(`Ran out of text content when drawing inline views`);
        this.text = t;
        let i = (this.textOff = Math.min(e, t.length));
        return n ? null : t.slice(0, i);
      }
      let t = Math.min(this.text.length, this.textOff + e),
        n = this.text.slice(this.textOff, t);
      return ((this.textOff = t), n);
    }
  },
  Zr = [Gr, Vr, Wr, z, Kr, Br, zr];
for (let e = 0; e < Zr.length; e++) Zr[e].bucket = e;
var Qr = class {
    constructor(e) {
      ((this.view = e),
        (this.buckets = Zr.map(() => [])),
        (this.index = Zr.map(() => 0)),
        (this.reused = new Map()));
    }
    add(e) {
      let t = e.constructor.bucket,
        n = this.buckets[t];
      n.length < 6 ? n.push(e) : (n[(this.index[t] = (this.index[t] + 1) % 6)] = e);
    }
    find(e, t, n = 2) {
      let r = e.bucket,
        i = this.buckets[r],
        a = this.index[r];
      for (let e = i.length - 1; e >= 0; e--) {
        let o = (e + a) % i.length,
          s = i[o];
        if ((!t || t(s)) && !this.reused.has(s))
          return (i.splice(o, 1), o < a && this.index[r]--, this.reused.set(s, n), s);
      }
      return null;
    }
    findWidget(e, t, n) {
      let r = this.buckets[0];
      if (r.length)
        for (let i = 0, a = 0; ; i++) {
          if (i == r.length) {
            if (a) return null;
            ((a = 1), (i = 0));
          }
          let o = r[i];
          if (
            !this.reused.has(o) &&
            (a == 0
              ? o.widget.compare(e)
              : o.widget.constructor == e.constructor && e.updateDOM(o.dom, this.view, o.widget))
          )
            return (
              r.splice(i, 1),
              i < this.index[0] && this.index[0]--,
              o.widget == e && o.length == t && (o.flags & 497) == n
                ? (this.reused.set(o, 1), o)
                : (this.reused.set(o, 2), new Gr(o.dom, t, e, (o.flags & -498) | n))
            );
        }
    }
    reuse(e) {
      return (this.reused.set(e, 1), e);
    }
    maybeReuse(e, t = 2) {
      if (!this.reused.has(e)) return (this.reused.set(e, t), e.dom);
    }
    clear() {
      for (let e = 0; e < this.buckets.length; e++) this.buckets[e].length = this.index[e] = 0;
    }
  },
  $r = class {
    constructor(e, t, n, r, i) {
      ((this.view = e),
        (this.decorations = r),
        (this.disallowBlockEffectsFor = i),
        (this.openWidget = !1),
        (this.openMarks = 0),
        (this.cache = new Qr(e)),
        (this.text = new Xr(e.state.doc)),
        (this.builder = new Yr(this.cache, new zr(e, e.contentDOM), A.iter(n))),
        this.cache.reused.set(t, 2),
        (this.old = new qr(t)),
        (this.reuseWalker = {
          skip: (e, t, n) => {
            if ((this.cache.add(e), e.isComposite())) return !1;
          },
          enter: (e) => this.cache.add(e),
          leave: () => {},
          break: () => {},
        }));
    }
    run(e, t) {
      let n = t && this.getCompositionContext(t.text);
      for (let r = 0, i = 0, a = 0; ;) {
        let o = a < e.length ? e[a++] : null,
          s = o ? o.fromA : this.old.root.length;
        if (s > r) {
          let e = s - r;
          (this.preserve(e, !a, !o), (r = s), (i += e));
        }
        if (!o) break;
        (t && o.fromA <= t.range.fromA && o.toA >= t.range.toA
          ? (this.forward(o.fromA, t.range.fromA, t.range.fromA < t.range.toA ? 1 : -1),
            this.emit(i, t.range.fromB),
            this.cache.clear(),
            this.builder.addComposition(t, n),
            this.text.skip(t.range.toB - t.range.fromB),
            this.forward(t.range.fromA, o.toA),
            this.emit(t.range.toB, o.toB))
          : (this.forward(o.fromA, o.toA), this.emit(i, o.toB)),
          (i = o.toB),
          (r = o.toA));
      }
      return (this.builder.curLine && this.builder.endLine(), this.builder.root);
    }
    preserve(e, t, n) {
      let r = ii(this.old),
        i = this.openMarks;
      (this.old.advance(e, n ? 1 : -1, {
        skip: (e, t, n) => {
          if (e.isWidget()) {
            if (this.openWidget) this.builder.continueWidget(n - t);
            else {
              let a =
                n > 0 || t < e.length
                  ? Gr.of(e.widget, this.view, n - t, e.flags & 496, this.cache.maybeReuse(e))
                  : this.cache.reuse(e);
              a.flags & 256
                ? ((a.flags &= -2), this.builder.addBlockWidget(a))
                : (this.builder.ensureLine(null),
                  this.builder.addInlineWidget(a, r, i),
                  (i = r.length));
            }
          } else if (e.isText())
            (this.builder.ensureLine(null),
              !t && n == e.length && !this.cache.reused.has(e)
                ? this.builder.addText(e.text, r, i, this.cache.reuse(e))
                : (this.cache.add(e), this.builder.addText(e.text.slice(t, n), r, i)),
              (i = r.length));
          else if (e.isLine())
            ((e.flags &= -2), this.cache.reused.set(e, 1), this.builder.addLine(e));
          else if (e instanceof Kr) this.cache.add(e);
          else if (e instanceof z)
            (this.builder.ensureLine(null),
              this.builder.addMark(e, r, i),
              this.cache.reused.set(e, 1),
              (i = r.length));
          else return !1;
          this.openWidget = !1;
        },
        enter: (e) => {
          (e.isLine()
            ? this.builder.addLineStart(e.attrs, this.cache.maybeReuse(e))
            : (this.cache.add(e), e instanceof z && r.unshift(e.mark)),
            (this.openWidget = !1));
        },
        leave: (e) => {
          e.isLine()
            ? (r.length &&= i = 0)
            : e instanceof z && (r.shift(), (i = Math.min(i, r.length)));
        },
        break: () => {
          (this.builder.addBreak(), (this.openWidget = !1));
        },
      }),
        this.text.skip(e));
    }
    emit(e, t) {
      let n = null,
        r = this.builder,
        i = 0,
        a = A.spans(this.decorations, e, t, {
          point: (e, t, a, o, s, c) => {
            if (a instanceof rn) {
              if (this.disallowBlockEffectsFor[c]) {
                if (a.block) throw RangeError(`Block decorations may not be specified via plugins`);
                if (t > this.view.state.doc.lineAt(e).to)
                  throw RangeError(
                    `Decorations that replace line breaks may not be specified via plugins`,
                  );
              }
              if (((i = o.length), s > o.length)) r.continueWidget(t - e);
              else {
                let i = a.widget || (a.block ? oi.block : oi.inline),
                  c = ti(a),
                  l = this.cache.findWidget(i, t - e, c) || Gr.of(i, this.view, t - e, c);
                a.block
                  ? (a.startSide > 0 && r.addLineStartIfNotCovered(n), r.addBlockWidget(l))
                  : (r.ensureLine(n), r.addInlineWidget(l, o, s));
              }
              n = null;
            } else n = ri(n, a);
            t > e && this.text.skip(t - e);
          },
          span: (e, t, i, a) => {
            for (let o = e; o < t;) {
              let s = this.text.next(Math.min(512, t - o));
              (s == null
                ? (r.addLineStartIfNotCovered(n), r.addBreak(), o++)
                : (r.ensureLine(n), r.addText(s, i, o == e ? a : i.length), (o += s.length)),
                (n = null));
            }
          },
        });
      (r.addLineStartIfNotCovered(n), (this.openWidget = a > i), (this.openMarks = a));
    }
    forward(e, t, n = 1) {
      t - e <= 10
        ? this.old.advance(t - e, n, this.reuseWalker)
        : (this.old.advance(5, -1, this.reuseWalker),
          this.old.advance(t - e - 10, -1),
          this.old.advance(5, n, this.reuseWalker));
    }
    getCompositionContext(e) {
      let t = [],
        n = null;
      for (let r = e.parentNode; ; r = r.parentNode) {
        let e = R.get(r);
        if (r == this.view.contentDOM) break;
        e instanceof z
          ? t.push(e)
          : e?.isLine()
            ? (n = e)
            : e instanceof Br ||
              (r.nodeName == `DIV` && !n && r != this.view.contentDOM
                ? (n = new Vr(r, ni))
                : n ||
                  t.push(
                    z.of(
                      new tn({
                        tagName: r.nodeName.toLowerCase(),
                        attributes: $t(r),
                      }),
                      r,
                    ),
                  ));
      }
      return {
        line: n,
        marks: t,
      };
    }
  };
function ei(e, t) {
  let n = (e) => {
    for (let r of e.children) if ((t ? r.isText() : r.length) || n(r)) return !0;
    return !1;
  };
  return n(e);
}
function ti(e) {
  let t = e.isReplace
    ? (e.startSide < 0 ? 64 : 0) | (e.endSide > 0 ? 128 : 0)
    : e.startSide > 0
      ? 32
      : 16;
  return (e.block && (t |= 256), t);
}
var ni = {
  class: `cm-line`,
};
function ri(e, t) {
  let n = t.spec.attributes,
    r = t.spec.class;
  return !n && !r
    ? e
    : ((e ||= {
        class: `cm-line`,
      }),
      n && Jt(n, e),
      r && (e.class += ` ` + r),
      e);
}
function ii(e) {
  let t = [];
  for (let n = e.parents.length; n > 1; n--) {
    let r = n == e.parents.length ? e.tile : e.parents[n].tile;
    r instanceof z && t.push(r.mark);
  }
  return t;
}
function ai(e) {
  let t = R.get(e);
  return (t && t.setDOM(e.cloneNode()), e);
}
var oi = class extends en {
  constructor(e) {
    (super(), (this.tag = e));
  }
  eq(e) {
    return e.tag == this.tag;
  }
  toDOM() {
    return document.createElement(this.tag);
  }
  updateDOM(e) {
    return e.nodeName.toLowerCase() == this.tag;
  }
  get isHidden() {
    return !0;
  }
};
((oi.inline = new oi(`span`)), (oi.block = new oi(`div`)));
var si = new (class extends en {
    toDOM() {
      return document.createElement(`br`);
    }
    get isHidden() {
      return !0;
    }
    get editable() {
      return !0;
    }
  })(),
  ci = class {
    constructor(e) {
      ((this.view = e),
        (this.decorations = []),
        (this.blockWrappers = []),
        (this.dynamicDecorationMap = [!1]),
        (this.domChanged = null),
        (this.hasComposition = null),
        (this.editContextFormatting = F.none),
        (this.lastCompositionAfterCursor = !1),
        (this.minWidth = 0),
        (this.minWidthFrom = 0),
        (this.minWidthTo = 0),
        (this.impreciseAnchor = null),
        (this.impreciseHead = null),
        (this.forceSelection = !1),
        (this.lastUpdate = Date.now()),
        this.updateDeco(),
        (this.tile = new zr(e, e.contentDOM)),
        this.updateInner([new Pr(0, 0, 0, e.state.doc.length)], null));
    }
    update(e) {
      let t = e.changedRanges;
      (this.minWidth > 0 &&
        t.length &&
        (t.every(({ fromA: e, toA: t }) => t < this.minWidthFrom || e > this.minWidthTo)
          ? ((this.minWidthFrom = e.changes.mapPos(this.minWidthFrom, 1)),
            (this.minWidthTo = e.changes.mapPos(this.minWidthTo, 1)))
          : (this.minWidth = this.minWidthFrom = this.minWidthTo = 0)),
        this.updateEditContextFormatting(e));
      let n = -1;
      this.view.inputState.composing >= 0 &&
        !this.view.observer.editContext &&
        (this.domChanged?.newSel
          ? (n = this.domChanged.newSel.head)
          : !yi(e.changes, this.hasComposition) &&
            !e.selectionSet &&
            (n = e.state.selection.main.head));
      let r = n > -1 ? fi(this.view, e.changes, n) : null;
      if (((this.domChanged = null), this.hasComposition)) {
        let { from: n, to: r } = this.hasComposition;
        t = new Pr(n, r, e.changes.mapPos(n, -1), e.changes.mapPos(r, 1)).addToSet(t.slice());
      }
      ((this.hasComposition = r
        ? {
            from: r.range.fromB,
            to: r.range.toB,
          }
        : null),
        (N.ie || N.chrome) &&
          !r &&
          e &&
          e.state.doc.lines != e.startState.doc.lines &&
          (this.forceSelection = !0));
      let i = this.decorations,
        a = this.blockWrappers;
      this.updateDeco();
      let o = hi(i, this.decorations, e.changes);
      o.length && (t = Pr.extendWithRanges(t, o));
      let s = _i(a, this.blockWrappers, e.changes);
      return (
        s.length && (t = Pr.extendWithRanges(t, s)),
        r &&
          !t.some((e) => e.fromA <= r.range.fromA && e.toA >= r.range.toA) &&
          (t = r.range.addToSet(t.slice())),
        this.tile.flags & 2 && t.length == 0
          ? !1
          : (this.updateInner(t, r), e.transactions.length && (this.lastUpdate = Date.now()), !0)
      );
    }
    updateInner(e, t) {
      this.view.viewState.mustMeasureContent = !0;
      let { observer: n } = this.view;
      n.ignore(() => {
        if (t || e.length) {
          let n = this.tile,
            r = new $r(
              this.view,
              n,
              this.blockWrappers,
              this.decorations,
              this.dynamicDecorationMap,
            );
          (t && R.get(t.text) && r.cache.reused.set(R.get(t.text), 2),
            (this.tile = r.run(e, t)),
            li(n, r.cache.reused));
        }
        ((this.tile.dom.style.height = this.view.viewState.contentHeight / this.view.scaleY + `px`),
          (this.tile.dom.style.flexBasis = this.minWidth ? this.minWidth + `px` : ``));
        let r =
          N.chrome || N.ios
            ? {
                node: n.selectionRange.focusNode,
                written: !1,
              }
            : void 0;
        (this.tile.sync(r),
          r &&
            (r.written ||
              n.selectionRange.focusNode != r.node ||
              !this.tile.dom.contains(r.node)) &&
            (this.forceSelection = !0),
          (this.tile.dom.style.height = ``));
      });
      let r = [];
      if (this.view.viewport.from || this.view.viewport.to < this.view.state.doc.length)
        for (let e of this.tile.children) e.isWidget() && e.widget instanceof bi && r.push(e.dom);
      n.updateGaps(r);
    }
    updateEditContextFormatting(e) {
      this.editContextFormatting = this.editContextFormatting.map(e.changes);
      for (let t of e.transactions)
        for (let e of t.effects) e.is(gr) && (this.editContextFormatting = e.value);
    }
    updateSelection(e = !1, t = !1) {
      (e || !this.view.observer.selectionRange.focusNode) &&
        this.view.observer.readSelectionRange();
      let { dom: n } = this.tile,
        r = this.view.root.activeElement,
        i = r == n,
        a =
          !i &&
          !(this.view.state.facet(vr) || n.tabIndex > -1) &&
          dn(n, this.view.observer.selectionRange) &&
          !(r && n.contains(r));
      if (!(i || t || a)) return;
      let o = this.forceSelection;
      this.forceSelection = !1;
      let s = this.view.state.selection.main,
        c,
        l;
      if (
        (s.empty
          ? (l = c = this.inlineDOMNearPos(s.anchor, s.assoc || 1))
          : ((l = this.inlineDOMNearPos(s.head, s.head == s.from ? 1 : -1)),
            (c = this.inlineDOMNearPos(s.anchor, s.anchor == s.from ? 1 : -1))),
        N.gecko && s.empty && !this.hasComposition && ui(c))
      ) {
        let e = document.createTextNode(``);
        (this.view.observer.ignore(() =>
          c.node.insertBefore(e, c.node.childNodes[c.offset] || null),
        ),
          (c = l = new Pn(e, 0)),
          (o = !0));
      }
      let u = this.view.observer.selectionRange;
      ((o ||
        !u.focusNode ||
        ((!pn(c.node, c.offset, u.anchorNode, u.anchorOffset) ||
          !pn(l.node, l.offset, u.focusNode, u.focusOffset)) &&
          !this.suppressWidgetCursorChange(u, s))) &&
        (this.view.observer.ignore(() => {
          N.android &&
            N.chrome &&
            n.contains(u.focusNode) &&
            vi(u.focusNode, n) &&
            (n.blur(),
            n.focus({
              preventScroll: !0,
            }));
          let e = ln(this.view.root);
          if (e)
            if (s.empty) {
              if (N.gecko) {
                let e = pi(c.node, c.offset);
                if (e && e != 3) {
                  let t = (e == 1 ? Mn : Nn)(c.node, c.offset);
                  t && (c = new Pn(t.node, t.offset));
                }
              }
              (e.collapse(c.node, c.offset),
                s.bidiLevel != null &&
                  e.caretBidiLevel !== void 0 &&
                  (e.caretBidiLevel = s.bidiLevel));
            } else if (e.extend) {
              e.collapse(c.node, c.offset);
              try {
                e.extend(l.node, l.offset);
              } catch {}
            } else {
              let t = document.createRange();
              (s.anchor > s.head && ([c, l] = [l, c]),
                t.setEnd(l.node, l.offset),
                t.setStart(c.node, c.offset),
                e.removeAllRanges(),
                e.addRange(t));
            }
          a && this.view.root.activeElement == n && (n.blur(), r && r.focus());
        }),
        this.view.observer.setSelectionRange(c, l)),
        (this.impreciseAnchor = c.precise ? null : new Pn(u.anchorNode, u.anchorOffset)),
        (this.impreciseHead = l.precise ? null : new Pn(u.focusNode, u.focusOffset)));
    }
    suppressWidgetCursorChange(e, t) {
      return (
        this.hasComposition &&
        t.empty &&
        pn(e.focusNode, e.focusOffset, e.anchorNode, e.anchorOffset) &&
        this.posFromDOM(e.focusNode, e.focusOffset) == t.head
      );
    }
    enforceCursorAssoc() {
      if (this.hasComposition) return;
      let { view: e } = this,
        t = e.state.selection.main,
        n = ln(e.root),
        { anchorNode: r, anchorOffset: i } = e.observer.selectionRange;
      if (!n || !t.empty || !t.assoc || !n.modify) return;
      let a = this.lineAt(t.head, t.assoc);
      if (!a) return;
      let o = a.posAtStart;
      if (t.head == o || t.head == o + a.length) return;
      let s = this.coordsAt(t.head, -1),
        c = this.coordsAt(t.head, 1);
      if (!s || !c || s.bottom > c.top) return;
      let l = this.domAtPos(t.head + t.assoc, t.assoc);
      (n.collapse(l.node, l.offset),
        n.modify(`move`, t.assoc < 0 ? `forward` : `backward`, `lineboundary`),
        e.observer.readSelectionRange());
      let u = e.observer.selectionRange;
      e.docView.posFromDOM(u.anchorNode, u.anchorOffset) != t.from && n.collapse(r, i);
    }
    posFromDOM(e, t) {
      let n = this.tile.nearest(e);
      if (!n) return this.tile.dom.compareDocumentPosition(e) & 2 ? 0 : this.view.state.doc.length;
      let r = n.posAtStart;
      if (n.isComposite()) {
        let i;
        if (e == n.dom) i = n.dom.childNodes[t];
        else {
          let r = _n(e) == 0 ? 0 : t == 0 ? -1 : 1;
          for (;;) {
            let t = e.parentNode;
            if (t == n.dom) break;
            (r == 0 && t.firstChild != t.lastChild && (r = e == t.firstChild ? -1 : 1), (e = t));
          }
          i = r < 0 ? e : e.nextSibling;
        }
        if (i == n.dom.firstChild) return r;
        for (; i && !R.get(i);) i = i.nextSibling;
        if (!i) return r + n.length;
        for (let e = 0, t = r; ; e++) {
          let r = n.children[e];
          if (r.dom == i) return t;
          t += r.length + r.breakAfter;
        }
      } else if (n.isText()) return e == n.dom ? r + t : r + (t ? n.length : 0);
      else return r;
    }
    domAtPos(e, t) {
      let { tile: n, offset: r } = this.tile.resolveBlock(e, t);
      return n.isWidget() ? n.domPosFor(e, t) : n.domIn(r, t);
    }
    inlineDOMNearPos(e, t) {
      let n,
        r = -1,
        i = !1,
        a,
        o = -1,
        s = !1;
      return (
        this.tile.blockTiles((t, c) => {
          if (t.isWidget()) {
            if (t.flags & 32 && c >= e) return !0;
            t.flags & 16 && (i = !0);
          } else {
            let l = c + t.length;
            if (
              (c <= e && ((n = t), (r = e - c), (i = l < e)),
              l >= e && !a && ((a = t), (o = e - c), (s = c > e)),
              c > e && a)
            )
              return !0;
          }
        }),
        !n && !a
          ? this.domAtPos(e, t)
          : (i && a ? (n = null) : s && n && (a = null),
            (n && t < 0) || !a ? n.domIn(r, t) : a.domIn(o, t))
      );
    }
    coordsAt(e, t) {
      let { tile: n, offset: r } = this.tile.resolveBlock(e, t);
      return n.isWidget()
        ? n.widget instanceof bi
          ? null
          : n.coordsInWidget(r, t, !0)
        : n.coordsIn(r, t);
    }
    lineAt(e, t) {
      let { tile: n } = this.tile.resolveBlock(e, t);
      return n.isLine() ? n : null;
    }
    coordsForChar(e) {
      let { tile: t, offset: n } = this.tile.resolveBlock(e, 1);
      if (!t.isLine()) return null;
      function r(e, t) {
        if (e.isComposite())
          for (let n of e.children) {
            if (n.length >= t) {
              let e = r(n, t);
              if (e) return e;
            }
            if (((t -= n.length), t < 0)) break;
          }
        else if (e.isText() && t < e.length) {
          let n = S(e.text, t);
          if (n == t) return null;
          let r = Dn(e.dom, t, n).getClientRects();
          for (let e = 0; e < r.length; e++) {
            let t = r[e];
            if (e == r.length - 1 || (t.top < t.bottom && t.left < t.right)) return t;
          }
        }
        return null;
      }
      return r(t, n);
    }
    measureVisibleLineHeights(e) {
      let t = [],
        { from: n, to: r } = e,
        i = this.view.contentDOM.clientWidth,
        a = i > Math.max(this.view.scrollDOM.clientWidth, this.minWidth) + 1,
        o = -1,
        s = this.view.textDirection == I.LTR,
        c = 0,
        l = (e, u, d) => {
          for (let f = 0; f < e.children.length && !(u > r); f++) {
            let r = e.children[f],
              p = u + r.length,
              m = r.dom.getBoundingClientRect(),
              { height: h } = m;
            if ((d && !f && (c += m.top - d.top), r instanceof Br)) p > n && l(r, u, m);
            else if (u >= n && (c > 0 && t.push(-c), t.push(h + c), (c = 0), a)) {
              let e = r.dom.lastChild,
                t = e ? fn(e) : [];
              if (t.length) {
                let e = t[t.length - 1],
                  n = s ? e.right - m.left : m.right - e.left;
                n > o &&
                  ((o = n), (this.minWidth = i), (this.minWidthFrom = u), (this.minWidthTo = p));
              }
            }
            (d && f == e.children.length - 1 && (c += d.bottom - m.bottom), (u = p + r.breakAfter));
          }
        };
      return (l(this.tile, 0, null), t);
    }
    textDirectionAt(e) {
      let { tile: t } = this.tile.resolveBlock(e, 1);
      return getComputedStyle(t.dom).direction == `rtl` ? I.RTL : I.LTR;
    }
    measureTextSize() {
      let e = this.tile.blockTiles((e) => {
        if (e.isLine() && e.children.length && e.length <= 20) {
          let t = 0,
            n;
          for (let r of e.children) {
            if (!r.isText() || /[^ -~]/.test(r.text)) return;
            let e = fn(r.dom);
            if (e.length != 1) return;
            ((t += e[0].width), (n = e[0].height));
          }
          if (t)
            return {
              lineHeight: e.dom.getBoundingClientRect().height,
              charWidth: t / e.length,
              textHeight: n,
            };
        }
      });
      if (e) return e;
      let t = document.createElement(`div`),
        n,
        r,
        i;
      return (
        (t.className = `cm-line`),
        (t.style.width = `99999px`),
        (t.style.position = `absolute`),
        (t.textContent = `abc def ghi jkl mno pqr stu`),
        this.view.observer.ignore(() => {
          this.tile.dom.appendChild(t);
          let e = fn(t.firstChild)[0];
          ((n = t.getBoundingClientRect().height),
            (r = e && e.width ? e.width / 27 : 7),
            (i = e && e.height ? e.height : n),
            t.remove());
        }),
        {
          lineHeight: n,
          charWidth: r,
          textHeight: i,
        }
      );
    }
    computeBlockGapDeco() {
      let e = [],
        t = this.view.viewState;
      for (let n = 0, r = 0; ; r++) {
        let i = r == t.viewports.length ? null : t.viewports[r],
          a = i ? i.from - 1 : this.view.state.doc.length;
        if (a > n) {
          let r = (t.lineBlockAt(a).bottom - t.lineBlockAt(n).top) / this.view.scaleY;
          e.push(
            F.replace({
              widget: new bi(r),
              block: !0,
              inclusive: !0,
              isBlockGap: !0,
            }).range(n, a),
          );
        }
        if (!i) break;
        n = i.to + 1;
      }
      return F.set(e);
    }
    updateDeco() {
      let e = 1,
        t = this.view.state
          .facet(Tr)
          .map((t) =>
            (this.dynamicDecorationMap[e++] = typeof t == `function`) ? t(this.view) : t,
          ),
        n = !1,
        r = this.view.state.facet(Dr).map((e, t) => {
          let r = typeof e == `function`;
          return (r && (n = !0), r ? e(this.view) : e);
        });
      for (
        r.length && ((this.dynamicDecorationMap[e++] = n), t.push(A.join(r))),
          this.decorations = [
            this.editContextFormatting,
            ...t,
            this.computeBlockGapDeco(),
            this.view.viewState.lineGapDeco,
          ];
        e < this.decorations.length;
      )
        this.dynamicDecorationMap[e++] = !1;
      this.blockWrappers = this.view.state
        .facet(Er)
        .map((e) => (typeof e == `function` ? e(this.view) : e));
    }
    scrollIntoView(e) {
      if (e.isSnapshot) {
        let t = this.view.viewState.lineBlockAt(e.range.head);
        ((this.view.scrollDOM.scrollTop = t.top - e.yMargin),
          (this.view.scrollDOM.scrollLeft = e.xMargin));
        return;
      }
      for (let t of this.view.state.facet(pr))
        try {
          if (t(this.view, e.range, e)) return !0;
        } catch (e) {
          _r(this.view.state, e, `scroll handler`);
        }
      let { range: t } = e,
        n = this.coordsAt(t.head, t.assoc ?? (t.empty ? 0 : t.head > t.anchor ? -1 : 1)),
        r;
      if (!n) return;
      !t.empty &&
        (r = this.coordsAt(t.anchor, t.anchor > t.head ? -1 : 1)) &&
        (n = {
          left: Math.min(n.left, r.left),
          top: Math.min(n.top, r.top),
          right: Math.max(n.right, r.right),
          bottom: Math.max(n.bottom, r.bottom),
        });
      let i = Mr(this.view),
        a = {
          left: n.left - i.left,
          top: n.top - i.top,
          right: n.right + i.right,
          bottom: n.bottom + i.bottom,
        },
        { offsetWidth: o, offsetHeight: s } = this.view.scrollDOM;
      if (
        (xn(
          this.view.scrollDOM,
          a,
          t.head < t.anchor ? -1 : 1,
          e.x,
          e.y,
          Math.max(Math.min(e.xMargin, o), -o),
          Math.max(Math.min(e.yMargin, s), -s),
          this.view.textDirection == I.LTR,
        ),
        window.visualViewport &&
          window.innerHeight - window.visualViewport.height > 1 &&
          (n.top >
            window.pageYOffset + window.visualViewport.offsetTop + window.visualViewport.height ||
            n.bottom < window.pageYOffset + window.visualViewport.offsetTop))
      ) {
        let e = this.view.docView.lineAt(t.head, 1);
        e &&
          e.dom.scrollIntoView({
            block: `nearest`,
          });
      }
    }
    lineHasWidget(e) {
      let t = (e) => e.isWidget() || e.children.some(t);
      return t(this.tile.resolveBlock(e, 1).tile);
    }
    destroy() {
      li(this.tile);
    }
  };
function li(e, t) {
  let n = t?.get(e);
  if (n != 1) {
    n ?? e.destroy();
    for (let n of e.children) li(n, t);
  }
}
function ui(e) {
  return (
    e.node.nodeType == 1 &&
    e.node.firstChild &&
    (e.offset == 0 || e.node.childNodes[e.offset - 1].contentEditable == `false`) &&
    (e.offset == e.node.childNodes.length || e.node.childNodes[e.offset].contentEditable == `false`)
  );
}
function di(e, t) {
  let n = e.observer.selectionRange;
  if (!n.focusNode) return null;
  let r = Mn(n.focusNode, n.focusOffset),
    i = Nn(n.focusNode, n.focusOffset),
    a = r || i;
  if (i && r && i.node != r.node) {
    let t = R.get(i.node);
    if (!t || (t.isText() && t.text != i.node.nodeValue)) a = i;
    else if (e.docView.lastCompositionAfterCursor) {
      let e = R.get(r.node);
      !e || (e.isText() && e.text != r.node.nodeValue) || (a = i);
    }
  }
  if (((e.docView.lastCompositionAfterCursor = a != r), !a)) return null;
  let o = t - a.offset;
  return {
    from: o,
    to: o + a.node.nodeValue.length,
    node: a.node,
  };
}
function fi(e, t, n) {
  let r = di(e, n);
  if (!r) return null;
  let { node: i, from: a, to: o } = r,
    s = i.nodeValue;
  if (/[\n\r]/.test(s) || e.state.doc.sliceString(r.from, r.to) != s) return null;
  let c = t.invertedDesc;
  return {
    range: new Pr(c.mapPos(a), c.mapPos(o), a, o),
    text: i,
  };
}
function pi(e, t) {
  return e.nodeType == 1
    ? (t && e.childNodes[t - 1].contentEditable == `false` ? 1 : 0) |
        (t < e.childNodes.length && e.childNodes[t].contentEditable == `false` ? 2 : 0)
    : 0;
}
var mi = class {
  constructor() {
    this.changes = [];
  }
  compareRange(e, t) {
    sn(e, t, this.changes);
  }
  comparePoint(e, t) {
    sn(e, t, this.changes);
  }
  boundChange(e) {
    sn(e, e, this.changes);
  }
};
function hi(e, t, n) {
  let r = new mi();
  return (A.compare(e, t, n, r), r.changes);
}
var gi = class {
  constructor() {
    this.changes = [];
  }
  compareRange(e, t) {
    sn(e, t, this.changes);
  }
  comparePoint() {}
  boundChange(e) {
    sn(e, e, this.changes);
  }
};
function _i(e, t, n) {
  let r = new gi();
  return (A.compare(e, t, n, r), r.changes);
}
function vi(e, t) {
  for (let n = e; n && n != t; n = n.assignedSlot || n.parentNode)
    if (n.nodeType == 1 && n.contentEditable == `false`) return !0;
  return !1;
}
function yi(e, t) {
  let n = !1;
  return (
    t &&
      e.iterChangedRanges((e, r) => {
        e < t.to && r > t.from && (n = !0);
      }),
    n
  );
}
var bi = class extends en {
  constructor(e) {
    (super(), (this.height = e));
  }
  toDOM() {
    let e = document.createElement(`div`);
    return ((e.className = `cm-gap`), this.updateDOM(e), e);
  }
  eq(e) {
    return e.height == this.height;
  }
  updateDOM(e) {
    return ((e.style.height = this.height + `px`), !0);
  }
  get editable() {
    return !0;
  }
  get estimatedHeight() {
    return this.height;
  }
  ignoreEvent() {
    return !1;
  }
};
function xi(e, t, n = 1) {
  let r = e.charCategorizer(t),
    i = e.doc.lineAt(t),
    a = t - i.from;
  if (i.length == 0) return T.cursor(t);
  a == 0 ? (n = 1) : a == i.length && (n = -1);
  let o = a,
    s = a;
  n < 0 ? (o = S(i.text, a, !1)) : (s = S(i.text, a));
  let c = r(i.text.slice(o, s));
  for (; o > 0;) {
    let e = S(i.text, o, !1);
    if (r(i.text.slice(e, o)) != c) break;
    o = e;
  }
  for (; s < i.length;) {
    let e = S(i.text, s);
    if (r(i.text.slice(s, e)) != c) break;
    s = e;
  }
  return T.range(o + i.from, s + i.from);
}
function Si(e, t, n, r, i) {
  let a = Math.round((r - t.left) * e.defaultCharacterWidth);
  if (e.lineWrapping && n.height > e.defaultLineHeight * 1.5) {
    let t = e.viewState.heightOracle.textHeight,
      r = Math.floor((i - n.top - (e.defaultLineHeight - t) * 0.5) / t);
    a += r * e.viewState.heightOracle.lineLength;
  }
  let o = e.state.sliceDoc(n.from, n.to);
  return n.from + St(o, a, e.state.tabSize);
}
function Ci(e, t, n) {
  let r = e.lineBlockAt(t);
  if (Array.isArray(r.type)) {
    let e;
    for (let i of r.type) {
      if (i.from > t) break;
      if (!(i.to < t)) {
        if (i.from < t && i.to > t) return i;
        (!e || (i.type == P.Text && (e.type != i.type || (n < 0 ? i.from < t : i.to > t)))) &&
          (e = i);
      }
    }
    return e || r;
  }
  return r;
}
function wi(e, t, n, r) {
  let i = Ci(e, t.head, t.assoc || -1),
    a =
      !r || i.type != P.Text || !(e.lineWrapping || i.widgetLineBreaks)
        ? null
        : e.coordsAtPos(t.assoc < 0 && t.head > i.from ? t.head - 1 : t.head);
  if (a) {
    let t = e.dom.getBoundingClientRect(),
      r = e.textDirectionAt(i.from),
      o = e.posAtCoords({
        x: n == (r == I.LTR) ? t.right - 1 : t.left + 1,
        y: (a.top + a.bottom) / 2,
      });
    if (o != null) return T.cursor(o, n ? -1 : 1);
  }
  return T.cursor(n ? i.to : i.from, n ? -1 : 1);
}
function Ti(e, t, n, r) {
  let i = e.state.doc.lineAt(t.head),
    a = e.bidiSpans(i),
    o = e.textDirectionAt(i.from);
  for (let s = t, c = null; ;) {
    let t = er(i, a, o, s, n),
      l = $n;
    if (!t) {
      if (i.number == (n ? e.state.doc.lines : 1)) return s;
      ((l = `
`),
        (i = e.state.doc.line(i.number + (n ? 1 : -1))),
        (a = e.bidiSpans(i)),
        (t = e.visualLineSide(i, !n)));
    }
    if (!c) {
      if (!r) return t;
      c = r(l);
    } else if (!c(l)) return s;
    s = t;
  }
}
function Ei(e, t, n) {
  let r = e.state.charCategorizer(t),
    i = r(n);
  return (e) => {
    let t = r(e);
    return (i == Qe.Space && (i = t), i == t);
  };
}
function Di(e, t, n, r) {
  let i = t.head,
    a = n ? 1 : -1;
  if (i == (n ? e.state.doc.length : 0)) return T.cursor(i, t.assoc);
  let o = t.goalColumn,
    s,
    c = e.contentDOM.getBoundingClientRect(),
    l = e.coordsAtPos(i, t.assoc || ((t.empty ? n : t.head == t.from) ? 1 : -1)),
    u = e.documentTop;
  if (l) ((o ??= l.left - c.left), (s = a < 0 ? l.top : l.bottom));
  else {
    let t = e.viewState.lineBlockAt(i);
    ((o ??= Math.min(c.right - c.left, e.defaultCharacterWidth * (i - t.from))),
      (s = (a < 0 ? t.top : t.bottom) + u));
  }
  let d = c.left + o,
    f = e.viewState.heightOracle.textHeight >> 1,
    p = r ?? f;
  for (let t = 0; ; t += f) {
    let r = s + (p + t) * a,
      i = Mi(
        e,
        {
          x: d,
          y: r,
        },
        !1,
        a,
      );
    if (n ? r > c.bottom : r < c.top) return T.cursor(i.pos, i.assoc);
    let l = e.coordsAtPos(i.pos, i.assoc),
      u = l ? (l.top + l.bottom) / 2 : 0;
    if (!l || (n ? u > s : u < s)) return T.cursor(i.pos, i.assoc, void 0, o);
  }
}
function Oi(e, t, n) {
  for (;;) {
    let r = 0;
    for (let i of e)
      i.between(t - 1, t + 1, (e, i, a) => {
        if (t > e && t < i) {
          let a = r || n || (t - e < i - t ? -1 : 1);
          ((t = a < 0 ? e : i), (r = a));
        }
      });
    if (!r) return t;
  }
}
function ki(e, t) {
  let n = null;
  for (let r = 0; r < t.ranges.length; r++) {
    let i = t.ranges[r],
      a = null;
    if (i.empty) {
      let t = Oi(e, i.from, 0);
      t != i.from && (a = T.cursor(t, -1));
    } else {
      let t = Oi(e, i.from, -1),
        n = Oi(e, i.to, 1);
      (t != i.from || n != i.to) &&
        (a = T.range(i.from == i.anchor ? t : n, i.from == i.head ? t : n));
    }
    a && ((n ||= t.ranges.slice()), (n[r] = a));
  }
  return n ? T.create(n, t.mainIndex) : t;
}
function Ai(e, t, n) {
  let r = Oi(
    e.state.facet(Or).map((t) => t(e)),
    n.from,
    t.head > n.from ? -1 : 1,
  );
  return r == n.from ? n : T.cursor(r, r < n.from ? 1 : -1);
}
var ji = class {
  constructor(e, t) {
    ((this.pos = e), (this.assoc = t));
  }
};
function Mi(e, t, n, r) {
  let i = e.contentDOM.getBoundingClientRect(),
    a = i.top + e.viewState.paddingTop,
    { x: o, y: s } = t,
    c = s - a,
    l;
  for (;;) {
    if (c < 0) return new ji(0, 1);
    if (c > e.viewState.docHeight) return new ji(e.state.doc.length, -1);
    if (((l = e.elementAtHeight(c)), r == null)) break;
    if (l.type == P.Text) {
      if (r < 0 ? l.to < e.viewport.from : l.from > e.viewport.to) break;
      let t = e.docView.coordsAt(r < 0 ? l.from : l.to, r > 0 ? -1 : 1);
      if (t && (r < 0 ? t.top <= c + a : t.bottom >= c + a)) break;
    }
    let t = e.viewState.heightOracle.textHeight / 2;
    c = r > 0 ? l.bottom + t : l.top - t;
  }
  if (e.viewport.from >= l.to || e.viewport.to <= l.from) {
    if (n) return null;
    if (l.type == P.Text) {
      let t = Si(e, i, l, o, s);
      return new ji(t, t == l.from ? 1 : -1);
    }
  }
  if (l.type != P.Text) return c < (l.top + l.bottom) / 2 ? new ji(l.from, 1) : new ji(l.to, -1);
  let u = e.docView.lineAt(l.from, 2);
  return (
    (!u || u.length != l.length) && (u = e.docView.lineAt(l.from, -2)),
    new Ni(e, o, s, e.textDirectionAt(l.from)).scanTile(u, l.from)
  );
}
var Ni = class {
    constructor(e, t, n, r) {
      ((this.view = e),
        (this.x = t),
        (this.y = n),
        (this.baseDir = r),
        (this.line = null),
        (this.spans = null));
    }
    bidiSpansAt(e) {
      return (
        (!this.line || this.line.from > e || this.line.to < e) &&
          ((this.line = this.view.state.doc.lineAt(e)),
          (this.spans = this.view.bidiSpans(this.line))),
        this
      );
    }
    baseDirAt(e, t) {
      let { line: n, spans: r } = this.bidiSpansAt(e);
      return r[Wn.find(r, e - n.from, -1, t)].level == this.baseDir;
    }
    dirAt(e, t) {
      let { line: n, spans: r } = this.bidiSpansAt(e);
      return r[Wn.find(r, e - n.from, -1, t)].dir;
    }
    bidiIn(e, t) {
      let { spans: n, line: r } = this.bidiSpansAt(e);
      return n.length > 1 || (n.length && (n[0].level != this.baseDir || n[0].to + r.from < t));
    }
    scan(e, t, n = !1) {
      let r = 0,
        i = e.length - 1,
        a = new Set(),
        o = this.bidiIn(e[0], e[i]),
        s,
        c,
        l = -1,
        u = 1e9,
        d;
      search: for (; r < i;) {
        let n = i - r,
          f = (r + i) >> 1;
        adjust: if (a.has(f)) {
          let e = r + Math.floor(Math.random() * n);
          for (let t = 0; t < n; t++) {
            if (!a.has(e)) {
              f = e;
              break adjust;
            }
            (e++, e == i && (e = r));
          }
          break search;
        }
        a.add(f);
        let p = t(f);
        if (p)
          for (let t = 0; t < p.length; t++) {
            let n = p[t],
              a = 0;
            if (!(n.width == 0 && p.length > 1)) {
              if (n.bottom < this.y) ((!s || s.bottom < n.bottom) && (s = n), (a = 1));
              else if (n.top > this.y) ((!c || c.top > n.top) && (c = n), (a = -1));
              else {
                let e = n.left > this.x ? this.x - n.left : n.right < this.x ? this.x - n.right : 0,
                  t = Math.abs(e);
                (t < u && ((l = f), (u = t), (d = n)),
                  e && (a = e < 0 == (this.baseDir == I.LTR) ? -1 : 1));
              }
              a == -1 && (!o || this.baseDirAt(e[f], 1))
                ? (i = f)
                : a == 1 && (!o || this.baseDirAt(e[f + 1], -1)) && (r = f + 1);
            }
          }
      }
      if (!d) {
        let n = s && (!c || this.y - s.bottom < c.top - this.y) ? s : c;
        return ((this.y = (n.top + n.bottom) / 2), this.scan(e, t, !0));
      }
      if (u && !n) {
        let { top: n, bottom: r } = d;
        if (s && s.bottom > (n + n + r) / 3) return ((this.y = s.bottom - 1), this.scan(e, t, !0));
        if (c && c.top < (n + r + r) / 3) return ((this.y = c.top + 1), this.scan(e, t, !0));
      }
      let f = (o ? this.dirAt(e[l], 1) : this.baseDir) == I.LTR;
      return {
        i: l,
        after: this.x > (d.left + d.right) / 2 == f,
      };
    }
    scanText(e, t) {
      let n = [];
      for (let r = 0; r < e.length; r = S(e.text, r)) n.push(t + r);
      n.push(t + e.length);
      let r = this.scan(n, (r) => {
        let i = n[r] - t,
          a = n[r + 1] - t;
        return Dn(e.dom, i, a).getClientRects();
      });
      return r.after ? new ji(n[r.i + 1], -1) : new ji(n[r.i], 1);
    }
    scanTile(e, t) {
      if (!e.length) return new ji(t, 1);
      if (e.children.length == 1) {
        let n = e.children[0];
        if (n.isText()) return this.scanText(n, t);
        if (n.isComposite()) return this.scanTile(n, t);
      }
      let n = [t];
      for (let r = 0, i = t; r < e.children.length; r++) n.push((i += e.children[r].length));
      let r = this.scan(n, (t) => {
          let n = e.children[t];
          return n.flags & 48
            ? null
            : (n.dom.nodeType == 1 ? n.dom : Dn(n.dom, 0, n.length)).getClientRects();
        }),
        i = e.children[r.i],
        a = n[r.i];
      return i.isText()
        ? this.scanText(i, a)
        : i.isComposite()
          ? this.scanTile(i, a)
          : r.after
            ? new ji(n[r.i + 1], -1)
            : new ji(a, 1);
    }
  },
  Pi = `￿`,
  Fi = class {
    constructor(e, t) {
      ((this.points = e),
        (this.view = t),
        (this.text = ``),
        (this.lineSeparator = t.state.facet(k.lineSeparator)));
    }
    append(e) {
      this.text += e;
    }
    lineBreak() {
      this.text += Pi;
    }
    readRange(e, t) {
      if (!e) return this;
      let n = e.parentNode;
      for (let r = e; ;) {
        this.findPointBefore(n, r);
        let e = this.text.length;
        this.readNode(r);
        let i = R.get(r),
          a = r.nextSibling;
        if (a == t) {
          i?.breakAfter && !a && n != this.view.contentDOM && this.lineBreak();
          break;
        }
        let o = R.get(a);
        ((i && o
          ? i.breakAfter
          : (i ? i.breakAfter : hn(r)) ||
            (hn(a) && (r.nodeName != `BR` || i?.isWidget()) && this.text.length > e)) &&
          !Li(a, t) &&
          this.lineBreak(),
          (r = a));
      }
      return (this.findPointBefore(n, t), this);
    }
    readTextNode(e) {
      let t = e.nodeValue;
      for (let n of this.points)
        n.node == e && (n.pos = this.text.length + Math.min(n.offset, t.length));
      for (let n = 0, r = this.lineSeparator ? null : /\r\n?|\n/g; ;) {
        let i = -1,
          a = 1,
          o;
        if (
          (this.lineSeparator
            ? ((i = t.indexOf(this.lineSeparator, n)), (a = this.lineSeparator.length))
            : (o = r.exec(t)) && ((i = o.index), (a = o[0].length)),
          this.append(t.slice(n, i < 0 ? t.length : i)),
          i < 0)
        )
          break;
        if ((this.lineBreak(), a > 1))
          for (let t of this.points) t.node == e && t.pos > this.text.length && (t.pos -= a - 1);
        n = i + a;
      }
    }
    readNode(e) {
      let t = R.get(e),
        n = t && t.overrideDOMText;
      if (n != null) {
        this.findPointInside(e, n.length);
        for (let e = n.iter(); !e.next().done;)
          e.lineBreak ? this.lineBreak() : this.append(e.value);
      } else
        e.nodeType == 3
          ? this.readTextNode(e)
          : e.nodeName == `BR`
            ? e.nextSibling && this.lineBreak()
            : e.nodeType == 1 && this.readRange(e.firstChild, null);
    }
    findPointBefore(e, t) {
      for (let n of this.points)
        n.node == e && e.childNodes[n.offset] == t && (n.pos = this.text.length);
    }
    findPointInside(e, t) {
      for (let n of this.points)
        (e.nodeType == 3 ? n.node == e : e.contains(n.node)) &&
          (n.pos = this.text.length + (Ii(e, n.node, n.offset) ? t : 0));
    }
  };
function Ii(e, t, n) {
  for (;;) {
    if (!t || n < _n(t)) return !1;
    if (t == e) return !0;
    ((n = mn(t) + 1), (t = t.parentNode));
  }
}
function Li(e, t) {
  let n;
  for (; !(e == t || !e); e = e.nextSibling) {
    let t = R.get(e);
    if (!t?.isWidget()) return !1;
    t && (n ||= []).push(t);
  }
  if (n) {
    for (let e of n) if (e.overrideDOMText?.length) return !1;
  }
  return !0;
}
var Ri = class {
    constructor(e, t) {
      ((this.node = e), (this.offset = t), (this.pos = -1));
    }
  },
  zi = class {
    constructor(e, t, n, r) {
      ((this.typeOver = r), (this.bounds = null), (this.text = ``), (this.domChanged = t > -1));
      let { impreciseHead: i, impreciseAnchor: a } = e.docView,
        o = e.state.selection;
      if (e.state.readOnly && t > -1) this.newSel = null;
      else if (t > -1 && (this.bounds = Bi(e.docView.tile, t, n, 0))) {
        let t = i || a ? [] : Gi(e),
          n = new Fi(t, e);
        (n.readRange(this.bounds.startDOM, this.bounds.endDOM),
          (this.text = n.text),
          (this.newSel = Ki(t, this.bounds.from)));
      } else {
        let t = e.observer.selectionRange,
          n =
            (i && i.node == t.focusNode && i.offset == t.focusOffset) ||
            !un(e.contentDOM, t.focusNode)
              ? o.main.head
              : e.docView.posFromDOM(t.focusNode, t.focusOffset),
          r =
            (a && a.node == t.anchorNode && a.offset == t.anchorOffset) ||
            !un(e.contentDOM, t.anchorNode)
              ? o.main.anchor
              : e.docView.posFromDOM(t.anchorNode, t.anchorOffset),
          s = e.viewport;
        if (
          (N.ios || N.chrome) &&
          o.main.empty &&
          n != r &&
          (s.from > 0 || s.to < e.state.doc.length)
        ) {
          let t = Math.min(n, r),
            i = Math.max(n, r),
            a = s.from - t,
            o = s.to - i;
          (a == 0 || a == 1 || t == 0) &&
            (o == 0 || o == -1 || i == e.state.doc.length) &&
            ((n = 0), (r = e.state.doc.length));
        }
        if (e.inputState.composing > -1 && o.ranges.length > 1)
          this.newSel = o.replaceRange(T.range(r, n));
        else if (
          e.lineWrapping &&
          r == n &&
          !(o.main.empty && o.main.head == n) &&
          e.inputState.lastTouchTime > Date.now() - 100
        ) {
          let t = e.coordsAtPos(n, -1),
            r = 0;
          (t && (r = e.inputState.lastTouchY <= t.bottom ? -1 : 1),
            (this.newSel = T.create([T.cursor(n, r)])));
        } else this.newSel = T.single(r, n);
      }
    }
  };
function Bi(e, t, n, r) {
  if (e.isComposite()) {
    let i = -1,
      a = -1,
      o = -1,
      s = -1;
    for (let c = 0, l = r, u = r; c < e.children.length; c++) {
      let r = e.children[c],
        d = l + r.length;
      if (l < t && d > n) return Bi(r, t, n, l);
      if ((d >= t && i == -1 && ((i = c), (a = l)), l > n && r.dom.parentNode == e.dom)) {
        ((o = c), (s = u));
        break;
      }
      ((u = d), (l = d + r.breakAfter));
    }
    return {
      from: a,
      to: s < 0 ? r + e.length : s,
      startDOM: (i ? e.children[i - 1].dom.nextSibling : null) || e.dom.firstChild,
      endDOM: o < e.children.length && o >= 0 ? e.children[o].dom : null,
    };
  } else if (e.isText())
    return {
      from: r,
      to: r + e.length,
      startDOM: e.dom,
      endDOM: e.dom.nextSibling,
    };
  else return null;
}
function Vi(e, t) {
  let n,
    { newSel: r } = t,
    { state: i } = e,
    a = i.selection.main,
    o = e.inputState.lastKeyTime > Date.now() - 100 ? e.inputState.lastKeyCode : -1;
  if (t.bounds) {
    let { from: e, to: r } = t.bounds,
      s = a.from,
      c = null;
    (o === 8 || (N.android && t.text.length < r - e)) && ((s = a.to), (c = `end`));
    let l = i.doc.sliceString(e, r, Pi),
      u,
      d;
    !a.empty &&
    a.from >= e &&
    a.to <= r &&
    (t.typeOver || l != t.text) &&
    l.slice(0, a.from - e) == t.text.slice(0, a.from - e) &&
    l.slice(a.to - e) == t.text.slice((u = t.text.length - (l.length - (a.to - e))))
      ? (n = {
          from: a.from,
          to: a.to,
          insert: f.of(t.text.slice(a.from - e, u).split(Pi)),
        })
      : (d = Wi(l, t.text, s - e, c)) &&
        (N.chrome &&
          o == 13 &&
          d.toB == d.from + 2 &&
          t.text.slice(d.from, d.toB) == `￿￿` &&
          d.toB--,
        (n = {
          from: e + d.from,
          to: e + d.toA,
          insert: f.of(t.text.slice(d.from, d.toB).split(Pi)),
        }));
  } else r && ((!e.hasFocus && i.facet(vr)) || qi(r, a)) && (r = null);
  if (!n && !r) return !1;
  if (
    ((N.mac || N.android) &&
    n &&
    n.from == n.to &&
    n.from == a.head - 1 &&
    /^\. ?$/.test(n.insert.toString()) &&
    e.contentDOM.getAttribute(`autocorrect`) == `off`
      ? (r && n.insert.length == 2 && (r = T.single(r.main.anchor - 1, r.main.head - 1)),
        (n = {
          from: n.from,
          to: n.to,
          insert: f.of([n.insert.toString().replace(`.`, ` `)]),
        }))
      : i.doc.lineAt(a.from).to < a.to &&
          e.docView.lineHasWidget(a.to) &&
          e.inputState.insertingTextAt > Date.now() - 50
        ? (n = {
            from: a.from,
            to: a.to,
            insert: i.toText(e.inputState.insertingText),
          })
        : N.chrome &&
          n &&
          n.from == n.to &&
          n.from == a.head &&
          n.insert.toString() ==
            `
 ` &&
          e.lineWrapping &&
          ((r &&= T.single(r.main.anchor - 1, r.main.head - 1)),
          (n = {
            from: a.from,
            to: a.to,
            insert: f.of([` `]),
          })),
    n)
  )
    return Hi(e, n, r, o);
  if (r && !qi(r, a)) {
    let t = !1,
      n = `select`;
    return (
      e.inputState.lastSelectionTime > Date.now() - 50 &&
        (e.inputState.lastSelectionOrigin == `select` && (t = !0),
        (n = e.inputState.lastSelectionOrigin),
        n == `select.pointer` &&
          (r = ki(
            i.facet(Or).map((t) => t(e)),
            r,
          ))),
      e.dispatch({
        selection: r,
        scrollIntoView: t,
        userEvent: n,
      }),
      !0
    );
  } else return !1;
}
function Hi(e, t, n, r = -1) {
  if (N.ios && e.inputState.flushIOSKey(t)) return !0;
  let i = e.state.selection.main;
  if (
    N.android &&
    ((t.to == i.to &&
      (t.from == i.from || (t.from == i.from - 1 && e.state.sliceDoc(t.from, i.from) == ` `)) &&
      t.insert.length == 1 &&
      t.insert.lines == 2 &&
      On(e.contentDOM, `Enter`, 13)) ||
      (((t.from == i.from - 1 && t.to == i.to && t.insert.length == 0) ||
        (r == 8 && t.insert.length < t.to - t.from && t.to > i.head)) &&
        On(e.contentDOM, `Backspace`, 8)) ||
      (t.from == i.from &&
        t.to == i.to + 1 &&
        t.insert.length == 0 &&
        On(e.contentDOM, `Delete`, 46)))
  )
    return !0;
  let a = t.insert.toString();
  e.inputState.composing >= 0 && e.inputState.composing++;
  let o,
    s = () => (o ||= Ui(e, t, n));
  return (e.state.facet(sr).some((n) => n(e, t.from, t.to, a, s)) || e.dispatch(s()), !0);
}
function Ui(e, t, n) {
  let r,
    i = e.state,
    a = i.selection.main,
    o = -1;
  if ((t.from == t.to && t.from < a.from) || t.from > a.to) {
    let n = t.from < a.from ? -1 : 1,
      r = n < 0 ? a.from : a.to,
      s = Oi(
        i.facet(Or).map((t) => t(e)),
        r,
        n,
      );
    t.from == s && (o = s);
  }
  if (o > -1)
    r = {
      changes: t,
      selection: T.cursor(t.from + t.insert.length, -1),
    };
  else if (
    t.from >= a.from &&
    t.to <= a.to &&
    t.to - t.from >= (a.to - a.from) / 3 &&
    (!n || (n.main.empty && n.main.from == t.from + t.insert.length)) &&
    e.inputState.composing < 0
  ) {
    let n = a.from < t.from ? i.sliceDoc(a.from, t.from) : ``,
      o = a.to > t.to ? i.sliceDoc(t.to, a.to) : ``;
    r = i.replaceSelection(
      e.state.toText(n + t.insert.sliceString(0, void 0, e.state.lineBreak) + o),
    );
  } else {
    let o = i.changes(t),
      s = n && n.main.to <= o.newLength ? n.main : void 0;
    if (
      i.selection.ranges.length > 1 &&
      (e.inputState.composing >= 0 || e.inputState.compositionPendingChange) &&
      t.to <= a.to + 10 &&
      t.to >= a.to - 10
    ) {
      let c = e.state.sliceDoc(t.from, t.to),
        l,
        u = n && di(e, n.main.head);
      if (u) {
        let e = t.insert.length - (t.to - t.from);
        l = {
          from: u.from,
          to: u.to - e,
        };
      } else l = e.state.doc.lineAt(a.head);
      let d = a.to - t.to;
      r = i.changeByRange((n) => {
        if (n.from == a.from && n.to == a.to)
          return {
            changes: o,
            range: s || n.map(o),
          };
        let r = n.to - d,
          u = r - c.length;
        if (e.state.sliceDoc(u, r) != c || (r >= l.from && u <= l.to))
          return {
            range: n,
          };
        let f = i.changes({
            from: u,
            to: r,
            insert: t.insert,
          }),
          p = n.to - a.to;
        return {
          changes: f,
          range: s ? T.range(Math.max(0, s.anchor + p), Math.max(0, s.head + p)) : n.map(f),
        };
      });
    } else
      r = {
        changes: o,
        selection: s && i.selection.replaceRange(s),
      };
  }
  let s = `input.type`;
  return (
    (e.composing ||
      (e.inputState.compositionPendingChange &&
        e.inputState.compositionEndedAt > Date.now() - 50)) &&
      ((e.inputState.compositionPendingChange = !1),
      (s += `.compose`),
      e.inputState.compositionFirstChange &&
        ((s += `.start`), (e.inputState.compositionFirstChange = !1))),
    i.update(r, {
      userEvent: s,
      scrollIntoView: !0,
    })
  );
}
function Wi(e, t, n, r) {
  let i = Math.min(e.length, t.length),
    a = 0;
  for (; a < i && e.charCodeAt(a) == t.charCodeAt(a);) a++;
  if (a == i && e.length == t.length) return null;
  let o = e.length,
    s = t.length;
  for (; o > 0 && s > 0 && e.charCodeAt(o - 1) == t.charCodeAt(s - 1);) (o--, s--);
  if (r == `end`) {
    let e = Math.max(0, a - Math.min(o, s));
    n -= o + e - a;
  }
  if (o < a && e.length < t.length) {
    let e = n <= a && n >= o ? a - n : 0;
    ((a -= e), (s = a + (s - o)), (o = a));
  } else if (s < a) {
    let e = n <= a && n >= s ? a - n : 0;
    ((a -= e), (o = a + (o - s)), (s = a));
  }
  return {
    from: a,
    toA: o,
    toB: s,
  };
}
function Gi(e) {
  let t = [];
  if (e.root.activeElement != e.contentDOM) return t;
  let { anchorNode: n, anchorOffset: r, focusNode: i, focusOffset: a } = e.observer.selectionRange;
  return (n && (t.push(new Ri(n, r)), (i != n || a != r) && t.push(new Ri(i, a))), t);
}
function Ki(e, t) {
  if (e.length == 0) return null;
  let n = e[0].pos,
    r = e.length == 2 ? e[1].pos : n;
  return n > -1 && r > -1 ? T.single(n + t, r + t) : null;
}
function qi(e, t) {
  return t.head == e.main.head && t.anchor == e.main.anchor;
}
var Ji = class {
  setSelectionOrigin(e) {
    ((this.lastSelectionOrigin = e), (this.lastSelectionTime = Date.now()));
  }
  constructor(e) {
    ((this.view = e),
      (this.lastKeyCode = 0),
      (this.lastKeyTime = 0),
      (this.lastTouchTime = 0),
      (this.lastTouchX = 0),
      (this.lastTouchY = 0),
      (this.lastFocusTime = 0),
      (this.lastScrollTop = 0),
      (this.lastScrollLeft = 0),
      (this.lastWheelEvent = 0),
      (this.pendingIOSKey = void 0),
      (this.tabFocusMode = -1),
      (this.lastSelectionOrigin = null),
      (this.lastSelectionTime = 0),
      (this.lastContextMenu = 0),
      (this.scrollHandlers = []),
      (this.handlers = Object.create(null)),
      (this.composing = -1),
      (this.compositionFirstChange = null),
      (this.compositionEndedAt = 0),
      (this.compositionPendingKey = !1),
      (this.compositionPendingChange = !1),
      (this.insertingText = ``),
      (this.insertingTextAt = 0),
      (this.mouseSelection = null),
      (this.draggedContent = null),
      (this.handleEvent = this.handleEvent.bind(this)),
      (this.notifiedFocused = e.hasFocus),
      N.safari && e.contentDOM.addEventListener(`input`, () => null),
      N.gecko && Oa(e.contentDOM.ownerDocument));
  }
  handleEvent(e) {
    !sa(this.view, e) ||
      this.ignoreDuringComposition(e) ||
      (e.type == `keydown` && this.keydown(e)) ||
      (this.view.updateState == 0
        ? this.runHandlers(e.type, e)
        : Promise.resolve().then(() => this.runHandlers(e.type, e)));
  }
  runHandlers(e, t) {
    let n = this.handlers[e];
    if (n) {
      for (let e of n.observers) e(this.view, t);
      for (let e of n.handlers) {
        if (t.defaultPrevented) break;
        if (e(this.view, t)) {
          t.preventDefault();
          break;
        }
      }
    }
  }
  ensureHandlers(e) {
    let t = Xi(e),
      n = this.handlers,
      r = this.view.contentDOM;
    for (let e in t)
      if (e != `scroll`) {
        let i = !t[e].handlers.length,
          a = n[e];
        (a && i != !a.handlers.length && (r.removeEventListener(e, this.handleEvent), (a = null)),
          a ||
            r.addEventListener(e, this.handleEvent, {
              passive: i,
            }));
      }
    for (let e in n) e != `scroll` && !t[e] && r.removeEventListener(e, this.handleEvent);
    this.handlers = t;
  }
  keydown(e) {
    if (
      ((this.lastKeyCode = e.keyCode),
      (this.lastKeyTime = Date.now()),
      e.keyCode == 9 &&
        this.tabFocusMode > -1 &&
        (!this.tabFocusMode || Date.now() <= this.tabFocusMode))
    )
      return !0;
    if (
      (this.tabFocusMode > 0 &&
        e.keyCode != 27 &&
        $i.indexOf(e.keyCode) < 0 &&
        (this.tabFocusMode = -1),
      N.android && N.chrome && !e.synthetic && (e.keyCode == 13 || e.keyCode == 8))
    )
      return (this.view.observer.delayAndroidKey(e.key, e.keyCode), !0);
    let t;
    return N.ios &&
      !e.synthetic &&
      !e.altKey &&
      !e.metaKey &&
      !e.shiftKey &&
      (((t = Zi.find((t) => t.keyCode == e.keyCode)) && !e.ctrlKey) ||
        (Qi.indexOf(e.key) > -1 && e.ctrlKey))
      ? ((this.pendingIOSKey = t || e), setTimeout(() => this.flushIOSKey(), 250), !0)
      : (e.keyCode != 229 && this.view.observer.forceFlush(), !1);
  }
  flushIOSKey(e) {
    let t = this.pendingIOSKey;
    return !t || (t.key == `Enter` && e && e.from < e.to && /^\S+$/.test(e.insert.toString()))
      ? !1
      : ((this.pendingIOSKey = void 0),
        On(this.view.contentDOM, t.key, t.keyCode, t instanceof KeyboardEvent ? t : void 0));
  }
  ignoreDuringComposition(e) {
    return !/^key/.test(e.type) || e.synthetic
      ? !1
      : this.composing > 0
        ? !0
        : N.safari &&
            !N.ios &&
            this.compositionPendingKey &&
            Date.now() - this.compositionEndedAt < 100
          ? ((this.compositionPendingKey = !1), !0)
          : !1;
  }
  startMouseSelection(e) {
    (this.mouseSelection && this.mouseSelection.destroy(), (this.mouseSelection = e));
  }
  update(e) {
    (this.view.observer.update(e),
      this.mouseSelection && this.mouseSelection.update(e),
      this.draggedContent &&
        e.docChanged &&
        (this.draggedContent = this.draggedContent.map(e.changes)),
      e.transactions.length && (this.lastKeyCode = this.lastSelectionTime = 0));
  }
  destroy() {
    this.mouseSelection && this.mouseSelection.destroy();
  }
};
function Yi(e, t) {
  return (n, r) => {
    try {
      return t.call(e, r, n);
    } catch (e) {
      _r(n.state, e);
    }
  };
}
function Xi(e) {
  let t = Object.create(null);
  function n(e) {
    return (
      t[e] ||
      (t[e] = {
        observers: [],
        handlers: [],
      })
    );
  }
  for (let t of e) {
    let e = t.spec,
      r = e && e.plugin.domEventHandlers,
      i = e && e.plugin.domEventObservers;
    if (r)
      for (let e in r) {
        let i = r[e];
        i && n(e).handlers.push(Yi(t.value, i));
      }
    if (i)
      for (let e in i) {
        let r = i[e];
        r && n(e).observers.push(Yi(t.value, r));
      }
  }
  for (let e in B) n(e).handlers.push(B[e]);
  for (let e in V) n(e).observers.push(V[e]);
  return t;
}
var Zi = [
    {
      key: `Backspace`,
      keyCode: 8,
      inputType: `deleteContentBackward`,
    },
    {
      key: `Enter`,
      keyCode: 13,
      inputType: `insertParagraph`,
    },
    {
      key: `Enter`,
      keyCode: 13,
      inputType: `insertLineBreak`,
    },
    {
      key: `Delete`,
      keyCode: 46,
      inputType: `deleteContentForward`,
    },
  ],
  Qi = `dthko`,
  $i = [16, 17, 18, 20, 91, 92, 224, 225],
  ea = 6;
function ta(e) {
  return Math.max(0, e) * 0.7 + 8;
}
function na(e, t) {
  return Math.max(Math.abs(e.clientX - t.clientX), Math.abs(e.clientY - t.clientY));
}
var ra = class {
  constructor(e, t, n, r) {
    ((this.view = e),
      (this.startEvent = t),
      (this.style = n),
      (this.mustSelect = r),
      (this.scrollSpeed = {
        x: 0,
        y: 0,
      }),
      (this.scrolling = -1),
      (this.lastEvent = t),
      (this.scrollParents = Sn(e.contentDOM)),
      (this.atoms = e.state.facet(Or).map((t) => t(e))));
    let i = e.contentDOM.ownerDocument;
    (i.addEventListener(`mousemove`, (this.move = this.move.bind(this))),
      i.addEventListener(`mouseup`, (this.up = this.up.bind(this))),
      (this.extend = t.shiftKey),
      (this.multiple = e.state.facet(k.allowMultipleSelections) && ia(e, t)),
      (this.dragging = oa(e, t) && _a(t) == 1 ? null : !1));
  }
  start(e) {
    this.dragging === !1 && this.select(e);
  }
  move(e) {
    if (e.buttons == 0) return this.destroy();
    if (this.dragging || (this.dragging == null && na(this.startEvent, e) < 10)) return;
    this.select((this.lastEvent = e));
    let t = 0,
      n = 0,
      r = 0,
      i = 0,
      a = this.view.win.innerWidth,
      o = this.view.win.innerHeight;
    (this.scrollParents.x && ({ left: r, right: a } = this.scrollParents.x.getBoundingClientRect()),
      this.scrollParents.y &&
        ({ top: i, bottom: o } = this.scrollParents.y.getBoundingClientRect()));
    let s = Mr(this.view);
    (e.clientX - s.left <= r + ea
      ? (t = -ta(r - e.clientX))
      : e.clientX + s.right >= a - ea && (t = ta(e.clientX - a)),
      e.clientY - s.top <= i + ea
        ? (n = -ta(i - e.clientY))
        : e.clientY + s.bottom >= o - ea && (n = ta(e.clientY - o)),
      this.setScrollSpeed(t, n));
  }
  up(e) {
    (this.dragging ?? this.select(this.lastEvent),
      this.dragging || e.preventDefault(),
      this.destroy());
  }
  destroy() {
    this.setScrollSpeed(0, 0);
    let e = this.view.contentDOM.ownerDocument;
    (e.removeEventListener(`mousemove`, this.move),
      e.removeEventListener(`mouseup`, this.up),
      (this.view.inputState.mouseSelection = this.view.inputState.draggedContent = null));
  }
  setScrollSpeed(e, t) {
    ((this.scrollSpeed = {
      x: e,
      y: t,
    }),
      e || t
        ? this.scrolling < 0 && (this.scrolling = setInterval(() => this.scroll(), 50))
        : this.scrolling > -1 && (clearInterval(this.scrolling), (this.scrolling = -1)));
  }
  scroll() {
    let { x: e, y: t } = this.scrollSpeed;
    (e && this.scrollParents.x && ((this.scrollParents.x.scrollLeft += e), (e = 0)),
      t && this.scrollParents.y && ((this.scrollParents.y.scrollTop += t), (t = 0)),
      (e || t) && this.view.win.scrollBy(e, t),
      this.dragging === !1 && this.select(this.lastEvent));
  }
  select(e) {
    let { view: t } = this,
      n = ki(this.atoms, this.style.get(e, this.extend, this.multiple));
    ((this.mustSelect || !n.eq(t.state.selection, this.dragging === !1)) &&
      this.view.dispatch({
        selection: n,
        userEvent: `select.pointer`,
      }),
      (this.mustSelect = !1));
  }
  update(e) {
    e.transactions.some((e) => e.isUserEvent(`input.type`))
      ? this.destroy()
      : this.style.update(e) && setTimeout(() => this.select(this.lastEvent), 20);
  }
};
function ia(e, t) {
  let n = e.state.facet(nr);
  return n.length ? n[0](t) : N.mac ? t.metaKey : t.ctrlKey;
}
function aa(e, t) {
  let n = e.state.facet(rr);
  return n.length ? n[0](t) : N.mac ? !t.altKey : !t.ctrlKey;
}
function oa(e, t) {
  let { main: n } = e.state.selection;
  if (n.empty) return !1;
  let r = ln(e.root);
  if (!r || r.rangeCount == 0) return !0;
  let i = r.getRangeAt(0).getClientRects();
  for (let e = 0; e < i.length; e++) {
    let n = i[e];
    if (n.left <= t.clientX && n.right >= t.clientX && n.top <= t.clientY && n.bottom >= t.clientY)
      return !0;
  }
  return !1;
}
function sa(e, t) {
  if (!t.bubbles) return !0;
  if (t.defaultPrevented) return !1;
  for (let n = t.target, r; n != e.contentDOM; n = n.parentNode)
    if (
      !n ||
      n.nodeType == 11 ||
      ((r = R.get(n)) && r.isWidget() && !r.isHidden && r.widget.ignoreEvent(t))
    )
      return !1;
  return !0;
}
var B = Object.create(null),
  V = Object.create(null),
  ca = (N.ie && N.ie_version < 15) || (N.ios && N.webkit_version < 604);
function la(e) {
  let t = e.dom.parentNode;
  if (!t) return;
  let n = t.appendChild(document.createElement(`textarea`));
  ((n.style.cssText = `position: fixed; left: -10000px; top: 10px`),
    n.focus(),
    setTimeout(() => {
      (e.focus(), n.remove(), da(e, n.value));
    }, 50));
}
function ua(e, t, n) {
  for (let r of e.facet(t)) n = r(n, e);
  return n;
}
function da(e, t) {
  t = ua(e.state, lr, t);
  let { state: n } = e,
    r,
    i = 1,
    a = n.toText(t),
    o = a.lines == n.selection.ranges.length;
  if (Ca != null && n.selection.ranges.every((e) => e.empty) && Ca == a.toString()) {
    let e = -1;
    r = n.changeByRange((r) => {
      let s = n.doc.lineAt(r.from);
      if (s.from == e)
        return {
          range: r,
        };
      e = s.from;
      let c = n.toText((o ? a.line(i++).text : t) + n.lineBreak);
      return {
        changes: {
          from: s.from,
          insert: c,
        },
        range: T.cursor(r.from + c.length),
      };
    });
  } else
    r = o
      ? n.changeByRange((e) => {
          let t = a.line(i++);
          return {
            changes: {
              from: e.from,
              to: e.to,
              insert: t.text,
            },
            range: T.cursor(e.from + t.length),
          };
        })
      : n.replaceSelection(a);
  e.dispatch(r, {
    userEvent: `input.paste`,
    scrollIntoView: !0,
  });
}
((V.scroll = (e) => {
  ((e.inputState.lastScrollTop = e.scrollDOM.scrollTop),
    (e.inputState.lastScrollLeft = e.scrollDOM.scrollLeft));
}),
  (V.wheel = V.mousewheel =
    (e) => {
      e.inputState.lastWheelEvent = Date.now();
    }),
  (B.keydown = (e, t) => (
    e.inputState.setSelectionOrigin(`select`),
    t.keyCode == 27 &&
      e.inputState.tabFocusMode != 0 &&
      (e.inputState.tabFocusMode = Date.now() + 2e3),
    !1
  )),
  (V.touchstart = (e, t) => {
    let n = e.inputState,
      r = t.targetTouches[0];
    ((n.lastTouchTime = Date.now()),
      r && ((n.lastTouchX = r.clientX), (n.lastTouchY = r.clientY)),
      n.setSelectionOrigin(`select.pointer`));
  }),
  (V.touchmove = (e) => {
    e.inputState.setSelectionOrigin(`select.pointer`);
  }),
  (B.mousedown = (e, t) => {
    if ((e.observer.flush(), e.inputState.lastTouchTime > Date.now() - 2e3)) return !1;
    let n = null;
    for (let r of e.state.facet(ir)) if (((n = r(e, t)), n)) break;
    if ((!n && t.button == 0 && (n = va(e, t)), n)) {
      let r = !e.hasFocus;
      (e.inputState.startMouseSelection(new ra(e, t, n, r)),
        r &&
          e.observer.ignore(() => {
            Tn(e.contentDOM);
            let t = e.root.activeElement;
            t && !t.contains(e.contentDOM) && t.blur();
          }));
      let i = e.inputState.mouseSelection;
      if (i) return (i.start(t), i.dragging === !1);
    } else e.inputState.setSelectionOrigin(`select.pointer`);
    return !1;
  }));
function fa(e, t, n, r) {
  if (r == 1) return T.cursor(t, n);
  if (r == 2) return xi(e.state, t, n);
  {
    let r = e.docView.lineAt(t, n),
      i = e.state.doc.lineAt(r ? r.posAtEnd : t),
      a = r ? r.posAtStart : i.from,
      o = r ? r.posAtEnd : i.to;
    return (o < e.state.doc.length && o == i.to && o++, T.range(a, o));
  }
}
var pa = N.ie && N.ie_version <= 11,
  ma = null,
  ha = 0,
  ga = 0;
function _a(e) {
  if (!pa) return e.detail;
  let t = ma,
    n = ga;
  return (
    (ma = e),
    (ga = Date.now()),
    (ha =
      !t ||
      (n > Date.now() - 400 &&
        Math.abs(t.clientX - e.clientX) < 2 &&
        Math.abs(t.clientY - e.clientY) < 2)
        ? (ha + 1) % 3
        : 1)
  );
}
function va(e, t) {
  let n = e.posAndSideAtCoords(
      {
        x: t.clientX,
        y: t.clientY,
      },
      !1,
    ),
    r = _a(t),
    i = e.state.selection;
  return {
    update(e) {
      e.docChanged && ((n.pos = e.changes.mapPos(n.pos)), (i = i.map(e.changes)));
    },
    get(t, a, o) {
      let s = e.posAndSideAtCoords(
          {
            x: t.clientX,
            y: t.clientY,
          },
          !1,
        ),
        c,
        l = fa(e, s.pos, s.assoc, r);
      if (n.pos != s.pos && !a) {
        let t = fa(e, n.pos, n.assoc, r),
          i = Math.min(t.from, l.from),
          a = Math.max(t.to, l.to);
        l = i < l.from ? T.range(i, a, l.assoc) : T.range(a, i, l.assoc);
      }
      return a
        ? i.replaceRange(i.main.extend(l.from, l.to, l.assoc))
        : o && r == 1 && i.ranges.length > 1 && (c = ya(i, s.pos))
          ? c
          : o
            ? i.addRange(l)
            : T.create([l]);
    },
  };
}
function ya(e, t) {
  for (let n = 0; n < e.ranges.length; n++) {
    let { from: r, to: i } = e.ranges[n];
    if (r <= t && i >= t)
      return T.create(
        e.ranges.slice(0, n).concat(e.ranges.slice(n + 1)),
        e.mainIndex == n ? 0 : e.mainIndex - +(e.mainIndex > n),
      );
  }
  return null;
}
((B.dragstart = (e, t) => {
  let {
    selection: { main: n },
  } = e.state;
  if (t.target.draggable) {
    let r = e.docView.tile.nearest(t.target);
    if (r && r.isWidget()) {
      let e = r.posAtStart,
        t = e + r.length;
      (e >= n.to || t <= n.from) && (n = T.range(e, t));
    }
  }
  let { inputState: r } = e;
  return (
    r.mouseSelection && (r.mouseSelection.dragging = !0),
    (r.draggedContent = n),
    t.dataTransfer &&
      (t.dataTransfer.setData(`Text`, ua(e.state, ur, e.state.sliceDoc(n.from, n.to))),
      (t.dataTransfer.effectAllowed = `copyMove`)),
    !1
  );
}),
  (B.dragend = (e) => ((e.inputState.draggedContent = null), !1)));
function ba(e, t, n, r) {
  if (((n = ua(e.state, lr, n)), !n)) return;
  let i = e.posAtCoords(
      {
        x: t.clientX,
        y: t.clientY,
      },
      !1,
    ),
    { draggedContent: a } = e.inputState,
    o =
      r && a && aa(e, t)
        ? {
            from: a.from,
            to: a.to,
          }
        : null,
    s = {
      from: i,
      insert: n,
    },
    c = e.state.changes(o ? [o, s] : s);
  (e.focus(),
    e.dispatch({
      changes: c,
      selection: {
        anchor: c.mapPos(i, -1),
        head: c.mapPos(i, 1),
      },
      userEvent: o ? `move.drop` : `input.drop`,
    }),
    (e.inputState.draggedContent = null));
}
((B.drop = (e, t) => {
  if (!t.dataTransfer) return !1;
  if (e.state.readOnly) return !0;
  let n = t.dataTransfer.files;
  if (n && n.length) {
    let r = Array(n.length),
      i = 0,
      a = () => {
        ++i == n.length && ba(e, t, r.filter((e) => e != null).join(e.state.lineBreak), !1);
      };
    for (let e = 0; e < n.length; e++) {
      let t = new FileReader();
      ((t.onerror = a),
        (t.onload = () => {
          (/[\x00-\x08\x0e-\x1f]{2}/.test(t.result) || (r[e] = t.result), a());
        }),
        t.readAsText(n[e]));
    }
    return !0;
  } else {
    let n = t.dataTransfer.getData(`Text`);
    if (n) return (ba(e, t, n, !0), !0);
  }
  return !1;
}),
  (B.paste = (e, t) => {
    if (e.state.readOnly) return !0;
    e.observer.flush();
    let n = ca ? null : t.clipboardData;
    return n ? (da(e, n.getData(`text/plain`) || n.getData(`text/uri-list`)), !0) : (la(e), !1);
  }));
function xa(e, t) {
  let n = e.dom.parentNode;
  if (!n) return;
  let r = n.appendChild(document.createElement(`textarea`));
  ((r.style.cssText = `position: fixed; left: -10000px; top: 10px`),
    (r.value = t),
    r.focus(),
    (r.selectionEnd = t.length),
    (r.selectionStart = 0),
    setTimeout(() => {
      (r.remove(), e.focus());
    }, 50));
}
function Sa(e) {
  let t = [],
    n = [],
    r = !1;
  for (let r of e.selection.ranges) r.empty || (t.push(e.sliceDoc(r.from, r.to)), n.push(r));
  if (!t.length) {
    let i = -1;
    for (let { from: r } of e.selection.ranges) {
      let a = e.doc.lineAt(r);
      (a.number > i &&
        (t.push(a.text),
        n.push({
          from: a.from,
          to: Math.min(e.doc.length, a.to + 1),
        })),
        (i = a.number));
    }
    r = !0;
  }
  return {
    text: ua(e, ur, t.join(e.lineBreak)),
    ranges: n,
    linewise: r,
  };
}
var Ca = null;
B.copy = B.cut = (e, t) => {
  if (!dn(e.contentDOM, e.observer.selectionRange)) return !1;
  let { text: n, ranges: r, linewise: i } = Sa(e.state);
  if (!n && !i) return !1;
  ((Ca = i ? n : null),
    t.type == `cut` &&
      !e.state.readOnly &&
      e.dispatch({
        changes: r,
        scrollIntoView: !0,
        userEvent: `delete.cut`,
      }));
  let a = ca ? null : t.clipboardData;
  return a ? (a.clearData(), a.setData(`text/plain`, n), !0) : (xa(e, n), !1);
};
var wa = Ve.define();
function Ta(e, t) {
  let n = [];
  for (let r of e.facet(cr)) {
    let i = r(e, t);
    i && n.push(i);
  }
  return n.length
    ? e.update({
        effects: n,
        annotations: wa.of(!0),
      })
    : null;
}
function Ea(e) {
  setTimeout(() => {
    let t = e.hasFocus;
    if (t != e.inputState.notifiedFocused) {
      let n = Ta(e.state, t);
      n ? e.dispatch(n) : e.update([]);
    }
  }, 10);
}
((V.focus = (e) => {
  ((e.inputState.lastFocusTime = Date.now()),
    !e.scrollDOM.scrollTop &&
      (e.inputState.lastScrollTop || e.inputState.lastScrollLeft) &&
      ((e.scrollDOM.scrollTop = e.inputState.lastScrollTop),
      (e.scrollDOM.scrollLeft = e.inputState.lastScrollLeft)),
    Ea(e));
}),
  (V.blur = (e) => {
    (e.observer.clearSelectionRange(), Ea(e));
  }),
  (V.compositionstart = V.compositionupdate =
    (e) => {
      e.observer.editContext ||
        (e.inputState.compositionFirstChange ?? (e.inputState.compositionFirstChange = !0),
        e.inputState.composing < 0 && (e.inputState.composing = 0));
    }),
  (V.compositionend = (e) => {
    e.observer.editContext ||
      ((e.inputState.composing = -1),
      (e.inputState.compositionEndedAt = Date.now()),
      (e.inputState.compositionPendingKey = !0),
      (e.inputState.compositionPendingChange = e.observer.pendingRecords().length > 0),
      (e.inputState.compositionFirstChange = null),
      N.chrome && N.android
        ? e.observer.flushSoon()
        : e.inputState.compositionPendingChange
          ? Promise.resolve().then(() => e.observer.flush())
          : setTimeout(() => {
              e.inputState.composing < 0 && e.docView.hasComposition && e.update([]);
            }, 50));
  }),
  (V.contextmenu = (e) => {
    e.inputState.lastContextMenu = Date.now();
  }),
  (B.beforeinput = (e, t) => {
    if (
      ((t.inputType == `insertText` || t.inputType == `insertCompositionText`) &&
        ((e.inputState.insertingText = t.data), (e.inputState.insertingTextAt = Date.now())),
      t.inputType == `insertReplacementText` && e.observer.editContext)
    ) {
      let n = t.dataTransfer?.getData(`text/plain`),
        r = t.getTargetRanges();
      if (n && r.length) {
        let t = r[0];
        return (
          Hi(
            e,
            {
              from: e.posAtDOM(t.startContainer, t.startOffset),
              to: e.posAtDOM(t.endContainer, t.endOffset),
              insert: e.state.toText(n),
            },
            null,
          ),
          !0
        );
      }
    }
    let n;
    if (
      N.chrome &&
      N.android &&
      (n = Zi.find((e) => e.inputType == t.inputType)) &&
      (e.observer.delayAndroidKey(n.key, n.keyCode), n.key == `Backspace` || n.key == `Delete`)
    ) {
      let t = window.visualViewport?.height || 0;
      setTimeout(() => {
        (window.visualViewport?.height || 0) > t + 10 &&
          e.hasFocus &&
          (e.contentDOM.blur(), e.focus());
      }, 100);
    }
    return (
      N.ios && t.inputType == `deleteContentForward` && e.observer.flushSoon(),
      N.safari &&
        t.inputType == `insertText` &&
        e.inputState.composing >= 0 &&
        setTimeout(() => V.compositionend(e, t), 20),
      !1
    );
  }));
var Da = new Set();
function Oa(e) {
  Da.has(e) ||
    (Da.add(e), e.addEventListener(`copy`, () => {}), e.addEventListener(`cut`, () => {}));
}
var ka = [`pre-wrap`, `normal`, `pre-line`, `break-spaces`],
  Aa = !1;
function ja() {
  Aa = !1;
}
var Ma = class {
    constructor(e) {
      ((this.lineWrapping = e),
        (this.doc = f.empty),
        (this.heightSamples = {}),
        (this.lineHeight = 14),
        (this.charWidth = 7),
        (this.textHeight = 14),
        (this.lineLength = 30));
    }
    heightForGap(e, t) {
      let n = this.doc.lineAt(t).number - this.doc.lineAt(e).number + 1;
      return (
        this.lineWrapping &&
          (n += Math.max(0, Math.ceil((t - e - n * this.lineLength * 0.5) / this.lineLength))),
        this.lineHeight * n
      );
    }
    heightForLine(e) {
      return this.lineWrapping
        ? (1 + Math.max(0, Math.ceil((e - this.lineLength) / Math.max(1, this.lineLength - 5)))) *
            this.lineHeight
        : this.lineHeight;
    }
    setDoc(e) {
      return ((this.doc = e), this);
    }
    mustRefreshForWrapping(e) {
      return ka.indexOf(e) > -1 != this.lineWrapping;
    }
    mustRefreshForHeights(e) {
      let t = !1;
      for (let n = 0; n < e.length; n++) {
        let r = e[n];
        r < 0
          ? n++
          : this.heightSamples[Math.floor(r * 10)] ||
            ((t = !0), (this.heightSamples[Math.floor(r * 10)] = !0));
      }
      return t;
    }
    refresh(e, t, n, r, i, a) {
      let o = ka.indexOf(e) > -1,
        s = Math.abs(t - this.lineHeight) > 0.3 || this.lineWrapping != o;
      if (
        ((this.lineWrapping = o),
        (this.lineHeight = t),
        (this.charWidth = n),
        (this.textHeight = r),
        (this.lineLength = i),
        s)
      ) {
        this.heightSamples = {};
        for (let e = 0; e < a.length; e++) {
          let t = a[e];
          t < 0 ? e++ : (this.heightSamples[Math.floor(t * 10)] = !0);
        }
      }
      return s;
    }
  },
  Na = class {
    constructor(e, t) {
      ((this.from = e), (this.heights = t), (this.index = 0));
    }
    get more() {
      return this.index < this.heights.length;
    }
  },
  Pa = class e {
    constructor(e, t, n, r, i) {
      ((this.from = e), (this.length = t), (this.top = n), (this.height = r), (this._content = i));
    }
    get type() {
      return typeof this._content == `number`
        ? P.Text
        : Array.isArray(this._content)
          ? this._content
          : this._content.type;
    }
    get to() {
      return this.from + this.length;
    }
    get bottom() {
      return this.top + this.height;
    }
    get widget() {
      return this._content instanceof rn ? this._content.widget : null;
    }
    get widgetLineBreaks() {
      return typeof this._content == `number` ? this._content : 0;
    }
    join(t) {
      let n = (Array.isArray(this._content) ? this._content : [this]).concat(
        Array.isArray(t._content) ? t._content : [t],
      );
      return new e(this.from, this.length + t.length, this.top, this.height + t.height, n);
    }
  },
  H = (function (e) {
    return (
      (e[(e.ByPos = 0)] = `ByPos`),
      (e[(e.ByHeight = 1)] = `ByHeight`),
      (e[(e.ByPosNoHeight = 2)] = `ByPosNoHeight`),
      e
    );
  })((H ||= {})),
  Fa = 0.001,
  Ia = class e {
    constructor(e, t, n = 2) {
      ((this.length = e), (this.height = t), (this.flags = n));
    }
    get outdated() {
      return (this.flags & 2) > 0;
    }
    set outdated(e) {
      this.flags = (e ? 2 : 0) | (this.flags & -3);
    }
    setHeight(e) {
      this.height != e && (Math.abs(this.height - e) > Fa && (Aa = !0), (this.height = e));
    }
    replace(t, n, r) {
      return e.of(r);
    }
    decomposeLeft(e, t) {
      t.push(this);
    }
    decomposeRight(e, t) {
      t.push(this);
    }
    applyChanges(e, t, n, r) {
      let i = this,
        a = n.doc;
      for (let o = r.length - 1; o >= 0; o--) {
        let { fromA: s, toA: c, fromB: l, toB: u } = r[o],
          d = i.lineAt(s, H.ByPosNoHeight, n.setDoc(t), 0, 0),
          f = d.to >= c ? d : i.lineAt(c, H.ByPosNoHeight, n, 0, 0);
        for (u += f.to - c, c = f.to; o > 0 && d.from <= r[o - 1].toA;)
          ((s = r[o - 1].fromA),
            (l = r[o - 1].fromB),
            o--,
            s < d.from && (d = i.lineAt(s, H.ByPosNoHeight, n, 0, 0)));
        ((l += d.from - s), (s = d.from));
        let p = Ga.build(n.setDoc(a), e, l, u);
        i = La(i, i.replace(s, c, p));
      }
      return i.updateHeight(n, 0);
    }
    static empty() {
      return new Ba(0, 0, 0);
    }
    static of(t) {
      if (t.length == 1) return t[0];
      let n = 0,
        r = t.length,
        i = 0,
        a = 0;
      for (;;)
        if (n == r) {
          if (i > a * 2) {
            let e = t[n - 1];
            (e.break ? t.splice(--n, 1, e.left, null, e.right) : t.splice(--n, 1, e.left, e.right),
              (r += 1 + e.break),
              (i -= e.size));
          } else if (a > i * 2) {
            let e = t[r];
            (e.break ? t.splice(r, 1, e.left, null, e.right) : t.splice(r, 1, e.left, e.right),
              (r += 2 + e.break),
              (a -= e.size));
          } else break;
        } else if (i < a) {
          let e = t[n++];
          e && (i += e.size);
        } else {
          let e = t[--r];
          e && (a += e.size);
        }
      let o = 0;
      return (
        t[n - 1] == null ? ((o = 1), n--) : (t[n] ?? ((o = 1), r++)),
        new Ha(e.of(t.slice(0, n)), o, e.of(t.slice(r)))
      );
    }
  };
function La(e, t) {
  return e == t ? e : (e.constructor != t.constructor && (Aa = !0), t);
}
Ia.prototype.size = 1;
var Ra = F.replace({}),
  za = class extends Ia {
    constructor(e, t, n) {
      (super(e, t), (this.deco = n), (this.spaceAbove = 0));
    }
    mainBlock(e, t) {
      return new Pa(
        t,
        this.length,
        e + this.spaceAbove,
        this.height - this.spaceAbove,
        this.deco || 0,
      );
    }
    blockAt(e, t, n, r) {
      return this.spaceAbove && e < n + this.spaceAbove
        ? new Pa(r, 0, n, this.spaceAbove, Ra)
        : this.mainBlock(n, r);
    }
    lineAt(e, t, n, r, i) {
      let a = this.mainBlock(r, i);
      return this.spaceAbove ? this.blockAt(0, n, r, i).join(a) : a;
    }
    forEachLine(e, t, n, r, i, a) {
      e <= i + this.length && t >= i && a(this.lineAt(0, H.ByPos, n, r, i));
    }
    setMeasuredHeight(e) {
      let t = e.heights[e.index++];
      (t < 0 ? ((this.spaceAbove = -t), (t = e.heights[e.index++])) : (this.spaceAbove = 0),
        this.setHeight(t));
    }
    updateHeight(e, t = 0, n = !1, r) {
      return (r && r.from <= t && r.more && this.setMeasuredHeight(r), (this.outdated = !1), this);
    }
    toString() {
      return `block(${this.length})`;
    }
  },
  Ba = class e extends za {
    constructor(e, t, n) {
      (super(e, t, null),
        (this.collapsed = 0),
        (this.widgetHeight = 0),
        (this.breaks = 0),
        (this.spaceAbove = n));
    }
    mainBlock(e, t) {
      return new Pa(
        t,
        this.length,
        e + this.spaceAbove,
        this.height - this.spaceAbove,
        this.breaks,
      );
    }
    replace(t, n, r) {
      let i = r[0];
      return r.length == 1 &&
        (i instanceof e || (i instanceof Va && i.flags & 4)) &&
        Math.abs(this.length - i.length) < 10
        ? (i instanceof Va
            ? (i = new e(i.length, this.height, this.spaceAbove))
            : (i.height = this.height),
          this.outdated || (i.outdated = !1),
          i)
        : Ia.of(r);
    }
    updateHeight(e, t = 0, n = !1, r) {
      return (
        r && r.from <= t && r.more
          ? this.setMeasuredHeight(r)
          : (n || this.outdated) &&
            ((this.spaceAbove = 0),
            this.setHeight(
              Math.max(this.widgetHeight, e.heightForLine(this.length - this.collapsed)) +
                this.breaks * e.lineHeight,
            )),
        (this.outdated = !1),
        this
      );
    }
    toString() {
      return `line(${this.length}${this.collapsed ? -this.collapsed : ``}${this.widgetHeight ? `:` + this.widgetHeight : ``})`;
    }
  },
  Va = class e extends Ia {
    constructor(e) {
      super(e, 0);
    }
    heightMetrics(e, t) {
      let n = e.doc.lineAt(t).number,
        r = e.doc.lineAt(t + this.length).number,
        i = r - n + 1,
        a,
        o = 0;
      if (e.lineWrapping) {
        let t = Math.min(this.height, e.lineHeight * i);
        ((a = t / i), this.length > i + 1 && (o = (this.height - t) / (this.length - i - 1)));
      } else a = this.height / i;
      return {
        firstLine: n,
        lastLine: r,
        perLine: a,
        perChar: o,
      };
    }
    blockAt(e, t, n, r) {
      let { firstLine: i, lastLine: a, perLine: o, perChar: s } = this.heightMetrics(t, r);
      if (t.lineWrapping) {
        let i =
            r +
            (e < t.lineHeight
              ? 0
              : Math.round(Math.max(0, Math.min(1, (e - n) / this.height)) * this.length)),
          a = t.doc.lineAt(i),
          c = o + a.length * s,
          l = Math.max(n, e - c / 2);
        return new Pa(a.from, a.length, l, c, 0);
      } else {
        let r = Math.max(0, Math.min(a - i, Math.floor((e - n) / o))),
          { from: s, length: c } = t.doc.line(i + r);
        return new Pa(s, c, n + o * r, o, 0);
      }
    }
    lineAt(e, t, n, r, i) {
      if (t == H.ByHeight) return this.blockAt(e, n, r, i);
      if (t == H.ByPosNoHeight) {
        let { from: t, to: r } = n.doc.lineAt(e);
        return new Pa(t, r - t, 0, 0, 0);
      }
      let { firstLine: a, perLine: o, perChar: s } = this.heightMetrics(n, i),
        c = n.doc.lineAt(e),
        l = o + c.length * s,
        u = c.number - a,
        d = r + o * u + s * (c.from - i - u);
      return new Pa(c.from, c.length, Math.max(r, Math.min(d, r + this.height - l)), l, 0);
    }
    forEachLine(e, t, n, r, i, a) {
      ((e = Math.max(e, i)), (t = Math.min(t, i + this.length)));
      let { firstLine: o, perLine: s, perChar: c } = this.heightMetrics(n, i);
      for (let l = e, u = r; l <= t;) {
        let t = n.doc.lineAt(l);
        if (l == e) {
          let n = t.number - o;
          u += s * n + c * (e - i - n);
        }
        let r = s + c * t.length;
        (a(new Pa(t.from, t.length, u, r, 0)), (u += r), (l = t.to + 1));
      }
    }
    replace(t, n, r) {
      let i = this.length - n;
      if (i > 0) {
        let t = r[r.length - 1];
        t instanceof e ? (r[r.length - 1] = new e(t.length + i)) : r.push(null, new e(i - 1));
      }
      if (t > 0) {
        let n = r[0];
        n instanceof e ? (r[0] = new e(t + n.length)) : r.unshift(new e(t - 1), null);
      }
      return Ia.of(r);
    }
    decomposeLeft(t, n) {
      n.push(new e(t - 1), null);
    }
    decomposeRight(t, n) {
      n.push(null, new e(this.length - t - 1));
    }
    updateHeight(t, n = 0, r = !1, i) {
      let a = n + this.length;
      if (i && i.from <= n + this.length && i.more) {
        let r = [],
          o = Math.max(n, i.from),
          s = -1;
        for (i.from > n && r.push(new e(i.from - n - 1).updateHeight(t, n)); o <= a && i.more;) {
          let e = t.doc.lineAt(o).length;
          r.length && r.push(null);
          let n = i.heights[i.index++],
            a = 0;
          (n < 0 && ((a = -n), (n = i.heights[i.index++])),
            s == -1 ? (s = n) : Math.abs(n - s) >= Fa && (s = -2));
          let c = new Ba(e, n, a);
          ((c.outdated = !1), r.push(c), (o += e + 1));
        }
        o <= a && r.push(null, new e(a - o).updateHeight(t, o));
        let c = Ia.of(r);
        return (
          (s < 0 ||
            Math.abs(c.height - this.height) >= Fa ||
            Math.abs(s - this.heightMetrics(t, n).perLine) >= Fa) &&
            (Aa = !0),
          La(this, c)
        );
      } else
        (r || this.outdated) &&
          (this.setHeight(t.heightForGap(n, n + this.length)), (this.outdated = !1));
      return this;
    }
    toString() {
      return `gap(${this.length})`;
    }
  },
  Ha = class extends Ia {
    constructor(e, t, n) {
      (super(e.length + t + n.length, e.height + n.height, t | (e.outdated || n.outdated ? 2 : 0)),
        (this.left = e),
        (this.right = n),
        (this.size = e.size + n.size));
    }
    get break() {
      return this.flags & 1;
    }
    blockAt(e, t, n, r) {
      let i = n + this.left.height;
      return e < i
        ? this.left.blockAt(e, t, n, r)
        : this.right.blockAt(e, t, i, r + this.left.length + this.break);
    }
    lineAt(e, t, n, r, i) {
      let a = r + this.left.height,
        o = i + this.left.length + this.break,
        s = t == H.ByHeight ? e < a : e < o,
        c = s ? this.left.lineAt(e, t, n, r, i) : this.right.lineAt(e, t, n, a, o);
      if (this.break || (s ? c.to < o : c.from > o)) return c;
      let l = t == H.ByPosNoHeight ? H.ByPosNoHeight : H.ByPos;
      return s ? c.join(this.right.lineAt(o, l, n, a, o)) : this.left.lineAt(o, l, n, r, i).join(c);
    }
    forEachLine(e, t, n, r, i, a) {
      let o = r + this.left.height,
        s = i + this.left.length + this.break;
      if (this.break)
        (e < s && this.left.forEachLine(e, t, n, r, i, a),
          t >= s && this.right.forEachLine(e, t, n, o, s, a));
      else {
        let c = this.lineAt(s, H.ByPos, n, r, i);
        (e < c.from && this.left.forEachLine(e, c.from - 1, n, r, i, a),
          c.to >= e && c.from <= t && a(c),
          t > c.to && this.right.forEachLine(c.to + 1, t, n, o, s, a));
      }
    }
    replace(e, t, n) {
      let r = this.left.length + this.break;
      if (t < r) return this.balanced(this.left.replace(e, t, n), this.right);
      if (e > this.left.length)
        return this.balanced(this.left, this.right.replace(e - r, t - r, n));
      let i = [];
      e > 0 && this.decomposeLeft(e, i);
      let a = i.length;
      for (let e of n) i.push(e);
      if ((e > 0 && Ua(i, a - 1), t < this.length)) {
        let e = i.length;
        (this.decomposeRight(t, i), Ua(i, e));
      }
      return Ia.of(i);
    }
    decomposeLeft(e, t) {
      let n = this.left.length;
      if (e <= n) return this.left.decomposeLeft(e, t);
      (t.push(this.left),
        this.break && (n++, e >= n && t.push(null)),
        e > n && this.right.decomposeLeft(e - n, t));
    }
    decomposeRight(e, t) {
      let n = this.left.length,
        r = n + this.break;
      if (e >= r) return this.right.decomposeRight(e - r, t);
      (e < n && this.left.decomposeRight(e, t),
        this.break && e < r && t.push(null),
        t.push(this.right));
    }
    balanced(e, t) {
      return e.size > 2 * t.size || t.size > 2 * e.size
        ? Ia.of(this.break ? [e, null, t] : [e, t])
        : ((this.left = La(this.left, e)),
          (this.right = La(this.right, t)),
          this.setHeight(e.height + t.height),
          (this.outdated = e.outdated || t.outdated),
          (this.size = e.size + t.size),
          (this.length = e.length + this.break + t.length),
          this);
    }
    updateHeight(e, t = 0, n = !1, r) {
      let { left: i, right: a } = this,
        o = t + i.length + this.break,
        s = null;
      return (
        r && r.from <= t + i.length && r.more
          ? (s = i = i.updateHeight(e, t, n, r))
          : i.updateHeight(e, t, n),
        r && r.from <= o + a.length && r.more
          ? (s = a = a.updateHeight(e, o, n, r))
          : a.updateHeight(e, o, n),
        s
          ? this.balanced(i, a)
          : ((this.height = this.left.height + this.right.height), (this.outdated = !1), this)
      );
    }
    toString() {
      return this.left + (this.break ? ` ` : `-`) + this.right;
    }
  };
function Ua(e, t) {
  let n, r;
  e[t] == null &&
    (n = e[t - 1]) instanceof Va &&
    (r = e[t + 1]) instanceof Va &&
    e.splice(t - 1, 3, new Va(n.length + 1 + r.length));
}
var Wa = 5,
  Ga = class e {
    constructor(e, t) {
      ((this.pos = e),
        (this.oracle = t),
        (this.nodes = []),
        (this.lineStart = -1),
        (this.lineEnd = -1),
        (this.covering = null),
        (this.writtenTo = e));
    }
    get isCovered() {
      return this.covering && this.nodes[this.nodes.length - 1] == this.covering;
    }
    span(e, t) {
      if (this.lineStart > -1) {
        let e = Math.min(t, this.lineEnd),
          n = this.nodes[this.nodes.length - 1];
        (n instanceof Ba
          ? (n.length += e - this.pos)
          : (e > this.pos || !this.isCovered) && this.nodes.push(new Ba(e - this.pos, -1, 0)),
          (this.writtenTo = e),
          t > e && (this.nodes.push(null), this.writtenTo++, (this.lineStart = -1)));
      }
      this.pos = t;
    }
    point(e, t, n) {
      if (e < t || n.heightRelevant) {
        let r = n.widget ? n.widget.estimatedHeight : 0,
          i = n.widget ? n.widget.lineBreaks : 0;
        r < 0 && (r = this.oracle.lineHeight);
        let a = t - e;
        n.block ? this.addBlock(new za(a, r, n)) : (a || i || r >= Wa) && this.addLineDeco(r, i, a);
      } else t > e && this.span(e, t);
      this.lineEnd > -1 &&
        this.lineEnd < this.pos &&
        (this.lineEnd = this.oracle.doc.lineAt(this.pos).to);
    }
    enterLine() {
      if (this.lineStart > -1) return;
      let { from: e, to: t } = this.oracle.doc.lineAt(this.pos);
      ((this.lineStart = e),
        (this.lineEnd = t),
        this.writtenTo < e &&
          ((this.writtenTo < e - 1 || this.nodes[this.nodes.length - 1] == null) &&
            this.nodes.push(this.blankContent(this.writtenTo, e - 1)),
          this.nodes.push(null)),
        this.pos > e && this.nodes.push(new Ba(this.pos - e, -1, 0)),
        (this.writtenTo = this.pos));
    }
    blankContent(e, t) {
      let n = new Va(t - e);
      return (this.oracle.doc.lineAt(e).to == t && (n.flags |= 4), n);
    }
    ensureLine() {
      this.enterLine();
      let e = this.nodes.length ? this.nodes[this.nodes.length - 1] : null;
      if (e instanceof Ba) return e;
      let t = new Ba(0, -1, 0);
      return (this.nodes.push(t), t);
    }
    addBlock(e) {
      this.enterLine();
      let t = e.deco;
      (t && t.startSide > 0 && !this.isCovered && this.ensureLine(),
        this.nodes.push(e),
        (this.writtenTo = this.pos += e.length),
        t && t.endSide > 0 && (this.covering = e));
    }
    addLineDeco(e, t, n) {
      let r = this.ensureLine();
      ((r.length += n),
        (r.collapsed += n),
        (r.widgetHeight = Math.max(r.widgetHeight, e)),
        (r.breaks += t),
        (this.writtenTo = this.pos += n));
    }
    finish(e) {
      let t = this.nodes.length == 0 ? null : this.nodes[this.nodes.length - 1];
      this.lineStart > -1 && !(t instanceof Ba) && !this.isCovered
        ? this.nodes.push(new Ba(0, -1, 0))
        : (this.writtenTo < this.pos || t == null) &&
          this.nodes.push(this.blankContent(this.writtenTo, this.pos));
      let n = e;
      for (let e of this.nodes)
        (e instanceof Ba && e.updateHeight(this.oracle, n), (n += e ? e.length : 1));
      return this.nodes;
    }
    static build(t, n, r, i) {
      let a = new e(r, t);
      return (A.spans(n, r, i, a, 0), a.finish(r));
    }
  };
function Ka(e, t, n) {
  let r = new qa();
  return (A.compare(e, t, n, r, 0), r.changes);
}
var qa = class {
  constructor() {
    this.changes = [];
  }
  compareRange() {}
  comparePoint(e, t, n, r) {
    (e < t || (n && n.heightRelevant) || (r && r.heightRelevant)) && sn(e, t, this.changes, 5);
  }
};
function Ja(e, t) {
  let n = e.getBoundingClientRect(),
    r = e.ownerDocument,
    i = r.defaultView || window,
    a = Math.max(0, n.left),
    o = Math.min(i.innerWidth, n.right),
    s = Math.max(0, n.top),
    c = Math.min(i.innerHeight, n.bottom);
  for (let t = e.parentNode; t && t != r.body;)
    if (t.nodeType == 1) {
      let n = t,
        r = window.getComputedStyle(n);
      if (
        (n.scrollHeight > n.clientHeight || n.scrollWidth > n.clientWidth) &&
        r.overflow != `visible`
      ) {
        let r = n.getBoundingClientRect();
        ((a = Math.max(a, r.left)),
          (o = Math.min(o, r.right)),
          (s = Math.max(s, r.top)),
          (c = Math.min(t == e.parentNode ? i.innerHeight : c, r.bottom)));
      }
      t = r.position == `absolute` || r.position == `fixed` ? n.offsetParent : n.parentNode;
    } else if (t.nodeType == 11) t = t.host;
    else break;
  return {
    left: a - n.left,
    right: Math.max(a, o) - n.left,
    top: s - (n.top + t),
    bottom: Math.max(s, c) - (n.top + t),
  };
}
function Ya(e) {
  let t = e.getBoundingClientRect(),
    n = e.ownerDocument.defaultView || window;
  return t.left < n.innerWidth && t.right > 0 && t.top < n.innerHeight && t.bottom > 0;
}
function Xa(e, t) {
  let n = e.getBoundingClientRect();
  return {
    left: 0,
    right: n.right - n.left,
    top: t,
    bottom: n.bottom - (n.top + t),
  };
}
var Za = class {
    constructor(e, t, n, r) {
      ((this.from = e), (this.to = t), (this.size = n), (this.displaySize = r));
    }
    static same(e, t) {
      if (e.length != t.length) return !1;
      for (let n = 0; n < e.length; n++) {
        let r = e[n],
          i = t[n];
        if (r.from != i.from || r.to != i.to || r.size != i.size) return !1;
      }
      return !0;
    }
    draw(e, t) {
      return F.replace({
        widget: new Qa(this.displaySize * (t ? e.scaleY : e.scaleX), t),
      }).range(this.from, this.to);
    }
  },
  Qa = class extends en {
    constructor(e, t) {
      (super(), (this.size = e), (this.vertical = t));
    }
    eq(e) {
      return e.size == this.size && e.vertical == this.vertical;
    }
    toDOM() {
      let e = document.createElement(`div`);
      return (
        this.vertical
          ? (e.style.height = this.size + `px`)
          : ((e.style.width = this.size + `px`),
            (e.style.height = `2px`),
            (e.style.display = `inline-block`)),
        e
      );
    }
    get estimatedHeight() {
      return this.vertical ? this.size : -1;
    }
  },
  $a = class {
    constructor(e, t) {
      ((this.view = e),
        (this.state = t),
        (this.pixelViewport = {
          left: 0,
          right: window.innerWidth,
          top: 0,
          bottom: 0,
        }),
        (this.inView = !0),
        (this.paddingTop = 0),
        (this.paddingBottom = 0),
        (this.contentDOMWidth = 0),
        (this.contentDOMHeight = 0),
        (this.editorHeight = 0),
        (this.editorWidth = 0),
        (this.scaleX = 1),
        (this.scaleY = 1),
        (this.scrollOffset = 0),
        (this.scrolledToBottom = !1),
        (this.scrollAnchorPos = 0),
        (this.scrollAnchorHeight = -1),
        (this.scaler = ao),
        (this.scrollTarget = null),
        (this.printing = !1),
        (this.mustMeasureContent = !0),
        (this.defaultTextDirection = I.LTR),
        (this.visibleRanges = []),
        (this.mustEnforceCursorAssoc = !1));
      let n = t.facet(wr).some((e) => typeof e != `function` && e.class == `cm-lineWrapping`);
      ((this.heightOracle = new Ma(n)),
        (this.stateDeco = oo(t)),
        (this.heightMap = Ia.empty().applyChanges(
          this.stateDeco,
          f.empty,
          this.heightOracle.setDoc(t.doc),
          [new Pr(0, 0, 0, t.doc.length)],
        )));
      for (
        let e = 0;
        e < 2 && ((this.viewport = this.getViewport(0, null)), this.updateForViewport());
        e++
      );
      (this.updateViewportLines(),
        (this.lineGaps = this.ensureLineGaps([])),
        (this.lineGapDeco = F.set(this.lineGaps.map((e) => e.draw(this, !1)))),
        (this.scrollParent = e.scrollDOM),
        this.computeVisibleRanges());
    }
    updateForViewport() {
      let e = [this.viewport],
        { main: t } = this.state.selection;
      for (let n = 0; n <= 1; n++) {
        let r = n ? t.head : t.anchor;
        if (!e.some(({ from: e, to: t }) => r >= e && r <= t)) {
          let { from: t, to: n } = this.lineBlockAt(r);
          e.push(new eo(t, n));
        }
      }
      return ((this.viewports = e.sort((e, t) => e.from - t.from)), this.updateScaler());
    }
    updateScaler() {
      let e = this.scaler;
      return (
        (this.scaler =
          this.heightMap.height <= 7e6
            ? ao
            : new so(this.heightOracle, this.heightMap, this.viewports)),
        e.eq(this.scaler) ? 0 : 2
      );
    }
    updateViewportLines() {
      ((this.viewportLines = []),
        this.heightMap.forEachLine(
          this.viewport.from,
          this.viewport.to,
          this.heightOracle.setDoc(this.state.doc),
          0,
          0,
          (e) => {
            this.viewportLines.push(co(e, this.scaler));
          },
        ));
    }
    update(e, t = null) {
      this.state = e.state;
      let n = this.stateDeco;
      this.stateDeco = oo(this.state);
      let r = e.changedRanges,
        i = Pr.extendWithRanges(
          r,
          Ka(n, this.stateDeco, e ? e.changes : ce.empty(this.state.doc.length)),
        ),
        a = this.heightMap.height,
        o = this.scrolledToBottom ? null : this.scrollAnchorAt(this.scrollOffset);
      (ja(),
        (this.heightMap = this.heightMap.applyChanges(
          this.stateDeco,
          e.startState.doc,
          this.heightOracle.setDoc(this.state.doc),
          i,
        )),
        (this.heightMap.height != a || Aa) && (e.flags |= 2),
        o
          ? ((this.scrollAnchorPos = e.changes.mapPos(o.from, -1)),
            (this.scrollAnchorHeight = o.top))
          : ((this.scrollAnchorPos = -1), (this.scrollAnchorHeight = a)));
      let s = i.length ? this.mapViewport(this.viewport, e.changes) : this.viewport;
      ((t && (t.range.head < s.from || t.range.head > s.to)) || !this.viewportIsAppropriate(s)) &&
        (s = this.getViewport(0, t));
      let c = s.from != this.viewport.from || s.to != this.viewport.to;
      ((this.viewport = s),
        (e.flags |= this.updateForViewport()),
        (c || !e.changes.empty || e.flags & 2) && this.updateViewportLines(),
        (this.lineGaps.length || this.viewport.to - this.viewport.from > 4e3) &&
          this.updateLineGaps(this.ensureLineGaps(this.mapLineGaps(this.lineGaps, e.changes))),
        (e.flags |= this.computeVisibleRanges(e.changes)),
        t && (this.scrollTarget = t),
        !this.mustEnforceCursorAssoc &&
          (e.selectionSet || e.focusChanged) &&
          e.view.lineWrapping &&
          e.state.selection.main.empty &&
          e.state.selection.main.assoc &&
          !e.state.facet(fr) &&
          (this.mustEnforceCursorAssoc = !0));
    }
    measure() {
      let { view: e } = this,
        t = e.contentDOM,
        n = window.getComputedStyle(t),
        r = this.heightOracle,
        i = n.whiteSpace;
      this.defaultTextDirection = n.direction == `rtl` ? I.RTL : I.LTR;
      let a = this.heightOracle.mustRefreshForWrapping(i) || this.mustMeasureContent === `refresh`,
        o = t.getBoundingClientRect(),
        s = a || this.mustMeasureContent || this.contentDOMHeight != o.height;
      ((this.contentDOMHeight = o.height), (this.mustMeasureContent = !1));
      let c = 0,
        l = 0;
      if (o.width && o.height) {
        let { scaleX: e, scaleY: n } = bn(t, o);
        ((e > 0.005 && Math.abs(this.scaleX - e) > 0.005) ||
          (n > 0.005 && Math.abs(this.scaleY - n) > 0.005)) &&
          ((this.scaleX = e), (this.scaleY = n), (c |= 16), (a = s = !0));
      }
      let u = (parseInt(n.paddingTop) || 0) * this.scaleY,
        d = (parseInt(n.paddingBottom) || 0) * this.scaleY;
      ((this.paddingTop != u || this.paddingBottom != d) &&
        ((this.paddingTop = u), (this.paddingBottom = d), (c |= 18)),
        this.editorWidth != e.scrollDOM.clientWidth &&
          (r.lineWrapping && (s = !0), (this.editorWidth = e.scrollDOM.clientWidth), (c |= 16)));
      let p = Sn(this.view.contentDOM, !1).y;
      p != this.scrollParent &&
        ((this.scrollParent = p), (this.scrollAnchorHeight = -1), (this.scrollOffset = 0));
      let m = this.getScrollOffset();
      (this.scrollOffset != m && ((this.scrollAnchorHeight = -1), (this.scrollOffset = m)),
        (this.scrolledToBottom = jn(this.scrollParent || e.win)));
      let h = (this.printing ? Xa : Ja)(t, this.paddingTop),
        g = h.top - this.pixelViewport.top,
        _ = h.bottom - this.pixelViewport.bottom;
      this.pixelViewport = h;
      let v =
        this.pixelViewport.bottom > this.pixelViewport.top &&
        this.pixelViewport.right > this.pixelViewport.left;
      if (
        (v != this.inView && ((this.inView = v), v && (s = !0)),
        !this.inView && !this.scrollTarget && !Ya(e.dom))
      )
        return 0;
      let y = o.width;
      if (
        ((this.contentDOMWidth != y || this.editorHeight != e.scrollDOM.clientHeight) &&
          ((this.contentDOMWidth = o.width),
          (this.editorHeight = e.scrollDOM.clientHeight),
          (c |= 16)),
        s)
      ) {
        let t = e.docView.measureVisibleLineHeights(this.viewport);
        if (
          (r.mustRefreshForHeights(t) && (a = !0),
          a || (r.lineWrapping && Math.abs(y - this.contentDOMWidth) > r.charWidth))
        ) {
          let { lineHeight: n, charWidth: o, textHeight: s } = e.docView.measureTextSize();
          ((a = n > 0 && r.refresh(i, n, o, s, Math.max(5, y / o), t)),
            a && ((e.docView.minWidth = 0), (c |= 16)));
        }
        (g > 0 && _ > 0 ? (l = Math.max(g, _)) : g < 0 && _ < 0 && (l = Math.min(g, _)), ja());
        for (let n of this.viewports) {
          let i = n.from == this.viewport.from ? t : e.docView.measureVisibleLineHeights(n);
          this.heightMap = (
            a
              ? Ia.empty().applyChanges(this.stateDeco, f.empty, this.heightOracle, [
                  new Pr(0, 0, 0, e.state.doc.length),
                ])
              : this.heightMap
          ).updateHeight(r, 0, a, new Na(n.from, i));
        }
        Aa && (c |= 2);
      }
      let ee =
        !this.viewportIsAppropriate(this.viewport, l) ||
        (this.scrollTarget &&
          (this.scrollTarget.range.head < this.viewport.from ||
            this.scrollTarget.range.head > this.viewport.to));
      return (
        ee &&
          (c & 2 && (c |= this.updateScaler()),
          (this.viewport = this.getViewport(l, this.scrollTarget)),
          (c |= this.updateForViewport())),
        (c & 2 || ee) && this.updateViewportLines(),
        (this.lineGaps.length || this.viewport.to - this.viewport.from > 4e3) &&
          this.updateLineGaps(this.ensureLineGaps(a ? [] : this.lineGaps, e)),
        (c |= this.computeVisibleRanges()),
        this.mustEnforceCursorAssoc &&
          ((this.mustEnforceCursorAssoc = !1), e.docView.enforceCursorAssoc()),
        c
      );
    }
    get visibleTop() {
      return this.scaler.fromDOM(this.pixelViewport.top);
    }
    get visibleBottom() {
      return this.scaler.fromDOM(this.pixelViewport.bottom);
    }
    getViewport(e, t) {
      let n = 0.5 - Math.max(-0.5, Math.min(0.5, e / 1e3 / 2)),
        r = this.heightMap,
        i = this.heightOracle,
        { visibleTop: a, visibleBottom: o } = this,
        s = new eo(
          r.lineAt(a - n * 1e3, H.ByHeight, i, 0, 0).from,
          r.lineAt(o + (1 - n) * 1e3, H.ByHeight, i, 0, 0).to,
        );
      if (t) {
        let { head: e } = t.range;
        if (e < s.from || e > s.to) {
          let n = Math.min(this.editorHeight, this.pixelViewport.bottom - this.pixelViewport.top),
            a = r.lineAt(e, H.ByPos, i, 0, 0),
            o;
          ((o =
            t.y == `center`
              ? (a.top + a.bottom) / 2 - n / 2
              : t.y == `start` || (t.y == `nearest` && e < s.from)
                ? a.top
                : a.bottom - n),
            (s = new eo(
              r.lineAt(o - 1e3 / 2, H.ByHeight, i, 0, 0).from,
              r.lineAt(o + n + 1e3 / 2, H.ByHeight, i, 0, 0).to,
            )));
        }
      }
      return s;
    }
    mapViewport(e, t) {
      let n = t.mapPos(e.from, -1),
        r = t.mapPos(e.to, 1);
      return new eo(
        this.heightMap.lineAt(n, H.ByPos, this.heightOracle, 0, 0).from,
        this.heightMap.lineAt(r, H.ByPos, this.heightOracle, 0, 0).to,
      );
    }
    viewportIsAppropriate({ from: e, to: t }, n = 0) {
      if (!this.inView) return !0;
      let { top: r } = this.heightMap.lineAt(e, H.ByPos, this.heightOracle, 0, 0),
        { bottom: i } = this.heightMap.lineAt(t, H.ByPos, this.heightOracle, 0, 0),
        { visibleTop: a, visibleBottom: o } = this;
      return (
        (e == 0 || r <= a - Math.max(10, Math.min(-n, 250))) &&
        (t == this.state.doc.length || i >= o + Math.max(10, Math.min(n, 250))) &&
        r > a - 2 * 1e3 &&
        i < o + 2 * 1e3
      );
    }
    mapLineGaps(e, t) {
      if (!e.length || t.empty) return e;
      let n = [];
      for (let r of e)
        t.touchesRange(r.from, r.to) ||
          n.push(new Za(t.mapPos(r.from), t.mapPos(r.to), r.size, r.displaySize));
      return n;
    }
    ensureLineGaps(e, t) {
      let n = this.heightOracle.lineWrapping,
        r = n ? 1e4 : 2e3,
        i = r >> 1,
        a = r << 1;
      if (this.defaultTextDirection != I.LTR && !n) return [];
      let o = [],
        s = (r, a, c, l) => {
          if (a - r < i) return;
          let u = this.state.selection.main,
            d = [u.from];
          u.empty || d.push(u.to);
          for (let e of d)
            if (e > r && e < a) {
              (s(r, e - 10, c, l), s(e + 10, a, c, l));
              return;
            }
          let f = io(
            e,
            (e) =>
              e.from >= c.from &&
              e.to <= c.to &&
              Math.abs(e.from - r) < i &&
              Math.abs(e.to - a) < i &&
              !d.some((t) => e.from < t && e.to > t),
          );
          if (!f) {
            if (a < c.to && t && n && t.visibleRanges.some((e) => e.from <= a && e.to >= a)) {
              let e = t.moveToLineBoundary(T.cursor(a), !1, !0).head;
              e > r && (a = e);
            }
            let e = this.gapSize(c, r, a, l);
            f = new Za(r, a, e, n || e < 2e6 ? e : 2e6);
          }
          o.push(f);
        },
        c = (t) => {
          if (t.length < a || t.type != P.Text) return;
          let i = to(t.from, t.to, this.stateDeco);
          if (i.total < a) return;
          let o = this.scrollTarget ? this.scrollTarget.range.head : null,
            c,
            l;
          if (n) {
            let e = (r / this.heightOracle.lineLength) * this.heightOracle.lineHeight,
              n,
              a;
            if (o != null) {
              let r = ro(i, o),
                s = ((this.visibleBottom - this.visibleTop) / 2 + e) / t.height;
              ((n = r - s), (a = r + s));
            } else
              ((n = (this.visibleTop - t.top - e) / t.height),
                (a = (this.visibleBottom - t.top + e) / t.height));
            ((c = no(i, n)), (l = no(i, a)));
          } else {
            let n = i.total * this.heightOracle.charWidth,
              a = r * this.heightOracle.charWidth,
              s = 0;
            if (n > 2e6)
              for (let n of e)
                n.from >= t.from &&
                  n.from < t.to &&
                  n.size != n.displaySize &&
                  n.from * this.heightOracle.charWidth + s < this.pixelViewport.left &&
                  (s = n.size - n.displaySize);
            let u = this.pixelViewport.left + s,
              d = this.pixelViewport.right + s,
              f,
              p;
            if (o != null) {
              let e = ro(i, o),
                t = ((d - u) / 2 + a) / n;
              ((f = e - t), (p = e + t));
            } else ((f = (u - a) / n), (p = (d + a) / n));
            ((c = no(i, f)), (l = no(i, p)));
          }
          (c > t.from && s(t.from, c, t, i), l < t.to && s(l, t.to, t, i));
        };
      for (let e of this.viewportLines) Array.isArray(e.type) ? e.type.forEach(c) : c(e);
      return o;
    }
    gapSize(e, t, n, r) {
      let i = ro(r, n) - ro(r, t);
      return this.heightOracle.lineWrapping
        ? e.height * i
        : r.total * this.heightOracle.charWidth * i;
    }
    updateLineGaps(e) {
      Za.same(e, this.lineGaps) ||
        ((this.lineGaps = e),
        (this.lineGapDeco = F.set(e.map((e) => e.draw(this, this.heightOracle.lineWrapping)))));
    }
    computeVisibleRanges(e) {
      let t = this.stateDeco;
      this.lineGaps.length && (t = t.concat(this.lineGapDeco));
      let n = [];
      A.spans(
        t,
        this.viewport.from,
        this.viewport.to,
        {
          span(e, t) {
            n.push({
              from: e,
              to: t,
            });
          },
          point() {},
        },
        20,
      );
      let r = 0;
      if (n.length != this.visibleRanges.length) r = 12;
      else
        for (let t = 0; t < n.length && !(r & 8); t++) {
          let i = this.visibleRanges[t],
            a = n[t];
          (i.from != a.from || i.to != a.to) &&
            ((r |= 4),
            (e && e.mapPos(i.from, -1) == a.from && e.mapPos(i.to, 1) == a.to) || (r |= 8));
        }
      return ((this.visibleRanges = n), r);
    }
    lineBlockAt(e) {
      return (
        (e >= this.viewport.from &&
          e <= this.viewport.to &&
          this.viewportLines.find((t) => t.from <= e && t.to >= e)) ||
        co(this.heightMap.lineAt(e, H.ByPos, this.heightOracle, 0, 0), this.scaler)
      );
    }
    lineBlockAtHeight(e) {
      return (
        (e >= this.viewportLines[0].top &&
          e <= this.viewportLines[this.viewportLines.length - 1].bottom &&
          this.viewportLines.find((t) => t.top <= e && t.bottom >= e)) ||
        co(
          this.heightMap.lineAt(this.scaler.fromDOM(e), H.ByHeight, this.heightOracle, 0, 0),
          this.scaler,
        )
      );
    }
    getScrollOffset() {
      return (
        (this.scrollParent == this.view.scrollDOM
          ? this.scrollParent.scrollTop
          : (this.scrollParent ? this.scrollParent.getBoundingClientRect().top : 0) -
            this.view.contentDOM.getBoundingClientRect().top) * this.scaleY
      );
    }
    scrollAnchorAt(e) {
      let t = this.lineBlockAtHeight(e + 8);
      return t.from >= this.viewport.from || this.viewportLines[0].top - e > 200
        ? t
        : this.viewportLines[0];
    }
    elementAtHeight(e) {
      return co(
        this.heightMap.blockAt(this.scaler.fromDOM(e), this.heightOracle, 0, 0),
        this.scaler,
      );
    }
    get docHeight() {
      return this.scaler.toDOM(this.heightMap.height);
    }
    get contentHeight() {
      return this.docHeight + this.paddingTop + this.paddingBottom;
    }
  },
  eo = class {
    constructor(e, t) {
      ((this.from = e), (this.to = t));
    }
  };
function to(e, t, n) {
  let r = [],
    i = e,
    a = 0;
  return (
    A.spans(
      n,
      e,
      t,
      {
        span() {},
        point(e, t) {
          (e > i &&
            (r.push({
              from: i,
              to: e,
            }),
            (a += e - i)),
            (i = t));
        },
      },
      20,
    ),
    i < t &&
      (r.push({
        from: i,
        to: t,
      }),
      (a += t - i)),
    {
      total: a,
      ranges: r,
    }
  );
}
function no({ total: e, ranges: t }, n) {
  if (n <= 0) return t[0].from;
  if (n >= 1) return t[t.length - 1].to;
  let r = Math.floor(e * n);
  for (let e = 0; ; e++) {
    let { from: n, to: i } = t[e],
      a = i - n;
    if (r <= a) return n + r;
    r -= a;
  }
}
function ro(e, t) {
  let n = 0;
  for (let { from: r, to: i } of e.ranges) {
    if (t <= i) {
      n += t - r;
      break;
    }
    n += i - r;
  }
  return n / e.total;
}
function io(e, t) {
  for (let n of e) if (t(n)) return n;
}
var ao = {
  toDOM(e) {
    return e;
  },
  fromDOM(e) {
    return e;
  },
  scale: 1,
  eq(e) {
    return e == this;
  },
};
function oo(e) {
  let t = e.facet(Tr).filter((e) => typeof e != `function`),
    n = e.facet(Dr).filter((e) => typeof e != `function`);
  return (n.length && t.push(A.join(n)), t);
}
var so = class e {
  constructor(e, t, n) {
    let r = 0,
      i = 0,
      a = 0;
    ((this.viewports = n.map(({ from: n, to: i }) => {
      let a = t.lineAt(n, H.ByPos, e, 0, 0).top,
        o = t.lineAt(i, H.ByPos, e, 0, 0).bottom;
      return (
        (r += o - a),
        {
          from: n,
          to: i,
          top: a,
          bottom: o,
          domTop: 0,
          domBottom: 0,
        }
      );
    })),
      (this.scale = (7e6 - r) / (t.height - r)));
    for (let e of this.viewports)
      ((e.domTop = a + (e.top - i) * this.scale),
        (a = e.domBottom = e.domTop + (e.bottom - e.top)),
        (i = e.bottom));
  }
  toDOM(e) {
    for (let t = 0, n = 0, r = 0; ; t++) {
      let i = t < this.viewports.length ? this.viewports[t] : null;
      if (!i || e < i.top) return r + (e - n) * this.scale;
      if (e <= i.bottom) return i.domTop + (e - i.top);
      ((n = i.bottom), (r = i.domBottom));
    }
  }
  fromDOM(e) {
    for (let t = 0, n = 0, r = 0; ; t++) {
      let i = t < this.viewports.length ? this.viewports[t] : null;
      if (!i || e < i.domTop) return n + (e - r) / this.scale;
      if (e <= i.domBottom) return i.top + (e - i.domTop);
      ((n = i.bottom), (r = i.domBottom));
    }
  }
  eq(t) {
    return t instanceof e
      ? this.scale == t.scale &&
          this.viewports.length == t.viewports.length &&
          this.viewports.every((e, n) => e.from == t.viewports[n].from && e.to == t.viewports[n].to)
      : !1;
  }
};
function co(e, t) {
  if (t.scale == 1) return e;
  let n = t.toDOM(e.top),
    r = t.toDOM(e.bottom);
  return new Pa(
    e.from,
    e.length,
    n,
    r - n,
    Array.isArray(e._content) ? e._content.map((e) => co(e, t)) : e._content,
  );
}
var lo = E.define({
    combine: (e) => e.join(` `),
  }),
  uo = E.define({
    combine: (e) => e.indexOf(!0) > -1,
  }),
  fo = Dt.newName(),
  po = Dt.newName(),
  mo = Dt.newName(),
  ho = {
    "&light": `.` + po,
    "&dark": `.` + mo,
  };
function go(e, t, n) {
  return new Dt(t, {
    finish(t) {
      return /&/.test(t)
        ? t.replace(/&\w*/, (t) => {
            if (t == `&`) return e;
            if (!n || !n[t]) throw RangeError(`Unsupported selector: ${t}`);
            return n[t];
          })
        : e + ` ` + t;
    },
  });
}
var _o = go(
    `.` + fo,
    {
      "&": {
        position: `relative !important`,
        boxSizing: `border-box`,
        "&.cm-focused": {
          outline: `1px dotted #212121`,
        },
        display: `flex !important`,
        flexDirection: `column`,
      },
      ".cm-scroller": {
        display: `flex !important`,
        alignItems: `flex-start !important`,
        fontFamily: `monospace`,
        lineHeight: 1.4,
        height: `100%`,
        overflowX: `auto`,
        position: `relative`,
        zIndex: 0,
        overflowAnchor: `none`,
      },
      ".cm-content": {
        margin: 0,
        flexGrow: 2,
        flexShrink: 0,
        display: `block`,
        whiteSpace: `pre`,
        wordWrap: `normal`,
        boxSizing: `border-box`,
        minHeight: `100%`,
        padding: `4px 0`,
        outline: `none`,
        "&[contenteditable=true]": {
          WebkitUserModify: `read-write-plaintext-only`,
        },
      },
      ".cm-lineWrapping": {
        whiteSpace_fallback: `pre-wrap`,
        whiteSpace: `break-spaces`,
        wordBreak: `break-word`,
        overflowWrap: `anywhere`,
        flexShrink: 1,
      },
      "&light .cm-content": {
        caretColor: `black`,
      },
      "&dark .cm-content": {
        caretColor: `white`,
      },
      ".cm-line": {
        display: `block`,
        padding: `0 2px 0 6px`,
      },
      ".cm-layer": {
        position: `absolute`,
        left: 0,
        top: 0,
        contain: `size style`,
        "& > *": {
          position: `absolute`,
        },
      },
      "&light .cm-selectionBackground": {
        background: `#d9d9d9`,
      },
      "&dark .cm-selectionBackground": {
        background: `#222`,
      },
      "&light.cm-focused > .cm-scroller > .cm-selectionLayer .cm-selectionBackground": {
        background: `#d7d4f0`,
      },
      "&dark.cm-focused > .cm-scroller > .cm-selectionLayer .cm-selectionBackground": {
        background: `#233`,
      },
      ".cm-cursorLayer": {
        pointerEvents: `none`,
      },
      "&.cm-focused > .cm-scroller > .cm-cursorLayer": {
        animation: `steps(1) cm-blink 1.2s infinite`,
      },
      "@keyframes cm-blink": {
        "0%": {},
        "50%": {
          opacity: 0,
        },
        "100%": {},
      },
      "@keyframes cm-blink2": {
        "0%": {},
        "50%": {
          opacity: 0,
        },
        "100%": {},
      },
      ".cm-cursor, .cm-dropCursor": {
        borderLeft: `1.2px solid black`,
        marginLeft: `-0.6px`,
        pointerEvents: `none`,
      },
      ".cm-cursor": {
        display: `none`,
      },
      "&dark .cm-cursor": {
        borderLeftColor: `#ddd`,
      },
      ".cm-selectionHandle": {
        backgroundColor: `currentColor`,
        width: `1.5px`,
      },
      ".cm-selectionHandle-start::before, .cm-selectionHandle-end::before": {
        content: `""`,
        backgroundColor: `inherit`,
        borderRadius: `50%`,
        width: `8px`,
        height: `8px`,
        position: `absolute`,
        left: `-3.25px`,
      },
      ".cm-selectionHandle-start::before": {
        top: `-8px`,
      },
      ".cm-selectionHandle-end::before": {
        bottom: `-8px`,
      },
      ".cm-dropCursor": {
        position: `absolute`,
      },
      "&.cm-focused > .cm-scroller > .cm-cursorLayer .cm-cursor": {
        display: `block`,
      },
      ".cm-iso": {
        unicodeBidi: `isolate`,
      },
      ".cm-announced": {
        position: `fixed`,
        top: `-10000px`,
      },
      "@media print": {
        ".cm-announced": {
          display: `none`,
        },
      },
      "&light .cm-activeLine": {
        backgroundColor: `#cceeff44`,
      },
      "&dark .cm-activeLine": {
        backgroundColor: `#99eeff33`,
      },
      "&light .cm-specialChar": {
        color: `red`,
      },
      "&dark .cm-specialChar": {
        color: `#f78`,
      },
      ".cm-gutters": {
        flexShrink: 0,
        display: `flex`,
        height: `100%`,
        boxSizing: `border-box`,
        zIndex: 200,
      },
      ".cm-gutters-before": {
        insetInlineStart: 0,
      },
      ".cm-gutters-after": {
        insetInlineEnd: 0,
      },
      "&light .cm-gutters": {
        backgroundColor: `#f5f5f5`,
        color: `#6c6c6c`,
        border: `0px solid #ddd`,
        "&.cm-gutters-before": {
          borderRightWidth: `1px`,
        },
        "&.cm-gutters-after": {
          borderLeftWidth: `1px`,
        },
      },
      "&dark .cm-gutters": {
        backgroundColor: `#333338`,
        color: `#ccc`,
      },
      ".cm-gutter": {
        display: `flex !important`,
        flexDirection: `column`,
        flexShrink: 0,
        boxSizing: `border-box`,
        minHeight: `100%`,
        overflow: `hidden`,
      },
      ".cm-gutterElement": {
        boxSizing: `border-box`,
      },
      ".cm-lineNumbers .cm-gutterElement": {
        padding: `0 3px 0 5px`,
        minWidth: `20px`,
        textAlign: `right`,
        whiteSpace: `nowrap`,
      },
      "&light .cm-activeLineGutter": {
        backgroundColor: `#e2f2ff`,
      },
      "&dark .cm-activeLineGutter": {
        backgroundColor: `#222227`,
      },
      ".cm-panels": {
        boxSizing: `border-box`,
        position: `sticky`,
        left: 0,
        right: 0,
        zIndex: 300,
      },
      "&light .cm-panels": {
        backgroundColor: `#f5f5f5`,
        color: `black`,
      },
      "&light .cm-panels-top": {
        borderBottom: `1px solid #ddd`,
      },
      "&light .cm-panels-bottom": {
        borderTop: `1px solid #ddd`,
      },
      "&dark .cm-panels": {
        backgroundColor: `#333338`,
        color: `white`,
      },
      ".cm-dialog": {
        padding: `2px 19px 4px 6px`,
        position: `relative`,
        "& label": {
          fontSize: `80%`,
        },
      },
      ".cm-dialog-close": {
        position: `absolute`,
        top: `3px`,
        right: `4px`,
        backgroundColor: `inherit`,
        border: `none`,
        font: `inherit`,
        fontSize: `14px`,
        padding: `0`,
      },
      ".cm-tab": {
        display: `inline-block`,
        overflow: `hidden`,
        verticalAlign: `bottom`,
      },
      ".cm-widgetBuffer": {
        verticalAlign: `text-top`,
        height: `1em`,
        width: 0,
        display: `inline`,
      },
      ".cm-placeholder": {
        color: `#888`,
        display: `inline-block`,
        verticalAlign: `top`,
        userSelect: `none`,
      },
      ".cm-highlightSpace": {
        backgroundImage: `radial-gradient(circle at 50% 55%, #aaa 20%, transparent 5%)`,
        backgroundPosition: `center`,
      },
      ".cm-highlightTab": {
        backgroundImage: `url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="200" height="20"><path stroke="%23888" stroke-width="1" fill="none" d="M1 10H196L190 5M190 15L196 10M197 4L197 16"/></svg>')`,
        backgroundSize: `auto 100%`,
        backgroundPosition: `right 90%`,
        backgroundRepeat: `no-repeat`,
      },
      ".cm-trailingSpace": {
        backgroundColor: `#ff332255`,
      },
      ".cm-button": {
        verticalAlign: `middle`,
        color: `inherit`,
        fontSize: `70%`,
        padding: `.2em 1em`,
        borderRadius: `1px`,
      },
      "&light .cm-button": {
        backgroundImage: `linear-gradient(#eff1f5, #d9d9df)`,
        border: `1px solid #888`,
        "&:active": {
          backgroundImage: `linear-gradient(#b4b4b4, #d0d3d6)`,
        },
      },
      "&dark .cm-button": {
        backgroundImage: `linear-gradient(#393939, #111)`,
        border: `1px solid #888`,
        "&:active": {
          backgroundImage: `linear-gradient(#111, #333)`,
        },
      },
      ".cm-textfield": {
        verticalAlign: `middle`,
        color: `inherit`,
        fontSize: `70%`,
        border: `1px solid silver`,
        padding: `.2em .5em`,
      },
      "&light .cm-textfield": {
        backgroundColor: `white`,
      },
      "&dark .cm-textfield": {
        border: `1px solid #555`,
        backgroundColor: `inherit`,
      },
    },
    ho,
  ),
  vo = {
    childList: !0,
    characterData: !0,
    subtree: !0,
    attributes: !0,
    characterDataOldValue: !0,
  },
  yo = N.ie && N.ie_version <= 11,
  bo = class {
    constructor(e) {
      ((this.view = e),
        (this.active = !1),
        (this.editContext = null),
        (this.selectionRange = new Cn()),
        (this.selectionChanged = !1),
        (this.delayedFlush = -1),
        (this.resizeTimeout = -1),
        (this.queue = []),
        (this.delayedAndroidKey = null),
        (this.flushingAndroidKey = -1),
        (this.lastChange = 0),
        (this.scrollTargets = []),
        (this.intersection = null),
        (this.resizeScroll = null),
        (this.intersecting = !1),
        (this.gapIntersection = null),
        (this.gaps = []),
        (this.printQuery = null),
        (this.parentCheck = -1),
        (this.dom = e.contentDOM),
        (this.observer = new MutationObserver((t) => {
          for (let e of t) this.queue.push(e);
          ((N.ie && N.ie_version <= 11) || (N.ios && e.composing)) &&
          t.some(
            (e) =>
              (e.type == `childList` && e.removedNodes.length) ||
              (e.type == `characterData` && e.oldValue.length > e.target.nodeValue.length),
          )
            ? this.flushSoon()
            : this.flush();
        })),
        window.EditContext &&
          N.android &&
          e.constructor.EDIT_CONTEXT !== !1 &&
          !(N.chrome && N.chrome_version < 126) &&
          ((this.editContext = new wo(e)),
          e.state.facet(vr) && (e.contentDOM.editContext = this.editContext.editContext)),
        yo &&
          (this.onCharData = (e) => {
            (this.queue.push({
              target: e.target,
              type: `characterData`,
              oldValue: e.prevValue,
            }),
              this.flushSoon());
          }),
        (this.onSelectionChange = this.onSelectionChange.bind(this)),
        (this.onResize = this.onResize.bind(this)),
        (this.onPrint = this.onPrint.bind(this)),
        (this.onScroll = this.onScroll.bind(this)),
        window.matchMedia && (this.printQuery = window.matchMedia(`print`)),
        typeof ResizeObserver == `function` &&
          ((this.resizeScroll = new ResizeObserver(() => {
            this.view.docView?.lastUpdate < Date.now() - 75 && this.onResize();
          })),
          this.resizeScroll.observe(e.scrollDOM)),
        this.addWindowListeners((this.win = e.win)),
        this.start(),
        typeof IntersectionObserver == `function` &&
          ((this.intersection = new IntersectionObserver(
            (e) => {
              (this.parentCheck < 0 &&
                (this.parentCheck = setTimeout(this.listenForScroll.bind(this), 1e3)),
                e.length > 0 &&
                  e[e.length - 1].intersectionRatio > 0 != this.intersecting &&
                  ((this.intersecting = !this.intersecting),
                  this.intersecting != this.view.inView &&
                    this.onScrollChanged(document.createEvent(`Event`))));
            },
            {
              threshold: [0, 0.001],
            },
          )),
          this.intersection.observe(this.dom),
          (this.gapIntersection = new IntersectionObserver((e) => {
            e.length > 0 &&
              e[e.length - 1].intersectionRatio > 0 &&
              this.onScrollChanged(document.createEvent(`Event`));
          }, {}))),
        this.listenForScroll(),
        this.readSelectionRange());
    }
    onScrollChanged(e) {
      (this.view.inputState.runHandlers(`scroll`, e), this.intersecting && this.view.measure());
    }
    onScroll(e) {
      (this.intersecting && this.flush(!1),
        this.editContext && this.view.requestMeasure(this.editContext.measureReq),
        this.onScrollChanged(e));
    }
    onResize() {
      this.resizeTimeout < 0 &&
        (this.resizeTimeout = setTimeout(() => {
          ((this.resizeTimeout = -1), this.view.requestMeasure());
        }, 50));
    }
    onPrint(e) {
      ((e.type == `change` || !e.type) && !e.matches) ||
        ((this.view.viewState.printing = !0),
        this.view.measure(),
        setTimeout(() => {
          ((this.view.viewState.printing = !1), this.view.requestMeasure());
        }, 500));
    }
    updateGaps(e) {
      if (
        this.gapIntersection &&
        (e.length != this.gaps.length || this.gaps.some((t, n) => t != e[n]))
      ) {
        this.gapIntersection.disconnect();
        for (let t of e) this.gapIntersection.observe(t);
        this.gaps = e;
      }
    }
    onSelectionChange(e) {
      let t = this.selectionChanged;
      if (!this.readSelectionRange() || this.delayedAndroidKey) return;
      let { view: n } = this,
        r = this.selectionRange;
      if (n.state.facet(vr) ? n.root.activeElement != this.dom : !dn(this.dom, r)) return;
      let i = r.anchorNode && n.docView.tile.nearest(r.anchorNode);
      if (i && i.isWidget() && i.widget.ignoreEvent(e)) {
        t || (this.selectionChanged = !1);
        return;
      }
      ((N.ie && N.ie_version <= 11) || (N.android && N.chrome)) &&
      !n.state.selection.main.empty &&
      r.focusNode &&
      pn(r.focusNode, r.focusOffset, r.anchorNode, r.anchorOffset)
        ? this.flushSoon()
        : this.flush(!1);
    }
    readSelectionRange() {
      let { view: e } = this,
        t = ln(e.root);
      if (!t) return !1;
      let n =
        (N.safari &&
          e.root.nodeType == 11 &&
          e.root.activeElement == this.dom &&
          Co(this.view, t)) ||
        t;
      if (!n || this.selectionRange.eq(n)) return !1;
      let r = dn(this.dom, n);
      return r &&
        !this.selectionChanged &&
        e.inputState.lastFocusTime > Date.now() - 200 &&
        e.inputState.lastTouchTime < Date.now() - 300 &&
        An(this.dom, n)
        ? ((this.view.inputState.lastFocusTime = 0), e.docView.updateSelection(), !1)
        : (this.selectionRange.setRange(n), r && (this.selectionChanged = !0), !0);
    }
    setSelectionRange(e, t) {
      (this.selectionRange.set(e.node, e.offset, t.node, t.offset), (this.selectionChanged = !1));
    }
    clearSelectionRange() {
      this.selectionRange.set(null, 0, null, 0);
    }
    listenForScroll() {
      this.parentCheck = -1;
      let e = 0,
        t = null;
      for (let n = this.dom; n;)
        if (n.nodeType == 1)
          (!t && e < this.scrollTargets.length && this.scrollTargets[e] == n
            ? e++
            : (t ||= this.scrollTargets.slice(0, e)),
            t && t.push(n),
            (n = n.assignedSlot || n.parentNode));
        else if (n.nodeType == 11) n = n.host;
        else break;
      if ((e < this.scrollTargets.length && !t && (t = this.scrollTargets.slice(0, e)), t)) {
        for (let e of this.scrollTargets) e.removeEventListener(`scroll`, this.onScroll);
        for (let e of (this.scrollTargets = t)) e.addEventListener(`scroll`, this.onScroll);
      }
    }
    ignore(e) {
      if (!this.active) return e();
      try {
        return (this.stop(), e());
      } finally {
        (this.start(), this.clear());
      }
    }
    start() {
      this.active ||=
        (this.observer.observe(this.dom, vo),
        yo && this.dom.addEventListener(`DOMCharacterDataModified`, this.onCharData),
        !0);
    }
    stop() {
      this.active &&
        ((this.active = !1),
        this.observer.disconnect(),
        yo && this.dom.removeEventListener(`DOMCharacterDataModified`, this.onCharData));
    }
    clear() {
      (this.processRecords(), (this.queue.length = 0), (this.selectionChanged = !1));
    }
    delayAndroidKey(e, t) {
      if (!this.delayedAndroidKey) {
        let e = () => {
          let e = this.delayedAndroidKey;
          e &&
            (this.clearDelayedAndroidKey(),
            (this.view.inputState.lastKeyCode = e.keyCode),
            (this.view.inputState.lastKeyTime = Date.now()),
            !this.flush() && e.force && On(this.dom, e.key, e.keyCode));
        };
        this.flushingAndroidKey = this.view.win.requestAnimationFrame(e);
      }
      (!this.delayedAndroidKey || e == `Enter`) &&
        (this.delayedAndroidKey = {
          key: e,
          keyCode: t,
          force: this.lastChange < Date.now() - 50 || !!this.delayedAndroidKey?.force,
        });
    }
    clearDelayedAndroidKey() {
      (this.win.cancelAnimationFrame(this.flushingAndroidKey),
        (this.delayedAndroidKey = null),
        (this.flushingAndroidKey = -1));
    }
    flushSoon() {
      this.delayedFlush < 0 &&
        (this.delayedFlush = this.view.win.requestAnimationFrame(() => {
          ((this.delayedFlush = -1), this.flush());
        }));
    }
    forceFlush() {
      (this.delayedFlush >= 0 &&
        (this.view.win.cancelAnimationFrame(this.delayedFlush), (this.delayedFlush = -1)),
        this.flush());
    }
    pendingRecords() {
      for (let e of this.observer.takeRecords()) this.queue.push(e);
      return this.queue;
    }
    processRecords() {
      let e = this.pendingRecords();
      e.length && (this.queue = []);
      let t = -1,
        n = -1,
        r = !1;
      for (let i of e) {
        let e = this.readMutation(i);
        e &&
          (e.typeOver && (r = !0),
          t == -1
            ? ({ from: t, to: n } = e)
            : ((t = Math.min(e.from, t)), (n = Math.max(e.to, n))));
      }
      return {
        from: t,
        to: n,
        typeOver: r,
      };
    }
    readChange() {
      let { from: e, to: t, typeOver: n } = this.processRecords(),
        r = this.selectionChanged && dn(this.dom, this.selectionRange);
      if (e < 0 && !r) return null;
      (e > -1 && (this.lastChange = Date.now()),
        (this.view.inputState.lastFocusTime = 0),
        (this.selectionChanged = !1));
      let i = new zi(this.view, e, t, n);
      return (
        (this.view.docView.domChanged = {
          newSel: i.newSel ? i.newSel.main : null,
        }),
        i
      );
    }
    flush(e = !0) {
      if (this.delayedFlush >= 0 || this.delayedAndroidKey) return !1;
      e && this.readSelectionRange();
      let t = this.readChange();
      if (!t) return (this.view.requestMeasure(), !1);
      let n = this.view.state,
        r = Vi(this.view, t);
      return (
        this.view.state == n &&
          (t.domChanged || (t.newSel && !qi(this.view.state.selection, t.newSel.main))) &&
          this.view.update([]),
        r
      );
    }
    readMutation(e) {
      let t = this.view.docView.tile.nearest(e.target);
      if (!t || t.isWidget()) return null;
      if ((t.markDirty(e.type == `attributes`), e.type == `childList`)) {
        let n = xo(t, e.previousSibling || e.target.previousSibling, -1),
          r = xo(t, e.nextSibling || e.target.nextSibling, 1);
        return {
          from: n ? t.posAfter(n) : t.posAtStart,
          to: r ? t.posBefore(r) : t.posAtEnd,
          typeOver: !1,
        };
      } else if (e.type == `characterData`)
        return {
          from: t.posAtStart,
          to: t.posAtEnd,
          typeOver: e.target.nodeValue == e.oldValue,
        };
      else return null;
    }
    setWindow(e) {
      e != this.win &&
        (this.removeWindowListeners(this.win), (this.win = e), this.addWindowListeners(this.win));
    }
    addWindowListeners(e) {
      (e.addEventListener(`resize`, this.onResize),
        this.printQuery
          ? this.printQuery.addEventListener
            ? this.printQuery.addEventListener(`change`, this.onPrint)
            : this.printQuery.addListener(this.onPrint)
          : e.addEventListener(`beforeprint`, this.onPrint),
        e.addEventListener(`scroll`, this.onScroll),
        e.document.addEventListener(`selectionchange`, this.onSelectionChange));
    }
    removeWindowListeners(e) {
      (e.removeEventListener(`scroll`, this.onScroll),
        e.removeEventListener(`resize`, this.onResize),
        this.printQuery
          ? this.printQuery.removeEventListener
            ? this.printQuery.removeEventListener(`change`, this.onPrint)
            : this.printQuery.removeListener(this.onPrint)
          : e.removeEventListener(`beforeprint`, this.onPrint),
        e.document.removeEventListener(`selectionchange`, this.onSelectionChange));
    }
    update(e) {
      this.editContext &&
        (this.editContext.update(e),
        e.startState.facet(vr) != e.state.facet(vr) &&
          (e.view.contentDOM.editContext = e.state.facet(vr)
            ? this.editContext.editContext
            : null));
    }
    destroy() {
      var e, t, n;
      (this.stop(),
        (e = this.intersection) == null || e.disconnect(),
        (t = this.gapIntersection) == null || t.disconnect(),
        (n = this.resizeScroll) == null || n.disconnect());
      for (let e of this.scrollTargets) e.removeEventListener(`scroll`, this.onScroll);
      (this.removeWindowListeners(this.win),
        clearTimeout(this.parentCheck),
        clearTimeout(this.resizeTimeout),
        this.win.cancelAnimationFrame(this.delayedFlush),
        this.win.cancelAnimationFrame(this.flushingAndroidKey),
        this.editContext &&
          ((this.view.contentDOM.editContext = null), this.editContext.destroy()));
    }
  };
function xo(e, t, n) {
  for (; t;) {
    let r = R.get(t);
    if (r && r.parent == e) return r;
    let i = t.parentNode;
    t = i == e.dom ? (n > 0 ? t.nextSibling : t.previousSibling) : i;
  }
  return null;
}
function So(e, t) {
  let n = t.startContainer,
    r = t.startOffset,
    i = t.endContainer,
    a = t.endOffset,
    o = e.docView.domAtPos(e.state.selection.main.anchor, 1);
  return (
    pn(o.node, o.offset, i, a) && ([n, r, i, a] = [i, a, n, r]),
    {
      anchorNode: n,
      anchorOffset: r,
      focusNode: i,
      focusOffset: a,
    }
  );
}
function Co(e, t) {
  if (t.getComposedRanges) {
    let n = t.getComposedRanges(e.root)[0];
    if (n) return So(e, n);
  }
  let n = null;
  function r(e) {
    (e.preventDefault(), e.stopImmediatePropagation(), (n = e.getTargetRanges()[0]));
  }
  return (
    e.contentDOM.addEventListener(`beforeinput`, r, !0),
    e.dom.ownerDocument.execCommand(`indent`),
    e.contentDOM.removeEventListener(`beforeinput`, r, !0),
    n ? So(e, n) : null
  );
}
var wo = class {
    constructor(e) {
      ((this.from = 0),
        (this.to = 0),
        (this.pendingContextChange = null),
        (this.handlers = Object.create(null)),
        (this.composing = null),
        this.resetRange(e.state));
      let t = (this.editContext = new window.EditContext({
        text: e.state.doc.sliceString(this.from, this.to),
        selectionStart: this.toContextPos(
          Math.max(this.from, Math.min(this.to, e.state.selection.main.anchor)),
        ),
        selectionEnd: this.toContextPos(e.state.selection.main.head),
      }));
      ((this.handlers.textupdate = (n) => {
        let r = e.state.selection.main,
          { anchor: i, head: a } = r,
          o = this.toEditorPos(n.updateRangeStart),
          s = this.toEditorPos(n.updateRangeEnd);
        e.inputState.composing >= 0 &&
          !this.composing &&
          (this.composing = {
            contextBase: n.updateRangeStart,
            editorBase: o,
            drifted: !1,
          });
        let c = s - o > n.text.length;
        o == this.from && i < this.from ? (o = i) : s == this.to && i > this.to && (s = i);
        let l = Wi(e.state.sliceDoc(o, s), n.text, (c ? r.from : r.to) - o, c ? `end` : null);
        if (!l) {
          let t = T.single(this.toEditorPos(n.selectionStart), this.toEditorPos(n.selectionEnd));
          qi(t, r) ||
            e.dispatch({
              selection: t,
              userEvent: `select`,
            });
          return;
        }
        let u = {
          from: l.from + o,
          to: l.toA + o,
          insert: f.of(
            n.text.slice(l.from, l.toB).split(`
`),
          ),
        };
        if (
          ((N.mac || N.android) &&
            u.from == a - 1 &&
            /^\. ?$/.test(n.text) &&
            e.contentDOM.getAttribute(`autocorrect`) == `off` &&
            (u = {
              from: o,
              to: s,
              insert: f.of([n.text.replace(`.`, ` `)]),
            }),
          (this.pendingContextChange = u),
          !e.state.readOnly)
        ) {
          let t = this.to - this.from + (u.to - u.from + u.insert.length);
          Hi(
            e,
            u,
            T.single(this.toEditorPos(n.selectionStart, t), this.toEditorPos(n.selectionEnd, t)),
          );
        }
        (this.pendingContextChange && (this.revertPending(e.state), this.setSelection(e.state)),
          u.from < u.to &&
            !u.insert.length &&
            e.inputState.composing >= 0 &&
            !/[\\p{Alphabetic}\\p{Number}_]/.test(
              t.text.slice(
                Math.max(0, n.updateRangeStart - 1),
                Math.min(t.text.length, n.updateRangeStart + 1),
              ),
            ) &&
            this.handlers.compositionend(n));
      }),
        (this.handlers.characterboundsupdate = (n) => {
          let r = [],
            i = null;
          for (
            let t = this.toEditorPos(n.rangeStart), a = this.toEditorPos(n.rangeEnd);
            t < a;
            t++
          ) {
            let n = e.coordsForChar(t);
            ((i =
              (n && new DOMRect(n.left, n.top, n.right - n.left, n.bottom - n.top)) ||
              i ||
              new DOMRect()),
              r.push(i));
          }
          t.updateCharacterBounds(n.rangeStart, r);
        }),
        (this.handlers.textformatupdate = (t) => {
          let n = [];
          for (let e of t.getTextFormats()) {
            let t = e.underlineStyle,
              r = e.underlineThickness;
            if (!/none/i.test(t) && !/none/i.test(r)) {
              let i = this.toEditorPos(e.rangeStart),
                a = this.toEditorPos(e.rangeEnd);
              if (i < a) {
                let e = `text-decoration: underline ${/^[a-z]/.test(t) ? t + ` ` : t == `Dashed` ? `dashed ` : t == `Squiggle` ? `wavy ` : ``}${/thin/i.test(r) ? 1 : 2}px`;
                n.push(
                  F.mark({
                    attributes: {
                      style: e,
                    },
                  }).range(i, a),
                );
              }
            }
          }
          e.dispatch({
            effects: gr.of(F.set(n)),
          });
        }),
        (this.handlers.compositionstart = () => {
          e.inputState.composing < 0 &&
            ((e.inputState.composing = 0), (e.inputState.compositionFirstChange = !0));
        }),
        (this.handlers.compositionend = () => {
          if (
            ((e.inputState.composing = -1),
            (e.inputState.compositionFirstChange = null),
            this.composing)
          ) {
            let { drifted: t } = this.composing;
            ((this.composing = null), t && this.reset(e.state));
          }
        }));
      for (let e in this.handlers) t.addEventListener(e, this.handlers[e]);
      this.measureReq = {
        read: (e) => {
          this.editContext.updateControlBounds(e.contentDOM.getBoundingClientRect());
          let t = ln(e.root);
          t &&
            t.rangeCount &&
            this.editContext.updateSelectionBounds(t.getRangeAt(0).getBoundingClientRect());
        },
      };
    }
    applyEdits(e) {
      let t = 0,
        n = !1,
        r = this.pendingContextChange;
      return (
        e.changes.iterChanges((i, a, o, s, c) => {
          if (n) return;
          let l = c.length - (a - i);
          if (r && a >= r.to)
            if (r.from == i && r.to == a && r.insert.eq(c)) {
              ((r = this.pendingContextChange = null), (t += l), (this.to += l));
              return;
            } else ((r = null), this.revertPending(e.state));
          if (((i += t), (a += t), a <= this.from)) ((this.from += l), (this.to += l));
          else if (i < this.to) {
            if (i < this.from || a > this.to || this.to - this.from + c.length > 3e4) {
              n = !0;
              return;
            }
            (this.editContext.updateText(this.toContextPos(i), this.toContextPos(a), c.toString()),
              (this.to += l));
          }
          t += l;
        }),
        r && !n && this.revertPending(e.state),
        !n
      );
    }
    update(e) {
      let t = this.pendingContextChange,
        n = e.startState.selection.main;
      (this.composing &&
      (this.composing.drifted ||
        (!e.changes.touchesRange(n.from, n.to) &&
          e.transactions.some(
            (e) => !e.isUserEvent(`input.type`) && e.changes.touchesRange(this.from, this.to),
          )))
        ? ((this.composing.drifted = !0),
          (this.composing.editorBase = e.changes.mapPos(this.composing.editorBase)))
        : !this.applyEdits(e) || !this.rangeIsValid(e.state)
          ? ((this.pendingContextChange = null), this.reset(e.state))
          : (e.docChanged || e.selectionSet || t) && this.setSelection(e.state),
        (e.geometryChanged || e.docChanged || e.selectionSet) &&
          e.view.requestMeasure(this.measureReq));
    }
    resetRange(e) {
      let { head: t } = e.selection.main;
      ((this.from = Math.max(0, t - 1e4)), (this.to = Math.min(e.doc.length, t + 1e4)));
    }
    reset(e) {
      (this.resetRange(e),
        this.editContext.updateText(
          0,
          this.editContext.text.length,
          e.doc.sliceString(this.from, this.to),
        ),
        this.setSelection(e));
    }
    revertPending(e) {
      let t = this.pendingContextChange;
      ((this.pendingContextChange = null),
        this.editContext.updateText(
          this.toContextPos(t.from),
          this.toContextPos(t.from + t.insert.length),
          e.doc.sliceString(t.from, t.to),
        ));
    }
    setSelection(e) {
      let { main: t } = e.selection,
        n = this.toContextPos(Math.max(this.from, Math.min(this.to, t.anchor))),
        r = this.toContextPos(t.head);
      (this.editContext.selectionStart != n || this.editContext.selectionEnd != r) &&
        this.editContext.updateSelection(n, r);
    }
    rangeIsValid(e) {
      let { head: t } = e.selection.main;
      return !(
        (this.from > 0 && t - this.from < 500) ||
        (this.to < e.doc.length && this.to - t < 500) ||
        this.to - this.from > 1e4 * 3
      );
    }
    toEditorPos(e, t = this.to - this.from) {
      e = Math.min(e, t);
      let n = this.composing;
      return n && n.drifted ? n.editorBase + (e - n.contextBase) : e + this.from;
    }
    toContextPos(e) {
      let t = this.composing;
      return t && t.drifted ? t.contextBase + (e - t.editorBase) : e - this.from;
    }
    destroy() {
      for (let e in this.handlers) this.editContext.removeEventListener(e, this.handlers[e]);
    }
  },
  U = class e {
    get state() {
      return this.viewState.state;
    }
    get viewport() {
      return this.viewState.viewport;
    }
    get visibleRanges() {
      return this.viewState.visibleRanges;
    }
    get inView() {
      return this.viewState.inView;
    }
    get composing() {
      return !!this.inputState && this.inputState.composing > 0;
    }
    get compositionStarted() {
      return !!this.inputState && this.inputState.composing >= 0;
    }
    get root() {
      return this._root;
    }
    get win() {
      return this.dom.ownerDocument.defaultView || window;
    }
    constructor(e = {}) {
      ((this.plugins = []),
        (this.pluginMap = new Map()),
        (this.editorAttrs = {}),
        (this.contentAttrs = {}),
        (this.bidiCache = []),
        (this.destroyed = !1),
        (this.updateState = 2),
        (this.measureScheduled = -1),
        (this.measureRequests = []),
        (this.contentDOM = document.createElement(`div`)),
        (this.scrollDOM = document.createElement(`div`)),
        (this.scrollDOM.tabIndex = -1),
        (this.scrollDOM.className = `cm-scroller`),
        this.scrollDOM.appendChild(this.contentDOM),
        (this.announceDOM = document.createElement(`div`)),
        (this.announceDOM.className = `cm-announced`),
        this.announceDOM.setAttribute(`aria-live`, `polite`),
        (this.dom = document.createElement(`div`)),
        this.dom.appendChild(this.announceDOM),
        this.dom.appendChild(this.scrollDOM),
        e.parent && e.parent.appendChild(this.dom));
      let { dispatch: t } = e;
      ((this.dispatchTransactions =
        e.dispatchTransactions ||
        (t && ((e) => e.forEach((e) => t(e, this)))) ||
        ((e) => this.update(e))),
        (this.dispatch = this.dispatch.bind(this)),
        (this._root = e.root || kn(e.parent) || document),
        (this.viewState = new $a(this, e.state || k.create(e))),
        e.scrollTo &&
          e.scrollTo.is(hr) &&
          (this.viewState.scrollTarget = e.scrollTo.value.clip(this.viewState.state)),
        (this.plugins = this.state.facet(br).map((e) => new Sr(e))));
      for (let e of this.plugins) e.update(this);
      ((this.observer = new bo(this)),
        (this.inputState = new Ji(this)),
        this.inputState.ensureHandlers(this.plugins),
        (this.docView = new ci(this)),
        this.mountStyles(),
        this.updateAttrs(),
        (this.updateState = 0),
        this.requestMeasure(),
        document.fonts?.ready &&
          document.fonts.ready.then(() => {
            ((this.viewState.mustMeasureContent = `refresh`), this.requestMeasure());
          }));
    }
    dispatch(...e) {
      let t =
        e.length == 1 && e[0] instanceof O
          ? e
          : e.length == 1 && Array.isArray(e[0])
            ? e[0]
            : [this.state.update(...e)];
      this.dispatchTransactions(t, this);
    }
    update(t) {
      if (this.updateState != 0)
        throw Error(`Calls to EditorView.update are not allowed while an update is in progress`);
      let n = !1,
        r = !1,
        i,
        a = this.state;
      for (let e of t) {
        if (e.startState != a)
          throw RangeError(
            `Trying to update state with a transaction that doesn't start from the previous state.`,
          );
        a = e.state;
      }
      if (this.destroyed) {
        this.viewState.state = a;
        return;
      }
      let o = this.hasFocus,
        s = 0,
        c = null;
      t.some((e) => e.annotation(wa))
        ? ((this.inputState.notifiedFocused = o), (s = 1))
        : o != this.inputState.notifiedFocused &&
          ((this.inputState.notifiedFocused = o), (c = Ta(a, o)), c || (s = 1));
      let l = this.observer.delayedAndroidKey,
        u = null;
      if (
        (l
          ? (this.observer.clearDelayedAndroidKey(),
            (u = this.observer.readChange()),
            ((u && !this.state.doc.eq(a.doc)) || !this.state.selection.eq(a.selection)) &&
              (u = null))
          : this.observer.clear(),
        a.facet(k.phrases) != this.state.facet(k.phrases))
      )
        return this.setState(a);
      ((i = Fr.create(this, a, t)), (i.flags |= s));
      let d = this.viewState.scrollTarget;
      try {
        this.updateState = 2;
        for (let n of t) {
          if (((d &&= d.map(n.changes)), n.scrollIntoView)) {
            let { main: t } = n.state.selection,
              { x: r, y: i } = this.state.facet(e.cursorScrollMargin);
            d = new mr(
              t.empty ? t : T.cursor(t.head, t.head > t.anchor ? -1 : 1),
              `nearest`,
              `nearest`,
              i,
              r,
            );
          }
          for (let e of n.effects) e.is(hr) && (d = e.value.clip(this.state));
        }
        (this.viewState.update(i, d),
          (this.bidiCache = Do.update(this.bidiCache, i.changes)),
          i.empty || (this.updatePlugins(i), this.inputState.update(i)),
          (n = this.docView.update(i)),
          this.state.facet(Nr) != this.styleModules && this.mountStyles(),
          (r = this.updateAttrs()),
          this.showAnnouncements(t),
          this.docView.updateSelection(
            n,
            t.some((e) => e.isUserEvent(`select.pointer`)),
          ));
      } finally {
        this.updateState = 0;
      }
      if (
        (i.startState.facet(lo) != i.state.facet(lo) && (this.viewState.mustMeasureContent = !0),
        (n ||
          r ||
          d ||
          this.viewState.mustEnforceCursorAssoc ||
          this.viewState.mustMeasureContent) &&
          this.requestMeasure(),
        n && this.docViewUpdate(),
        !i.empty)
      )
        for (let e of this.state.facet(or))
          try {
            e(i);
          } catch (e) {
            _r(this.state, e, `update listener`);
          }
      (c || u) &&
        Promise.resolve().then(() => {
          (c && this.state == c.startState && this.dispatch(c),
            u && !Vi(this, u) && l.force && On(this.contentDOM, l.key, l.keyCode));
        });
    }
    setState(e) {
      if (this.updateState != 0)
        throw Error(`Calls to EditorView.setState are not allowed while an update is in progress`);
      if (this.destroyed) {
        this.viewState.state = e;
        return;
      }
      this.updateState = 2;
      let t = this.hasFocus;
      try {
        for (let e of this.plugins) e.destroy(this);
        ((this.viewState = new $a(this, e)),
          (this.plugins = e.facet(br).map((e) => new Sr(e))),
          this.pluginMap.clear());
        for (let e of this.plugins) e.update(this);
        (this.docView.destroy(),
          (this.docView = new ci(this)),
          this.inputState.ensureHandlers(this.plugins),
          this.mountStyles(),
          this.updateAttrs(),
          (this.bidiCache = []));
      } finally {
        this.updateState = 0;
      }
      (t && this.focus(), this.requestMeasure());
    }
    updatePlugins(e) {
      let t = e.startState.facet(br),
        n = e.state.facet(br);
      if (t != n) {
        let r = [];
        for (let i of n) {
          let n = t.indexOf(i);
          if (n < 0) r.push(new Sr(i));
          else {
            let t = this.plugins[n];
            ((t.mustUpdate = e), r.push(t));
          }
        }
        for (let t of this.plugins) t.mustUpdate != e && t.destroy(this);
        ((this.plugins = r), this.pluginMap.clear());
      } else for (let t of this.plugins) t.mustUpdate = e;
      for (let e = 0; e < this.plugins.length; e++) this.plugins[e].update(this);
      t != n && this.inputState.ensureHandlers(this.plugins);
    }
    docViewUpdate() {
      for (let e of this.plugins) {
        let t = e.value;
        if (t && t.docViewUpdate)
          try {
            t.docViewUpdate(this);
          } catch (e) {
            _r(this.state, e, `doc view update listener`);
          }
      }
    }
    measure(e = !0) {
      if (this.destroyed) return;
      if (
        (this.measureScheduled > -1 && this.win.cancelAnimationFrame(this.measureScheduled),
        this.observer.delayedAndroidKey)
      ) {
        ((this.measureScheduled = -1), this.requestMeasure());
        return;
      }
      ((this.measureScheduled = 0), e && this.observer.forceFlush());
      let t = null,
        n = this.viewState.scrollParent,
        r = this.viewState.getScrollOffset(),
        { scrollAnchorPos: i, scrollAnchorHeight: a } = this.viewState;
      (Math.abs(r - this.viewState.scrollOffset) > 1 && (a = -1),
        (this.viewState.scrollAnchorHeight = -1));
      try {
        for (let e = 0; ; e++) {
          if (a < 0)
            if (jn(n || this.win)) ((i = -1), (a = this.viewState.heightMap.height));
            else {
              let e = this.viewState.scrollAnchorAt(r);
              ((i = e.from), (a = e.top));
            }
          this.updateState = 1;
          let o = this.viewState.measure();
          if (!o && !this.measureRequests.length && this.viewState.scrollTarget == null) break;
          if (e > 5) {
            console.warn(
              this.measureRequests.length
                ? `Measure loop restarted more than 5 times`
                : `Viewport failed to stabilize`,
            );
            break;
          }
          let s = [];
          o & 4 || ([this.measureRequests, s] = [s, this.measureRequests]);
          let c = s.map((e) => {
              try {
                return e.read(this);
              } catch (e) {
                return (_r(this.state, e), Eo);
              }
            }),
            l = Fr.create(this, this.state, []),
            u = !1;
          ((l.flags |= o),
            t ? (t.flags |= o) : (t = l),
            (this.updateState = 2),
            l.empty ||
              (this.updatePlugins(l),
              this.inputState.update(l),
              this.updateAttrs(),
              (u = this.docView.update(l)),
              u && this.docViewUpdate()));
          for (let e = 0; e < s.length; e++)
            if (c[e] != Eo)
              try {
                let t = s[e];
                t.write && t.write(c[e], this);
              } catch (e) {
                _r(this.state, e);
              }
          if (
            (u && this.docView.updateSelection(!0),
            !l.viewportChanged && this.measureRequests.length == 0)
          ) {
            if (this.viewState.editorHeight)
              if (this.viewState.scrollTarget) {
                (this.docView.scrollIntoView(this.viewState.scrollTarget),
                  (this.viewState.scrollTarget = null),
                  (a = -1));
                continue;
              } else {
                let e =
                  ((i < 0 ? this.viewState.heightMap.height : this.viewState.lineBlockAt(i).top) -
                    a) /
                  this.scaleY;
                if (
                  (e > 1 || e < -1) &&
                  (n == this.scrollDOM ||
                    this.hasFocus ||
                    Math.max(this.inputState.lastWheelEvent, this.inputState.lastTouchTime) >
                      Date.now() - 100)
                ) {
                  ((r += e), n ? (n.scrollTop += e) : this.win.scrollBy(0, e), (a = -1));
                  continue;
                }
              }
            break;
          }
        }
      } finally {
        ((this.updateState = 0), (this.measureScheduled = -1));
      }
      if (t && !t.empty) for (let e of this.state.facet(or)) e(t);
    }
    get themeClasses() {
      return fo + ` ` + (this.state.facet(uo) ? mo : po) + ` ` + this.state.facet(lo);
    }
    updateAttrs() {
      let e = Oo(this, Cr, {
          class: `cm-editor` + (this.hasFocus ? ` cm-focused ` : ` `) + this.themeClasses,
        }),
        t = {
          spellcheck: `false`,
          autocorrect: `off`,
          autocapitalize: `off`,
          writingsuggestions: `false`,
          translate: `no`,
          contenteditable: this.state.facet(vr) ? `true` : `false`,
          class: `cm-content`,
          style: `${N.tabSize}: ${this.state.tabSize}`,
          role: `textbox`,
          "aria-multiline": `true`,
        };
      (this.state.readOnly && (t[`aria-readonly`] = `true`), Oo(this, wr, t));
      let n = this.observer.ignore(() => {
        let n = Qt(this.contentDOM, this.contentAttrs, t),
          r = Qt(this.dom, this.editorAttrs, e);
        return n || r;
      });
      return ((this.editorAttrs = e), (this.contentAttrs = t), n);
    }
    showAnnouncements(t) {
      let n = !0;
      for (let r of t)
        for (let t of r.effects)
          if (t.is(e.announce)) {
            (n && (this.announceDOM.textContent = ``), (n = !1));
            let e = this.announceDOM.appendChild(document.createElement(`div`));
            e.textContent = t.value;
          }
    }
    mountStyles() {
      this.styleModules = this.state.facet(Nr);
      let t = this.state.facet(e.cspNonce);
      Dt.mount(
        this.root,
        this.styleModules.concat(_o).reverse(),
        t
          ? {
              nonce: t,
            }
          : void 0,
      );
    }
    readMeasured() {
      if (this.updateState == 2)
        throw Error(`Reading the editor layout isn't allowed during an update`);
      this.updateState == 0 && this.measureScheduled > -1 && this.measure(!1);
    }
    requestMeasure(e) {
      if (
        (this.measureScheduled < 0 &&
          (this.measureScheduled = this.win.requestAnimationFrame(() => this.measure())),
        e)
      ) {
        if (this.measureRequests.indexOf(e) > -1) return;
        if (e.key != null) {
          for (let t = 0; t < this.measureRequests.length; t++)
            if (this.measureRequests[t].key === e.key) {
              this.measureRequests[t] = e;
              return;
            }
        }
        this.measureRequests.push(e);
      }
    }
    plugin(e) {
      let t = this.pluginMap.get(e);
      return (
        (t === void 0 || (t && t.plugin != e)) &&
          this.pluginMap.set(e, (t = this.plugins.find((t) => t.plugin == e) || null)),
        t && t.update(this).value
      );
    }
    get documentTop() {
      return this.contentDOM.getBoundingClientRect().top + this.viewState.paddingTop;
    }
    get documentPadding() {
      return {
        top: this.viewState.paddingTop,
        bottom: this.viewState.paddingBottom,
      };
    }
    get scaleX() {
      return this.viewState.scaleX;
    }
    get scaleY() {
      return this.viewState.scaleY;
    }
    elementAtHeight(e) {
      return (this.readMeasured(), this.viewState.elementAtHeight(e));
    }
    lineBlockAtHeight(e) {
      return (this.readMeasured(), this.viewState.lineBlockAtHeight(e));
    }
    get viewportLineBlocks() {
      return this.viewState.viewportLines;
    }
    lineBlockAt(e) {
      return this.viewState.lineBlockAt(e);
    }
    get contentHeight() {
      return this.viewState.contentHeight;
    }
    moveByChar(e, t, n) {
      return Ai(this, e, Ti(this, e, t, n));
    }
    moveByGroup(e, t) {
      return Ai(
        this,
        e,
        Ti(this, e, t, (t) => Ei(this, e.head, t)),
      );
    }
    visualLineSide(e, t) {
      let n = this.bidiSpans(e),
        r = this.textDirectionAt(e.from),
        i = n[t ? n.length - 1 : 0];
      return T.cursor(i.side(t, r) + e.from, i.forward(!t, r) ? 1 : -1);
    }
    moveToLineBoundary(e, t, n = !0) {
      return wi(this, e, t, n);
    }
    moveVertically(e, t, n) {
      return Ai(this, e, Di(this, e, t, n));
    }
    domAtPos(e, t = 1) {
      return this.docView.domAtPos(e, t);
    }
    posAtDOM(e, t = 0) {
      return this.docView.posFromDOM(e, t);
    }
    posAtCoords(e, t = !0) {
      this.readMeasured();
      let n = Mi(this, e, t);
      return n && n.pos;
    }
    posAndSideAtCoords(e, t = !0) {
      return (this.readMeasured(), Mi(this, e, t));
    }
    coordsAtPos(e, t = 1) {
      this.readMeasured();
      let n = this.docView.coordsAt(e, t);
      if (!n || n.left == n.right) return n;
      let r = this.state.doc.lineAt(e),
        i = this.bidiSpans(r),
        a = i[Wn.find(i, e - r.from, -1, t)];
      return vn(n, (a.dir == I.LTR) == t > 0);
    }
    coordsForChar(e) {
      return (this.readMeasured(), this.docView.coordsForChar(e));
    }
    get defaultCharacterWidth() {
      return this.viewState.heightOracle.charWidth;
    }
    get defaultLineHeight() {
      return this.viewState.heightOracle.lineHeight;
    }
    get textDirection() {
      return this.viewState.defaultTextDirection;
    }
    textDirectionAt(e) {
      return !this.state.facet(dr) || e < this.viewport.from || e > this.viewport.to
        ? this.textDirection
        : (this.readMeasured(), this.docView.textDirectionAt(e));
    }
    get lineWrapping() {
      return this.viewState.heightOracle.lineWrapping;
    }
    bidiSpans(e) {
      if (e.length > To) return Qn(e.length);
      let t = this.textDirectionAt(e.from),
        n;
      for (let r of this.bidiCache)
        if (r.from == e.from && r.dir == t && (r.fresh || Gn(r.isolates, (n = Ar(this, e)))))
          return r.order;
      n ||= Ar(this, e);
      let r = Zn(e.text, t, n);
      return (this.bidiCache.push(new Do(e.from, e.to, t, n, !0, r)), r);
    }
    get hasFocus() {
      return (
        (this.dom.ownerDocument.hasFocus() ||
          (N.safari && this.inputState?.lastContextMenu > Date.now() - 3e4)) &&
        this.root.activeElement == this.contentDOM
      );
    }
    focus() {
      this.observer.ignore(() => {
        (Tn(this.contentDOM), this.docView.updateSelection());
      });
    }
    setRoot(e) {
      this._root != e &&
        ((this._root = e),
        this.observer.setWindow((e.nodeType == 9 ? e : e.ownerDocument).defaultView || window),
        this.mountStyles());
    }
    destroy() {
      this.root.activeElement == this.contentDOM && this.contentDOM.blur();
      for (let e of this.plugins) e.destroy(this);
      ((this.plugins = []),
        this.inputState.destroy(),
        this.docView.destroy(),
        this.dom.remove(),
        this.observer.destroy(),
        this.measureScheduled > -1 && this.win.cancelAnimationFrame(this.measureScheduled),
        (this.destroyed = !0));
    }
    static scrollIntoView(e, t = {}) {
      return hr.of(
        new mr(
          typeof e == `number` ? T.cursor(e) : e,
          t.y ?? `nearest`,
          t.x ?? `nearest`,
          t.yMargin ?? 5,
          t.xMargin ?? 5,
        ),
      );
    }
    scrollSnapshot() {
      let { scrollTop: e, scrollLeft: t } = this.scrollDOM,
        n = this.viewState.scrollAnchorAt(e);
      return hr.of(new mr(T.cursor(n.from), `start`, `start`, n.top - e, t, !0));
    }
    setTabFocusMode(e) {
      e == null
        ? (this.inputState.tabFocusMode = this.inputState.tabFocusMode < 0 ? 0 : -1)
        : typeof e == `boolean`
          ? (this.inputState.tabFocusMode = e ? 0 : -1)
          : this.inputState.tabFocusMode != 0 && (this.inputState.tabFocusMode = Date.now() + e);
    }
    static domEventHandlers(e) {
      return xr.define(() => ({}), {
        eventHandlers: e,
      });
    }
    static domEventObservers(e) {
      return xr.define(() => ({}), {
        eventObservers: e,
      });
    }
    static theme(e, t) {
      let n = Dt.newName(),
        r = [lo.of(n), Nr.of(go(`.${n}`, e))];
      return (t && t.dark && r.push(uo.of(!0)), r);
    }
    static baseTheme(e) {
      return Ee.lowest(Nr.of(go(`.` + fo, e, ho)));
    }
    static findFromDOM(e) {
      let t = e.querySelector(`.cm-content`);
      return ((t && R.get(t)) || R.get(e))?.root?.view || null;
    }
  };
((U.styleModule = Nr),
  (U.inputHandler = sr),
  (U.clipboardInputFilter = lr),
  (U.clipboardOutputFilter = ur),
  (U.scrollHandler = pr),
  (U.focusChangeEffect = cr),
  (U.perLineTextDirection = dr),
  (U.exceptionSink = ar),
  (U.updateListener = or),
  (U.editable = vr),
  (U.mouseSelectionStyle = ir),
  (U.dragMovesSelection = rr),
  (U.clickAddsSelectionRange = nr),
  (U.decorations = Tr),
  (U.blockWrappers = Er),
  (U.outerDecorations = Dr),
  (U.atomicRanges = Or),
  (U.bidiIsolatedRanges = kr),
  (U.cursorScrollMargin = E.define({
    combine: (e) => {
      let t = 5,
        n = 5;
      for (let r of e) typeof r == `number` ? (t = n = r) : ({ x: t, y: n } = r);
      return {
        x: t,
        y: n,
      };
    },
  })),
  (U.scrollMargins = jr),
  (U.darkTheme = uo),
  (U.cspNonce = E.define({
    combine: (e) => (e.length ? e[0] : ``),
  })),
  (U.contentAttributes = wr),
  (U.editorAttributes = Cr),
  (U.lineWrapping = U.contentAttributes.of({
    class: `cm-lineWrapping`,
  })),
  (U.announce = D.define()));
var To = 4096,
  Eo = {},
  Do = class e {
    constructor(e, t, n, r, i, a) {
      ((this.from = e),
        (this.to = t),
        (this.dir = n),
        (this.isolates = r),
        (this.fresh = i),
        (this.order = a));
    }
    static update(t, n) {
      if (n.empty && !t.some((e) => e.fresh)) return t;
      let r = [],
        i = t.length ? t[t.length - 1].dir : I.LTR;
      for (let a = Math.max(0, t.length - 10); a < t.length; a++) {
        let o = t[a];
        o.dir == i &&
          !n.touchesRange(o.from, o.to) &&
          r.push(new e(n.mapPos(o.from, 1), n.mapPos(o.to, -1), o.dir, o.isolates, !1, o.order));
      }
      return r;
    }
  };
function Oo(e, t, n) {
  for (let r = e.state.facet(t), i = r.length - 1; i >= 0; i--) {
    let t = r[i],
      a = typeof t == `function` ? t(e) : t;
    a && Jt(a, n);
  }
  return n;
}
var ko = N.mac ? `mac` : N.windows ? `win` : N.linux ? `linux` : `key`;
function Ao(e, t) {
  let n = e.split(/-(?!$)/),
    r = n[n.length - 1];
  r == `Space` && (r = ` `);
  let i, a, o, s;
  for (let e = 0; e < n.length - 1; ++e) {
    let r = n[e];
    if (/^(cmd|meta|m)$/i.test(r)) s = !0;
    else if (/^a(lt)?$/i.test(r)) i = !0;
    else if (/^(c|ctrl|control)$/i.test(r)) a = !0;
    else if (/^s(hift)?$/i.test(r)) o = !0;
    else if (/^mod$/i.test(r)) t == `mac` ? (s = !0) : (a = !0);
    else throw Error(`Unrecognized modifier name: ` + r);
  }
  return (
    i && (r = `Alt-` + r),
    a && (r = `Ctrl-` + r),
    s && (r = `Meta-` + r),
    o && (r = `Shift-` + r),
    r
  );
}
function jo(e, t, n) {
  return (
    t.altKey && (e = `Alt-` + e),
    t.ctrlKey && (e = `Ctrl-` + e),
    t.metaKey && (e = `Meta-` + e),
    n !== !1 && t.shiftKey && (e = `Shift-` + e),
    e
  );
}
var Mo = Ee.default(
    U.domEventHandlers({
      keydown(e, t) {
        return Vo(Fo(t.state), e, t, `editor`);
      },
    }),
  ),
  No = E.define({
    enables: Mo,
  }),
  Po = new WeakMap();
function Fo(e) {
  let t = e.facet(No),
    n = Po.get(t);
  return (n || Po.set(t, (n = zo(t.reduce((e, t) => e.concat(t), [])))), n);
}
function Io(e, t, n) {
  return Vo(Fo(e.state), t, e, n);
}
var Lo = null,
  Ro = 4e3;
function zo(e, t = ko) {
  let n = Object.create(null),
    r = Object.create(null),
    i = (e, t) => {
      let n = r[e];
      if (n == null) r[e] = t;
      else if (n != t)
        throw Error(
          `Key binding ` + e + ` is used both as a regular binding and as a multi-stroke prefix`,
        );
    },
    a = (e, r, a, o, s) => {
      let c = n[e] || (n[e] = Object.create(null)),
        l = r.split(/ (?!$)/).map((e) => Ao(e, t));
      for (let t = 1; t < l.length; t++) {
        let n = l.slice(0, t).join(` `);
        (i(n, !0),
          c[n] ||
            (c[n] = {
              preventDefault: !0,
              stopPropagation: !1,
              run: [
                (t) => {
                  let r = (Lo = {
                    view: t,
                    prefix: n,
                    scope: e,
                  });
                  return (
                    setTimeout(() => {
                      Lo == r && (Lo = null);
                    }, Ro),
                    !0
                  );
                },
              ],
            }));
      }
      let u = l.join(` `);
      i(u, !1);
      let d =
        c[u] ||
        (c[u] = {
          preventDefault: !1,
          stopPropagation: !1,
          run: c._any?.run?.slice() || [],
        });
      (a && d.run.push(a), o && (d.preventDefault = !0), s && (d.stopPropagation = !0));
    };
  for (let r of e) {
    let e = r.scope ? r.scope.split(` `) : [`editor`];
    if (r.any)
      for (let t of e) {
        let e = n[t] || (n[t] = Object.create(null));
        e._any ||= {
          preventDefault: !1,
          stopPropagation: !1,
          run: [],
        };
        let { any: i } = r;
        for (let t in e) e[t].run.push((e) => i(e, Bo));
      }
    let i = r[t] || r.key;
    if (i)
      for (let t of e)
        (a(t, i, r.run, r.preventDefault, r.stopPropagation),
          r.shift && a(t, `Shift-` + i, r.shift, r.preventDefault, r.stopPropagation));
  }
  return n;
}
var Bo = null;
function Vo(e, t, n, r) {
  Bo = t;
  let i = Ft(t),
    a = ae(re(i, 0)) == i.length && i != ` `,
    o = ``,
    s = !1,
    c = !1,
    l = !1;
  Lo &&
    Lo.view == n &&
    Lo.scope == r &&
    ((o = Lo.prefix + ` `), $i.indexOf(t.keyCode) < 0 && ((c = !0), (Lo = null)));
  let u = new Set(),
    d = (e) => {
      if (e) {
        for (let t of e.run)
          if (!u.has(t) && (u.add(t), t(n))) return (e.stopPropagation && (l = !0), !0);
        e.preventDefault && (e.stopPropagation && (l = !0), (c = !0));
      }
      return !1;
    },
    f = e[r],
    p,
    m;
  return (
    f &&
      (d(f[o + jo(i, t, !a)])
        ? (s = !0)
        : a &&
            (t.altKey || t.metaKey || t.ctrlKey) &&
            !(N.windows && t.ctrlKey && t.altKey) &&
            !(N.mac && t.altKey && !(t.ctrlKey || t.metaKey)) &&
            (p = At[t.keyCode]) &&
            p != i
          ? (d(f[o + jo(p, t, !0)]) ||
              (t.shiftKey && (m = jt[t.keyCode]) != i && m != p && d(f[o + jo(m, t, !1)]))) &&
            (s = !0)
          : a && t.shiftKey && d(f[o + jo(i, t, !0)]) && (s = !0),
      !s && d(f._any) && (s = !0)),
    c && (s = !0),
    s && l && t.stopPropagation(),
    (Bo = null),
    s
  );
}
var Ho = class e {
  constructor(e, t, n, r, i) {
    ((this.className = e), (this.left = t), (this.top = n), (this.width = r), (this.height = i));
  }
  draw() {
    let e = document.createElement(`div`);
    return ((e.className = this.className), this.adjust(e), e);
  }
  update(e, t) {
    return t.className == this.className ? (this.adjust(e), !0) : !1;
  }
  adjust(e) {
    ((e.style.left = this.left + `px`),
      (e.style.top = this.top + `px`),
      this.width != null && (e.style.width = this.width + `px`),
      (e.style.height = this.height + `px`));
  }
  eq(e) {
    return (
      this.left == e.left &&
      this.top == e.top &&
      this.width == e.width &&
      this.height == e.height &&
      this.className == e.className
    );
  }
  static forRange(t, n, r) {
    if (r.empty) {
      let i = t.coordsAtPos(r.head, r.assoc || 1);
      if (!i) return [];
      let a = Uo(t);
      return [new e(n, i.left - a.left, i.top - a.top, null, i.bottom - i.top)];
    } else return Go(t, n, r);
  }
};
function Uo(e) {
  let t = e.scrollDOM.getBoundingClientRect();
  return {
    left:
      (e.textDirection == I.LTR ? t.left : t.right - e.scrollDOM.clientWidth * e.scaleX) -
      e.scrollDOM.scrollLeft * e.scaleX,
    top: t.top - e.scrollDOM.scrollTop * e.scaleY,
  };
}
function Wo(e, t, n, r) {
  let i = e.coordsAtPos(t, n * 2);
  if (!i) return r;
  let a = e.dom.getBoundingClientRect(),
    o = (i.top + i.bottom) / 2,
    s = e.posAtCoords({
      x: a.left + 1,
      y: o,
    }),
    c = e.posAtCoords({
      x: a.right - 1,
      y: o,
    });
  return s == null || c == null
    ? r
    : {
        from: Math.max(r.from, Math.min(s, c)),
        to: Math.min(r.to, Math.max(s, c)),
      };
}
function Go(e, t, n) {
  if (n.to <= e.viewport.from || n.from >= e.viewport.to) return [];
  let r = Math.max(n.from, e.viewport.from),
    i = Math.min(n.to, e.viewport.to),
    a = e.textDirection == I.LTR,
    o = e.contentDOM,
    s = o.getBoundingClientRect(),
    c = Uo(e),
    l = o.querySelector(`.cm-line`),
    u = l && window.getComputedStyle(l),
    d = s.left + (u ? parseInt(u.paddingLeft) + Math.min(0, parseInt(u.textIndent)) : 0),
    f = s.right - (u ? parseInt(u.paddingRight) : 0),
    p = Ci(e, r, 1),
    m = Ci(e, i, -1),
    h = p.type == P.Text ? p : null,
    g = m.type == P.Text ? m : null;
  if (
    (h && (e.lineWrapping || p.widgetLineBreaks) && (h = Wo(e, r, 1, h)),
    g && (e.lineWrapping || m.widgetLineBreaks) && (g = Wo(e, i, -1, g)),
    h && g && h.from == g.from && h.to == g.to)
  )
    return v(y(n.from, n.to, h));
  {
    let t = h ? y(n.from, null, h) : ee(p, !1),
      r = g ? y(null, n.to, g) : ee(m, !0),
      i = [];
    return (
      (h || p).to < (g || m).from - (h && g ? 1 : 0) ||
      (p.widgetLineBreaks > 1 && t.bottom + e.defaultLineHeight / 2 < r.top)
        ? i.push(_(d, t.bottom, f, r.top))
        : t.bottom < r.top &&
          e.elementAtHeight((t.bottom + r.top) / 2).type == P.Text &&
          (t.bottom = r.top = (t.bottom + r.top) / 2),
      v(t).concat(i).concat(v(r))
    );
  }
  function _(e, n, r, i) {
    return new Ho(t, e - c.left, n - c.top, Math.max(0, r - e), i - n);
  }
  function v({ top: e, bottom: t, horizontal: n }) {
    let r = [];
    for (let i = 0; i < n.length; i += 2) r.push(_(n[i], e, n[i + 1], t));
    return r;
  }
  function y(t, n, r) {
    let i = 1e9,
      o = -1e9,
      s = [];
    function c(t, n, c, l, u) {
      let p = e.coordsAtPos(t, t == r.to ? -2 : 2),
        m = e.coordsAtPos(c, c == r.from ? 2 : -2);
      !p ||
        !m ||
        ((i = Math.min(p.top, m.top, i)),
        (o = Math.max(p.bottom, m.bottom, o)),
        u == I.LTR
          ? s.push(a && n ? d : p.left, a && l ? f : m.right)
          : s.push(!a && l ? d : m.left, !a && n ? f : p.right));
    }
    let l = t ?? r.from,
      u = n ?? r.to;
    for (let r of e.visibleRanges)
      if (r.to > l && r.from < u)
        for (let i = Math.max(r.from, l), a = Math.min(r.to, u); ;) {
          let r = e.state.doc.lineAt(i);
          for (let o of e.bidiSpans(r)) {
            let e = o.from + r.from,
              s = o.to + r.from;
            if (e >= a) break;
            s > i &&
              c(Math.max(e, i), t == null && e <= l, Math.min(s, a), n == null && s >= u, o.dir);
          }
          if (((i = r.to + 1), i >= a)) break;
        }
    return (
      s.length == 0 && c(l, t == null, u, n == null, e.textDirection),
      {
        top: i,
        bottom: o,
        horizontal: s,
      }
    );
  }
  function ee(e, t) {
    let n = s.top + (t ? e.top : e.bottom);
    return {
      top: n,
      bottom: n,
      horizontal: [],
    };
  }
}
function Ko(e, t) {
  return e.constructor == t.constructor && e.eq(t);
}
var qo = class {
    constructor(e, t) {
      ((this.view = e),
        (this.layer = t),
        (this.drawn = []),
        (this.scaleX = 1),
        (this.scaleY = 1),
        (this.measureReq = {
          read: this.measure.bind(this),
          write: this.draw.bind(this),
        }),
        (this.dom = e.scrollDOM.appendChild(document.createElement(`div`))),
        this.dom.classList.add(`cm-layer`),
        t.above && this.dom.classList.add(`cm-layer-above`),
        t.class && this.dom.classList.add(t.class),
        this.scale(),
        this.dom.setAttribute(`aria-hidden`, `true`),
        this.setOrder(e.state),
        e.requestMeasure(this.measureReq),
        t.mount && t.mount(this.dom, e));
    }
    update(e) {
      (e.startState.facet(Jo) != e.state.facet(Jo) && this.setOrder(e.state),
        (this.layer.update(e, this.dom) || e.geometryChanged) &&
          (this.scale(), e.view.requestMeasure(this.measureReq)));
    }
    docViewUpdate(e) {
      this.layer.updateOnDocViewUpdate !== !1 && e.requestMeasure(this.measureReq);
    }
    setOrder(e) {
      let t = 0,
        n = e.facet(Jo);
      for (; t < n.length && n[t] != this.layer;) t++;
      this.dom.style.zIndex = String((this.layer.above ? 150 : -1) - t);
    }
    measure() {
      return this.layer.markers(this.view);
    }
    scale() {
      let { scaleX: e, scaleY: t } = this.view;
      (e != this.scaleX || t != this.scaleY) &&
        ((this.scaleX = e),
        (this.scaleY = t),
        (this.dom.style.transform = `scale(${1 / e}, ${1 / t})`));
    }
    draw(e) {
      if (e.length != this.drawn.length || e.some((e, t) => !Ko(e, this.drawn[t]))) {
        let t = this.dom.firstChild,
          n = 0;
        for (let r of e)
          r.update && t && r.constructor && this.drawn[n].constructor && r.update(t, this.drawn[n])
            ? ((t = t.nextSibling), n++)
            : this.dom.insertBefore(r.draw(), t);
        for (; t;) {
          let e = t.nextSibling;
          (t.remove(), (t = e));
        }
        ((this.drawn = e),
          N.webkit && (this.dom.style.display = this.dom.firstChild ? `` : `none`));
      }
    }
    destroy() {
      (this.layer.destroy && this.layer.destroy(this.dom, this.view), this.dom.remove());
    }
  },
  Jo = E.define();
function Yo(e) {
  return [xr.define((t) => new qo(t, e)), Jo.of(e)];
}
var Xo = E.define({
  combine(e) {
    return rt(
      e,
      {
        cursorBlinkRate: 1200,
        drawRangeCursor: !0,
        iosSelectionHandles: !0,
      },
      {
        cursorBlinkRate: (e, t) => Math.min(e, t),
        drawRangeCursor: (e, t) => e || t,
      },
    );
  },
});
function Zo(e = {}) {
  return [Xo.of(e), $o, ts, ns, fr.of(!0)];
}
function Qo(e) {
  return e.startState.facet(Xo) != e.state.facet(Xo);
}
var $o = Yo({
  above: !0,
  markers(e) {
    let { state: t } = e,
      n = t.facet(Xo),
      r = [];
    for (let i of t.selection.ranges) {
      let a = i == t.selection.main;
      if (i.empty || (n.drawRangeCursor && !(a && N.ios && n.iosSelectionHandles))) {
        let t = a ? `cm-cursor cm-cursor-primary` : `cm-cursor cm-cursor-secondary`,
          n = i.empty ? i : T.cursor(i.head, i.assoc);
        for (let i of Ho.forRange(e, t, n)) r.push(i);
      }
    }
    return r;
  },
  update(e, t) {
    e.transactions.some((e) => e.selection) &&
      (t.style.animationName = t.style.animationName == `cm-blink` ? `cm-blink2` : `cm-blink`);
    let n = Qo(e);
    return (n && es(e.state, t), e.docChanged || e.selectionSet || n);
  },
  mount(e, t) {
    es(t.state, e);
  },
  class: `cm-cursorLayer`,
});
function es(e, t) {
  t.style.animationDuration = e.facet(Xo).cursorBlinkRate + `ms`;
}
var ts = Yo({
    above: !1,
    markers(e) {
      let t = [],
        { main: n, ranges: r } = e.state.selection;
      for (let n of r)
        if (!n.empty) for (let r of Ho.forRange(e, `cm-selectionBackground`, n)) t.push(r);
      if (N.ios && !n.empty && e.state.facet(Xo).iosSelectionHandles) {
        for (let r of Ho.forRange(
          e,
          `cm-selectionHandle cm-selectionHandle-start`,
          T.cursor(n.from, 1),
        ))
          t.push(r);
        for (let r of Ho.forRange(
          e,
          `cm-selectionHandle cm-selectionHandle-end`,
          T.cursor(n.to, 1),
        ))
          t.push(r);
      }
      return t;
    },
    update(e, t) {
      return e.docChanged || e.selectionSet || e.viewportChanged || Qo(e);
    },
    class: `cm-selectionLayer`,
  }),
  ns = Ee.highest(
    U.theme({
      ".cm-line": {
        "& ::selection, &::selection": {
          backgroundColor: `transparent !important`,
        },
        caretColor: `transparent !important`,
      },
      ".cm-content": {
        caretColor: `transparent !important`,
        "& :focus": {
          caretColor: `initial !important`,
          "&::selection, & ::selection": {
            backgroundColor: `Highlight !important`,
          },
        },
      },
    }),
  );
/x/.unicode;
var rs = class extends en {
  constructor(e) {
    (super(), (this.content = e));
  }
  toDOM(e) {
    let t = document.createElement(`span`);
    return (
      (t.className = `cm-placeholder`),
      (t.style.pointerEvents = `none`),
      t.appendChild(
        typeof this.content == `string`
          ? document.createTextNode(this.content)
          : typeof this.content == `function`
            ? this.content(e)
            : this.content.cloneNode(!0),
      ),
      t.setAttribute(`aria-hidden`, `true`),
      t
    );
  }
  coordsAt(e) {
    let t = e.firstChild ? fn(e.firstChild) : [];
    if (!t.length) return null;
    let n = window.getComputedStyle(e.parentNode),
      r = vn(t[0], n.direction != `rtl`),
      i = parseInt(n.lineHeight);
    return r.bottom - r.top > i * 1.5
      ? {
          left: r.left,
          right: r.right,
          top: r.top,
          bottom: r.top + i,
        }
      : r;
  }
  ignoreEvent() {
    return !1;
  }
};
function is(e) {
  let t = xr.fromClass(
    class {
      constructor(t) {
        ((this.view = t),
          (this.placeholder = e
            ? F.set([
                F.widget({
                  widget: new rs(e),
                  side: 1,
                }).range(0),
              ])
            : F.none));
      }
      get decorations() {
        return this.view.state.doc.length ? F.none : this.placeholder;
      }
    },
    {
      decorations: (e) => e.decorations,
    },
  );
  return typeof e == `string`
    ? [
        t,
        U.contentAttributes.of({
          "aria-placeholder": e,
        }),
      ]
    : t;
}
var as = `-10000px`,
  os = class {
    constructor(e, t, n, r) {
      ((this.facet = t),
        (this.createTooltipView = n),
        (this.removeTooltipView = r),
        (this.input = e.state.facet(t)),
        (this.tooltips = this.input.filter((e) => e)));
      let i = null;
      this.tooltipViews = this.tooltips.map((e) => (i = n(e, i)));
    }
    update(e, t) {
      var n;
      let r = e.state.facet(this.facet),
        i = r.filter((e) => e);
      if (r === this.input) {
        for (let t of this.tooltipViews) t.update && t.update(e);
        return !1;
      }
      let a = [],
        o = t ? [] : null;
      for (let n = 0; n < i.length; n++) {
        let r = i[n],
          s = -1;
        if (r) {
          for (let e = 0; e < this.tooltips.length; e++) {
            let t = this.tooltips[e];
            t && t.create == r.create && (s = e);
          }
          if (s < 0)
            ((a[n] = this.createTooltipView(r, n ? a[n - 1] : null)), o && (o[n] = !!r.above));
          else {
            let r = (a[n] = this.tooltipViews[s]);
            (o && (o[n] = t[s]), r.update && r.update(e));
          }
        }
      }
      for (let e of this.tooltipViews)
        a.indexOf(e) < 0 && (this.removeTooltipView(e), (n = e.destroy) == null || n.call(e));
      return (
        t && (o.forEach((e, n) => (t[n] = e)), (t.length = o.length)),
        (this.input = r),
        (this.tooltips = i),
        (this.tooltipViews = a),
        !0
      );
    }
  };
function ss(e) {
  let t = e.dom.ownerDocument.documentElement;
  return {
    top: 0,
    left: 0,
    bottom: t.clientHeight,
    right: t.clientWidth,
  };
}
var cs = E.define({
    combine: (e) => ({
      position: N.ios ? `absolute` : e.find((e) => e.position)?.position || `fixed`,
      parent: e.find((e) => e.parent)?.parent || null,
      tooltipSpace: e.find((e) => e.tooltipSpace)?.tooltipSpace || ss,
    }),
  }),
  ls = new WeakMap(),
  us = xr.fromClass(
    class {
      constructor(e) {
        ((this.view = e),
          (this.above = []),
          (this.inView = !0),
          (this.madeAbsolute = !1),
          (this.lastTransaction = 0),
          (this.measureTimeout = -1));
        let t = e.state.facet(cs);
        ((this.position = t.position),
          (this.parent = t.parent),
          (this.classes = e.themeClasses),
          this.createContainer(),
          (this.measureReq = {
            read: this.readMeasure.bind(this),
            write: this.writeMeasure.bind(this),
            key: this,
          }),
          (this.resizeObserver =
            typeof ResizeObserver == `function`
              ? new ResizeObserver(() => this.measureSoon())
              : null),
          (this.manager = new os(
            e,
            ms,
            (e, t) => this.createTooltip(e, t),
            (e) => {
              (this.resizeObserver && this.resizeObserver.unobserve(e.dom), e.dom.remove());
            },
          )),
          (this.above = this.manager.tooltips.map((e) => !!e.above)),
          (this.intersectionObserver =
            typeof IntersectionObserver == `function`
              ? new IntersectionObserver(
                  (e) => {
                    Date.now() > this.lastTransaction - 50 &&
                      e.length > 0 &&
                      e[e.length - 1].intersectionRatio < 1 &&
                      this.measureSoon();
                  },
                  {
                    threshold: [1],
                  },
                )
              : null),
          this.observeIntersection(),
          e.win.addEventListener(`resize`, (this.measureSoon = this.measureSoon.bind(this))),
          this.maybeMeasure());
      }
      createContainer() {
        this.parent
          ? ((this.container = document.createElement(`div`)),
            (this.container.style.position = `relative`),
            (this.container.className = this.view.themeClasses),
            this.parent.appendChild(this.container))
          : (this.container = this.view.dom);
      }
      observeIntersection() {
        if (this.intersectionObserver) {
          this.intersectionObserver.disconnect();
          for (let e of this.manager.tooltipViews) this.intersectionObserver.observe(e.dom);
        }
      }
      measureSoon() {
        this.measureTimeout < 0 &&
          (this.measureTimeout = setTimeout(() => {
            ((this.measureTimeout = -1), this.maybeMeasure());
          }, 50));
      }
      update(e) {
        e.transactions.length && (this.lastTransaction = Date.now());
        let t = this.manager.update(e, this.above);
        t && this.observeIntersection();
        let n = t || e.geometryChanged,
          r = e.state.facet(cs);
        if (r.position != this.position && !this.madeAbsolute) {
          this.position = r.position;
          for (let e of this.manager.tooltipViews) e.dom.style.position = this.position;
          n = !0;
        }
        if (r.parent != this.parent) {
          (this.parent && this.container.remove(),
            (this.parent = r.parent),
            this.createContainer());
          for (let e of this.manager.tooltipViews) this.container.appendChild(e.dom);
          n = !0;
        } else
          this.parent &&
            this.view.themeClasses != this.classes &&
            (this.classes = this.container.className = this.view.themeClasses);
        n && this.maybeMeasure();
      }
      createTooltip(e, t) {
        let n = e.create(this.view),
          r = t ? t.dom : null;
        if (
          (n.dom.classList.add(`cm-tooltip`),
          e.arrow && !n.dom.querySelector(`.cm-tooltip > .cm-tooltip-arrow`))
        ) {
          let e = document.createElement(`div`);
          ((e.className = `cm-tooltip-arrow`), n.dom.appendChild(e));
        }
        return (
          (n.dom.style.position = this.position),
          (n.dom.style.top = as),
          (n.dom.style.left = `0px`),
          this.container.insertBefore(n.dom, r),
          n.mount && n.mount(this.view),
          this.resizeObserver && this.resizeObserver.observe(n.dom),
          n
        );
      }
      destroy() {
        var e, t, n;
        this.view.win.removeEventListener(`resize`, this.measureSoon);
        for (let t of this.manager.tooltipViews)
          (t.dom.remove(), (e = t.destroy) == null || e.call(t));
        (this.parent && this.container.remove(),
          (t = this.resizeObserver) == null || t.disconnect(),
          (n = this.intersectionObserver) == null || n.disconnect(),
          clearTimeout(this.measureTimeout));
      }
      readMeasure() {
        let e = 1,
          t = 1,
          n = !1;
        if (this.position == `fixed` && this.manager.tooltipViews.length) {
          let { dom: e } = this.manager.tooltipViews[0];
          if (N.safari) {
            let t = e.getBoundingClientRect();
            n = Math.abs(t.top + 1e4) > 1 || Math.abs(t.left) > 1;
          } else n = !!e.offsetParent && e.offsetParent != this.container.ownerDocument.body;
        }
        if (n || this.position == `absolute`)
          if (this.parent) {
            let n = this.parent.getBoundingClientRect();
            n.width &&
              n.height &&
              ((e = n.width / this.parent.offsetWidth), (t = n.height / this.parent.offsetHeight));
          } else ({ scaleX: e, scaleY: t } = this.view.viewState);
        let r = this.view.scrollDOM.getBoundingClientRect(),
          i = Mr(this.view);
        return {
          visible: {
            left: r.left + i.left,
            top: r.top + i.top,
            right: r.right - i.right,
            bottom: r.bottom - i.bottom,
          },
          parent: this.parent
            ? this.container.getBoundingClientRect()
            : this.view.dom.getBoundingClientRect(),
          pos: this.manager.tooltips.map((e, t) => {
            let n = this.manager.tooltipViews[t];
            return n.getCoords ? n.getCoords(e.pos) : this.view.coordsAtPos(e.pos);
          }),
          size: this.manager.tooltipViews.map(({ dom: e }) => e.getBoundingClientRect()),
          space: this.view.state.facet(cs).tooltipSpace(this.view),
          scaleX: e,
          scaleY: t,
          makeAbsolute: n,
        };
      }
      writeMeasure(e) {
        if (e.makeAbsolute) {
          ((this.madeAbsolute = !0), (this.position = `absolute`));
          for (let e of this.manager.tooltipViews) e.dom.style.position = `absolute`;
        }
        let { visible: t, space: n, scaleX: r, scaleY: i } = e,
          a = [];
        for (let o = 0; o < this.manager.tooltips.length; o++) {
          let s = this.manager.tooltips[o],
            c = this.manager.tooltipViews[o],
            { dom: l } = c,
            u = e.pos[o],
            d = e.size[o];
          if (
            !u ||
            (s.clip !== !1 &&
              (u.bottom <= Math.max(t.top, n.top) ||
                u.top >= Math.min(t.bottom, n.bottom) ||
                u.right < Math.max(t.left, n.left) - 0.1 ||
                u.left > Math.min(t.right, n.right) + 0.1))
          ) {
            l.style.top = as;
            continue;
          }
          let f = s.arrow ? c.dom.querySelector(`.cm-tooltip-arrow`) : null,
            p = f ? 7 : 0,
            m = d.right - d.left,
            h = ls.get(c) ?? d.bottom - d.top,
            g = c.offset || ps,
            _ = this.view.textDirection == I.LTR,
            v =
              d.width > n.right - n.left
                ? _
                  ? n.left
                  : n.right - d.width
                : _
                  ? Math.max(n.left, Math.min(u.left - (f ? 14 : 0) + g.x, n.right - m))
                  : Math.min(Math.max(n.left, u.left - m + (f ? 14 : 0) - g.x), n.right - m),
            y = this.above[o];
          !s.strictSide &&
            (y ? u.top - h - p - g.y < n.top : u.bottom + h + p + g.y > n.bottom) &&
            y == n.bottom - u.bottom > u.top - n.top &&
            (y = this.above[o] = !y);
          let ee = (y ? u.top - n.top : n.bottom - u.bottom) - p;
          if (ee < h && c.resize !== !1) {
            if (ee < this.view.defaultLineHeight) {
              l.style.top = as;
              continue;
            }
            (ls.set(c, h), (l.style.height = (h = ee) / i + `px`));
          } else l.style.height && (l.style.height = ``);
          let b = y ? u.top - h - p - g.y : u.bottom + p + g.y,
            x = v + m;
          if (c.overlap !== !0)
            for (let e of a)
              e.left < x &&
                e.right > v &&
                e.top < b + h &&
                e.bottom > b &&
                (b = y ? e.top - h - 2 - p : e.bottom + p + 2);
          if (
            (this.position == `absolute`
              ? ((l.style.top = (b - e.parent.top) / i + `px`), ds(l, (v - e.parent.left) / r))
              : ((l.style.top = b / i + `px`), ds(l, v / r)),
            f)
          ) {
            let e = u.left + (_ ? g.x : -g.x) - (v + 14 - 7);
            f.style.left = e / r + `px`;
          }
          (c.overlap !== !0 &&
            a.push({
              left: v,
              top: b,
              right: x,
              bottom: b + h,
            }),
            l.classList.toggle(`cm-tooltip-above`, y),
            l.classList.toggle(`cm-tooltip-below`, !y),
            c.positioned && c.positioned(e.space));
        }
      }
      maybeMeasure() {
        if (
          this.manager.tooltips.length &&
          (this.view.inView && this.view.requestMeasure(this.measureReq),
          this.inView != this.view.inView && ((this.inView = this.view.inView), !this.inView))
        )
          for (let e of this.manager.tooltipViews) e.dom.style.top = as;
      }
    },
    {
      eventObservers: {
        scroll() {
          this.maybeMeasure();
        },
      },
    },
  );
function ds(e, t) {
  let n = parseInt(e.style.left, 10);
  (isNaN(n) || Math.abs(t - n) > 1) && (e.style.left = t + `px`);
}
var fs = U.baseTheme({
    ".cm-tooltip": {
      zIndex: 500,
      boxSizing: `border-box`,
    },
    "&light .cm-tooltip": {
      border: `1px solid #bbb`,
      backgroundColor: `#f5f5f5`,
    },
    "&light .cm-tooltip-section:not(:first-child)": {
      borderTop: `1px solid #bbb`,
    },
    "&dark .cm-tooltip": {
      backgroundColor: `#333338`,
      color: `white`,
    },
    ".cm-tooltip-arrow": {
      height: `7px`,
      width: `14px`,
      position: `absolute`,
      zIndex: -1,
      overflow: `hidden`,
      "&:before, &:after": {
        content: `''`,
        position: `absolute`,
        width: 0,
        height: 0,
        borderLeft: `7px solid transparent`,
        borderRight: `7px solid transparent`,
      },
      ".cm-tooltip-above &": {
        bottom: `-7px`,
        "&:before": {
          borderTop: `7px solid #bbb`,
        },
        "&:after": {
          borderTop: `7px solid #f5f5f5`,
          bottom: `1px`,
        },
      },
      ".cm-tooltip-below &": {
        top: `-7px`,
        "&:before": {
          borderBottom: `7px solid #bbb`,
        },
        "&:after": {
          borderBottom: `7px solid #f5f5f5`,
          top: `1px`,
        },
      },
    },
    "&dark .cm-tooltip .cm-tooltip-arrow": {
      "&:before": {
        borderTopColor: `#333338`,
        borderBottomColor: `#333338`,
      },
      "&:after": {
        borderTopColor: `transparent`,
        borderBottomColor: `transparent`,
      },
    },
  }),
  ps = {
    x: 0,
    y: 0,
  },
  ms = E.define({
    enables: [us, fs],
  });
function hs(e, t) {
  let n = e.plugin(us);
  if (!n) return null;
  let r = n.manager.tooltips.indexOf(t);
  return r < 0 ? null : n.manager.tooltipViews[r];
}
var gs = E.define({
  combine(e) {
    let t, n;
    for (let r of e) ((t ||= r.topContainer), (n ||= r.bottomContainer));
    return {
      topContainer: t,
      bottomContainer: n,
    };
  },
});
function _s(e, t) {
  let n = e.plugin(vs),
    r = n ? n.specs.indexOf(t) : -1;
  return r > -1 ? n.panels[r] : null;
}
var vs = xr.fromClass(
    class {
      constructor(e) {
        ((this.input = e.state.facet(xs)),
          (this.specs = this.input.filter((e) => e)),
          (this.panels = this.specs.map((t) => t(e))));
        let t = e.state.facet(gs);
        ((this.top = new ys(e, !0, t.topContainer)),
          (this.bottom = new ys(e, !1, t.bottomContainer)),
          this.top.sync(this.panels.filter((e) => e.top)),
          this.bottom.sync(this.panels.filter((e) => !e.top)));
        for (let e of this.panels) (e.dom.classList.add(`cm-panel`), e.mount && e.mount());
      }
      update(e) {
        let t = e.state.facet(gs);
        (this.top.container != t.topContainer &&
          (this.top.sync([]), (this.top = new ys(e.view, !0, t.topContainer))),
          this.bottom.container != t.bottomContainer &&
            (this.bottom.sync([]), (this.bottom = new ys(e.view, !1, t.bottomContainer))),
          this.top.syncClasses(),
          this.bottom.syncClasses());
        let n = e.state.facet(xs);
        if (n != this.input) {
          let t = n.filter((e) => e),
            r = [],
            i = [],
            a = [],
            o = [];
          for (let n of t) {
            let t = this.specs.indexOf(n),
              s;
            (t < 0 ? ((s = n(e.view)), o.push(s)) : ((s = this.panels[t]), s.update && s.update(e)),
              r.push(s),
              (s.top ? i : a).push(s));
          }
          ((this.specs = t), (this.panels = r), this.top.sync(i), this.bottom.sync(a));
          for (let e of o) (e.dom.classList.add(`cm-panel`), e.mount && e.mount());
        } else for (let t of this.panels) t.update && t.update(e);
      }
      destroy() {
        (this.top.sync([]), this.bottom.sync([]));
      }
    },
    {
      provide: (e) =>
        U.scrollMargins.of((t) => {
          let n = t.plugin(e);
          return (
            n && {
              top: n.top.scrollMargin(),
              bottom: n.bottom.scrollMargin(),
            }
          );
        }),
    },
  ),
  ys = class {
    constructor(e, t, n) {
      ((this.view = e),
        (this.top = t),
        (this.container = n),
        (this.dom = void 0),
        (this.classes = ``),
        (this.panels = []),
        this.syncClasses());
    }
    sync(e) {
      for (let t of this.panels) t.destroy && e.indexOf(t) < 0 && t.destroy();
      ((this.panels = e), this.syncDOM());
    }
    syncDOM() {
      if (this.panels.length == 0) {
        this.dom &&= (this.dom.remove(), void 0);
        return;
      }
      if (!this.dom) {
        ((this.dom = document.createElement(`div`)),
          (this.dom.className = this.top
            ? `cm-panels cm-panels-top`
            : `cm-panels cm-panels-bottom`),
          (this.dom.style[this.top ? `top` : `bottom`] = `0`));
        let e = this.container || this.view.dom;
        e.insertBefore(this.dom, this.top ? e.firstChild : null);
      }
      let e = this.dom.firstChild;
      for (let t of this.panels)
        if (t.dom.parentNode == this.dom) {
          for (; e != t.dom;) e = bs(e);
          e = e.nextSibling;
        } else this.dom.insertBefore(t.dom, e);
      for (; e;) e = bs(e);
    }
    scrollMargin() {
      return !this.dom || this.container
        ? 0
        : Math.max(
            0,
            this.top
              ? this.dom.getBoundingClientRect().bottom -
                  Math.max(0, this.view.scrollDOM.getBoundingClientRect().top)
              : Math.min(innerHeight, this.view.scrollDOM.getBoundingClientRect().bottom) -
                  this.dom.getBoundingClientRect().top,
          );
    }
    syncClasses() {
      if (!(!this.container || this.classes == this.view.themeClasses)) {
        for (let e of this.classes.split(` `)) e && this.container.classList.remove(e);
        for (let e of (this.classes = this.view.themeClasses).split(` `))
          e && this.container.classList.add(e);
      }
    }
  };
function bs(e) {
  let t = e.nextSibling;
  return (e.remove(), t);
}
var xs = E.define({
  enables: vs,
});
function Ss(e, t) {
  let n,
    r = new Promise((e) => (n = e)),
    i = (e) => Es(e, t, n);
  e.state.field(Cs, !1)
    ? e.dispatch({
        effects: ws.of(i),
      })
    : e.dispatch({
        effects: D.appendConfig.of(Cs.init(() => [i])),
      });
  let a = Ts.of(i);
  return {
    close: a,
    result: r.then(
      (t) => (
        (e.win.queueMicrotask || ((t) => e.win.setTimeout(t, 10)))(() => {
          e.state.field(Cs).indexOf(i) > -1 &&
            e.dispatch({
              effects: a,
            });
        }),
        t
      ),
    ),
  };
}
var Cs = Ce.define({
    create() {
      return [];
    },
    update(e, t) {
      for (let n of t.effects)
        n.is(ws) ? (e = [n.value].concat(e)) : n.is(Ts) && (e = e.filter((e) => e != n.value));
      return e;
    },
    provide: (e) => xs.computeN([e], (t) => t.field(e)),
  }),
  ws = D.define(),
  Ts = D.define();
function Es(e, t, n) {
  let r = t.content ? t.content(e, () => o(null)) : null;
  if (!r) {
    if (((r = It(`form`)), t.input)) {
      let e = It(`input`, t.input);
      (/^(text|password|number|email|tel|url)$/.test(e.type) && e.classList.add(`cm-textfield`),
        (e.name ||= `input`),
        r.appendChild(It(`label`, (t.label || ``) + `: `, e)));
    } else r.appendChild(document.createTextNode(t.label || ``));
    (r.appendChild(document.createTextNode(` `)),
      r.appendChild(
        It(
          `button`,
          {
            class: `cm-button`,
            type: `submit`,
          },
          t.submitLabel || `OK`,
        ),
      ));
  }
  let i = r.nodeName == `FORM` ? [r] : r.querySelectorAll(`form`);
  for (let e = 0; e < i.length; e++) {
    let t = i[e];
    (t.addEventListener(`keydown`, (e) => {
      e.keyCode == 27
        ? (e.preventDefault(), o(null))
        : e.keyCode == 13 && (e.preventDefault(), o(t));
    }),
      t.addEventListener(`submit`, (e) => {
        (e.preventDefault(), o(t));
      }));
  }
  let a = It(
    `div`,
    r,
    It(
      `button`,
      {
        onclick: () => o(null),
        "aria-label": e.state.phrase(`close`),
        class: `cm-dialog-close`,
        type: `button`,
      },
      [`×`],
    ),
  );
  (t.class && (a.className = t.class), a.classList.add(`cm-dialog`));
  function o(t) {
    (a.contains(a.ownerDocument.activeElement) && e.focus(), n(t));
  }
  return {
    dom: a,
    top: t.top,
    mount: () => {
      if (t.focus) {
        let e;
        ((e =
          typeof t.focus == `string`
            ? r.querySelector(t.focus)
            : r.querySelector(`input`) || r.querySelector(`button`)),
          e && `select` in e ? e.select() : e && `focus` in e && e.focus());
      }
    },
  };
}
var Ds = class extends it {
  compare(e) {
    return this == e || (this.constructor == e.constructor && this.eq(e));
  }
  eq(e) {
    return !1;
  }
  destroy(e) {}
};
((Ds.prototype.elementClass = ``),
  (Ds.prototype.toDOM = void 0),
  (Ds.prototype.mapMode = C.TrackBefore),
  (Ds.prototype.startSide = Ds.prototype.endSide = -1),
  (Ds.prototype.point = !0));
var Os = 1024,
  ks = 0,
  W = class {
    constructor(e, t) {
      ((this.from = e), (this.to = t));
    }
  },
  G = class {
    constructor(e = {}) {
      ((this.id = ks++),
        (this.perNode = !!e.perNode),
        (this.deserialize =
          e.deserialize ||
          (() => {
            throw Error(`This node type doesn't define a deserialize function`);
          })),
        (this.combine = e.combine || null));
    }
    add(e) {
      if (this.perNode) throw RangeError(`Can't add per-node props to node types`);
      return (
        typeof e != `function` && (e = K.match(e)),
        (t) => {
          let n = e(t);
          return n === void 0 ? null : [this, n];
        }
      );
    }
  };
((G.closedBy = new G({
  deserialize: (e) => e.split(` `),
})),
  (G.openedBy = new G({
    deserialize: (e) => e.split(` `),
  })),
  (G.group = new G({
    deserialize: (e) => e.split(` `),
  })),
  (G.isolate = new G({
    deserialize: (e) => {
      if (e && e != `rtl` && e != `ltr` && e != `auto`)
        throw RangeError(`Invalid value for isolate: ` + e);
      return e || `auto`;
    },
  })),
  (G.contextHash = new G({
    perNode: !0,
  })),
  (G.lookAhead = new G({
    perNode: !0,
  })),
  (G.mounted = new G({
    perNode: !0,
  })));
var As = class {
    constructor(e, t, n, r = !1) {
      ((this.tree = e), (this.overlay = t), (this.parser = n), (this.bracketed = r));
    }
    static get(e) {
      return e && e.props && e.props[G.mounted.id];
    }
  },
  js = Object.create(null),
  K = class e {
    constructor(e, t, n, r = 0) {
      ((this.name = e), (this.props = t), (this.id = n), (this.flags = r));
    }
    static define(t) {
      let n = t.props && t.props.length ? Object.create(null) : js,
        r = !!t.top | (t.skipped ? 2 : 0) | (t.error ? 4 : 0) | (t.name == null ? 8 : 0),
        i = new e(t.name || ``, n, t.id, r);
      if (t.props) {
        for (let e of t.props)
          if ((Array.isArray(e) || (e = e(i)), e)) {
            if (e[0].perNode) throw RangeError(`Can't store a per-node prop on a node type`);
            n[e[0].id] = e[1];
          }
      }
      return i;
    }
    prop(e) {
      return this.props[e.id];
    }
    get isTop() {
      return (this.flags & 1) > 0;
    }
    get isSkipped() {
      return (this.flags & 2) > 0;
    }
    get isError() {
      return (this.flags & 4) > 0;
    }
    get isAnonymous() {
      return (this.flags & 8) > 0;
    }
    is(e) {
      if (typeof e == `string`) {
        if (this.name == e) return !0;
        let t = this.prop(G.group);
        return t ? t.indexOf(e) > -1 : !1;
      }
      return this.id == e;
    }
    static match(e) {
      let t = Object.create(null);
      for (let n in e) for (let r of n.split(` `)) t[r] = e[n];
      return (e) => {
        for (let n = e.prop(G.group), r = -1; r < (n ? n.length : 0); r++) {
          let i = t[r < 0 ? e.name : n[r]];
          if (i) return i;
        }
      };
    }
  };
K.none = new K(``, Object.create(null), 0, 8);
var Ms = class e {
    constructor(e) {
      this.types = e;
      for (let t = 0; t < e.length; t++)
        if (e[t].id != t)
          throw RangeError(
            `Node type ids should correspond to array positions when creating a node set`,
          );
    }
    extend(...t) {
      let n = [];
      for (let e of this.types) {
        let r = null;
        for (let n of t) {
          let t = n(e);
          if (t) {
            r ||= Object.assign({}, e.props);
            let n = t[1],
              i = t[0];
            (i.combine && i.id in r && (n = i.combine(r[i.id], n)), (r[i.id] = n));
          }
        }
        n.push(r ? new K(e.name, r, e.id, e.flags) : e);
      }
      return new e(n);
    }
  },
  Ns = new WeakMap(),
  Ps = new WeakMap(),
  q;
(function (e) {
  ((e[(e.ExcludeBuffers = 1)] = `ExcludeBuffers`),
    (e[(e.IncludeAnonymous = 2)] = `IncludeAnonymous`),
    (e[(e.IgnoreMounts = 4)] = `IgnoreMounts`),
    (e[(e.IgnoreOverlays = 8)] = `IgnoreOverlays`),
    (e[(e.EnterBracketed = 16)] = `EnterBracketed`));
})((q ||= {}));
var J = class e {
  constructor(e, t, n, r, i) {
    if (
      ((this.type = e),
      (this.children = t),
      (this.positions = n),
      (this.length = r),
      (this.props = null),
      i && i.length)
    ) {
      this.props = Object.create(null);
      for (let [e, t] of i) this.props[typeof e == `number` ? e : e.id] = t;
    }
  }
  toString() {
    let e = As.get(this);
    if (e && !e.overlay) return e.tree.toString();
    let t = ``;
    for (let e of this.children) {
      let n = e.toString();
      n && (t && (t += `,`), (t += n));
    }
    return this.type.name
      ? (/\W/.test(this.type.name) && !this.type.isError
          ? JSON.stringify(this.type.name)
          : this.type.name) + (t.length ? `(` + t + `)` : ``)
      : t;
  }
  cursor(e = 0) {
    return new qs(this.topNode, e);
  }
  cursorAt(e, t = 0, n = 0) {
    let r = new qs(Ns.get(this) || this.topNode);
    return (r.moveTo(e, t), Ns.set(this, r._tree), r);
  }
  get topNode() {
    return new Y(this, 0, 0, null);
  }
  resolve(e, t = 0) {
    let n = Rs(Ns.get(this) || this.topNode, e, t, !1);
    return (Ns.set(this, n), n);
  }
  resolveInner(e, t = 0) {
    let n = Rs(Ps.get(this) || this.topNode, e, t, !0);
    return (Ps.set(this, n), n);
  }
  resolveStack(e, t = 0) {
    return Ks(this, e, t);
  }
  iterate(e) {
    let { enter: t, leave: n, from: r = 0, to: i = this.length } = e,
      a = e.mode || 0,
      o = (a & q.IncludeAnonymous) > 0;
    for (let e = this.cursor(a | q.IncludeAnonymous); ;) {
      let a = !1;
      if (e.from <= i && e.to >= r && ((!o && e.type.isAnonymous) || t(e) !== !1)) {
        if (e.firstChild()) continue;
        a = !0;
      }
      for (; a && n && (o || !e.type.isAnonymous) && n(e), !e.nextSibling();) {
        if (!e.parent()) return;
        a = !0;
      }
    }
  }
  prop(e) {
    return e.perNode ? (this.props ? this.props[e.id] : void 0) : this.type.prop(e);
  }
  get propValues() {
    let e = [];
    if (this.props) for (let t in this.props) e.push([+t, this.props[t]]);
    return e;
  }
  balance(t = {}) {
    return this.children.length <= 8
      ? this
      : Qs(
          K.none,
          this.children,
          this.positions,
          0,
          this.children.length,
          0,
          this.length,
          (t, n, r) => new e(this.type, t, n, r, this.propValues),
          t.makeTree || ((t, n, r) => new e(K.none, t, n, r)),
        );
  }
  static build(e) {
    return Ys(e);
  }
};
J.empty = new J(K.none, [], [], 0);
var Fs = class e {
    constructor(e, t) {
      ((this.buffer = e), (this.index = t));
    }
    get id() {
      return this.buffer[this.index - 4];
    }
    get start() {
      return this.buffer[this.index - 3];
    }
    get end() {
      return this.buffer[this.index - 2];
    }
    get size() {
      return this.buffer[this.index - 1];
    }
    get pos() {
      return this.index;
    }
    next() {
      this.index -= 4;
    }
    fork() {
      return new e(this.buffer, this.index);
    }
  },
  Is = class e {
    constructor(e, t, n) {
      ((this.buffer = e), (this.length = t), (this.set = n));
    }
    get type() {
      return K.none;
    }
    toString() {
      let e = [];
      for (let t = 0; t < this.buffer.length;)
        (e.push(this.childString(t)), (t = this.buffer[t + 3]));
      return e.join(`,`);
    }
    childString(e) {
      let t = this.buffer[e],
        n = this.buffer[e + 3],
        r = this.set.types[t],
        i = r.name;
      if ((/\W/.test(i) && !r.isError && (i = JSON.stringify(i)), (e += 4), n == e)) return i;
      let a = [];
      for (; e < n;) (a.push(this.childString(e)), (e = this.buffer[e + 3]));
      return i + `(` + a.join(`,`) + `)`;
    }
    findChild(e, t, n, r, i) {
      let { buffer: a } = this,
        o = -1;
      for (let s = e; s != t && !(Ls(i, r, a[s + 1], a[s + 2]) && ((o = s), n > 0)); s = a[s + 3]);
      return o;
    }
    slice(t, n, r) {
      let i = this.buffer,
        a = new Uint16Array(n - t),
        o = 0;
      for (let e = t, s = 0; e < n;) {
        ((a[s++] = i[e++]), (a[s++] = i[e++] - r));
        let n = (a[s++] = i[e++] - r);
        ((a[s++] = i[e++] - t), (o = Math.max(o, n)));
      }
      return new e(a, o, this.set);
    }
  };
function Ls(e, t, n, r) {
  switch (e) {
    case -2:
      return n < t;
    case -1:
      return r >= t && n < t;
    case 0:
      return n < t && r > t;
    case 1:
      return n <= t && r > t;
    case 2:
      return r > t;
    case 4:
      return !0;
  }
}
function Rs(e, t, n, r) {
  for (; e.from == e.to || (n < 1 ? e.from >= t : e.from > t) || (n > -1 ? e.to <= t : e.to < t);) {
    let t = !r && e instanceof Y && e.index < 0 ? null : e.parent;
    if (!t) return e;
    e = t;
  }
  let i = r ? 0 : q.IgnoreOverlays;
  if (r)
    for (let r = e, a = r.parent; a; r = a, a = r.parent)
      r instanceof Y && r.index < 0 && a.enter(t, n, i)?.from != r.from && (e = a);
  for (;;) {
    let r = e.enter(t, n, i);
    if (!r) return e;
    e = r;
  }
}
var zs = class {
    cursor(e = 0) {
      return new qs(this, e);
    }
    getChild(e, t = null, n = null) {
      let r = Bs(this, e, t, n);
      return r.length ? r[0] : null;
    }
    getChildren(e, t = null, n = null) {
      return Bs(this, e, t, n);
    }
    resolve(e, t = 0) {
      return Rs(this, e, t, !1);
    }
    resolveInner(e, t = 0) {
      return Rs(this, e, t, !0);
    }
    matchContext(e) {
      return Vs(this.parent, e);
    }
    enterUnfinishedNodesBefore(e) {
      let t = this.childBefore(e),
        n = this;
      for (; t;) {
        let e = t.lastChild;
        if (!e || e.to != t.to) break;
        e.type.isError && e.from == e.to ? ((n = t), (t = e.prevSibling)) : (t = e);
      }
      return n;
    }
    get node() {
      return this;
    }
    get next() {
      return this.parent;
    }
  },
  Y = class e extends zs {
    constructor(e, t, n, r) {
      (super(), (this._tree = e), (this.from = t), (this.index = n), (this._parent = r));
    }
    get type() {
      return this._tree.type;
    }
    get name() {
      return this._tree.type.name;
    }
    get to() {
      return this.from + this._tree.length;
    }
    nextChild(t, n, r, i, a = 0) {
      for (let o = this; ;) {
        for (
          let { children: s, positions: c } = o._tree, l = n > 0 ? s.length : -1;
          t != l;
          t += n
        ) {
          let l = s[t],
            u = c[t] + o.from,
            d;
          if (!(
            !(
              a & q.EnterBracketed &&
              l instanceof J &&
              (d = As.get(l)) &&
              !d.overlay &&
              d.bracketed &&
              r >= u &&
              r <= u + l.length
            ) && !Ls(i, r, u, u + l.length)
          )) {
            if (l instanceof Is) {
              if (a & q.ExcludeBuffers) continue;
              let e = l.findChild(0, l.buffer.length, n, r - u, i);
              if (e > -1) return new Us(new Hs(o, l, t, u), null, e);
            } else if (a & q.IncludeAnonymous || !l.type.isAnonymous || Js(l)) {
              let s;
              if (!(a & q.IgnoreMounts) && (s = As.get(l)) && !s.overlay)
                return new e(s.tree, u, t, o);
              let c = new e(l, u, t, o);
              return a & q.IncludeAnonymous || !c.type.isAnonymous
                ? c
                : c.nextChild(n < 0 ? l.children.length - 1 : 0, n, r, i, a);
            }
          }
        }
        if (
          a & q.IncludeAnonymous ||
          !o.type.isAnonymous ||
          ((t = o.index >= 0 ? o.index + n : n < 0 ? -1 : o._parent._tree.children.length),
          (o = o._parent),
          !o)
        )
          return null;
      }
    }
    get firstChild() {
      return this.nextChild(0, 1, 0, 4);
    }
    get lastChild() {
      return this.nextChild(this._tree.children.length - 1, -1, 0, 4);
    }
    childAfter(e) {
      return this.nextChild(0, 1, e, 2);
    }
    childBefore(e) {
      return this.nextChild(this._tree.children.length - 1, -1, e, -2);
    }
    prop(e) {
      return this._tree.prop(e);
    }
    enter(t, n, r = 0) {
      let i;
      if (!(r & q.IgnoreOverlays) && (i = As.get(this._tree)) && i.overlay) {
        let a = t - this.from,
          o = r & q.EnterBracketed && i.bracketed;
        for (let { from: t, to: r } of i.overlay)
          if ((n > 0 || o ? t <= a : t < a) && (n < 0 || o ? r >= a : r > a))
            return new e(i.tree, i.overlay[0].from + this.from, -1, this);
      }
      return this.nextChild(0, 1, t, n, r);
    }
    nextSignificantParent() {
      let e = this;
      for (; e.type.isAnonymous && e._parent;) e = e._parent;
      return e;
    }
    get parent() {
      return this._parent ? this._parent.nextSignificantParent() : null;
    }
    get nextSibling() {
      return this._parent && this.index >= 0
        ? this._parent.nextChild(this.index + 1, 1, 0, 4)
        : null;
    }
    get prevSibling() {
      return this._parent && this.index >= 0
        ? this._parent.nextChild(this.index - 1, -1, 0, 4)
        : null;
    }
    get tree() {
      return this._tree;
    }
    toTree() {
      return this._tree;
    }
    toString() {
      return this._tree.toString();
    }
  };
function Bs(e, t, n, r) {
  let i = e.cursor(),
    a = [];
  if (!i.firstChild()) return a;
  if (n != null) {
    for (let e = !1; !e;) if (((e = i.type.is(n)), !i.nextSibling())) return a;
  }
  for (;;) {
    if (r != null && i.type.is(r)) return a;
    if ((i.type.is(t) && a.push(i.node), !i.nextSibling())) return r == null ? a : [];
  }
}
function Vs(e, t, n = t.length - 1) {
  for (let r = e; n >= 0; r = r.parent) {
    if (!r) return !1;
    if (!r.type.isAnonymous) {
      if (t[n] && t[n] != r.name) return !1;
      n--;
    }
  }
  return !0;
}
var Hs = class {
    constructor(e, t, n, r) {
      ((this.parent = e), (this.buffer = t), (this.index = n), (this.start = r));
    }
  },
  Us = class e extends zs {
    get name() {
      return this.type.name;
    }
    get from() {
      return this.context.start + this.context.buffer.buffer[this.index + 1];
    }
    get to() {
      return this.context.start + this.context.buffer.buffer[this.index + 2];
    }
    constructor(e, t, n) {
      (super(),
        (this.context = e),
        (this._parent = t),
        (this.index = n),
        (this.type = e.buffer.set.types[e.buffer.buffer[n]]));
    }
    child(t, n, r) {
      let { buffer: i } = this.context,
        a = i.findChild(this.index + 4, i.buffer[this.index + 3], t, n - this.context.start, r);
      return a < 0 ? null : new e(this.context, this, a);
    }
    get firstChild() {
      return this.child(1, 0, 4);
    }
    get lastChild() {
      return this.child(-1, 0, 4);
    }
    childAfter(e) {
      return this.child(1, e, 2);
    }
    childBefore(e) {
      return this.child(-1, e, -2);
    }
    prop(e) {
      return this.type.prop(e);
    }
    enter(t, n, r = 0) {
      if (r & q.ExcludeBuffers) return null;
      let { buffer: i } = this.context,
        a = i.findChild(
          this.index + 4,
          i.buffer[this.index + 3],
          n > 0 ? 1 : -1,
          t - this.context.start,
          n,
        );
      return a < 0 ? null : new e(this.context, this, a);
    }
    get parent() {
      return this._parent || this.context.parent.nextSignificantParent();
    }
    externalSibling(e) {
      return this._parent ? null : this.context.parent.nextChild(this.context.index + e, e, 0, 4);
    }
    get nextSibling() {
      let { buffer: t } = this.context,
        n = t.buffer[this.index + 3];
      return n < (this._parent ? t.buffer[this._parent.index + 3] : t.buffer.length)
        ? new e(this.context, this._parent, n)
        : this.externalSibling(1);
    }
    get prevSibling() {
      let { buffer: t } = this.context,
        n = this._parent ? this._parent.index + 4 : 0;
      return this.index == n
        ? this.externalSibling(-1)
        : new e(this.context, this._parent, t.findChild(n, this.index, -1, 0, 4));
    }
    get tree() {
      return null;
    }
    toTree() {
      let e = [],
        t = [],
        { buffer: n } = this.context,
        r = this.index + 4,
        i = n.buffer[this.index + 3];
      if (i > r) {
        let a = n.buffer[this.index + 1];
        (e.push(n.slice(r, i, a)), t.push(0));
      }
      return new J(this.type, e, t, this.to - this.from);
    }
    toString() {
      return this.context.buffer.childString(this.index);
    }
  };
function Ws(e) {
  if (!e.length) return null;
  let t = 0,
    n = e[0];
  for (let r = 1; r < e.length; r++) {
    let i = e[r];
    (i.from > n.from || i.to < n.to) && ((n = i), (t = r));
  }
  let r = n instanceof Y && n.index < 0 ? null : n.parent,
    i = e.slice();
  return (r ? (i[t] = r) : i.splice(t, 1), new Gs(i, n));
}
var Gs = class {
  constructor(e, t) {
    ((this.heads = e), (this.node = t));
  }
  get next() {
    return Ws(this.heads);
  }
};
function Ks(e, t, n) {
  let r = e.resolveInner(t, n),
    i = null;
  for (let e = r instanceof Y ? r : r.context.parent; e; e = e.parent)
    if (e.index < 0) {
      let a = e.parent;
      ((i ||= [r]).push(a.resolve(t, n)), (e = a));
    } else {
      let a = As.get(e.tree);
      if (a && a.overlay && a.overlay[0].from <= t && a.overlay[a.overlay.length - 1].to >= t) {
        let o = new Y(a.tree, a.overlay[0].from + e.from, -1, e);
        (i ||= [r]).push(Rs(o, t, n, !1));
      }
    }
  return i ? Ws(i) : r;
}
var qs = class {
  get name() {
    return this.type.name;
  }
  constructor(e, t = 0) {
    if (
      ((this.buffer = null),
      (this.stack = []),
      (this.index = 0),
      (this.bufferNode = null),
      (this.mode = t & ~q.EnterBracketed),
      e instanceof Y)
    )
      this.yieldNode(e);
    else {
      ((this._tree = e.context.parent), (this.buffer = e.context));
      for (let t = e._parent; t; t = t._parent) this.stack.unshift(t.index);
      ((this.bufferNode = e), this.yieldBuf(e.index));
    }
  }
  yieldNode(e) {
    return e
      ? ((this._tree = e), (this.type = e.type), (this.from = e.from), (this.to = e.to), !0)
      : !1;
  }
  yieldBuf(e, t) {
    this.index = e;
    let { start: n, buffer: r } = this.buffer;
    return (
      (this.type = t || r.set.types[r.buffer[e]]),
      (this.from = n + r.buffer[e + 1]),
      (this.to = n + r.buffer[e + 2]),
      !0
    );
  }
  yield(e) {
    return e
      ? e instanceof Y
        ? ((this.buffer = null), this.yieldNode(e))
        : ((this.buffer = e.context), this.yieldBuf(e.index, e.type))
      : !1;
  }
  toString() {
    return this.buffer ? this.buffer.buffer.childString(this.index) : this._tree.toString();
  }
  enterChild(e, t, n) {
    if (!this.buffer)
      return this.yield(
        this._tree.nextChild(e < 0 ? this._tree._tree.children.length - 1 : 0, e, t, n, this.mode),
      );
    let { buffer: r } = this.buffer,
      i = r.findChild(this.index + 4, r.buffer[this.index + 3], e, t - this.buffer.start, n);
    return i < 0 ? !1 : (this.stack.push(this.index), this.yieldBuf(i));
  }
  firstChild() {
    return this.enterChild(1, 0, 4);
  }
  lastChild() {
    return this.enterChild(-1, 0, 4);
  }
  childAfter(e) {
    return this.enterChild(1, e, 2);
  }
  childBefore(e) {
    return this.enterChild(-1, e, -2);
  }
  enter(e, t, n = this.mode) {
    return this.buffer
      ? n & q.ExcludeBuffers
        ? !1
        : this.enterChild(1, e, t)
      : this.yield(this._tree.enter(e, t, n));
  }
  parent() {
    if (!this.buffer)
      return this.yieldNode(
        this.mode & q.IncludeAnonymous ? this._tree._parent : this._tree.parent,
      );
    if (this.stack.length) return this.yieldBuf(this.stack.pop());
    let e =
      this.mode & q.IncludeAnonymous
        ? this.buffer.parent
        : this.buffer.parent.nextSignificantParent();
    return ((this.buffer = null), this.yieldNode(e));
  }
  sibling(e) {
    if (!this.buffer)
      return this._tree._parent
        ? this.yield(
            this._tree.index < 0
              ? null
              : this._tree._parent.nextChild(this._tree.index + e, e, 0, 4, this.mode),
          )
        : !1;
    let { buffer: t } = this.buffer,
      n = this.stack.length - 1;
    if (e < 0) {
      let e = n < 0 ? 0 : this.stack[n] + 4;
      if (this.index != e) return this.yieldBuf(t.findChild(e, this.index, -1, 0, 4));
    } else {
      let e = t.buffer[this.index + 3];
      if (e < (n < 0 ? t.buffer.length : t.buffer[this.stack[n] + 3])) return this.yieldBuf(e);
    }
    return n < 0
      ? this.yield(this.buffer.parent.nextChild(this.buffer.index + e, e, 0, 4, this.mode))
      : !1;
  }
  nextSibling() {
    return this.sibling(1);
  }
  prevSibling() {
    return this.sibling(-1);
  }
  atLastNode(e) {
    let t,
      n,
      { buffer: r } = this;
    if (r) {
      if (e > 0) {
        if (this.index < r.buffer.buffer.length) return !1;
      } else
        for (let e = 0; e < this.index; e++) if (r.buffer.buffer[e + 3] < this.index) return !1;
      ({ index: t, parent: n } = r);
    } else ({ index: t, _parent: n } = this._tree);
    for (; n; { index: t, _parent: n } = n)
      if (t > -1)
        for (let r = t + e, i = e < 0 ? -1 : n._tree.children.length; r != i; r += e) {
          let e = n._tree.children[r];
          if (this.mode & q.IncludeAnonymous || e instanceof Is || !e.type.isAnonymous || Js(e))
            return !1;
        }
    return !0;
  }
  move(e, t) {
    if (t && this.enterChild(e, 0, 4)) return !0;
    for (;;) {
      if (this.sibling(e)) return !0;
      if (this.atLastNode(e) || !this.parent()) return !1;
    }
  }
  next(e = !0) {
    return this.move(1, e);
  }
  prev(e = !0) {
    return this.move(-1, e);
  }
  moveTo(e, t = 0) {
    for (
      ;
      (this.from == this.to ||
        (t < 1 ? this.from >= e : this.from > e) ||
        (t > -1 ? this.to <= e : this.to < e)) &&
      this.parent();
    );
    for (; this.enterChild(1, e, t););
    return this;
  }
  get node() {
    if (!this.buffer) return this._tree;
    let e = this.bufferNode,
      t = null,
      n = 0;
    if (e && e.context == this.buffer)
      scan: for (let r = this.index, i = this.stack.length; i >= 0;) {
        for (let a = e; a; a = a._parent)
          if (a.index == r) {
            if (r == this.index) return a;
            ((t = a), (n = i + 1));
            break scan;
          }
        r = this.stack[--i];
      }
    for (let e = n; e < this.stack.length; e++) t = new Us(this.buffer, t, this.stack[e]);
    return (this.bufferNode = new Us(this.buffer, t, this.index));
  }
  get tree() {
    return this.buffer ? null : this._tree._tree;
  }
  iterate(e, t) {
    for (let n = 0; ;) {
      let r = !1;
      if (this.type.isAnonymous || e(this) !== !1) {
        if (this.firstChild()) {
          n++;
          continue;
        }
        this.type.isAnonymous || (r = !0);
      }
      for (;;) {
        if ((r && t && t(this), (r = this.type.isAnonymous), !n)) return;
        if (this.nextSibling()) break;
        (this.parent(), n--, (r = !0));
      }
    }
  }
  matchContext(e) {
    if (!this.buffer) return Vs(this.node.parent, e);
    let { buffer: t } = this.buffer,
      { types: n } = t.set;
    for (let r = e.length - 1, i = this.stack.length - 1; r >= 0; i--) {
      if (i < 0) return Vs(this._tree, e, r);
      let a = n[t.buffer[this.stack[i]]];
      if (!a.isAnonymous) {
        if (e[r] && e[r] != a.name) return !1;
        r--;
      }
    }
    return !0;
  }
};
function Js(e) {
  return e.children.some((e) => e instanceof Is || !e.type.isAnonymous || Js(e));
}
function Ys(e) {
  let {
      buffer: t,
      nodeSet: n,
      maxBufferLength: r = Os,
      reused: i = [],
      minRepeatType: a = n.types.length,
    } = e,
    o = Array.isArray(t) ? new Fs(t, t.length) : t,
    s = n.types,
    c = 0,
    l = 0;
  function u(e, t, _, v, y, ee) {
    let { id: b, start: x, end: S, size: te } = o,
      ne = l,
      re = c;
    if (te < 0)
      if ((o.next(), te == -1)) {
        let t = i[b];
        (_.push(t), v.push(x - e));
        return;
      } else if (te == -3) {
        c = b;
        return;
      } else if (te == -4) {
        l = b;
        return;
      } else throw RangeError(`Unrecognized record size: ${te}`);
    let ie = s[b],
      ae,
      oe,
      C = x - e;
    if (S - x <= r && (oe = h(o.pos - t, y))) {
      let t = new Uint16Array(oe.size - oe.skip),
        r = o.pos - oe.size,
        i = t.length;
      for (; o.pos > r;) i = g(oe.start, t, i);
      ((ae = new Is(t, S - oe.start, n)), (C = oe.start - e));
    } else {
      let e = o.pos - te;
      o.next();
      let t = [],
        n = [],
        i = b >= a ? b : -1,
        s = 0,
        c = S;
      for (; o.pos > e;)
        i >= 0 && o.id == i && o.size >= 0
          ? (o.end <= c - r && (p(t, n, x, s, o.end, c, i, ne, re), (s = t.length), (c = o.end)),
            o.next())
          : ee > 2500
            ? d(x, e, t, n)
            : u(x, e, t, n, i, ee + 1);
      if (
        (i >= 0 && s > 0 && s < t.length && p(t, n, x, s, x, c, i, ne, re),
        t.reverse(),
        n.reverse(),
        i > -1 && s > 0)
      ) {
        let e = f(ie, re);
        ae = Qs(ie, t, n, 0, t.length, 0, S - x, e, e);
      } else ae = m(ie, t, n, S - x, ne - S, re);
    }
    (_.push(ae), v.push(C));
  }
  function d(e, t, i, a) {
    let s = [],
      c = 0,
      l = -1;
    for (; o.pos > t;) {
      let { id: e, start: t, end: n, size: i } = o;
      if (i > 4) o.next();
      else if (l > -1 && t < l) break;
      else (l < 0 && (l = n - r), s.push(e, t, n), c++, o.next());
    }
    if (c) {
      let t = new Uint16Array(c * 4),
        r = s[s.length - 2];
      for (let e = s.length - 3, n = 0; e >= 0; e -= 3)
        ((t[n++] = s[e]), (t[n++] = s[e + 1] - r), (t[n++] = s[e + 2] - r), (t[n++] = n));
      (i.push(new Is(t, s[2] - r, n)), a.push(r - e));
    }
  }
  function f(e, t) {
    return (n, r, i) => {
      let a = 0,
        o = n.length - 1,
        s,
        c;
      if (o >= 0 && (s = n[o]) instanceof J) {
        if (!o && s.type == e && s.length == i) return s;
        (c = s.prop(G.lookAhead)) && (a = r[o] + s.length + c);
      }
      return m(e, n, r, i, a, t);
    };
  }
  function p(e, t, r, i, a, o, s, c, l) {
    let u = [],
      d = [];
    for (; e.length > i;) (u.push(e.pop()), d.push(t.pop() + r - a));
    (e.push(m(n.types[s], u, d, o - a, c - o, l)), t.push(a - r));
  }
  function m(e, t, n, r, i, a, o) {
    if (a) {
      let e = [G.contextHash, a];
      o = o ? [e].concat(o) : [e];
    }
    if (i > 25) {
      let e = [G.lookAhead, i];
      o = o ? [e].concat(o) : [e];
    }
    return new J(e, t, n, r, o);
  }
  function h(e, t) {
    let n = o.fork(),
      i = 0,
      s = 0,
      c = 0,
      l = n.end - r,
      u = {
        size: 0,
        start: 0,
        skip: 0,
      };
    scan: for (let r = n.pos - e; n.pos > r;) {
      let e = n.size;
      if (n.id == t && e >= 0) {
        ((u.size = i), (u.start = s), (u.skip = c), (c += 4), (i += 4), n.next());
        continue;
      }
      let o = n.pos - e;
      if (e < 0 || o < r || n.start < l) break;
      let d = n.id >= a ? 4 : 0,
        f = n.start;
      for (n.next(); n.pos > o;) {
        if (n.size < 0) {
          if (n.size == -3 || n.size == -4) d += 4;
          else break scan;
        } else n.id >= a && (d += 4);
        n.next();
      }
      ((s = f), (i += e), (c += d));
    }
    return (
      (t < 0 || i == e) && ((u.size = i), (u.start = s), (u.skip = c)),
      u.size > 4 ? u : void 0
    );
  }
  function g(e, t, n) {
    let { id: r, start: i, end: s, size: u } = o;
    if ((o.next(), u >= 0 && r < a)) {
      let a = n;
      if (u > 4) {
        let r = o.pos - (u - 4);
        for (; o.pos > r;) n = g(e, t, n);
      }
      ((t[--n] = a), (t[--n] = s - e), (t[--n] = i - e), (t[--n] = r));
    } else u == -3 ? (c = r) : u == -4 && (l = r);
    return n;
  }
  let _ = [],
    v = [];
  for (; o.pos > 0;) u(e.start || 0, e.bufferStart || 0, _, v, -1, 0);
  let y = e.length ?? (_.length ? v[0] + _[0].length : 0);
  return new J(s[e.topID], _.reverse(), v.reverse(), y);
}
var Xs = new WeakMap();
function Zs(e, t) {
  if (!e.isAnonymous || t instanceof Is || t.type != e) return 1;
  let n = Xs.get(t);
  if (n == null) {
    n = 1;
    for (let r of t.children) {
      if (r.type != e || !(r instanceof J)) {
        n = 1;
        break;
      }
      n += Zs(e, r);
    }
    Xs.set(t, n);
  }
  return n;
}
function Qs(e, t, n, r, i, a, o, s, c) {
  let l = 0;
  for (let n = r; n < i; n++) l += Zs(e, t[n]);
  let u = Math.ceil((l * 1.5) / 8),
    d = [],
    f = [];
  function p(t, n, r, i, o) {
    for (let s = r; s < i;) {
      let r = s,
        l = n[s],
        m = Zs(e, t[s]);
      for (s++; s < i; s++) {
        let n = Zs(e, t[s]);
        if (m + n >= u) break;
        m += n;
      }
      if (s == r + 1) {
        if (m > u) {
          let e = t[r];
          p(e.children, e.positions, 0, e.children.length, n[r] + o);
          continue;
        }
        d.push(t[r]);
      } else {
        let i = n[s - 1] + t[s - 1].length - l;
        d.push(Qs(e, t, n, r, s, l, i, null, c));
      }
      f.push(l + o - a);
    }
  }
  return (p(t, n, r, i, 0), (s || c)(d, f, o));
}
var $s = class {
    constructor() {
      this.map = new WeakMap();
    }
    setBuffer(e, t, n) {
      let r = this.map.get(e);
      (r || this.map.set(e, (r = new Map())), r.set(t, n));
    }
    getBuffer(e, t) {
      let n = this.map.get(e);
      return n && n.get(t);
    }
    set(e, t) {
      e instanceof Us
        ? this.setBuffer(e.context.buffer, e.index, t)
        : e instanceof Y && this.map.set(e.tree, t);
    }
    get(e) {
      return e instanceof Us
        ? this.getBuffer(e.context.buffer, e.index)
        : e instanceof Y
          ? this.map.get(e.tree)
          : void 0;
    }
    cursorSet(e, t) {
      e.buffer ? this.setBuffer(e.buffer.buffer, e.index, t) : this.map.set(e.tree, t);
    }
    cursorGet(e) {
      return e.buffer ? this.getBuffer(e.buffer.buffer, e.index) : this.map.get(e.tree);
    }
  },
  ec = class e {
    constructor(e, t, n, r, i = !1, a = !1) {
      ((this.from = e),
        (this.to = t),
        (this.tree = n),
        (this.offset = r),
        (this.open = !!i | (a ? 2 : 0)));
    }
    get openStart() {
      return (this.open & 1) > 0;
    }
    get openEnd() {
      return (this.open & 2) > 0;
    }
    static addTree(t, n = [], r = !1) {
      let i = [new e(0, t.length, t, 0, !1, r)];
      for (let e of n) e.to > t.length && i.push(e);
      return i;
    }
    static applyChanges(t, n, r = 128) {
      if (!n.length) return t;
      let i = [],
        a = 1,
        o = t.length ? t[0] : null;
      for (let s = 0, c = 0, l = 0; ; s++) {
        let u = s < n.length ? n[s] : null,
          d = u ? u.fromA : 1e9;
        if (d - c >= r)
          for (; o && o.from < d;) {
            let n = o;
            if (c >= n.from || d <= n.to || l) {
              let t = Math.max(n.from, c) - l,
                r = Math.min(n.to, d) - l;
              n = t >= r ? null : new e(t, r, n.tree, n.offset + l, s > 0, !!u);
            }
            if ((n && i.push(n), o.to > d)) break;
            o = a < t.length ? t[a++] : null;
          }
        if (!u) break;
        ((c = u.toA), (l = u.toA - u.toB));
      }
      return i;
    }
  },
  tc = class {
    startParse(e, t, n) {
      return (
        typeof e == `string` && (e = new nc(e)),
        (n = n
          ? n.length
            ? n.map((e) => new W(e.from, e.to))
            : [new W(0, 0)]
          : [new W(0, e.length)]),
        this.createParse(e, t || [], n)
      );
    }
    parse(e, t, n) {
      let r = this.startParse(e, t, n);
      for (;;) {
        let e = r.advance();
        if (e) return e;
      }
    }
  },
  nc = class {
    constructor(e) {
      this.string = e;
    }
    get length() {
      return this.string.length;
    }
    chunk(e) {
      return this.string.slice(e);
    }
    get lineChunks() {
      return !1;
    }
    read(e, t) {
      return this.string.slice(e, t);
    }
  };
function rc(e) {
  return (t, n, r, i) => new cc(t, e, n, r, i);
}
var ic = class {
  constructor(e, t, n, r, i, a) {
    ((this.parser = e),
      (this.parse = t),
      (this.overlay = n),
      (this.bracketed = r),
      (this.target = i),
      (this.from = a));
  }
};
function ac(e) {
  if (!e.length || e.some((e) => e.from >= e.to))
    throw RangeError(`Invalid inner parse ranges given: ` + JSON.stringify(e));
}
var oc = class {
    constructor(e, t, n, r, i, a, o, s) {
      ((this.parser = e),
        (this.predicate = t),
        (this.mounts = n),
        (this.index = r),
        (this.start = i),
        (this.bracketed = a),
        (this.target = o),
        (this.prev = s),
        (this.depth = 0),
        (this.ranges = []));
    }
  },
  sc = new G({
    perNode: !0,
  }),
  cc = class {
    constructor(e, t, n, r, i) {
      ((this.nest = t),
        (this.input = n),
        (this.fragments = r),
        (this.ranges = i),
        (this.inner = []),
        (this.innerDone = 0),
        (this.baseTree = null),
        (this.stoppedAt = null),
        (this.baseParse = e));
    }
    advance() {
      if (this.baseParse) {
        let e = this.baseParse.advance();
        if (!e) return null;
        if (
          ((this.baseParse = null), (this.baseTree = e), this.startInner(), this.stoppedAt != null)
        )
          for (let e of this.inner) e.parse.stopAt(this.stoppedAt);
      }
      if (this.innerDone == this.inner.length) {
        let e = this.baseTree;
        return (
          this.stoppedAt != null &&
            (e = new J(
              e.type,
              e.children,
              e.positions,
              e.length,
              e.propValues.concat([[sc, this.stoppedAt]]),
            )),
          e
        );
      }
      let e = this.inner[this.innerDone],
        t = e.parse.advance();
      if (t) {
        this.innerDone++;
        let n = Object.assign(Object.create(null), e.target.props);
        ((n[G.mounted.id] = new As(t, e.overlay, e.parser, e.bracketed)), (e.target.props = n));
      }
      return null;
    }
    get parsedPos() {
      if (this.baseParse) return 0;
      let e = this.input.length;
      for (let t = this.innerDone; t < this.inner.length; t++)
        this.inner[t].from < e && (e = Math.min(e, this.inner[t].parse.parsedPos));
      return e;
    }
    stopAt(e) {
      if (((this.stoppedAt = e), this.baseParse)) this.baseParse.stopAt(e);
      else for (let t = this.innerDone; t < this.inner.length; t++) this.inner[t].parse.stopAt(e);
    }
    startInner() {
      let e = new pc(this.fragments),
        t = null,
        n = null,
        r = new qs(
          new Y(this.baseTree, this.ranges[0].from, 0, null),
          q.IncludeAnonymous | q.IgnoreMounts,
        );
      scan: for (let i, a; ;) {
        let o = !0,
          s;
        if (this.stoppedAt != null && r.from >= this.stoppedAt) o = !1;
        else if (e.hasNode(r)) {
          if (t) {
            let e = t.mounts.find(
              (e) => e.frag.from <= r.from && e.frag.to >= r.to && e.mount.overlay,
            );
            if (e)
              for (let n of e.mount.overlay) {
                let i = n.from + e.pos,
                  a = n.to + e.pos;
                i >= r.from &&
                  a <= r.to &&
                  !t.ranges.some((e) => e.from < a && e.to > i) &&
                  t.ranges.push({
                    from: i,
                    to: a,
                  });
              }
          }
          o = !1;
        } else if (n && (a = lc(n.ranges, r.from, r.to))) o = a != 2;
        else if (
          !r.type.isAnonymous &&
          (i = this.nest(r, this.input)) &&
          (r.from < r.to || !i.overlay)
        ) {
          r.tree || (dc(r), t && t.depth++, n && n.depth++);
          let a = e.findMounts(r.from, i.parser);
          if (typeof i.overlay == `function`)
            t = new oc(i.parser, i.overlay, a, this.inner.length, r.from, !!i.bracketed, r.tree, t);
          else {
            let e = mc(this.ranges, i.overlay || (r.from < r.to ? [new W(r.from, r.to)] : []));
            (e.length && ac(e),
              (e.length || !i.overlay) &&
                this.inner.push(
                  new ic(
                    i.parser,
                    e.length
                      ? i.parser.startParse(this.input, gc(a, e), e)
                      : i.parser.startParse(``),
                    i.overlay ? i.overlay.map((e) => new W(e.from - r.from, e.to - r.from)) : null,
                    !!i.bracketed,
                    r.tree,
                    e.length ? e[0].from : r.from,
                  ),
                ),
              i.overlay
                ? e.length &&
                  (n = {
                    ranges: e,
                    depth: 0,
                    prev: n,
                  })
                : (o = !1));
          }
        } else if (
          t &&
          (s = t.predicate(r)) &&
          (s === !0 && (s = new W(r.from, r.to)), s.from < s.to)
        ) {
          let e = t.ranges.length - 1;
          e >= 0 && t.ranges[e].to == s.from
            ? (t.ranges[e] = {
                from: t.ranges[e].from,
                to: s.to,
              })
            : t.ranges.push(s);
        }
        if (o && r.firstChild()) (t && t.depth++, n && n.depth++);
        else
          for (; !r.nextSibling();) {
            if (!r.parent()) break scan;
            if (t && !--t.depth) {
              let e = mc(this.ranges, t.ranges);
              (e.length &&
                (ac(e),
                this.inner.splice(
                  t.index,
                  0,
                  new ic(
                    t.parser,
                    t.parser.startParse(this.input, gc(t.mounts, e), e),
                    t.ranges.map((e) => new W(e.from - t.start, e.to - t.start)),
                    t.bracketed,
                    t.target,
                    e[0].from,
                  ),
                )),
                (t = t.prev));
            }
            n && !--n.depth && (n = n.prev);
          }
      }
    }
  };
function lc(e, t, n) {
  for (let r of e) {
    if (r.from >= n) break;
    if (r.to > t) return r.from <= t && r.to >= n ? 2 : 1;
  }
  return 0;
}
function uc(e, t, n, r, i, a) {
  if (t < n) {
    let o = e.buffer[t + 1];
    (r.push(e.slice(t, n, o)), i.push(o - a));
  }
}
function dc(e) {
  let { node: t } = e,
    n = [],
    r = t.context.buffer;
  do (n.push(e.index), e.parent());
  while (!e.tree);
  let i = e.tree,
    a = i.children.indexOf(r),
    o = i.children[a],
    s = o.buffer,
    c = [a];
  function l(e, r, i, a, u, d) {
    let f = n[d],
      p = [],
      m = [];
    uc(o, e, f, p, m, a);
    let h = s[f + 1],
      g = s[f + 2];
    c.push(p.length);
    let _ = d ? l(f + 4, s[f + 3], o.set.types[s[f]], h, g - h, d - 1) : t.toTree();
    return (p.push(_), m.push(h - a), uc(o, s[f + 3], r, p, m, a), new J(i, p, m, u));
  }
  i.children[a] = l(0, s.length, K.none, 0, o.length, n.length - 1);
  for (let t of c) {
    let n = e.tree.children[t],
      r = e.tree.positions[t];
    e.yield(new Y(n, r + e.from, t, e._tree));
  }
}
var fc = class {
    constructor(e, t) {
      ((this.offset = t),
        (this.done = !1),
        (this.cursor = e.cursor(q.IncludeAnonymous | q.IgnoreMounts)));
    }
    moveTo(e) {
      let { cursor: t } = this,
        n = e - this.offset;
      for (; !this.done && t.from < n;)
        if (!(t.to >= e && t.enter(n, 1, q.IgnoreOverlays | q.ExcludeBuffers)))
          if (t.to <= e) t.next(!1) || (this.done = !0);
          else break;
    }
    hasNode(e) {
      if (
        (this.moveTo(e.from),
        !this.done && this.cursor.from + this.offset == e.from && this.cursor.tree)
      )
        for (let t = this.cursor.tree; ;) {
          if (t == e.tree) return !0;
          if (t.children.length && t.positions[0] == 0 && t.children[0] instanceof J)
            t = t.children[0];
          else break;
        }
      return !1;
    }
  },
  pc = class {
    constructor(e) {
      if (((this.fragments = e), (this.curTo = 0), (this.fragI = 0), e.length)) {
        let t = (this.curFrag = e[0]);
        ((this.curTo = t.tree.prop(sc) ?? t.to), (this.inner = new fc(t.tree, -t.offset)));
      } else this.curFrag = this.inner = null;
    }
    hasNode(e) {
      for (; this.curFrag && e.from >= this.curTo;) this.nextFrag();
      return (
        this.curFrag && this.curFrag.from <= e.from && this.curTo >= e.to && this.inner.hasNode(e)
      );
    }
    nextFrag() {
      if ((this.fragI++, this.fragI == this.fragments.length)) this.curFrag = this.inner = null;
      else {
        let e = (this.curFrag = this.fragments[this.fragI]);
        ((this.curTo = e.tree.prop(sc) ?? e.to), (this.inner = new fc(e.tree, -e.offset)));
      }
    }
    findMounts(e, t) {
      let n = [];
      if (this.inner) {
        this.inner.cursor.moveTo(e, 1);
        for (let e = this.inner.cursor.node; e; e = e.parent) {
          let r = e.tree?.prop(G.mounted);
          if (r && r.parser == t)
            for (let t = this.fragI; t < this.fragments.length; t++) {
              let i = this.fragments[t];
              if (i.from >= e.to) break;
              i.tree == this.curFrag.tree &&
                n.push({
                  frag: i,
                  pos: e.from - i.offset,
                  mount: r,
                });
            }
        }
      }
      return n;
    }
  };
function mc(e, t) {
  let n = null,
    r = t;
  for (let i = 1, a = 0; i < e.length; i++) {
    let o = e[i - 1].to,
      s = e[i].from;
    for (; a < r.length; a++) {
      let e = r[a];
      if (e.from >= s) break;
      e.to <= o ||
        (n || (r = n = t.slice()),
        e.from < o
          ? ((n[a] = new W(e.from, o)), e.to > s && n.splice(a + 1, 0, new W(s, e.to)))
          : e.to > s
            ? (n[a--] = new W(s, e.to))
            : n.splice(a--, 1));
    }
  }
  return r;
}
function hc(e, t, n, r) {
  let i = 0,
    a = 0,
    o = !1,
    s = !1,
    c = -1e9,
    l = [];
  for (;;) {
    let u = i == e.length ? 1e9 : o ? e[i].to : e[i].from,
      d = a == t.length ? 1e9 : s ? t[a].to : t[a].from;
    if (o != s) {
      let e = Math.max(c, n),
        t = Math.min(u, d, r);
      e < t && l.push(new W(e, t));
    }
    if (((c = Math.min(u, d)), c == 1e9)) break;
    (u == c && (o ? ((o = !1), i++) : (o = !0)), d == c && (s ? ((s = !1), a++) : (s = !0)));
  }
  return l;
}
function gc(e, t) {
  let n = [];
  for (let { pos: r, mount: i, frag: a } of e) {
    let e = r + (i.overlay ? i.overlay[0].from : 0),
      o = e + i.tree.length,
      s = Math.max(a.from, e),
      c = Math.min(a.to, o);
    if (i.overlay) {
      let o = hc(
        t,
        i.overlay.map((e) => new W(e.from + r, e.to + r)),
        s,
        c,
      );
      for (let t = 0, r = s; ; t++) {
        let s = t == o.length,
          l = s ? c : o[t].from;
        if (
          (l > r &&
            n.push(new ec(r, l, i.tree, -e, a.from >= r || a.openStart, a.to <= l || a.openEnd)),
          s)
        )
          break;
        r = o[t].to;
      }
    } else n.push(new ec(s, c, i.tree, -e, a.from >= e || a.openStart, a.to <= o || a.openEnd));
  }
  return n;
}
var _c = 0,
  vc = class e {
    constructor(e, t, n, r) {
      ((this.name = e), (this.set = t), (this.base = n), (this.modified = r), (this.id = _c++));
    }
    toString() {
      let { name: e } = this;
      for (let t of this.modified) t.name && (e = `${t.name}(${e})`);
      return e;
    }
    static define(t, n) {
      let r = typeof t == `string` ? t : `?`;
      if ((t instanceof e && (n = t), n?.base)) throw Error(`Can not derive from a modified tag`);
      let i = new e(r, [], null, []);
      if ((i.set.push(i), n)) for (let e of n.set) i.set.push(e);
      return i;
    }
    static defineModifier(e) {
      let t = new bc(e);
      return (e) =>
        e.modified.indexOf(t) > -1
          ? e
          : bc.get(
              e.base || e,
              e.modified.concat(t).sort((e, t) => e.id - t.id),
            );
    }
  },
  yc = 0,
  bc = class e {
    constructor(e) {
      ((this.name = e), (this.instances = []), (this.id = yc++));
    }
    static get(t, n) {
      if (!n.length) return t;
      let r = n[0].instances.find((e) => e.base == t && xc(n, e.modified));
      if (r) return r;
      let i = [],
        a = new vc(t.name, i, t, n);
      for (let e of n) e.instances.push(a);
      let o = Sc(n);
      for (let n of t.set) if (!n.modified.length) for (let t of o) i.push(e.get(n, t));
      return a;
    }
  };
function xc(e, t) {
  return e.length == t.length && e.every((e, n) => e == t[n]);
}
function Sc(e) {
  let t = [[]];
  for (let n = 0; n < e.length; n++)
    for (let r = 0, i = t.length; r < i; r++) t.push(t[r].concat(e[n]));
  return t.sort((e, t) => t.length - e.length);
}
function Cc(e) {
  let t = Object.create(null);
  for (let n in e) {
    let r = e[n];
    Array.isArray(r) || (r = [r]);
    for (let e of n.split(` `))
      if (e) {
        let n = [],
          i = 2,
          a = e;
        for (let t = 0; ;) {
          if (a == `...` && t > 0 && t + 3 == e.length) {
            i = 1;
            break;
          }
          let r = /^"(?:[^"\\]|\\.)*?"|[^\/!]+/.exec(a);
          if (!r) throw RangeError(`Invalid path: ` + e);
          if (
            (n.push(r[0] == `*` ? `` : r[0][0] == `"` ? JSON.parse(r[0]) : r[0]),
            (t += r[0].length),
            t == e.length)
          )
            break;
          let o = e[t++];
          if (t == e.length && o == `!`) {
            i = 0;
            break;
          }
          if (o != `/`) throw RangeError(`Invalid path: ` + e);
          a = e.slice(t);
        }
        let o = n.length - 1,
          s = n[o];
        if (!s) throw RangeError(`Invalid path: ` + e);
        t[s] = new Tc(r, i, o > 0 ? n.slice(0, o) : null).sort(t[s]);
      }
  }
  return wc.add(t);
}
var wc = new G({
    combine(e, t) {
      let n, r, i;
      for (; e || t;) {
        if (
          (!e || (t && e.depth >= t.depth) ? ((i = t), (t = t.next)) : ((i = e), (e = e.next)),
          n && n.mode == i.mode && !i.context && !n.context)
        )
          continue;
        let a = new Tc(i.tags, i.mode, i.context);
        (n ? (n.next = a) : (r = a), (n = a));
      }
      return r;
    },
  }),
  Tc = class {
    constructor(e, t, n, r) {
      ((this.tags = e), (this.mode = t), (this.context = n), (this.next = r));
    }
    get opaque() {
      return this.mode == 0;
    }
    get inherit() {
      return this.mode == 1;
    }
    sort(e) {
      return !e || e.depth < this.depth
        ? ((this.next = e), this)
        : ((e.next = this.sort(e.next)), e);
    }
    get depth() {
      return this.context ? this.context.length : 0;
    }
  };
Tc.empty = new Tc([], 2, null);
function Ec(e, t) {
  let n = Object.create(null);
  for (let t of e)
    if (!Array.isArray(t.tag)) n[t.tag.id] = t.class;
    else for (let e of t.tag) n[e.id] = t.class;
  let { scope: r, all: i = null } = t || {};
  return {
    style: (e) => {
      let t = i;
      for (let r of e)
        for (let e of r.set) {
          let r = n[e.id];
          if (r) {
            t = t ? t + ` ` + r : r;
            break;
          }
        }
      return t;
    },
    scope: r,
  };
}
function Dc(e, t) {
  let n = null;
  for (let r of e) {
    let e = r.style(t);
    e && (n = n ? n + ` ` + e : e);
  }
  return n;
}
function Oc(e, t, n, r = 0, i = e.length) {
  let a = new kc(r, Array.isArray(t) ? t : [t], n);
  (a.highlightRange(e.cursor(), r, i, ``, a.highlighters), a.flush(i));
}
var kc = class {
  constructor(e, t, n) {
    ((this.at = e), (this.highlighters = t), (this.span = n), (this.class = ``));
  }
  startSpan(e, t) {
    t != this.class && (this.flush(e), e > this.at && (this.at = e), (this.class = t));
  }
  flush(e) {
    e > this.at && this.class && this.span(this.at, e, this.class);
  }
  highlightRange(e, t, n, r, i) {
    let { type: a, from: o, to: s } = e;
    if (o >= n || s <= t) return;
    a.isTop && (i = this.highlighters.filter((e) => !e.scope || e.scope(a)));
    let c = r,
      l = Ac(e) || Tc.empty,
      u = Dc(i, l.tags);
    if (
      (u && (c && (c += ` `), (c += u), l.mode == 1 && (r += (r ? ` ` : ``) + u)),
      this.startSpan(Math.max(t, o), c),
      l.opaque)
    )
      return;
    let d = e.tree && e.tree.prop(G.mounted);
    if (d && d.overlay) {
      let a = e.node.enter(d.overlay[0].from + o, 1),
        l = this.highlighters.filter((e) => !e.scope || e.scope(d.tree.type)),
        u = e.firstChild();
      for (let f = 0, p = o; ; f++) {
        let m = f < d.overlay.length ? d.overlay[f] : null,
          h = m ? m.from + o : s,
          g = Math.max(t, p),
          _ = Math.min(n, h);
        if (g < _ && u)
          for (
            ;
            e.from < _ &&
            (this.highlightRange(e, g, _, r, i),
            this.startSpan(Math.min(_, e.to), c),
            !(e.to >= h || !e.nextSibling()));
          );
        if (!m || h > n) break;
        ((p = m.to + o),
          p > t &&
            (this.highlightRange(a.cursor(), Math.max(t, m.from + o), Math.min(n, p), ``, l),
            this.startSpan(Math.min(n, p), c)));
      }
      u && e.parent();
    } else if (e.firstChild()) {
      d && (r = ``);
      do {
        if (e.to <= t) continue;
        if (e.from >= n) break;
        (this.highlightRange(e, t, n, r, i), this.startSpan(Math.min(n, e.to), c));
      } while (e.nextSibling());
      e.parent();
    }
  }
};
function Ac(e) {
  let t = e.type.prop(wc);
  for (; t && t.context && !e.matchContext(t.context);) t = t.next;
  return t || null;
}
var X = vc.define,
  jc = X(),
  Mc = X(),
  Nc = X(Mc),
  Pc = X(Mc),
  Fc = X(),
  Ic = X(Fc),
  Lc = X(Fc),
  Rc = X(),
  zc = X(Rc),
  Bc = X(),
  Vc = X(),
  Hc = X(),
  Uc = X(Hc),
  Wc = X(),
  Z = {
    comment: jc,
    lineComment: X(jc),
    blockComment: X(jc),
    docComment: X(jc),
    name: Mc,
    variableName: X(Mc),
    typeName: Nc,
    tagName: X(Nc),
    propertyName: Pc,
    attributeName: X(Pc),
    className: X(Mc),
    labelName: X(Mc),
    namespace: X(Mc),
    macroName: X(Mc),
    literal: Fc,
    string: Ic,
    docString: X(Ic),
    character: X(Ic),
    attributeValue: X(Ic),
    number: Lc,
    integer: X(Lc),
    float: X(Lc),
    bool: X(Fc),
    regexp: X(Fc),
    escape: X(Fc),
    color: X(Fc),
    url: X(Fc),
    keyword: Bc,
    self: X(Bc),
    null: X(Bc),
    atom: X(Bc),
    unit: X(Bc),
    modifier: X(Bc),
    operatorKeyword: X(Bc),
    controlKeyword: X(Bc),
    definitionKeyword: X(Bc),
    moduleKeyword: X(Bc),
    operator: Vc,
    derefOperator: X(Vc),
    arithmeticOperator: X(Vc),
    logicOperator: X(Vc),
    bitwiseOperator: X(Vc),
    compareOperator: X(Vc),
    updateOperator: X(Vc),
    definitionOperator: X(Vc),
    typeOperator: X(Vc),
    controlOperator: X(Vc),
    punctuation: Hc,
    separator: X(Hc),
    bracket: Uc,
    angleBracket: X(Uc),
    squareBracket: X(Uc),
    paren: X(Uc),
    brace: X(Uc),
    content: Rc,
    heading: zc,
    heading1: X(zc),
    heading2: X(zc),
    heading3: X(zc),
    heading4: X(zc),
    heading5: X(zc),
    heading6: X(zc),
    contentSeparator: X(Rc),
    list: X(Rc),
    quote: X(Rc),
    emphasis: X(Rc),
    strong: X(Rc),
    link: X(Rc),
    monospace: X(Rc),
    strikethrough: X(Rc),
    inserted: X(),
    deleted: X(),
    changed: X(),
    invalid: X(),
    meta: Wc,
    documentMeta: X(Wc),
    annotation: X(Wc),
    processingInstruction: X(Wc),
    definition: vc.defineModifier(`definition`),
    constant: vc.defineModifier(`constant`),
    function: vc.defineModifier(`function`),
    standard: vc.defineModifier(`standard`),
    local: vc.defineModifier(`local`),
    special: vc.defineModifier(`special`),
  };
for (let e in Z) {
  let t = Z[e];
  t instanceof vc && (t.name = e);
}
Ec([
  {
    tag: Z.link,
    class: `tok-link`,
  },
  {
    tag: Z.heading,
    class: `tok-heading`,
  },
  {
    tag: Z.emphasis,
    class: `tok-emphasis`,
  },
  {
    tag: Z.strong,
    class: `tok-strong`,
  },
  {
    tag: Z.keyword,
    class: `tok-keyword`,
  },
  {
    tag: Z.atom,
    class: `tok-atom`,
  },
  {
    tag: Z.bool,
    class: `tok-bool`,
  },
  {
    tag: Z.url,
    class: `tok-url`,
  },
  {
    tag: Z.labelName,
    class: `tok-labelName`,
  },
  {
    tag: Z.inserted,
    class: `tok-inserted`,
  },
  {
    tag: Z.deleted,
    class: `tok-deleted`,
  },
  {
    tag: Z.literal,
    class: `tok-literal`,
  },
  {
    tag: Z.string,
    class: `tok-string`,
  },
  {
    tag: Z.number,
    class: `tok-number`,
  },
  {
    tag: [Z.regexp, Z.escape, Z.special(Z.string)],
    class: `tok-string2`,
  },
  {
    tag: Z.variableName,
    class: `tok-variableName`,
  },
  {
    tag: Z.local(Z.variableName),
    class: `tok-variableName tok-local`,
  },
  {
    tag: Z.definition(Z.variableName),
    class: `tok-variableName tok-definition`,
  },
  {
    tag: Z.special(Z.variableName),
    class: `tok-variableName2`,
  },
  {
    tag: Z.definition(Z.propertyName),
    class: `tok-propertyName tok-definition`,
  },
  {
    tag: Z.typeName,
    class: `tok-typeName`,
  },
  {
    tag: Z.namespace,
    class: `tok-namespace`,
  },
  {
    tag: Z.className,
    class: `tok-className`,
  },
  {
    tag: Z.macroName,
    class: `tok-macroName`,
  },
  {
    tag: Z.propertyName,
    class: `tok-propertyName`,
  },
  {
    tag: Z.operator,
    class: `tok-operator`,
  },
  {
    tag: Z.comment,
    class: `tok-comment`,
  },
  {
    tag: Z.meta,
    class: `tok-meta`,
  },
  {
    tag: Z.invalid,
    class: `tok-invalid`,
  },
  {
    tag: Z.punctuation,
    class: `tok-punctuation`,
  },
]);
var Gc = new G();
function Kc(e) {
  return E.define({
    combine: e ? (t) => t.concat(e) : void 0,
  });
}
var qc = new G(),
  Q = class {
    constructor(e, t, n = [], r = ``) {
      ((this.data = e),
        (this.name = r),
        k.prototype.hasOwnProperty(`tree`) ||
          Object.defineProperty(k.prototype, "tree", {
            get() {
              return Xc(this);
            },
          }),
        (this.parser = t),
        (this.extension = [
          al.of(this),
          k.languageData.of((e, t, n) => {
            let r = Jc(e, t, n),
              i = r.type.prop(Gc);
            if (!i) return [];
            let a = e.facet(i),
              o = r.type.prop(qc);
            if (o) {
              let i = r.resolve(t - r.from, n);
              for (let t of o)
                if (t.test(i, e)) {
                  let n = e.facet(t.facet);
                  return t.type == `replace` ? n : n.concat(a);
                }
            }
            return a;
          }),
        ].concat(n)));
    }
    isActiveAt(e, t, n = -1) {
      return Jc(e, t, n).type.prop(Gc) == this.data;
    }
    findRegions(e) {
      let t = e.facet(al);
      if (t?.data == this.data)
        return [
          {
            from: 0,
            to: e.doc.length,
          },
        ];
      if (!t || !t.allowsNesting) return [];
      let n = [],
        r = (e, t) => {
          if (e.prop(Gc) == this.data) {
            n.push({
              from: t,
              to: t + e.length,
            });
            return;
          }
          let i = e.prop(G.mounted);
          if (i) {
            if (i.tree.prop(Gc) == this.data) {
              if (i.overlay)
                for (let e of i.overlay)
                  n.push({
                    from: e.from + t,
                    to: e.to + t,
                  });
              else
                n.push({
                  from: t,
                  to: t + e.length,
                });
              return;
            } else if (i.overlay) {
              let e = n.length;
              if ((r(i.tree, i.overlay[0].from + t), n.length > e)) return;
            }
          }
          for (let n = 0; n < e.children.length; n++) {
            let i = e.children[n];
            i instanceof J && r(i, e.positions[n] + t);
          }
        };
      return (r(Xc(e), 0), n);
    }
    get allowsNesting() {
      return !0;
    }
  };
Q.setState = D.define();
function Jc(e, t, n) {
  let r = e.facet(al),
    i = Xc(e).topNode;
  if (!r || r.allowsNesting)
    for (let e = i; e; e = e.enter(t, n, q.ExcludeBuffers | q.EnterBracketed))
      e.type.isTop && (i = e);
  return i;
}
var Yc = class e extends Q {
  constructor(e, t, n) {
    (super(e, t, [], n), (this.parser = t));
  }
  static define(t) {
    let n = Kc(t.languageData);
    return new e(
      n,
      t.parser.configure({
        props: [Gc.add((e) => (e.isTop ? n : void 0))],
      }),
      t.name,
    );
  }
  configure(t, n) {
    return new e(this.data, this.parser.configure(t), n || this.name);
  }
  get allowsNesting() {
    return this.parser.hasWrappers();
  }
};
function Xc(e) {
  let t = e.field(Q.state, !1);
  return t ? t.tree : J.empty;
}
var Zc = class {
    constructor(e) {
      ((this.doc = e), (this.cursorPos = 0), (this.string = ``), (this.cursor = e.iter()));
    }
    get length() {
      return this.doc.length;
    }
    syncTo(e) {
      return (
        (this.string = this.cursor.next(e - this.cursorPos).value),
        (this.cursorPos = e + this.string.length),
        this.cursorPos - this.string.length
      );
    }
    chunk(e) {
      return (this.syncTo(e), this.string);
    }
    get lineChunks() {
      return !0;
    }
    read(e, t) {
      let n = this.cursorPos - this.string.length;
      return e < n || t >= this.cursorPos
        ? this.doc.sliceString(e, t)
        : this.string.slice(e - n, t - n);
    }
  },
  Qc = null,
  $c = class e {
    constructor(e, t, n = [], r, i, a, o, s) {
      ((this.parser = e),
        (this.state = t),
        (this.fragments = n),
        (this.tree = r),
        (this.treeLen = i),
        (this.viewport = a),
        (this.skipped = o),
        (this.scheduleOn = s),
        (this.parse = null),
        (this.tempSkipped = []));
    }
    static create(t, n, r) {
      return new e(t, n, [], J.empty, 0, r, [], null);
    }
    startParse() {
      return this.parser.startParse(new Zc(this.state.doc), this.fragments);
    }
    work(e, t) {
      return (
        t != null && t >= this.state.doc.length && (t = void 0),
        this.tree != J.empty && this.isDone(t ?? this.state.doc.length)
          ? (this.takeTree(), !0)
          : this.withContext(() => {
              if (typeof e == `number`) {
                let t = Date.now() + e;
                e = () => Date.now() > t;
              }
              for (
                this.parse ||= this.startParse(),
                  t != null &&
                    (this.parse.stoppedAt == null || this.parse.stoppedAt > t) &&
                    t < this.state.doc.length &&
                    this.parse.stopAt(t);
                ;
              ) {
                let n = this.parse.advance();
                if (n)
                  if (
                    ((this.fragments = this.withoutTempSkipped(
                      ec.addTree(n, this.fragments, this.parse.stoppedAt != null),
                    )),
                    (this.treeLen = this.parse.stoppedAt ?? this.state.doc.length),
                    (this.tree = n),
                    (this.parse = null),
                    this.treeLen < (t ?? this.state.doc.length))
                  )
                    this.parse = this.startParse();
                  else return !0;
                if (e()) return !1;
              }
            })
      );
    }
    takeTree() {
      let e, t;
      this.parse &&
        (e = this.parse.parsedPos) >= this.treeLen &&
        ((this.parse.stoppedAt == null || this.parse.stoppedAt > e) && this.parse.stopAt(e),
        this.withContext(() => {
          for (; !(t = this.parse.advance()););
        }),
        (this.treeLen = e),
        (this.tree = t),
        (this.fragments = this.withoutTempSkipped(ec.addTree(this.tree, this.fragments, !0))),
        (this.parse = null));
    }
    withContext(e) {
      let t = Qc;
      Qc = this;
      try {
        return e();
      } finally {
        Qc = t;
      }
    }
    withoutTempSkipped(e) {
      for (let t; (t = this.tempSkipped.pop());) e = el(e, t.from, t.to);
      return e;
    }
    changes(t, n) {
      let { fragments: r, tree: i, treeLen: a, viewport: o, skipped: s } = this;
      if ((this.takeTree(), !t.empty)) {
        let e = [];
        if (
          (t.iterChangedRanges((t, n, r, i) =>
            e.push({
              fromA: t,
              toA: n,
              fromB: r,
              toB: i,
            }),
          ),
          (r = ec.applyChanges(r, e)),
          (i = J.empty),
          (a = 0),
          (o = {
            from: t.mapPos(o.from, -1),
            to: t.mapPos(o.to, 1),
          }),
          this.skipped.length)
        ) {
          s = [];
          for (let e of this.skipped) {
            let n = t.mapPos(e.from, 1),
              r = t.mapPos(e.to, -1);
            n < r &&
              s.push({
                from: n,
                to: r,
              });
          }
        }
      }
      return new e(this.parser, n, r, i, a, o, s, this.scheduleOn);
    }
    updateViewport(e) {
      if (this.viewport.from == e.from && this.viewport.to == e.to) return !1;
      this.viewport = e;
      let t = this.skipped.length;
      for (let t = 0; t < this.skipped.length; t++) {
        let { from: n, to: r } = this.skipped[t];
        n < e.to &&
          r > e.from &&
          ((this.fragments = el(this.fragments, n, r)), this.skipped.splice(t--, 1));
      }
      return this.skipped.length >= t ? !1 : (this.reset(), !0);
    }
    reset() {
      this.parse &&= (this.takeTree(), null);
    }
    skipUntilInView(e, t) {
      this.skipped.push({
        from: e,
        to: t,
      });
    }
    static getSkippingParser(e) {
      return new (class extends tc {
        createParse(t, n, r) {
          let i = r[0].from,
            a = r[r.length - 1].to;
          return {
            parsedPos: i,
            advance() {
              let t = Qc;
              if (t) {
                for (let e of r) t.tempSkipped.push(e);
                e && (t.scheduleOn = t.scheduleOn ? Promise.all([t.scheduleOn, e]) : e);
              }
              return ((this.parsedPos = a), new J(K.none, [], [], a - i));
            },
            stoppedAt: null,
            stopAt() {},
          };
        }
      })();
    }
    isDone(e) {
      e = Math.min(e, this.state.doc.length);
      let t = this.fragments;
      return this.treeLen >= e && t.length && t[0].from == 0 && t[0].to >= e;
    }
    static get() {
      return Qc;
    }
  };
function el(e, t, n) {
  return ec.applyChanges(e, [
    {
      fromA: t,
      toA: n,
      fromB: t,
      toB: n,
    },
  ]);
}
var tl = class e {
  constructor(e) {
    ((this.context = e), (this.tree = e.tree));
  }
  apply(t) {
    if (!t.docChanged && this.tree == this.context.tree) return this;
    let n = this.context.changes(t.changes, t.state),
      r =
        this.context.treeLen == t.startState.doc.length
          ? void 0
          : Math.max(t.changes.mapPos(this.context.treeLen), n.viewport.to);
    return (n.work(20, r) || n.takeTree(), new e(n));
  }
  static init(t) {
    let n = Math.min(3e3, t.doc.length),
      r = $c.create(t.facet(al).parser, t, {
        from: 0,
        to: n,
      });
    return (r.work(20, n) || r.takeTree(), new e(r));
  }
};
Q.state = Ce.define({
  create: tl.init,
  update(e, t) {
    for (let e of t.effects) if (e.is(Q.setState)) return e.value;
    return t.startState.facet(al) == t.state.facet(al) ? e.apply(t) : tl.init(t.state);
  },
});
var nl = (e) => {
  let t = setTimeout(() => e(), 500);
  return () => clearTimeout(t);
};
typeof requestIdleCallback < `u` &&
  (nl = (e) => {
    let t = -1,
      n = setTimeout(() => {
        t = requestIdleCallback(e, {
          timeout: 400,
        });
      }, 100);
    return () => (t < 0 ? clearTimeout(n) : cancelIdleCallback(t));
  });
var rl =
    typeof navigator < `u` && navigator.scheduling?.isInputPending
      ? () => navigator.scheduling.isInputPending()
      : null,
  il = xr.fromClass(
    class {
      constructor(e) {
        ((this.view = e),
          (this.working = null),
          (this.workScheduled = 0),
          (this.chunkEnd = -1),
          (this.chunkBudget = -1),
          (this.work = this.work.bind(this)),
          this.scheduleWork());
      }
      update(e) {
        let t = this.view.state.field(Q.state).context;
        ((t.updateViewport(e.view.viewport) || this.view.viewport.to > t.treeLen) &&
          this.scheduleWork(),
          (e.docChanged || e.selectionSet) &&
            (this.view.hasFocus && (this.chunkBudget += 50), this.scheduleWork()),
          this.checkAsyncSchedule(t));
      }
      scheduleWork() {
        if (this.working) return;
        let { state: e } = this.view,
          t = e.field(Q.state);
        (t.tree != t.context.tree || !t.context.isDone(e.doc.length)) &&
          (this.working = nl(this.work));
      }
      work(e) {
        this.working = null;
        let t = Date.now();
        if (
          (this.chunkEnd < t &&
            (this.chunkEnd < 0 || this.view.hasFocus) &&
            ((this.chunkEnd = t + 3e4), (this.chunkBudget = 3e3)),
          this.chunkBudget <= 0)
        )
          return;
        let {
            state: n,
            viewport: { to: r },
          } = this.view,
          i = n.field(Q.state);
        if (i.tree == i.context.tree && i.context.isDone(r + 1e5)) return;
        let a =
            Date.now() +
            Math.min(this.chunkBudget, 100, e && !rl ? Math.max(25, e.timeRemaining() - 5) : 1e9),
          o = i.context.treeLen < r && n.doc.length > r + 1e3,
          s = i.context.work(() => (rl && rl()) || Date.now() > a, r + (o ? 0 : 1e5));
        ((this.chunkBudget -= Date.now() - t),
          (s || this.chunkBudget <= 0) &&
            (i.context.takeTree(),
            this.view.dispatch({
              effects: Q.setState.of(new tl(i.context)),
            })),
          this.chunkBudget > 0 && !(s && !o) && this.scheduleWork(),
          this.checkAsyncSchedule(i.context));
      }
      checkAsyncSchedule(e) {
        e.scheduleOn &&=
          (this.workScheduled++,
          e.scheduleOn
            .then(() => this.scheduleWork())
            .catch((e) => _r(this.view.state, e))
            .then(() => this.workScheduled--),
          null);
      }
      destroy() {
        this.working && this.working();
      }
      isWorking() {
        return !!(this.working || this.workScheduled > 0);
      }
    },
    {
      eventHandlers: {
        focus() {
          this.scheduleWork();
        },
      },
    },
  ),
  al = E.define({
    combine(e) {
      return e.length ? e[0] : null;
    },
    enables: (e) => [
      Q.state,
      il,
      U.contentAttributes.compute([e], (t) => {
        let n = t.facet(e);
        return n && n.name
          ? {
              "data-language": n.name,
            }
          : {};
      }),
    ],
  }),
  ol = class {
    constructor(e, t = []) {
      ((this.language = e), (this.support = t), (this.extension = [e, t]));
    }
  },
  sl = class e {
    constructor(e, t, n, r, i, a = void 0) {
      ((this.name = e),
        (this.alias = t),
        (this.extensions = n),
        (this.filename = r),
        (this.loadFunc = i),
        (this.support = a),
        (this.loading = null));
    }
    load() {
      return (this.loading ||= this.loadFunc().then(
        (e) => (this.support = e),
        (e) => {
          throw ((this.loading = null), e);
        },
      ));
    }
    static of(t) {
      let { load: n, support: r } = t;
      if (!n) {
        if (!r) throw RangeError(`Must pass either 'load' or 'support' to LanguageDescription.of`);
        n = () => Promise.resolve(r);
      }
      return new e(
        t.name,
        (t.alias || []).concat(t.name).map((e) => e.toLowerCase()),
        t.extensions || [],
        t.filename,
        n,
        r,
      );
    }
    static matchFilename(e, t) {
      for (let n of e) if (n.filename && n.filename.test(t)) return n;
      let n = /\.([^.]+)$/.exec(t);
      if (n) {
        for (let t of e) if (t.extensions.indexOf(n[1]) > -1) return t;
      }
      return null;
    }
    static matchLanguageName(e, t, n = !0) {
      t = t.toLowerCase();
      for (let n of e) if (n.alias.some((e) => e == t)) return n;
      if (n)
        for (let n of e)
          for (let e of n.alias) {
            let r = t.indexOf(e);
            if (r > -1 && (e.length > 2 || (!/\w/.test(t[r - 1]) && !/\w/.test(t[r + e.length]))))
              return n;
          }
      return null;
    }
  },
  cl = E.define(),
  ll = E.define({
    combine: (e) => {
      if (!e.length) return `  `;
      let t = e[0];
      if (!t || /\S/.test(t) || Array.from(t).some((e) => e != t[0]))
        throw Error(`Invalid indent unit: ` + JSON.stringify(e[0]));
      return t;
    },
  });
function ul(e) {
  let t = e.facet(ll);
  return t.charCodeAt(0) == 9 ? e.tabSize * t.length : t.length;
}
function dl(e, t) {
  let n = ``,
    r = e.tabSize,
    i = e.facet(ll)[0];
  if (i == `	`) {
    for (; t >= r;) ((n += `	`), (t -= r));
    i = ` `;
  }
  for (let e = 0; e < t; e++) n += i;
  return n;
}
function fl(e, t) {
  e instanceof k && (e = new pl(e));
  for (let n of e.state.facet(cl)) {
    let r = n(e, t);
    if (r !== void 0) return r;
  }
  let n = Xc(e.state);
  return n.length >= t ? hl(e, n, t) : null;
}
var pl = class {
    constructor(e, t = {}) {
      ((this.state = e), (this.options = t), (this.unit = ul(e)));
    }
    lineAt(e, t = 1) {
      let n = this.state.doc.lineAt(e),
        { simulateBreak: r, simulateDoubleBreak: i } = this.options;
      return r != null && r >= n.from && r <= n.to
        ? i && r == e
          ? {
              text: ``,
              from: e,
            }
          : (t < 0 ? r < e : r <= e)
            ? {
                text: n.text.slice(r - n.from),
                from: r,
              }
            : {
                text: n.text.slice(0, r - n.from),
                from: n.from,
              }
        : n;
    }
    textAfterPos(e, t = 1) {
      if (this.options.simulateDoubleBreak && e == this.options.simulateBreak) return ``;
      let { text: n, from: r } = this.lineAt(e, t);
      return n.slice(e - r, Math.min(n.length, e + 100 - r));
    }
    column(e, t = 1) {
      let { text: n, from: r } = this.lineAt(e, t),
        i = this.countColumn(n, e - r),
        a = this.options.overrideIndentation ? this.options.overrideIndentation(r) : -1;
      return (a > -1 && (i += a - this.countColumn(n, n.search(/\S|$/))), i);
    }
    countColumn(e, t = e.length) {
      return xt(e, this.state.tabSize, t);
    }
    lineIndent(e, t = 1) {
      let { text: n, from: r } = this.lineAt(e, t),
        i = this.options.overrideIndentation;
      if (i) {
        let e = i(r);
        if (e > -1) return e;
      }
      return this.countColumn(n, n.search(/\S|$/));
    }
    get simulatedBreak() {
      return this.options.simulateBreak || null;
    }
  },
  ml = new G();
function hl(e, t, n) {
  let r = t.resolveStack(n),
    i = t.resolveInner(n, -1).resolve(n, 0).enterUnfinishedNodesBefore(n);
  if (i != r.node) {
    let e = [];
    for (
      let t = i;
      t &&
      !(
        t.from < r.node.from ||
        t.to > r.node.to ||
        (t.from == r.node.from && t.type == r.node.type)
      );
      t = t.parent
    )
      e.push(t);
    for (let t = e.length - 1; t >= 0; t--)
      r = {
        node: e[t],
        next: r,
      };
  }
  return gl(r, e, n);
}
function gl(e, t, n) {
  for (let r = e; r; r = r.next) {
    let e = vl(r.node);
    if (e) return e(bl.create(t, n, r));
  }
  return 0;
}
function _l(e) {
  return e.pos == e.options.simulateBreak && e.options.simulateDoubleBreak;
}
function vl(e) {
  let t = e.type.prop(ml);
  if (t) return t;
  let n = e.firstChild,
    r;
  if (n && (r = n.type.prop(G.closedBy))) {
    let t = e.lastChild,
      n = t && r.indexOf(t.name) > -1;
    return (e) => wl(e, !0, 1, void 0, n && !_l(e) ? t.from : void 0);
  }
  return e.parent == null ? yl : null;
}
function yl() {
  return 0;
}
var bl = class e extends pl {
  constructor(e, t, n) {
    (super(e.state, e.options), (this.base = e), (this.pos = t), (this.context = n));
  }
  get node() {
    return this.context.node;
  }
  static create(t, n, r) {
    return new e(t, n, r);
  }
  get textAfter() {
    return this.textAfterPos(this.pos);
  }
  get baseIndent() {
    return this.baseIndentFor(this.node);
  }
  baseIndentFor(e) {
    let t = this.state.doc.lineAt(e.from);
    for (;;) {
      let n = e.resolve(t.from);
      for (; n.parent && n.parent.from == n.from;) n = n.parent;
      if (xl(n, e)) break;
      t = this.state.doc.lineAt(n.from);
    }
    return this.lineIndent(t.from);
  }
  continue() {
    return gl(this.context.next, this.base, this.pos);
  }
};
function xl(e, t) {
  for (let n = t; n; n = n.parent) if (e == n) return !0;
  return !1;
}
function Sl(e) {
  let t = e.node,
    n = t.childAfter(t.from),
    r = t.lastChild;
  if (!n) return null;
  let i = e.options.simulateBreak,
    a = e.state.doc.lineAt(n.from),
    o = i == null || i <= a.from ? a.to : Math.min(a.to, i);
  for (let e = n.to; ;) {
    let i = t.childAfter(e);
    if (!i || i == r) return null;
    if (!i.type.isSkipped) {
      if (i.from >= o) return null;
      let e = /^ */.exec(a.text.slice(n.to - a.from))[0].length;
      return {
        from: n.from,
        to: n.to + e,
      };
    }
    e = i.to;
  }
}
function Cl({ closing: e, align: t = !0, units: n = 1 }) {
  return (r) => wl(r, t, n, e);
}
function wl(e, t, n, r, i) {
  let a = e.textAfter,
    o = a.match(/^\s*/)[0].length,
    s = (r && a.slice(o, o + r.length) == r) || i == e.pos + o,
    c = t ? Sl(e) : null;
  return c ? (s ? e.column(c.from) : e.column(c.to)) : e.baseIndent + (s ? 0 : e.unit * n);
}
var Tl = (e) => e.baseIndent;
function El({ except: e, units: t = 1 } = {}) {
  return (n) => {
    let r = e && e.test(n.textAfter);
    return n.baseIndent + (r ? 0 : t * n.unit);
  };
}
var Dl = E.define(),
  Ol = new G();
function kl(e) {
  let t = e.firstChild,
    n = e.lastChild;
  return t && t.to < n.from
    ? {
        from: t.to,
        to: n.type.isError ? e.to : n.from,
      }
    : null;
}
var Al = class e {
    constructor(e, t) {
      this.specs = e;
      let n;
      function r(e) {
        let t = Dt.newName();
        return (((n ||= Object.create(null))[`.` + t] = e), t);
      }
      let i = typeof t.all == `string` ? t.all : t.all ? r(t.all) : void 0,
        a = t.scope;
      ((this.scope = a instanceof Q ? (e) => e.prop(Gc) == a.data : a ? (e) => e == a : void 0),
        (this.style = Ec(
          e.map((e) => ({
            tag: e.tag,
            class:
              e.class ||
              r(
                Object.assign({}, e, {
                  tag: null,
                }),
              ),
          })),
          {
            all: i,
          },
        ).style),
        (this.module = n ? new Dt(n) : null),
        (this.themeType = t.themeType));
    }
    static define(t, n) {
      return new e(t, n || {});
    }
  },
  jl = E.define(),
  Ml = E.define({
    combine(e) {
      return e.length ? [e[0]] : null;
    },
  });
function Nl(e) {
  let t = e.facet(jl);
  return t.length ? t : e.facet(Ml);
}
function Pl(e, t) {
  let n = [Il],
    r;
  return (
    e instanceof Al && (e.module && n.push(U.styleModule.of(e.module)), (r = e.themeType)),
    t?.fallback
      ? n.push(Ml.of(e))
      : r
        ? n.push(
            jl.computeN([U.darkTheme], (t) => (t.facet(U.darkTheme) == (r == `dark`) ? [e] : [])),
          )
        : n.push(jl.of(e)),
    n
  );
}
var Fl = class {
    constructor(e) {
      ((this.markCache = Object.create(null)),
        (this.tree = Xc(e.state)),
        (this.decorations = this.buildDeco(e, Nl(e.state))),
        (this.decoratedTo = e.viewport.to));
    }
    update(e) {
      let t = Xc(e.state),
        n = Nl(e.state),
        r = n != Nl(e.startState),
        { viewport: i } = e.view,
        a = e.changes.mapPos(this.decoratedTo, 1);
      t.length < i.to && !r && t.type == this.tree.type && a >= i.to
        ? ((this.decorations = this.decorations.map(e.changes)), (this.decoratedTo = a))
        : (t != this.tree || e.viewportChanged || r) &&
          ((this.tree = t),
          (this.decorations = this.buildDeco(e.view, n)),
          (this.decoratedTo = i.to));
    }
    buildDeco(e, t) {
      if (!t || !this.tree.length) return F.none;
      let n = new ut();
      for (let { from: r, to: i } of e.visibleRanges)
        Oc(
          this.tree,
          t,
          (e, t, r) => {
            n.add(
              e,
              t,
              this.markCache[r] ||
                (this.markCache[r] = F.mark({
                  class: r,
                })),
            );
          },
          r,
          i,
        );
      return n.finish();
    }
  },
  Il = Ee.high(
    xr.fromClass(Fl, {
      decorations: (e) => e.decorations,
    }),
  );
(Z.meta,
  Z.link,
  Z.heading,
  Z.emphasis,
  Z.strong,
  Z.strikethrough,
  Z.keyword,
  Z.atom,
  Z.bool,
  Z.url,
  Z.contentSeparator,
  Z.labelName,
  Z.literal,
  Z.inserted,
  Z.string,
  Z.deleted,
  Z.regexp,
  Z.escape,
  Z.string,
  Z.variableName,
  Z.variableName,
  Z.typeName,
  Z.namespace,
  Z.className,
  Z.variableName,
  Z.macroName,
  Z.propertyName,
  Z.comment,
  Z.invalid);
var Ll = 1e4,
  Rl = `()[]{}`,
  zl = new G();
function Bl(e, t, n) {
  let r = e.prop(t < 0 ? G.openedBy : G.closedBy);
  if (r) return r;
  if (e.name.length == 1) {
    let r = n.indexOf(e.name);
    if (r > -1 && r % 2 == +(t < 0)) return [n[r + t]];
  }
  return null;
}
function Vl(e) {
  let t = e.type.prop(zl);
  return t ? t(e.node) : e;
}
function Hl(e, t, n, r = {}) {
  let i = r.maxScanDistance || Ll,
    a = r.brackets || Rl,
    o = Xc(e),
    s = o.resolveInner(t, n);
  for (let r = s; r; r = r.parent) {
    let i = Bl(r.type, n, a);
    if (i && r.from < r.to) {
      let o = Vl(r);
      if (o && (n > 0 ? t >= o.from && t < o.to : t > o.from && t <= o.to))
        return Ul(e, t, n, r, o, i, a);
    }
  }
  return Wl(e, t, n, o, s.type, i, a);
}
function Ul(e, t, n, r, i, a, o) {
  let s = r.parent,
    c = {
      from: i.from,
      to: i.to,
    },
    l = 0,
    u = s?.cursor();
  if (u && (n < 0 ? u.childBefore(r.from) : u.childAfter(r.to)))
    do
      if (n < 0 ? u.to <= r.from : u.from >= r.to) {
        if (l == 0 && a.indexOf(u.type.name) > -1 && u.from < u.to) {
          let e = Vl(u);
          return {
            start: c,
            end: e
              ? {
                  from: e.from,
                  to: e.to,
                }
              : void 0,
            matched: !0,
          };
        } else if (Bl(u.type, n, o)) l++;
        else if (Bl(u.type, -n, o)) {
          if (l == 0) {
            let e = Vl(u);
            return {
              start: c,
              end:
                e && e.from < e.to
                  ? {
                      from: e.from,
                      to: e.to,
                    }
                  : void 0,
              matched: !1,
            };
          }
          l--;
        }
      }
    while (n < 0 ? u.prevSibling() : u.nextSibling());
  return {
    start: c,
    matched: !1,
  };
}
function Wl(e, t, n, r, i, a, o) {
  if (n < 0 ? !t : t == e.doc.length) return null;
  let s = n < 0 ? e.sliceDoc(t - 1, t) : e.sliceDoc(t, t + 1),
    c = o.indexOf(s);
  if (c < 0 || (c % 2 == 0) != n > 0) return null;
  let l = {
      from: n < 0 ? t - 1 : t,
      to: n > 0 ? t + 1 : t,
    },
    u = e.doc.iterRange(t, n > 0 ? e.doc.length : 0),
    d = 0;
  for (let e = 0; !u.next().done && e <= a;) {
    let a = u.value;
    n < 0 && (e += a.length);
    let s = t + e * n;
    for (let e = n > 0 ? 0 : a.length - 1, t = n > 0 ? a.length : -1; e != t; e += n) {
      let t = o.indexOf(a[e]);
      if (!(t < 0 || r.resolveInner(s + e, 1).type != i))
        if ((t % 2 == 0) == n > 0) d++;
        else if (d == 1)
          return {
            start: l,
            end: {
              from: s + e,
              to: s + e + 1,
            },
            matched: t >> 1 == c >> 1,
          };
        else d--;
    }
    n > 0 && (e += a.length);
  }
  return u.done
    ? {
        start: l,
        matched: !1,
      }
    : null;
}
function Gl(e, t, n, r = 0, i = 0) {
  t ?? ((t = e.search(/[^\s\u00a0]/)), t == -1 && (t = e.length));
  let a = i;
  for (let i = r; i < t; i++) e.charCodeAt(i) == 9 ? (a += n - (a % n)) : a++;
  return a;
}
var Kl = class {
  constructor(e, t, n, r) {
    ((this.string = e),
      (this.tabSize = t),
      (this.indentUnit = n),
      (this.overrideIndent = r),
      (this.pos = 0),
      (this.start = 0),
      (this.lastColumnPos = 0),
      (this.lastColumnValue = 0));
  }
  eol() {
    return this.pos >= this.string.length;
  }
  sol() {
    return this.pos == 0;
  }
  peek() {
    return this.string.charAt(this.pos) || void 0;
  }
  next() {
    if (this.pos < this.string.length) return this.string.charAt(this.pos++);
  }
  eat(e) {
    let t = this.string.charAt(this.pos),
      n;
    if (((n = typeof e == `string` ? t == e : t && (e instanceof RegExp ? e.test(t) : e(t))), n))
      return (++this.pos, t);
  }
  eatWhile(e) {
    let t = this.pos;
    for (; this.eat(e););
    return this.pos > t;
  }
  eatSpace() {
    let e = this.pos;
    for (; /[\s\u00a0]/.test(this.string.charAt(this.pos));) ++this.pos;
    return this.pos > e;
  }
  skipToEnd() {
    this.pos = this.string.length;
  }
  skipTo(e) {
    let t = this.string.indexOf(e, this.pos);
    if (t > -1) return ((this.pos = t), !0);
  }
  backUp(e) {
    this.pos -= e;
  }
  column() {
    return (
      this.lastColumnPos < this.start &&
        ((this.lastColumnValue = Gl(
          this.string,
          this.start,
          this.tabSize,
          this.lastColumnPos,
          this.lastColumnValue,
        )),
        (this.lastColumnPos = this.start)),
      this.lastColumnValue
    );
  }
  indentation() {
    return this.overrideIndent ?? Gl(this.string, null, this.tabSize);
  }
  match(e, t, n) {
    if (typeof e == `string`) {
      let r = (e) => (n ? e.toLowerCase() : e);
      return r(this.string.substr(this.pos, e.length)) == r(e)
        ? (t !== !1 && (this.pos += e.length), !0)
        : null;
    } else {
      let n = this.string.slice(this.pos).match(e);
      return n && n.index > 0 ? null : (n && t !== !1 && (this.pos += n[0].length), n);
    }
  }
  current() {
    return this.string.slice(this.start, this.pos);
  }
};
function ql(e) {
  return {
    name: e.name || ``,
    token: e.token,
    blankLine: e.blankLine || (() => {}),
    startState: e.startState || (() => !0),
    copyState: e.copyState || Jl,
    indent: e.indent || (() => null),
    languageData: e.languageData || {},
    tokenTable: e.tokenTable || nu,
    mergeTokens: e.mergeTokens !== !1,
  };
}
function Jl(e) {
  if (typeof e != `object`) return e;
  let t = {};
  for (let n in e) {
    let r = e[n];
    t[n] = r instanceof Array ? r.slice() : r;
  }
  return t;
}
var Yl = new WeakMap(),
  Xl = class e extends Q {
    constructor(e) {
      let t = Kc(e.languageData),
        n = ql(e),
        r,
        i = new (class extends tc {
          createParse(e, t, n) {
            return new eu(r, e, t, n);
          }
        })();
      (super(t, i, [], e.name),
        (this.topNode = fu(t, this)),
        (r = this),
        (this.streamParser = n),
        (this.stateAfter = new G({
          perNode: !0,
        })),
        (this.tokenTable = e.tokenTable ? new cu(n.tokenTable) : lu));
    }
    static define(t) {
      return new e(t);
    }
    getIndent(e) {
      let t,
        { overrideIndentation: n } = e.options;
      n && ((t = Yl.get(e.state)), t != null && t < e.pos - 1e4 && (t = void 0));
      let r = Zl(this, e.node.tree, e.node.from, e.node.from, t ?? e.pos),
        i,
        a;
      if (
        (r
          ? ((a = r.state), (i = r.pos + 1))
          : ((a = this.streamParser.startState(e.unit)), (i = e.node.from)),
        e.pos - i > 1e4)
      )
        return null;
      for (; i < e.pos;) {
        let t = e.state.doc.lineAt(i),
          r = Math.min(e.pos, t.to);
        if (t.length) {
          let i = n ? n(t.from) : -1,
            o = new Kl(t.text, e.state.tabSize, e.unit, i < 0 ? void 0 : i);
          for (; o.pos < r - t.from;) tu(this.streamParser.token, o, a);
        } else this.streamParser.blankLine(a, e.unit);
        if (r == e.pos) break;
        i = t.to + 1;
      }
      let o = e.lineAt(e.pos);
      return (
        n && t == null && Yl.set(e.state, o.from),
        this.streamParser.indent(a, /^\s*(.*)/.exec(o.text)[1], e)
      );
    }
    get allowsNesting() {
      return !1;
    }
  };
function Zl(e, t, n, r, i) {
  let a = n >= r && n + t.length <= i && t.prop(e.stateAfter);
  if (a)
    return {
      state: e.streamParser.copyState(a),
      pos: n + t.length,
    };
  for (let a = t.children.length - 1; a >= 0; a--) {
    let o = t.children[a],
      s = n + t.positions[a],
      c = o instanceof J && s < i && Zl(e, o, s, r, i);
    if (c) return c;
  }
  return null;
}
function Ql(e, t, n, r, i) {
  if (i && n <= 0 && r >= t.length) return t;
  !i && n == 0 && t.type == e.topNode && (i = !0);
  for (let a = t.children.length - 1; a >= 0; a--) {
    let o = t.positions[a],
      s = t.children[a],
      c;
    if (o < r && s instanceof J) {
      if (!(c = Ql(e, s, n - o, r - o, i))) break;
      return i
        ? new J(t.type, t.children.slice(0, a).concat(c), t.positions.slice(0, a + 1), o + c.length)
        : c;
    }
  }
  return null;
}
function $l(e, t, n, r, i) {
  for (let i of t) {
    let t = i.from + (i.openStart ? 25 : 0),
      a = i.to - (i.openEnd ? 25 : 0),
      o = t <= n && a > n && Zl(e, i.tree, 0 - i.offset, n, a),
      s;
    if (o && o.pos <= r && (s = Ql(e, i.tree, n + i.offset, o.pos + i.offset, !1)))
      return {
        state: o.state,
        tree: s,
      };
  }
  return {
    state: e.streamParser.startState(i ? ul(i) : 4),
    tree: J.empty,
  };
}
var eu = class {
  constructor(e, t, n, r) {
    ((this.lang = e),
      (this.input = t),
      (this.fragments = n),
      (this.ranges = r),
      (this.stoppedAt = null),
      (this.chunks = []),
      (this.chunkPos = []),
      (this.chunk = []),
      (this.chunkReused = void 0),
      (this.rangeIndex = 0),
      (this.to = r[r.length - 1].to));
    let i = $c.get(),
      a = r[0].from,
      { state: o, tree: s } = $l(e, n, a, this.to, i?.state);
    ((this.state = o), (this.parsedPos = this.chunkStart = a + s.length));
    for (let e = 0; e < s.children.length; e++)
      (this.chunks.push(s.children[e]), this.chunkPos.push(s.positions[e]));
    (i &&
      this.parsedPos < i.viewport.from - 1e5 &&
      r.some((e) => e.from <= i.viewport.from && e.to >= i.viewport.from) &&
      ((this.state = this.lang.streamParser.startState(ul(i.state))),
      i.skipUntilInView(this.parsedPos, i.viewport.from),
      (this.parsedPos = i.viewport.from)),
      this.moveRangeIndex());
  }
  advance() {
    let e = $c.get(),
      t = this.stoppedAt == null ? this.to : Math.min(this.to, this.stoppedAt),
      n = Math.min(t, this.chunkStart + 512);
    for (e && (n = Math.min(n, e.viewport.to)); this.parsedPos < n;) this.parseLine(e);
    return (
      this.chunkStart < this.parsedPos && this.finishChunk(),
      this.parsedPos >= t
        ? this.finish()
        : e && this.parsedPos >= e.viewport.to
          ? (e.skipUntilInView(this.parsedPos, t), this.finish())
          : null
    );
  }
  stopAt(e) {
    this.stoppedAt = e;
  }
  lineAfter(e) {
    let t = this.input.chunk(e);
    if (this.input.lineChunks)
      t ==
        `
` && (t = ``);
    else {
      let e = t.indexOf(`
`);
      e > -1 && (t = t.slice(0, e));
    }
    return e + t.length <= this.to ? t : t.slice(0, this.to - e);
  }
  nextLine() {
    let e = this.parsedPos,
      t = this.lineAfter(e),
      n = e + t.length;
    for (let e = this.rangeIndex; ;) {
      let r = this.ranges[e].to;
      if (r >= n || ((t = t.slice(0, r - (n - t.length))), e++, e == this.ranges.length)) break;
      let i = this.ranges[e].from,
        a = this.lineAfter(i);
      ((t += a), (n = i + a.length));
    }
    return {
      line: t,
      end: n,
    };
  }
  skipGapsTo(e, t, n) {
    for (;;) {
      let r = this.ranges[this.rangeIndex].to,
        i = e + t;
      if (n > 0 ? r > i : r >= i) break;
      let a = this.ranges[++this.rangeIndex].from;
      t += a - r;
    }
    return t;
  }
  moveRangeIndex() {
    for (; this.ranges[this.rangeIndex].to < this.parsedPos;) this.rangeIndex++;
  }
  emitToken(e, t, n, r) {
    let i = 4;
    if (this.ranges.length > 1) {
      ((r = this.skipGapsTo(t, r, 1)), (t += r));
      let e = this.chunk.length;
      ((r = this.skipGapsTo(n, r, -1)), (n += r), (i += this.chunk.length - e));
    }
    let a = this.chunk.length - 4;
    return (
      this.lang.streamParser.mergeTokens &&
      i == 4 &&
      a >= 0 &&
      this.chunk[a] == e &&
      this.chunk[a + 2] == t
        ? (this.chunk[a + 2] = n)
        : this.chunk.push(e, t, n, i),
      r
    );
  }
  parseLine(e) {
    let { line: t, end: n } = this.nextLine(),
      r = 0,
      { streamParser: i } = this.lang,
      a = new Kl(t, e ? e.state.tabSize : 4, e ? ul(e.state) : 2);
    if (a.eol()) i.blankLine(this.state, a.indentUnit);
    else
      for (; !a.eol();) {
        let e = tu(i.token, a, this.state);
        if (
          (e &&
            (r = this.emitToken(
              this.lang.tokenTable.resolve(e),
              this.parsedPos + a.start,
              this.parsedPos + a.pos,
              r,
            )),
          a.start > 1e4)
        )
          break;
      }
    ((this.parsedPos = n), this.moveRangeIndex(), this.parsedPos < this.to && this.parsedPos++);
  }
  finishChunk() {
    let e = J.build({
      buffer: this.chunk,
      start: this.chunkStart,
      length: this.parsedPos - this.chunkStart,
      nodeSet: iu,
      topID: 0,
      maxBufferLength: 512,
      reused: this.chunkReused,
    });
    ((e = new J(e.type, e.children, e.positions, e.length, [
      [this.lang.stateAfter, this.lang.streamParser.copyState(this.state)],
    ])),
      this.chunks.push(e),
      this.chunkPos.push(this.chunkStart - this.ranges[0].from),
      (this.chunk = []),
      (this.chunkReused = void 0),
      (this.chunkStart = this.parsedPos));
  }
  finish() {
    return new J(
      this.lang.topNode,
      this.chunks,
      this.chunkPos,
      this.parsedPos - this.ranges[0].from,
    ).balance();
  }
};
function tu(e, t, n) {
  t.start = t.pos;
  for (let r = 0; r < 10; r++) {
    let r = e(t, n);
    if (t.pos > t.start) return r;
  }
  throw Error(`Stream parser failed to advance stream.`);
}
var nu = Object.create(null),
  ru = [K.none],
  iu = new Ms(ru),
  au = [],
  ou = Object.create(null),
  su = Object.create(null);
for (let [e, t] of [
  [`variable`, `variableName`],
  [`variable-2`, `variableName.special`],
  [`string-2`, `string.special`],
  [`def`, `variableName.definition`],
  [`tag`, `tagName`],
  [`attribute`, `attributeName`],
  [`type`, `typeName`],
  [`builtin`, `variableName.standard`],
  [`qualifier`, `modifier`],
  [`error`, `invalid`],
  [`header`, `heading`],
  [`property`, `propertyName`],
])
  su[e] = du(nu, t);
var cu = class {
    constructor(e) {
      ((this.extra = e), (this.table = Object.assign(Object.create(null), su)));
    }
    resolve(e) {
      return e ? this.table[e] || (this.table[e] = du(this.extra, e)) : 0;
    }
  },
  lu = new cu(nu);
function uu(e, t) {
  au.indexOf(e) > -1 || (au.push(e), console.warn(t));
}
function du(e, t) {
  let n = [];
  for (let r of t.split(` `)) {
    let t = [];
    for (let n of r.split(`.`)) {
      let r = e[n] || Z[n];
      r
        ? typeof r == `function`
          ? t.length
            ? (t = t.map(r))
            : uu(n, `Modifier ${n} used at start of tag`)
          : t.length
            ? uu(n, `Tag ${n} used as modifier`)
            : (t = Array.isArray(r) ? r : [r])
        : uu(n, `Unknown highlighting tag ${n}`);
    }
    for (let e of t) n.push(e);
  }
  if (!n.length) return 0;
  let r = t.replace(/ /g, `_`),
    i = r + ` ` + n.map((e) => e.id),
    a = ou[i];
  if (a) return a.id;
  let o = (ou[i] = K.define({
    id: ru.length,
    name: r,
    props: [
      Cc({
        [r]: n,
      }),
    ],
  }));
  return (ru.push(o), o.id);
}
function fu(e, t) {
  let n = K.define({
    id: ru.length,
    name: `Document`,
    props: [Gc.add(() => e), ml.add(() => (e) => t.getIndent(e))],
    top: !0,
  });
  return (ru.push(n), n);
}
(I.RTL, I.LTR);
var pu = class e {
    constructor(e, t, n, r, i, a, o, s, c, l = 0, u) {
      ((this.p = e),
        (this.stack = t),
        (this.state = n),
        (this.reducePos = r),
        (this.pos = i),
        (this.score = a),
        (this.buffer = o),
        (this.bufferBase = s),
        (this.curContext = c),
        (this.lookAhead = l),
        (this.parent = u));
    }
    toString() {
      return `[${this.stack.filter((e, t) => t % 3 == 0).concat(this.state)}]@${this.pos}${this.score ? `!` + this.score : ``}`;
    }
    static start(t, n, r = 0) {
      let i = t.parser.context;
      return new e(t, [], n, r, r, 0, [], 0, i ? new mu(i, i.start) : null, 0, null);
    }
    get context() {
      return this.curContext ? this.curContext.context : null;
    }
    pushState(e, t) {
      (this.stack.push(this.state, t, this.bufferBase + this.buffer.length), (this.state = e));
    }
    reduce(e) {
      let t = e >> 19,
        n = e & 65535,
        { parser: r } = this.p,
        i = this.reducePos < this.pos - 25 && this.setLookAhead(this.pos),
        a = r.dynamicPrecedence(n);
      if ((a && (this.score += a), t == 0)) {
        (n < r.minRepeatTerm && this.reducePos < this.pos && (this.reducePos = this.pos),
          this.pushState(r.getGoto(this.state, n, !0), this.reducePos),
          n < r.minRepeatTerm && this.storeNode(n, this.reducePos, this.reducePos, i ? 8 : 4, !0),
          this.reduceContext(n, this.reducePos));
        return;
      }
      let o = this.stack.length - (t - 1) * 3 - (e & 262144 ? 6 : 0),
        s = o ? this.stack[o - 2] : this.p.ranges[0].from;
      n < r.minRepeatTerm &&
        s == this.reducePos &&
        this.reducePos < this.pos &&
        (this.reducePos = this.pos);
      let c = this.reducePos - s;
      c >= 2e3 &&
        !this.p.parser.nodeSet.types[n]?.isAnonymous &&
        (s == this.p.lastBigReductionStart
          ? (this.p.bigReductionCount++, (this.p.lastBigReductionSize = c))
          : this.p.lastBigReductionSize < c &&
            ((this.p.bigReductionCount = 1),
            (this.p.lastBigReductionStart = s),
            (this.p.lastBigReductionSize = c)));
      let l = o ? this.stack[o - 1] : 0,
        u = this.bufferBase + this.buffer.length - l;
      if (n < r.minRepeatTerm || e & 131072) {
        let e = r.stateFlag(this.state, 1) ? this.pos : this.reducePos;
        this.storeNode(n, s, e, u + 4, !0);
      }
      if (e & 262144) this.state = this.stack[o];
      else {
        let e = this.stack[o - 3];
        this.state = r.getGoto(e, n, !0);
      }
      for (; this.stack.length > o;) this.stack.pop();
      this.reduceContext(n, s);
    }
    storeNode(e, t, n, r = 4, i = !1) {
      if (
        e == 0 &&
        (!this.stack.length ||
          this.stack[this.stack.length - 1] < this.buffer.length + this.bufferBase)
      ) {
        let e = this.buffer.length;
        if (e > 0 && this.buffer[e - 4] == 0 && this.buffer[e - 1] > -1) {
          if (t == n) return;
          if (this.buffer[e - 2] >= t) {
            this.buffer[e - 2] = n;
            return;
          }
        }
      }
      if (!i || this.pos == n) this.buffer.push(e, t, n, r);
      else {
        let i = this.buffer.length;
        if (i > 0 && (this.buffer[i - 4] != 0 || this.buffer[i - 1] < 0)) {
          let e = !1;
          for (let t = i; t > 0 && this.buffer[t - 2] > n; t -= 4)
            if (this.buffer[t - 1] >= 0) {
              e = !0;
              break;
            }
          if (e)
            for (; i > 0 && this.buffer[i - 2] > n;)
              ((this.buffer[i] = this.buffer[i - 4]),
                (this.buffer[i + 1] = this.buffer[i - 3]),
                (this.buffer[i + 2] = this.buffer[i - 2]),
                (this.buffer[i + 3] = this.buffer[i - 1]),
                (i -= 4),
                r > 4 && (r -= 4));
        }
        ((this.buffer[i] = e),
          (this.buffer[i + 1] = t),
          (this.buffer[i + 2] = n),
          (this.buffer[i + 3] = r));
      }
    }
    shift(e, t, n, r) {
      if (e & 131072) this.pushState(e & 65535, this.pos);
      else if (e & 262144)
        ((this.pos = r),
          this.shiftContext(t, n),
          t <= this.p.parser.maxNode && this.buffer.push(t, n, r, 4));
      else {
        let i = e,
          { parser: a } = this.p;
        this.pos = r;
        let o = a.stateFlag(i, 1);
        (!o && (r > n || t <= a.maxNode) && (this.reducePos = r),
          this.pushState(i, o ? n : Math.min(n, this.reducePos)),
          this.shiftContext(t, n),
          t <= a.maxNode && this.buffer.push(t, n, r, 4));
      }
    }
    apply(e, t, n, r) {
      e & 65536 ? this.reduce(e) : this.shift(e, t, n, r);
    }
    useNode(e, t) {
      let n = this.p.reused.length - 1;
      (n < 0 || this.p.reused[n] != e) && (this.p.reused.push(e), n++);
      let r = this.pos;
      ((this.reducePos = this.pos = r + e.length),
        this.pushState(t, r),
        this.buffer.push(n, r, this.reducePos, -1),
        this.curContext &&
          this.updateContext(
            this.curContext.tracker.reuse(
              this.curContext.context,
              e,
              this,
              this.p.stream.reset(this.pos - e.length),
            ),
          ));
    }
    split() {
      let t = this,
        n = t.buffer.length;
      for (n && t.buffer[n - 4] == 0 && (n -= 4); n > 0 && t.buffer[n - 2] > t.reducePos;) n -= 4;
      let r = t.buffer.slice(n),
        i = t.bufferBase + n;
      for (; t && i == t.bufferBase;) t = t.parent;
      return new e(
        this.p,
        this.stack.slice(),
        this.state,
        this.reducePos,
        this.pos,
        this.score,
        r,
        i,
        this.curContext,
        this.lookAhead,
        t,
      );
    }
    recoverByDelete(e, t) {
      let n = e <= this.p.parser.maxNode;
      (n && this.storeNode(e, this.pos, t, 4),
        this.storeNode(0, this.pos, t, n ? 8 : 4),
        (this.pos = this.reducePos = t),
        (this.score -= 190));
    }
    canShift(e) {
      for (let t = new hu(this); ;) {
        let n = this.p.parser.stateSlot(t.state, 4) || this.p.parser.hasAction(t.state, e);
        if (n == 0) return !1;
        if (!(n & 65536)) return !0;
        t.reduce(n);
      }
    }
    recoverByInsert(e) {
      if (this.stack.length >= 300) return [];
      let t = this.p.parser.nextStates(this.state);
      if (t.length > 8 || this.stack.length >= 120) {
        let n = [];
        for (let r = 0, i; r < t.length; r += 2)
          (i = t[r + 1]) != this.state && this.p.parser.hasAction(i, e) && n.push(t[r], i);
        if (this.stack.length < 120)
          for (let e = 0; n.length < 8 && e < t.length; e += 2) {
            let r = t[e + 1];
            n.some((e, t) => t & 1 && e == r) || n.push(t[e], r);
          }
        t = n;
      }
      let n = [];
      for (let e = 0; e < t.length && n.length < 4; e += 2) {
        let r = t[e + 1];
        if (r == this.state) continue;
        let i = this.split();
        (i.pushState(r, this.pos),
          i.storeNode(0, i.pos, i.pos, 4, !0),
          i.shiftContext(t[e], this.pos),
          (i.reducePos = this.pos),
          (i.score -= 200),
          n.push(i));
      }
      return n;
    }
    forceReduce() {
      let { parser: e } = this.p,
        t = e.stateSlot(this.state, 5);
      if (!(t & 65536)) return !1;
      if (!e.validAction(this.state, t)) {
        let n = t >> 19,
          r = t & 65535,
          i = this.stack.length - n * 3;
        if (i < 0 || e.getGoto(this.stack[i], r, !1) < 0) {
          let e = this.findForcedReduction();
          if (e == null) return !1;
          t = e;
        }
        (this.storeNode(0, this.pos, this.pos, 4, !0), (this.score -= 100));
      }
      return ((this.reducePos = this.pos), this.reduce(t), !0);
    }
    findForcedReduction() {
      let { parser: e } = this.p,
        t = [],
        n = (r, i) => {
          if (!t.includes(r))
            return (
              t.push(r),
              e.allActions(r, (t) => {
                if (!(t & 393216))
                  if (t & 65536) {
                    let n = (t >> 19) - i;
                    if (n > 1) {
                      let r = t & 65535,
                        i = this.stack.length - n * 3;
                      if (i >= 0 && e.getGoto(this.stack[i], r, !1) >= 0)
                        return (n << 19) | 65536 | r;
                    }
                  } else {
                    let e = n(t, i + 1);
                    if (e != null) return e;
                  }
              })
            );
        };
      return n(this.state, 0);
    }
    forceAll() {
      for (; !this.p.parser.stateFlag(this.state, 2);)
        if (!this.forceReduce()) {
          this.storeNode(0, this.pos, this.pos, 4, !0);
          break;
        }
      return this;
    }
    get deadEnd() {
      if (this.stack.length != 3) return !1;
      let { parser: e } = this.p;
      return e.data[e.stateSlot(this.state, 1)] == 65535 && !e.stateSlot(this.state, 4);
    }
    restart() {
      (this.storeNode(0, this.pos, this.pos, 4, !0),
        (this.state = this.stack[0]),
        (this.stack.length = 0));
    }
    sameState(e) {
      if (this.state != e.state || this.stack.length != e.stack.length) return !1;
      for (let t = 0; t < this.stack.length; t += 3) if (this.stack[t] != e.stack[t]) return !1;
      return !0;
    }
    get parser() {
      return this.p.parser;
    }
    dialectEnabled(e) {
      return this.p.parser.dialect.flags[e];
    }
    shiftContext(e, t) {
      this.curContext &&
        this.updateContext(
          this.curContext.tracker.shift(this.curContext.context, e, this, this.p.stream.reset(t)),
        );
    }
    reduceContext(e, t) {
      this.curContext &&
        this.updateContext(
          this.curContext.tracker.reduce(this.curContext.context, e, this, this.p.stream.reset(t)),
        );
    }
    emitContext() {
      let e = this.buffer.length - 1;
      (e < 0 || this.buffer[e] != -3) &&
        this.buffer.push(this.curContext.hash, this.pos, this.pos, -3);
    }
    emitLookAhead() {
      let e = this.buffer.length - 1;
      (e < 0 || this.buffer[e] != -4) && this.buffer.push(this.lookAhead, this.pos, this.pos, -4);
    }
    updateContext(e) {
      if (e != this.curContext.context) {
        let t = new mu(this.curContext.tracker, e);
        (t.hash != this.curContext.hash && this.emitContext(), (this.curContext = t));
      }
    }
    setLookAhead(e) {
      return e <= this.lookAhead ? !1 : (this.emitLookAhead(), (this.lookAhead = e), !0);
    }
    close() {
      (this.curContext && this.curContext.tracker.strict && this.emitContext(),
        this.lookAhead > 0 && this.emitLookAhead());
    }
  },
  mu = class {
    constructor(e, t) {
      ((this.tracker = e), (this.context = t), (this.hash = e.strict ? e.hash(t) : 0));
    }
  },
  hu = class {
    constructor(e) {
      ((this.start = e),
        (this.state = e.state),
        (this.stack = e.stack),
        (this.base = this.stack.length));
    }
    reduce(e) {
      let t = e & 65535,
        n = e >> 19;
      n == 0
        ? (this.stack == this.start.stack && (this.stack = this.stack.slice()),
          this.stack.push(this.state, 0, 0),
          (this.base += 3))
        : (this.base -= (n - 1) * 3);
      let r = this.start.p.parser.getGoto(this.stack[this.base - 3], t, !0);
      this.state = r;
    }
  },
  gu = class e {
    constructor(e, t, n) {
      ((this.stack = e),
        (this.pos = t),
        (this.index = n),
        (this.buffer = e.buffer),
        this.index == 0 && this.maybeNext());
    }
    static create(t, n = t.bufferBase + t.buffer.length) {
      return new e(t, n, n - t.bufferBase);
    }
    maybeNext() {
      let e = this.stack.parent;
      e != null &&
        ((this.index = this.stack.bufferBase - e.bufferBase),
        (this.stack = e),
        (this.buffer = e.buffer));
    }
    get id() {
      return this.buffer[this.index - 4];
    }
    get start() {
      return this.buffer[this.index - 3];
    }
    get end() {
      return this.buffer[this.index - 2];
    }
    get size() {
      return this.buffer[this.index - 1];
    }
    next() {
      ((this.index -= 4), (this.pos -= 4), this.index == 0 && this.maybeNext());
    }
    fork() {
      return new e(this.stack, this.pos, this.index);
    }
  };
function _u(e, t = Uint16Array) {
  if (typeof e != `string`) return e;
  let n = null;
  for (let r = 0, i = 0; r < e.length;) {
    let a = 0;
    for (;;) {
      let t = e.charCodeAt(r++),
        n = !1;
      if (t == 126) {
        a = 65535;
        break;
      }
      (t >= 92 && t--, t >= 34 && t--);
      let i = t - 32;
      if ((i >= 46 && ((i -= 46), (n = !0)), (a += i), n)) break;
      a *= 46;
    }
    n ? (n[i++] = a) : (n = new t(a));
  }
  return n;
}
var vu = class {
    constructor() {
      ((this.start = -1),
        (this.value = -1),
        (this.end = -1),
        (this.extended = -1),
        (this.lookAhead = 0),
        (this.mask = 0),
        (this.context = 0));
    }
  },
  yu = new vu(),
  bu = class {
    constructor(e, t) {
      ((this.input = e),
        (this.ranges = t),
        (this.chunk = ``),
        (this.chunkOff = 0),
        (this.chunk2 = ``),
        (this.chunk2Pos = 0),
        (this.next = -1),
        (this.token = yu),
        (this.rangeIndex = 0),
        (this.pos = this.chunkPos = t[0].from),
        (this.range = t[0]),
        (this.end = t[t.length - 1].to),
        this.readNext());
    }
    resolveOffset(e, t) {
      let n = this.range,
        r = this.rangeIndex,
        i = this.pos + e;
      for (; i < n.from;) {
        if (!r) return null;
        let e = this.ranges[--r];
        ((i -= n.from - e.to), (n = e));
      }
      for (; t < 0 ? i > n.to : i >= n.to;) {
        if (r == this.ranges.length - 1) return null;
        let e = this.ranges[++r];
        ((i += e.from - n.to), (n = e));
      }
      return i;
    }
    clipPos(e) {
      if (e >= this.range.from && e < this.range.to) return e;
      for (let t of this.ranges) if (t.to > e) return Math.max(e, t.from);
      return this.end;
    }
    peek(e) {
      let t = this.chunkOff + e,
        n,
        r;
      if (t >= 0 && t < this.chunk.length) ((n = this.pos + e), (r = this.chunk.charCodeAt(t)));
      else {
        let t = this.resolveOffset(e, 1);
        if (t == null) return -1;
        if (((n = t), n >= this.chunk2Pos && n < this.chunk2Pos + this.chunk2.length))
          r = this.chunk2.charCodeAt(n - this.chunk2Pos);
        else {
          let e = this.rangeIndex,
            t = this.range;
          for (; t.to <= n;) t = this.ranges[++e];
          ((this.chunk2 = this.input.chunk((this.chunk2Pos = n))),
            n + this.chunk2.length > t.to && (this.chunk2 = this.chunk2.slice(0, t.to - n)),
            (r = this.chunk2.charCodeAt(0)));
        }
      }
      return (n >= this.token.lookAhead && (this.token.lookAhead = n + 1), r);
    }
    acceptToken(e, t = 0) {
      let n = t ? this.resolveOffset(t, -1) : this.pos;
      if (n == null || n < this.token.start) throw RangeError(`Token end out of bounds`);
      ((this.token.value = e), (this.token.end = n));
    }
    acceptTokenTo(e, t) {
      ((this.token.value = e), (this.token.end = t));
    }
    getChunk() {
      if (this.pos >= this.chunk2Pos && this.pos < this.chunk2Pos + this.chunk2.length) {
        let { chunk: e, chunkPos: t } = this;
        ((this.chunk = this.chunk2),
          (this.chunkPos = this.chunk2Pos),
          (this.chunk2 = e),
          (this.chunk2Pos = t),
          (this.chunkOff = this.pos - this.chunkPos));
      } else {
        ((this.chunk2 = this.chunk), (this.chunk2Pos = this.chunkPos));
        let e = this.input.chunk(this.pos),
          t = this.pos + e.length;
        ((this.chunk = t > this.range.to ? e.slice(0, this.range.to - this.pos) : e),
          (this.chunkPos = this.pos),
          (this.chunkOff = 0));
      }
    }
    readNext() {
      return this.chunkOff >= this.chunk.length &&
        (this.getChunk(), this.chunkOff == this.chunk.length)
        ? (this.next = -1)
        : (this.next = this.chunk.charCodeAt(this.chunkOff));
    }
    advance(e = 1) {
      for (this.chunkOff += e; this.pos + e >= this.range.to;) {
        if (this.rangeIndex == this.ranges.length - 1) return this.setDone();
        ((e -= this.range.to - this.pos),
          (this.range = this.ranges[++this.rangeIndex]),
          (this.pos = this.range.from));
      }
      return (
        (this.pos += e),
        this.pos >= this.token.lookAhead && (this.token.lookAhead = this.pos + 1),
        this.readNext()
      );
    }
    setDone() {
      return (
        (this.pos = this.chunkPos = this.end),
        (this.range = this.ranges[(this.rangeIndex = this.ranges.length - 1)]),
        (this.chunk = ``),
        (this.next = -1)
      );
    }
    reset(e, t) {
      if (
        (t
          ? ((this.token = t), (t.start = e), (t.lookAhead = e + 1), (t.value = t.extended = -1))
          : (this.token = yu),
        this.pos != e)
      ) {
        if (((this.pos = e), e == this.end)) return (this.setDone(), this);
        for (; e < this.range.from;) this.range = this.ranges[--this.rangeIndex];
        for (; e >= this.range.to;) this.range = this.ranges[++this.rangeIndex];
        (e >= this.chunkPos && e < this.chunkPos + this.chunk.length
          ? (this.chunkOff = e - this.chunkPos)
          : ((this.chunk = ``), (this.chunkOff = 0)),
          this.readNext());
      }
      return this;
    }
    read(e, t) {
      if (e >= this.chunkPos && t <= this.chunkPos + this.chunk.length)
        return this.chunk.slice(e - this.chunkPos, t - this.chunkPos);
      if (e >= this.chunk2Pos && t <= this.chunk2Pos + this.chunk2.length)
        return this.chunk2.slice(e - this.chunk2Pos, t - this.chunk2Pos);
      if (e >= this.range.from && t <= this.range.to) return this.input.read(e, t);
      let n = ``;
      for (let r of this.ranges) {
        if (r.from >= t) break;
        r.to > e && (n += this.input.read(Math.max(r.from, e), Math.min(r.to, t)));
      }
      return n;
    }
  },
  xu = class {
    constructor(e, t) {
      ((this.data = e), (this.id = t));
    }
    token(e, t) {
      let { parser: n } = t.p;
      wu(this.data, e, t, this.id, n.data, n.tokenPrecTable);
    }
  };
xu.prototype.contextual = xu.prototype.fallback = xu.prototype.extend = !1;
var Su = class {
  constructor(e, t, n) {
    ((this.precTable = t), (this.elseToken = n), (this.data = typeof e == `string` ? _u(e) : e));
  }
  token(e, t) {
    let n = e.pos,
      r = 0;
    for (;;) {
      let n = e.next < 0,
        i = e.resolveOffset(1, 1);
      if ((wu(this.data, e, t, 0, this.data, this.precTable), e.token.value > -1)) break;
      if (this.elseToken == null) return;
      if ((n || r++, i == null)) break;
      e.reset(i, e.token);
    }
    r && (e.reset(n, e.token), e.acceptToken(this.elseToken, r));
  }
};
Su.prototype.contextual = xu.prototype.fallback = xu.prototype.extend = !1;
var Cu = class {
  constructor(e, t = {}) {
    ((this.token = e),
      (this.contextual = !!t.contextual),
      (this.fallback = !!t.fallback),
      (this.extend = !!t.extend));
  }
};
function wu(e, t, n, r, i, a) {
  let o = 0,
    s = 1 << r,
    { dialect: c } = n.p.parser;
  scan: for (; (s & e[o]) != 0;) {
    let n = e[o + 1];
    for (let r = o + 3; r < n; r += 2)
      if ((e[r + 1] & s) > 0) {
        let n = e[r];
        if (
          c.allows(n) &&
          (t.token.value == -1 || t.token.value == n || Eu(n, t.token.value, i, a))
        ) {
          t.acceptToken(n);
          break;
        }
      }
    let r = t.next,
      l = 0,
      u = e[o + 2];
    if (t.next < 0 && u > l && e[n + u * 3 - 3] == 65535) {
      o = e[n + u * 3 - 1];
      continue scan;
    }
    for (; l < u;) {
      let i = (l + u) >> 1,
        a = n + i + (i << 1),
        s = e[a],
        c = e[a + 1] || 65536;
      if (r < s) u = i;
      else if (r >= c) l = i + 1;
      else {
        ((o = e[a + 2]), t.advance());
        continue scan;
      }
    }
    break;
  }
}
function Tu(e, t, n) {
  for (let r = t, i; (i = e[r]) != 65535; r++) if (i == n) return r - t;
  return -1;
}
function Eu(e, t, n, r) {
  let i = Tu(n, r, t);
  return i < 0 || Tu(n, r, e) < i;
}
var $ = typeof process < `u` && /\bparse\b/.test({}.LOG),
  Du = null;
function Ou(e, t, n) {
  let r = e.cursor(q.IncludeAnonymous);
  for (r.moveTo(t); ;)
    if (!(n < 0 ? r.childBefore(t) : r.childAfter(t)))
      for (;;) {
        if ((n < 0 ? r.to < t : r.from > t) && !r.type.isError)
          return n < 0
            ? Math.max(0, Math.min(r.to - 1, t - 25))
            : Math.min(e.length, Math.max(r.from + 1, t + 25));
        if (n < 0 ? r.prevSibling() : r.nextSibling()) break;
        if (!r.parent()) return n < 0 ? 0 : e.length;
      }
}
var ku = class {
    constructor(e, t) {
      ((this.fragments = e),
        (this.nodeSet = t),
        (this.i = 0),
        (this.fragment = null),
        (this.safeFrom = -1),
        (this.safeTo = -1),
        (this.trees = []),
        (this.start = []),
        (this.index = []),
        this.nextFragment());
    }
    nextFragment() {
      let e = (this.fragment = this.i == this.fragments.length ? null : this.fragments[this.i++]);
      if (e) {
        for (
          this.safeFrom = e.openStart ? Ou(e.tree, e.from + e.offset, 1) - e.offset : e.from,
            this.safeTo = e.openEnd ? Ou(e.tree, e.to + e.offset, -1) - e.offset : e.to;
          this.trees.length;
        )
          (this.trees.pop(), this.start.pop(), this.index.pop());
        (this.trees.push(e.tree),
          this.start.push(-e.offset),
          this.index.push(0),
          (this.nextStart = this.safeFrom));
      } else this.nextStart = 1e9;
    }
    nodeAt(e) {
      if (e < this.nextStart) return null;
      for (; this.fragment && this.safeTo <= e;) this.nextFragment();
      if (!this.fragment) return null;
      for (;;) {
        let t = this.trees.length - 1;
        if (t < 0) return (this.nextFragment(), null);
        let n = this.trees[t],
          r = this.index[t];
        if (r == n.children.length) {
          (this.trees.pop(), this.start.pop(), this.index.pop());
          continue;
        }
        let i = n.children[r],
          a = this.start[t] + n.positions[r];
        if (a > e) return ((this.nextStart = a), null);
        if (i instanceof J) {
          if (a == e) {
            if (a < this.safeFrom) return null;
            let e = a + i.length;
            if (e <= this.safeTo) {
              let t = i.prop(G.lookAhead);
              if (!t || e + t < this.fragment.to) return i;
            }
          }
          (this.index[t]++,
            a + i.length >= Math.max(this.safeFrom, e) &&
              (this.trees.push(i), this.start.push(a), this.index.push(0)));
        } else (this.index[t]++, (this.nextStart = a + i.length));
      }
    }
  },
  Au = class {
    constructor(e, t) {
      ((this.stream = t),
        (this.tokens = []),
        (this.mainToken = null),
        (this.actions = []),
        (this.tokens = e.tokenizers.map((e) => new vu())));
    }
    getActions(e) {
      let t = 0,
        n = null,
        { parser: r } = e.p,
        { tokenizers: i } = r,
        a = r.stateSlot(e.state, 3),
        o = e.curContext ? e.curContext.hash : 0,
        s = 0;
      for (let r = 0; r < i.length; r++) {
        if (!((1 << r) & a)) continue;
        let c = i[r],
          l = this.tokens[r];
        if (
          !(n && !c.fallback) &&
          ((c.contextual || l.start != e.pos || l.mask != a || l.context != o) &&
            (this.updateCachedToken(l, c, e), (l.mask = a), (l.context = o)),
          l.lookAhead > l.end + 25 && (s = Math.max(l.lookAhead, s)),
          l.value != 0)
        ) {
          let r = t;
          if (
            (l.extended > -1 && (t = this.addActions(e, l.extended, l.end, t)),
            (t = this.addActions(e, l.value, l.end, t)),
            !c.extend && ((n = l), t > r))
          )
            break;
        }
      }
      for (; this.actions.length > t;) this.actions.pop();
      return (
        s && e.setLookAhead(s),
        !n &&
          e.pos == this.stream.end &&
          ((n = new vu()),
          (n.value = e.p.parser.eofTerm),
          (n.start = n.end = e.pos),
          (t = this.addActions(e, n.value, n.end, t))),
        (this.mainToken = n),
        this.actions
      );
    }
    getMainToken(e) {
      if (this.mainToken) return this.mainToken;
      let t = new vu(),
        { pos: n, p: r } = e;
      return (
        (t.start = n),
        (t.end = Math.min(n + 1, r.stream.end)),
        (t.value = n == r.stream.end ? r.parser.eofTerm : 0),
        t
      );
    }
    updateCachedToken(e, t, n) {
      let r = this.stream.clipPos(n.pos);
      if ((t.token(this.stream.reset(r, e), n), e.value > -1)) {
        let { parser: t } = n.p;
        for (let r = 0; r < t.specialized.length; r++)
          if (t.specialized[r] == e.value) {
            let i = t.specializers[r](this.stream.read(e.start, e.end), n);
            if (i >= 0 && n.p.parser.dialect.allows(i >> 1)) {
              i & 1 ? (e.extended = i >> 1) : (e.value = i >> 1);
              break;
            }
          }
      } else ((e.value = 0), (e.end = this.stream.clipPos(r + 1)));
    }
    putAction(e, t, n, r) {
      for (let t = 0; t < r; t += 3) if (this.actions[t] == e) return r;
      return ((this.actions[r++] = e), (this.actions[r++] = t), (this.actions[r++] = n), r);
    }
    addActions(e, t, n, r) {
      let { state: i } = e,
        { parser: a } = e.p,
        { data: o } = a;
      for (let e = 0; e < 2; e++)
        for (let s = a.stateSlot(i, e ? 2 : 1); ; s += 3) {
          if (o[s] == 65535)
            if (o[s + 1] == 1) s = Lu(o, s + 2);
            else {
              r == 0 && o[s + 1] == 2 && (r = this.putAction(Lu(o, s + 2), t, n, r));
              break;
            }
          o[s] == t && (r = this.putAction(Lu(o, s + 1), t, n, r));
        }
      return r;
    }
  },
  ju = class {
    constructor(e, t, n, r) {
      ((this.parser = e),
        (this.input = t),
        (this.ranges = r),
        (this.recovering = 0),
        (this.nextStackID = 9812),
        (this.minStackPos = 0),
        (this.reused = []),
        (this.stoppedAt = null),
        (this.lastBigReductionStart = -1),
        (this.lastBigReductionSize = 0),
        (this.bigReductionCount = 0),
        (this.stream = new bu(t, r)),
        (this.tokens = new Au(e, this.stream)),
        (this.topTerm = e.top[1]));
      let { from: i } = r[0];
      ((this.stacks = [pu.start(this, e.top[0], i)]),
        (this.fragments =
          n.length && this.stream.end - i > e.bufferLength * 4 ? new ku(n, e.nodeSet) : null));
    }
    get parsedPos() {
      return this.minStackPos;
    }
    advance() {
      let e = this.stacks,
        t = this.minStackPos,
        n = (this.stacks = []),
        r,
        i;
      if (this.bigReductionCount > 300 && e.length == 1) {
        let [t] = e;
        for (
          ;
          t.forceReduce() &&
          t.stack.length &&
          t.stack[t.stack.length - 2] >= this.lastBigReductionStart;
        );
        this.bigReductionCount = this.lastBigReductionSize = 0;
      }
      for (let a = 0; a < e.length; a++) {
        let o = e[a];
        for (;;) {
          if (((this.tokens.mainToken = null), o.pos > t)) n.push(o);
          else if (this.advanceStack(o, n, e)) continue;
          else {
            (r || ((r = []), (i = [])), r.push(o));
            let e = this.tokens.getMainToken(o);
            i.push(e.value, e.end);
          }
          break;
        }
      }
      if (!n.length) {
        let e = r && Ru(r);
        if (e) return ($ && console.log(`Finish with ` + this.stackID(e)), this.stackToTree(e));
        if (this.parser.strict)
          throw (
            $ &&
              r &&
              console.log(
                `Stuck with token ` +
                  (this.tokens.mainToken
                    ? this.parser.getName(this.tokens.mainToken.value)
                    : `none`),
              ),
            SyntaxError(`No parse at ` + t)
          );
        this.recovering ||= 5;
      }
      if (this.recovering && r) {
        let e =
          this.stoppedAt != null && r[0].pos > this.stoppedAt ? r[0] : this.runRecovery(r, i, n);
        if (e)
          return (
            $ && console.log(`Force-finish ` + this.stackID(e)),
            this.stackToTree(e.forceAll())
          );
      }
      if (this.recovering) {
        let e = this.recovering == 1 ? 1 : this.recovering * 3;
        if (n.length > e) for (n.sort((e, t) => t.score - e.score); n.length > e;) n.pop();
        n.some((e) => e.reducePos > t) && this.recovering--;
      } else if (n.length > 1) {
        outer: for (let e = 0; e < n.length - 1; e++) {
          let t = n[e];
          for (let r = e + 1; r < n.length; r++) {
            let i = n[r];
            if (t.sameState(i) || (t.buffer.length > 500 && i.buffer.length > 500))
              if ((t.score - i.score || t.buffer.length - i.buffer.length) > 0) n.splice(r--, 1);
              else {
                n.splice(e--, 1);
                continue outer;
              }
          }
        }
        n.length > 12 && (n.sort((e, t) => t.score - e.score), n.splice(12, n.length - 12));
      }
      this.minStackPos = n[0].pos;
      for (let e = 1; e < n.length; e++)
        n[e].pos < this.minStackPos && (this.minStackPos = n[e].pos);
      return null;
    }
    stopAt(e) {
      if (this.stoppedAt != null && this.stoppedAt < e)
        throw RangeError(`Can't move stoppedAt forward`);
      this.stoppedAt = e;
    }
    advanceStack(e, t, n) {
      let r = e.pos,
        { parser: i } = this,
        a = $ ? this.stackID(e) + ` -> ` : ``;
      if (this.stoppedAt != null && r > this.stoppedAt) return e.forceReduce() ? e : null;
      if (this.fragments) {
        let t = e.curContext && e.curContext.tracker.strict,
          n = t ? e.curContext.hash : 0;
        for (let o = this.fragments.nodeAt(r); o;) {
          let r =
            this.parser.nodeSet.types[o.type.id] == o.type ? i.getGoto(e.state, o.type.id) : -1;
          if (r > -1 && o.length && (!t || (o.prop(G.contextHash) || 0) == n))
            return (
              e.useNode(o, r),
              $ && console.log(a + this.stackID(e) + ` (via reuse of ${i.getName(o.type.id)})`),
              !0
            );
          if (!(o instanceof J) || o.children.length == 0 || o.positions[0] > 0) break;
          let s = o.children[0];
          if (s instanceof J && o.positions[0] == 0) o = s;
          else break;
        }
      }
      let o = i.stateSlot(e.state, 4);
      if (o > 0)
        return (
          e.reduce(o),
          $ && console.log(a + this.stackID(e) + ` (via always-reduce ${i.getName(o & 65535)})`),
          !0
        );
      if (e.stack.length >= 8400) for (; e.stack.length > 6e3 && e.forceReduce(););
      let s = this.tokens.getActions(e);
      for (let o = 0; o < s.length;) {
        let c = s[o++],
          l = s[o++],
          u = s[o++],
          d = o == s.length || !n,
          f = d ? e : e.split(),
          p = this.tokens.mainToken;
        if (
          (f.apply(c, l, p ? p.start : f.pos, u),
          $ &&
            console.log(
              a +
                this.stackID(f) +
                ` (via ${c & 65536 ? `reduce of ${i.getName(c & 65535)}` : `shift`} for ${i.getName(l)} @ ${r}${f == e ? `` : `, split`})`,
            ),
          d)
        )
          return !0;
        f.pos > r ? t.push(f) : n.push(f);
      }
      return !1;
    }
    advanceFully(e, t) {
      let n = e.pos;
      for (;;) {
        if (!this.advanceStack(e, null, null)) return !1;
        if (e.pos > n) return (Mu(e, t), !0);
      }
    }
    runRecovery(e, t, n) {
      let r = null,
        i = !1;
      for (let a = 0; a < e.length; a++) {
        let o = e[a],
          s = t[a << 1],
          c = t[(a << 1) + 1],
          l = $ ? this.stackID(o) + ` -> ` : ``;
        if (
          o.deadEnd &&
          (i ||
            ((i = !0),
            o.restart(),
            $ && console.log(l + this.stackID(o) + ` (restarted)`),
            this.advanceFully(o, n)))
        )
          continue;
        let u = o.split(),
          d = l;
        for (
          let e = 0;
          e < 10 &&
          u.forceReduce() &&
          ($ && console.log(d + this.stackID(u) + ` (via force-reduce)`), !this.advanceFully(u, n));
          e++
        )
          $ && (d = this.stackID(u) + ` -> `);
        for (let e of o.recoverByInsert(s))
          ($ && console.log(l + this.stackID(e) + ` (via recover-insert)`),
            this.advanceFully(e, n));
        this.stream.end > o.pos
          ? (c == o.pos && (c++, (s = 0)),
            o.recoverByDelete(s, c),
            $ &&
              console.log(l + this.stackID(o) + ` (via recover-delete ${this.parser.getName(s)})`),
            Mu(o, n))
          : (!r || r.score < u.score) && (r = u);
      }
      return r;
    }
    stackToTree(e) {
      return (
        e.close(),
        J.build({
          buffer: gu.create(e),
          nodeSet: this.parser.nodeSet,
          topID: this.topTerm,
          maxBufferLength: this.parser.bufferLength,
          reused: this.reused,
          start: this.ranges[0].from,
          length: e.pos - this.ranges[0].from,
          minRepeatType: this.parser.minRepeatTerm,
        })
      );
    }
    stackID(e) {
      let t = (Du ||= new WeakMap()).get(e);
      return (t || Du.set(e, (t = String.fromCodePoint(this.nextStackID++))), t + e);
    }
  };
function Mu(e, t) {
  for (let n = 0; n < t.length; n++) {
    let r = t[n];
    if (r.pos == e.pos && r.sameState(e)) {
      t[n].score < e.score && (t[n] = e);
      return;
    }
  }
  t.push(e);
}
var Nu = class {
    constructor(e, t, n) {
      ((this.source = e), (this.flags = t), (this.disabled = n));
    }
    allows(e) {
      return !this.disabled || this.disabled[e] == 0;
    }
  },
  Pu = (e) => e,
  Fu = class {
    constructor(e) {
      ((this.start = e.start),
        (this.shift = e.shift || Pu),
        (this.reduce = e.reduce || Pu),
        (this.reuse = e.reuse || Pu),
        (this.hash = e.hash || (() => 0)),
        (this.strict = e.strict !== !1));
    }
  },
  Iu = class e extends tc {
    constructor(e) {
      if ((super(), (this.wrappers = []), e.version != 14))
        throw RangeError(`Parser version (${e.version}) doesn't match runtime version (14)`);
      let t = e.nodeNames.split(` `);
      this.minRepeatTerm = t.length;
      for (let n = 0; n < e.repeatNodeCount; n++) t.push(``);
      let n = Object.keys(e.topRules).map((t) => e.topRules[t][1]),
        r = [];
      for (let e = 0; e < t.length; e++) r.push([]);
      function i(e, t, n) {
        r[e].push([t, t.deserialize(String(n))]);
      }
      if (e.nodeProps)
        for (let t of e.nodeProps) {
          let e = t[0];
          typeof e == `string` && (e = G[e]);
          for (let n = 1; n < t.length;) {
            let r = t[n++];
            if (r >= 0) i(r, e, t[n++]);
            else {
              let a = t[n + -r];
              for (let o = -r; o > 0; o--) i(t[n++], e, a);
              n++;
            }
          }
        }
      ((this.nodeSet = new Ms(
        t.map((t, i) =>
          K.define({
            name: i >= this.minRepeatTerm ? void 0 : t,
            id: i,
            props: r[i],
            top: n.indexOf(i) > -1,
            error: i == 0,
            skipped: e.skippedNodes && e.skippedNodes.indexOf(i) > -1,
          }),
        ),
      )),
        e.propSources && (this.nodeSet = this.nodeSet.extend(...e.propSources)),
        (this.strict = !1),
        (this.bufferLength = Os));
      let a = _u(e.tokenData);
      ((this.context = e.context),
        (this.specializerSpecs = e.specialized || []),
        (this.specialized = new Uint16Array(this.specializerSpecs.length)));
      for (let e = 0; e < this.specializerSpecs.length; e++)
        this.specialized[e] = this.specializerSpecs[e].term;
      ((this.specializers = this.specializerSpecs.map(zu)),
        (this.states = _u(e.states, Uint32Array)),
        (this.data = _u(e.stateData)),
        (this.goto = _u(e.goto)),
        (this.maxTerm = e.maxTerm),
        (this.tokenizers = e.tokenizers.map((e) => (typeof e == `number` ? new xu(a, e) : e))),
        (this.topRules = e.topRules),
        (this.dialects = e.dialects || {}),
        (this.dynamicPrecedences = e.dynamicPrecedences || null),
        (this.tokenPrecTable = e.tokenPrec),
        (this.termNames = e.termNames || null),
        (this.maxNode = this.nodeSet.types.length - 1),
        (this.dialect = this.parseDialect()),
        (this.top = this.topRules[Object.keys(this.topRules)[0]]));
    }
    createParse(e, t, n) {
      let r = new ju(this, e, t, n);
      for (let i of this.wrappers) r = i(r, e, t, n);
      return r;
    }
    getGoto(e, t, n = !1) {
      let r = this.goto;
      if (t >= r[0]) return -1;
      for (let i = r[t + 1]; ;) {
        let t = r[i++],
          a = t & 1,
          o = r[i++];
        if (a && n) return o;
        for (let n = i + (t >> 1); i < n; i++) if (r[i] == e) return o;
        if (a) return -1;
      }
    }
    hasAction(e, t) {
      let n = this.data;
      for (let r = 0; r < 2; r++)
        for (let i = this.stateSlot(e, r ? 2 : 1), a; ; i += 3) {
          if ((a = n[i]) == 65535)
            if (n[i + 1] == 1) a = n[(i = Lu(n, i + 2))];
            else if (n[i + 1] == 2) return Lu(n, i + 2);
            else break;
          if (a == t || a == 0) return Lu(n, i + 1);
        }
      return 0;
    }
    stateSlot(e, t) {
      return this.states[e * 6 + t];
    }
    stateFlag(e, t) {
      return (this.stateSlot(e, 0) & t) > 0;
    }
    validAction(e, t) {
      return !!this.allActions(e, (e) => (e == t ? !0 : null));
    }
    allActions(e, t) {
      let n = this.stateSlot(e, 4),
        r = n ? t(n) : void 0;
      for (let n = this.stateSlot(e, 1); r == null; n += 3) {
        if (this.data[n] == 65535)
          if (this.data[n + 1] == 1) n = Lu(this.data, n + 2);
          else break;
        r = t(Lu(this.data, n + 1));
      }
      return r;
    }
    nextStates(e) {
      let t = [];
      for (let n = this.stateSlot(e, 1); ; n += 3) {
        if (this.data[n] == 65535)
          if (this.data[n + 1] == 1) n = Lu(this.data, n + 2);
          else break;
        if (!(this.data[n + 2] & 1)) {
          let e = this.data[n + 1];
          t.some((t, n) => n & 1 && t == e) || t.push(this.data[n], e);
        }
      }
      return t;
    }
    configure(t) {
      let n = Object.assign(Object.create(e.prototype), this);
      if ((t.props && (n.nodeSet = this.nodeSet.extend(...t.props)), t.top)) {
        let e = this.topRules[t.top];
        if (!e) throw RangeError(`Invalid top rule name ${t.top}`);
        n.top = e;
      }
      return (
        t.tokenizers &&
          (n.tokenizers = this.tokenizers.map((e) => {
            let n = t.tokenizers.find((t) => t.from == e);
            return n ? n.to : e;
          })),
        t.specializers &&
          ((n.specializers = this.specializers.slice()),
          (n.specializerSpecs = this.specializerSpecs.map((e, r) => {
            let i = t.specializers.find((t) => t.from == e.external);
            if (!i) return e;
            let a = Object.assign(Object.assign({}, e), {
              external: i.to,
            });
            return ((n.specializers[r] = zu(a)), a);
          }))),
        t.contextTracker && (n.context = t.contextTracker),
        t.dialect && (n.dialect = this.parseDialect(t.dialect)),
        t.strict != null && (n.strict = t.strict),
        t.wrap && (n.wrappers = n.wrappers.concat(t.wrap)),
        t.bufferLength != null && (n.bufferLength = t.bufferLength),
        n
      );
    }
    hasWrappers() {
      return this.wrappers.length > 0;
    }
    getName(e) {
      return this.termNames
        ? this.termNames[e]
        : String((e <= this.maxNode && this.nodeSet.types[e].name) || e);
    }
    get eofTerm() {
      return this.maxNode + 1;
    }
    get topNode() {
      return this.nodeSet.types[this.top[1]];
    }
    dynamicPrecedence(e) {
      let t = this.dynamicPrecedences;
      return t == null ? 0 : t[e] || 0;
    }
    parseDialect(e) {
      let t = Object.keys(this.dialects),
        n = t.map(() => !1);
      if (e)
        for (let r of e.split(` `)) {
          let e = t.indexOf(r);
          e >= 0 && (n[e] = !0);
        }
      let r = null;
      for (let e = 0; e < t.length; e++)
        if (!n[e])
          for (let n = this.dialects[t[e]], i; (i = this.data[n++]) != 65535;)
            (r ||= new Uint8Array(this.maxTerm + 1))[i] = 1;
      return new Nu(e, n, r);
    }
    static deserialize(t) {
      return new e(t);
    }
  };
function Lu(e, t) {
  return e[t] | (e[t + 1] << 16);
}
function Ru(e) {
  let t = null;
  for (let n of e) {
    let e = n.p.stoppedAt;
    (n.pos == n.p.stream.end || (e != null && n.pos > e)) &&
      n.p.parser.stateFlag(n.state, 2) &&
      (!t || t.score < n.score) &&
      (t = n);
  }
  return t;
}
function zu(e) {
  if (e.external) {
    let t = +!!e.extend;
    return (n, r) => (e.external(n, r) << 1) | t;
  }
  return e.get;
}
export {
  Io as $,
  Xc as A,
  J as B,
  ml as C,
  xt as Ct,
  Hl as D,
  Gc as E,
  G as F,
  xr as G,
  F as H,
  Ms as I,
  _s as J,
  en as K,
  K as L,
  Cc as M,
  Z as N,
  qc as O,
  q as P,
  is as Q,
  $s as R,
  fl as S,
  rt as St,
  ll as T,
  ie as Tt,
  I as U,
  rc as V,
  U as W,
  No as X,
  hs as Y,
  _r as Z,
  Tl as _,
  Ce as _t,
  Al as a,
  se as at,
  Dl as b,
  re as bt,
  Q as c,
  Oe as ct,
  $c as d,
  E as dt,
  Ss as et,
  Xl as f,
  C as ft,
  Cl as g,
  D as gt,
  Kc as h,
  it as ht,
  Su as i,
  Ve as it,
  vc as j,
  Pl as k,
  sl as l,
  T as lt,
  El as m,
  ut as mt,
  Cu as n,
  ms as nt,
  pl as o,
  ce as ot,
  zl as p,
  Ee as pt,
  Zo as q,
  Iu as r,
  It as rt,
  Yc as s,
  Qe as st,
  Fu as t,
  xs as tt,
  ol as u,
  k as ut,
  kl as v,
  f as vt,
  dl as w,
  S as wt,
  ul as x,
  ae as xt,
  Ol as y,
  O as yt,
  tc as z,
};
